(function() {
  'use strict';

  angular
    .module('connectsx.settings.manufacturers', []);

})();

(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.settings.manufacturers')
        .factory('NewManufactureModal', NewManufactureModal);

    NewManufactureModal.$inject = ['$mdDialog'];

    function NewManufactureModal($mdDialog) {


        function show(searchText, callback) {
            $mdDialog.show({
                locals: { 'SearchText':searchText, 'Callback': callback || function() {}},
                controller: 'ManufactureCreateModalController',
                controllerAs: 'vm',
                templateUrl:'app/settings/manufacturers/modal/manufacturer.modal.tmpl.html',
                clickOutsideToClose:true
            });
        }

        return {
            show : show,
        };

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.settings.manufacturers')
        .controller('ManufactureCreateModalController', ManufactureCreateModalController);

    ManufactureCreateModalController.$inject = ['$log', '$mdDialog', 'Toast', 'Callback', 'Gudid', 'Manufacturers'];

    function ManufactureCreateModalController($log, $mdDialog,  Toast, Callback, Gudid, Manufacturers) {

        var vm = this;

        vm.manufacturer = {};
        vm.gudidManufacturer = '';
        vm.manufacturerSearchText = '';
        vm.cancel = $mdDialog.hide;
        vm.save = save;
        vm.searchManufacturers = searchManufacturers;

        activate();

        function activate() {
            $log.info('ManufactureCreateModalController activated.')
        }

        function searchManufacturers (searchText) {
            return Gudid.searchManufacturers({search: searchText, limit: 50}).$promise.then(function (response) {
                return response.items || [];
            });
        }

        function save() {

            if (!vm.gudidManufacturer === '') {
                Toast.error('Manufacture name is required.');
                return;
            }

            vm.manufacturer.name =  angular.isString(vm.gudidManufacturer) ? vm.gudidManufacturer.name : vm.manufacturerSearchText;

            vm.saving = true;

            Manufacturers.insert( vm.manufacturer, success, error);

            function success(response) {
                vm.saving = false;
                Callback(response);
                $mdDialog.hide();
            }

            function error(response) {
                vm.saving = false;
                Toast.error(response);
            }

        }

    }

})();

(function() {
  'use strict';


  angular
    .module('connectsx', [
      'ngAnimate',
      'ngPlacesAutocomplete',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ngMaterial',
      'ngMaterialDatePicker',
      'ui.router',
      'ui.bootstrap',
      'ui.slimscroll',
      'firebase',
      'gridshore.c3js.chart',
      'angularUUID2',
      'angular-ladda',
      'dndLists',
      'connectsx.auth',
      'connectsx.accounts',
      'connectsx.cases',
      'connectsx.catalog',
      'connectsx.comments',
      'connectsx.onboarding',
      'connectsx.catalog.trays',
      'connectsx.catalog.products',
      'connectsx.catalog.guides',
      'connectsx.catalog.layers',
      'connectsx.inventory',
      'connectsx.inventory.transfers',
      'connectsx.inventory.requests',
      'connectsx.inventory.catalog',
      'connectsx.inventory.import',
      'connectsx.home',
      'connectsx.notifications',
      'connectsx.errors',
      'connectsx.settings',
      'connectsx.settings.org',
      'connectsx.settings.personal',
      'connectsx.settings.manufacturers',
      'connectsx.directory',
      'connectsx.directory.physicians',
      'connectsx.directory.facilities',
      'connectsx.directory.procedures',
      'connectsx.confirmUnsavedChanges'
    ]);

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx')
        .factory('TransferModal', TransferModal);

    TransferModal.$inject = ['$mdDialog'];

    function TransferModal($mdDialog) {


        function show(custody, item, callback) {
            _show(custody, null, null, item, false, null, callback);
        }

        function _show(custody, target, fulfillment, item, requestMode, comment, callback) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                locals: {
                    'Custody': custody || "",
                    'RequestMode': requestMode,
                    'InventoryItem': item || {},
                    'Target': target || {},
                    'Comment': comment || '',
                    'Fulfillment': fulfillment || [],
                    'Callback': callback || function () {}
                },
                controller: 'TransferModalController',
                controllerAs: 'vm',
                templateUrl: 'app/inventory/transfers/modal/transfer.tmpl.html',
                clickOutsideToClose: true
            });
        }

        function showForRequest(custody, target, fulfillment, comment, callback) {
            _show(custody, target, fulfillment, null, true, comment, callback);
        }

        return {
            show: show,
            showForRequest: showForRequest,
        };

    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.transfers', []);

})();

(function () {
    'use strict';
/* global angular */
    angular
        .module('connectsx.inventory.transfers')
        .controller('TransferModalController', TransferModalController);

    TransferModalController.$inject = ['$log', '$mdDialog', 'Transfers', 'RequestMode', 'Target', 'Fulfillment',
        'Accounts', 'Manufacturers', 'Inventory', 'Custody', 'InventoryItem', 'Comment', 'Callback', 'Toast', '$timeout'];

    function TransferModalController($log, $mdDialog, Transfers, RequestMode, Target, Fulfillment,
                                     Accounts, Manufacturers, Inventory, Custody, InventoryItem, Comment, Callback,
                                     Toast, $timeout) {

        var vm = this;
        vm.accounts = [];
        vm.inventory = [];
        vm.inventoryKeys = {};
        vm.requestMode = RequestMode;
        vm.comment = Comment || '';
        vm.manufacturer = undefined;
        vm.isSearchContainerTextChanged = false;
        vm.cacheContainers = [];
        vm.isSearching = null;
        vm.isInventoryItem = false;
        vm.findingExistInventory = false;
        vm.errorFindInventory = false;
        vm.loading = false;
        vm.type = 'Device';
        vm.isItemsLoading = false;
        vm.maxLengthLoadInventoriesFirstTime = 0;
        vm.maxLengthLoadInventoriesSecondTime = 0;
        vm.isRequestMultiInventories = false;
        vm.requestInventories = [];
        vm.contsinsInventoriesFromRequestPage = false;

        if (angular.isString(Target.key)) {
            vm.selectedAccount = Target;
        }

        if (angular.isString(Custody)) {
            vm.custody = Custody;
        } else if (angular.isObject(Custody) && angular.isString(Custody.key)) {
            vm.custody = Custody.key;
        }

        if(Fulfillment.length) {
            if (Fulfillment.length === 1) {
                vm.type = Fulfillment[0].type;
            }
            vm.requestInventories = Fulfillment;
            vm.requestInventories[0].requestPageSelected = true;
            vm.contsinsInventoriesFromRequestPage = true;
            setInventoryDescription(vm.requestInventories[0]);
            vm.findingExistInventory = true;
            vm.isInventoryItem = true;
            addInventory(vm.requestInventories[0]);


        }

        if(Fulfillment.length > 1){
            vm.isRequestMultiInventories = true;
        }

        if (angular.isObject(InventoryItem) && angular.isString(InventoryItem.key)) {
            if(InventoryItem.type){
                vm.type = InventoryItem.type;
            }

            vm.findingExistInventory = true;
            vm.isInventoryItem = true;
            setInventoryDescription(InventoryItem);
            addInventory(InventoryItem);
        }

        angular.forEach(vm.inventory, function(i) {
            vm.inventoryKeys[i.key] = true;
        });

        function setInventoryDescription(i) {
            i.description = i.name;
            if (i.reference !== i.name) {
                i.description += ' (' + i.reference + ')';
            }
        }


        vm.cancel = $mdDialog.hide;
        vm.transfer = transfer;
        vm.removeInventory = removeInventory;
        vm.searchInventory = searchInventory;
        vm.addInventory = addInventory;
        vm.done = done;
        vm.checkCustody = checkCustody;
        vm.isStringLength = isStringLength;
        vm.changeAmount = changeAmount;

        vm.$onInit = function() {

            var closestByClass = function(el, clazz) {
                if(!el || el === document) return null
                //We need .itemInnerContent if event get above this element, we find if in hi, childs
                if(el.tagName === "LI"){
                     return el.querySelector('.' + clazz)
                }
                //Recursion to find parent  El
                function getParent(el, clazz){
                    if(!el || el.tagName === 'BODY') return null

                    if (el.classList.contains(clazz)) {
                        return  el
                    }
                    else {
                        return getParent(el.parentNode, clazz);
                    }
                }
                getParent(el, clazz)
            }

            function asyncLoadData(e){
                var height = document.querySelector('.md-virtual-repeat-sizer').offsetHeight;
                var parentEl = closestByClass(e.target, 'itemInnerContent');

                if(parentEl){
                    var ind =  +parentEl.getAttribute('data-index');
                    //If scroll less 80% load posts
                    if((height/5)*3 < ind*62){
                        callLoadData(32)
                    }
                }
            }
            var iTiming = false;
            function callLoadData(time){
                if(!vm.isItemsLoading && vm.maxLengthLoadInventoriesFirstTime !== vm.maxLengthLoadInventoriesSecondTime){

                    if(iTiming) return
                    iTiming = true;
                    var val = vm.inventorySearchText;
                    vm.isScrollSearch = true;
                    vm.inventorySearchText = ' ';
                    //Need refactor!!!!!!!!!!!!!!!!!!!!!!!!  Now haven't time for it
                    $timeout(function(){
                        vm.inventorySearchText = val;
                        $timeout(function(){
                            vm.inventorySearchText = val;
                            $timeout(function(){
                                vm.inventorySearchText = val;
                                $timeout(function(){
                                    vm.inventorySearchText = val;
                                    $timeout(function(){
                                        vm.inventorySearchText = val;
                                        $timeout(function(){
                                            vm.inventorySearchText = val;
                                            iTiming = false;
                                        }, 1200);
                                    }, 16);
                                }, 3);
                            });
                        }, 0);
                    }, time);
                }
            }

            $timeout(function(){
                //We have a constant of height if LI element in list options, 62px
                var parents = document.querySelectorAll('.md-virtual-repeat-container.md-autocomplete-suggestions-container');
                parents.forEach(function(parent){
                    parent.addEventListener('wheel', function(e){
                        if(!e) return
                        asyncLoadData(e, parent)
                    })

                    parent.addEventListener('mouseup', function(e){
                        if(!e) return
                        if( (+parent.offsetHeight /5)*3 < +e.offsetY){
                            callLoadData(0, parent)
                        }
                    });
                })


            })
        }

        function getRecipients() {

            if (angular.isUndefined(vm.manufacturer.key)){
                return;
            }
            var custodyKey = null;
          
            if (vm.inventory.length > 0) {
                custodyKey = vm.inventory[0].custodyKey;
            }
            else {
                return;
            }

            var manufacturerKey = vm.manufacturer.key;
            
            vm.loading = true;
            Accounts.list({ limit: 1000, manufacturer:manufacturerKey }, success, error);

            function success(response) {

                var accounts = [];
                angular.forEach(response.items || [], function (item) {
                    if (item.accountType === 'Individual' && item.key !== custodyKey) {
                        accounts.push(item);
                    }
                });

                Manufacturers.get({ objectKey: manufacturerKey }, function (response) {

                    var orgs = response.orgs || [];
                    angular.forEach(orgs, function(org) {
                        accounts.push(org);
                    });
                    vm.accounts = accounts;



                    //Filter account list from custodies inventory which are selected
                    filterRecipients();

                    vm.loading = false;
                }, error);


            }
        }

        function filterRecipients(){
            var inventories = vm.inventory;
            var accounts =  vm.accounts;

            var filteredAccounts = accounts.filter(function (acc) {
                return inventories.every(function(inv){
                    return acc.key !== inv.custodyKey
                });
            });

            vm.accounts = filteredAccounts;
        }

        function removeInventory(item) {
            // remove relatedItems to show them in the search again
            vm.inventoryKeys[item.key] = false;
            var relatedItems = item.relatedItems || [];

            relatedItems.forEach(function(el){
                vm.inventoryKeys[el.key] = false;
            })

            for (var i = 0; i < vm.inventory.length; i++) {
                if (vm.inventory[i].key === item.key) {
                    vm.inventory.splice(i, 1);
                    vm.inventoryKeys[vm.inventory.key] = false;
                    break;
                }
            }

            if (vm.inventory.length === 0) {
                delete vm.manufacturer;
                delete vm.selectedAccount;
                vm.accounts = [];
            }
            vm.inventoryKeys[item.key] = false;
            //Refilter recipients from custody removed inventory
            if(vm.manufacturer){
                getRecipients()
            }
        }

        function transferSuccess(response) {
            vm.transferLoading = false;
            Callback(response);
            $mdDialog.hide();
        }

        function error(error) {
            $log.error(error);
            vm.error = error.data.error.message;
            vm.transferLoading = false;
            vm.loading = false;
            vm.findingExistInventory = false;
            Toast.error(vm.error);
        }

        function addInventory(item) {

            if (!angular.isObject(item) || !angular.isString(item.key)) {
                return;
            }

            if (vm.inventoryKeys[item.key] === true) {
                return;
            }

            var params = {
                search: item.reference,
                type: vm.type,
                unassigned:true,
                size: 1000,
                extendedInfo: true
            };

            if (vm.type === 'Device') {
                params.loose = true;
            }

            vm.findingExistInventory = true;

            Inventory.basicSearch(params).$promise.then(function (response) {

                var items =  response.items || [];

                //If Modal popup opened from inventory edit page, came inventory object with not expected format;
                if(vm.isInventoryItem){

                    var key = item.key;

                    item = null;
                    items.every(function(el){
                        if(el.key === key){
                            item = el;
                        }
                        else {
                            return true
                        }
                    })

                    if(!item) {
                        vm.errorFindInventory = true;
                        vm.findingExistInventory = false;
                        $timeout(function(){
                            vm.errorFindInventory = false;
                        }, 7000)
                        return
                    }
                }

                item.relatedItems = [];

                if(vm.contsinsInventoriesFromRequestPage){

                    var identKey = null;
                    items.forEach(function(y, index){
                        if(y.key === item.key){
                            identKey = y;
                        }
                        if(y.reference === item.reference && y.lot === item.lot && item.custodyKey === y.custodyKey){
                            if(!vm.checkCustody(item, vm.selectedAccount) ){
                                if(!(angular.isObject(y) &&
                                    angular.isString(y.transferStatus) &&
                                    y.transferStatus === 'Pending') && y.key !== item.key) {

                                    // if(item.relatedItems.length === 1){
                                    //     item.relatedItems[0].isSelected = true
                                    // }

                                    vm.requestInventories.forEach(function(requestEl, rIndx){
                                        if(requestEl.key === y.key ){

                                            y.isSelected = true;
                                            requestEl.requestPageSelected = true;
                                        }
                                    });

                                    vm.inventoryKeys[y.key] = true;
                                    item.relatedItems.push(y);

                                }
                            }
                        }
                    });

                    //if(!item.relatedItems.length && identKey){
                        item.relatedItems.unshift(identKey);
                        item.relatedItems[0].isSelected = true;
                   // }

                    (function(){
                        item.amount = 0;
                        item.relatedItems.forEach(function(it){
                            if(it.isSelected){
                                item.amount += 1
                            }
                        });
                    }());

                    vm.requestInventories.every(function(el){
                        if(!el.requestPageSelected){
                            vm.findingExistInventory = true;
                            vm.isInventoryItem = true;
                            addInventory(el);
                        }
                        else {
                            return true
                        }
                    })

                }
                else {
                    var identKey = null;
                    items.forEach(function(y, index){
                        if(y.key === item.key){
                            identKey = y;
                        }

                        if(y.reference === item.reference && y.lot === item.lot && item.custodyKey === y.custodyKey){
                            if(!vm.checkCustody(item, vm.selectedAccount) && y.key !== item.key){
                                if(!(angular.isObject(y) &&
                                    angular.isString(y.transferStatus) &&
                                    y.transferStatus === 'Pending') ) {
                                    vm.inventoryKeys[y.key] = true;
                                    item.relatedItems.push(y);
                                }
                            }
                        }
                    });

                        item.relatedItems.unshift(identKey);
                        item.relatedItems[0].isSelected = true

                }

                item.loading = false;
                vm.findingExistInventory = false;
                if(item.relatedItems.length){
                    item.relatedItems.every(function(el){
                        if(el.key === item.key){
                            el.isSelected = true;
                        }
                        else {
                            return true
                        }
                    })
                }
                if(!vm.contsinsInventoriesFromRequestPage) {
                    item.amount = 1;
                }
                vm.inventory.every( function(inv, index) {
                    if (inv.key === item.key) {
                        vm.inventory.splice(index, 1)
                    }
                    else {
                        return true
                    }
                });

                setInventoryDescription(item);

                vm.inventory.push(item);
                // Added keys to hide this items in search
                item.relatedItems.forEach(function(el){
                    vm.inventoryKeys[el.key] = true;
                })

                if (angular.isUndefined(vm.manufacturer)) {
                    vm.manufacturer = {};
                    vm.manufacturer.key = item.manufacturer ? item.manufacturer.key : item.manufactureKey;
                    //Load accounts list
                    getRecipients();
                }
                else {
                    //filter accounts list
                    filterRecipients()
                }

                if(vm.isRequestMultiInventories){


                    vm.isRequestMultiInventories = false;
                }

            }).catch(error)

            vm.inventoryKeys[item.key] = true;
            item.loading = true;
            // vm.inventory.push(item);
            vm.inventorySearchText = '';

        }

        //Search containers
        function sleep(ms) {
            return new Promise(function(resolve){
                vm.isSearching = setTimeout(resolve, ms)
            } );
        }
        var size = 1000;

        function searchInventory(searchText) {

            if(vm.isSearchContainerTextChanged){
                vm.maxLengthLoadInventoriesFirstTime = 0;
                vm.maxLengthLoadInventoriesSecondTime = 0;
            }

            clearTimeout(vm.isSearching);
            // if(!searchText || searchText.length === 0 || searchText === ' ') {
            //     vm.isItemsLoading = false;
            //     return
            // }
            if(!vm.isSearchContainerTextChanged && !vm.isScrollSearch){
                return vm.cacheContainers
            }

            var slp =  1500;
            var sz = 1000;
            if(vm.isScrollSearch){
                slp = 0;
                size += 500;
                sz = size;
            }

            vm.isItemsLoading = true;

            return sleep(slp).then(function() {
                //showCustodyName: true/false -20% performance from backend response if set true (false by default)
                var params = {
                    showCustodyName: true,
                    //custody:vm.custody,
                    search: searchText,
                    type: vm.type,
                    unassigned: true,
                    size: sz,
                    extendedInfo: true
                };

                if (vm.type === 'Device') {
                    params.loose = true;
                }

                return Inventory.basicSearch(params).$promise.then(function (response) {
                    var items = response.items || [];
                    vm.isSearchContainerTextChanged = false;

                    var inventory = [];

                    angular.forEach(items, function (i) {
                        /// don't show items that have already been added
                        if (vm.inventoryKeys[i.key] === true ||
                            vm.checkCustody(i, vm.selectedAccount) ||
                            (angular.isObject(i) &&
                                angular.isString(i.transferStatus) &&
                                i.transferStatus === 'Pending')  ) {
                            return;
                        }
                        // don't show items that are already assigned to a transfer
                        setInventoryDescription(i);
                        inventory.push(i);
                    });
                    vm.cacheContainers = inventory;
                    vm.maxLengthLoadInventoriesSecondTime = vm.maxLengthLoadInventoriesFirstTime;
                    vm.maxLengthLoadInventoriesFirstTime = inventory.length;
                    vm.isItemsLoading = false;
                    vm.isScrollSearch = false;
                    return inventory;
                }).catch(function(err){
                    $log.info(err)
                    vm.isItemsLoading = false;
                    vm.isScrollSearch = false;
                    return []
                })
            });
        }
        //</>

        function done() {

            var arrInvToCallBack = [];

            vm.inventory.forEach(function(inv){
                if(inv.relatedItems.length){
                    inv.relatedItems.forEach(function(relInv){
                        if(relInv.isSelected){
                            arrInvToCallBack.push(relInv)
                        }
                    })
                }
                else {
                    arrInvToCallBack.push(inv)
                }

            });

            Callback(arrInvToCallBack, vm.comment);
            $mdDialog.hide();
        }

        function transfer() {

            if (vm.transferLoading) {
                return;
            }

            if (!angular.isObject(vm.selectedAccount) ||
                !angular.isString(vm.selectedAccount.key)) {
                return;
            }

            if (vm.inventory.length === 0) {
                return;
            }

            var allSelectedinventories = setSelectedInvenories(vm.inventory);
            var account = {key: vm.selectedAccount.key};
            var transfer = {target: account};
            var inventory = [];

            angular.forEach(allSelectedinventories, function (i) {
                inventory.push({key: i.key})
            });
            transfer.inventory = inventory;
            transfer.note = vm.comment;

            vm.transferLoading = true;
            Transfers.insert(transfer, transferSuccess, error);

        }

        function changeAmount(invent, isIncrease){

            var index = +invent.amount;
            if(isIncrease){
                invent.amount = +invent.amount + 1;
                invent.relatedItems[index].isSelected = true;
            }
            else {
                index = index -1;
                invent.amount = +invent.amount - 1;
                invent.relatedItems[index].isSelected = false;
            }
        }

        function setSelectedInvenories(invent){
            var result = [];
            invent.forEach(function(inv){
                inv.relatedItems.forEach(function(relInv){
                    if(relInv.isSelected){
                        result.push(relInv)
                    }
                })
            })
            return result
        }

        function checkCustody (item, account){
            if(!account || !item || !vm.requestMode){
                return false
            }
            return item.custodyKey === account.key
        }

        function isStringLength(el){
            if(typeof el === 'string'){
                return el.length > 0
            }
            else {
                return false
            }
        }
    }
})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory.transfers')
        .controller('TransferDetailController', TransferDetailController);

    TransferDetailController.$inject = ['$scope', '$log', '$location', '$stateParams',
        'currentAuth', 'Transfers', 'Show', 'Toast', '$state', 'DeclineTransferModal', '$timeout'];

    function TransferDetailController($scope, $log, $location, $stateParams,
                                      currentAuth, Transfers, Show, Toast, $state, DeclineTransferModal, $timeout) {
        $state.activeTabsInventory = "index.inventory.transfers";

        var vm = this;

        vm.show = Show;
        vm.cancelTransfer = cancelTransfer;
        vm.acceptTransfer = acceptTransfer;
        vm.isLoading = false;
        vm.isSaving = false;
        vm.trackingEnabled = true;
        vm.save = save;

        vm.carriers = [
            {value: "ups", name: "UPS"},
            {value: "usps", name: "USPS"},
            {value: "fedex", name: "FedEx"},
            {value: "dhl_express", name: "DHL Express"},
            {value: "aramex", name: "Aramex"},
            {value: "asendia_us", name: "Asendia"},
            {value: "borderguru", name: "BorderGuru"},
            {value: "boxberry", name: "Boxberry"},
            {value: "bring", name: "Bring (also used for Posten Norge)"},
            {value: "canada_post", name: "Canada Post"},
            {value: "correios_br", name: "Correios Brazil"},
            {value: "correos_espana", name: "Correos Espana"},
            {value: "collect_plus", name: "CollectPlus"},
            {value: "couriersplease", name: "CouriersPlease"},
            {value: "deutsche_post", name: "Deutsche Post"},
            {value: "dhl_benelux", name: "DHL Benelux"},
            {value: "dhl_germany", name: "DHL Germany"},
            {value: "dhl_ecommerce", name: "DHL eCommerce"},
            {value: "dpd_germany", name: "DPD Germany"},
            {value: "dpd_uk", name: "DPD UK"},
            {value: "estafeta", name: "Estafeta"},
            {value: "fastway_australia", name: "Fastway Australia"},
            {value: "gls_de", name: "GLS Germany"},
            {value: "gls_fr", name: "GLS France"},
            {value: "globegistics", name: "Globegistics"},
            {value: "gophr", name: "Gophr"},
            {value: "gso", name: "GSO"},
            {value: "hermes_uk", name: "Hermes UK"},
            {value: "hongkong_post", name: "HongKong Post"},
            {value: "lasership", name: "Lasership"},
            {value: "mondial_relay", name: "Mondial Relay"},
            {value: "new_zealand_post", name: "New Zealand Post (also used for Pace and CourierPost)"},
            {value: "newgistics", name: "Newgistics"},
            {value: "nippon_express", name: "Nippon Express"},
            {value: "ontrac", name: "OnTrac"},
            {value: "orangeds", name: "OrangeDS"},
            {value: "parcel", name: "Parcel"},
            {value: "posti", name: "Posti"},
            {value: "rr_donnelley", name: "RR Donnelley"},
            {value: "russian_post", name: "Russian Post"},
            {value: "sendle", name: "Sendle"},
            {value: "skypostal", name: "SkyPostal"},
            {value: "stuart", name: "Stuart"},
            {value: "yodel", name: "Yodel"}
        ];

        vm.statusClass = function statusClass(status) {
            switch (status) {
                case 'Accepted':
                    return 'csx-closed';
                case 'Pending':
                    return 'csx-open';
                case 'Declined':
                    return 'csx-cancelled';
            }
            return '';
        };

        activate();

        function activate() {

            vm.isLoading = true;

            var params = {
                objectKey: $stateParams.objectKey
            };

            Transfers.get(params,
                function (response) {
                    $scope.$emit('loading', false);
                    vm.transfer = response;

                    //Get unique inventories by refrrence and set them quantity to show in table
                    $timeout(function(){
                        var refsArr = [];
                        var inventories = [];

                        vm.transfer.inventory.forEach(function(inv){
                            if(refsArr.indexOf(inv.reference) === -1){
                                inv.quantity = 1;
                                inventories.push(inv)
                                refsArr.push(inv.reference)
                            }
                            else {
                                inventories.every(function(el){
                                    if(el.reference === inv.reference){
                                        el.quantity = +el.quantity + 1;
                                    }
                                    else {
                                        return true
                                    }
                                })
                            }
                        })
                        vm.transfer.inventory  = inventories;
                    })
                },
                function (error) {
                    vm.isLoading = false;
                    $scope.$emit('loading', false);
                    Toast.error(error);
                }
            );
        }

        function acceptTransfer(transfer) {

            var key = transfer.key;
            var params = {objectKey: key};

            if (vm.isAccepting) {
                return;
            }

            vm.isAccepting = true;

            Transfers.accept(params, null, transferSuccess, handleError);

        }

        function cancelTransfer() {
            DeclineTransferModal.show(function(reason) {

                var key = vm.transfer.key;
                var params =  { objectKey: key };
                var body = { content: reason };

                Transfers.decline(params, body, transferSuccess, handleError);

            });
        }

        function transferSuccess(response) {
            vm.transfer = response;
            Toast.success('Saved!')
        }

        function handleError(error) {
            Toast.error(error);
            vm.isCancelling = false;
            vm.isAccepting = false;

        }

        function save(){

            var params = {
                objectKey: vm.transfer.key
            };

            var err = '';
            var isCarries = {
                carr: false,
                num: false
            };
            if(!vm.transfer.tracking || !vm.transfer.tracking.carrier){
                err += 'Carrier ';
                isCarries.carr = true;
            }
            if(!vm.transfer.tracking || !vm.transfer.tracking.number){
                if(err.length){
                    err += ' and ';
                }
                err += 'Tracking number ';
                isCarries.num = true;
            }
            if(isCarries.carr && isCarries.num ){
                err += 'are'
            }
            if(err.length){
                if(!isCarries.carr || !isCarries.num ){
                    err += 'is'
                }
                err += ' required.';
                Toast.error(err)
                return
            }

            Transfers.update(params,  vm.transfer, function(){
                Toast.success('Saved!')
            }, function(err){
                Toast.error('Save error')
            })
        }

    }

})
();


(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx')
    .factory('DeclineTransferModal', DeclineTransferModal);

  DeclineTransferModal.$inject = ['$mdDialog'];

  function DeclineTransferModal($mdDialog) {


    function show(callback) {
      $mdDialog.show({
        locals: { 'Callback': callback || function() {}},
        controller: 'DeclineTransferModalController',
        controllerAs: 'vm',
        templateUrl:'app/inventory/transfers/comments/decline.transfer.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.inventory.transfers')
    .controller('DeclineTransferModalController', DeclineTransferModalController);

  DeclineTransferModalController.$inject = ['$log', '$mdDialog', 'Callback', '$state'];

  function DeclineTransferModalController($log, $mdDialog, Callback, $state) {

    $state.activeTabsInventory = "index.inventory.transfers";

    var vm = this;
    vm.cancel = $mdDialog.hide;

    vm.transfer = transfer;

    activate();

    function activate() {
      $log.info('DeclineTransferModalController activated.');
    }

    function transfer() {
      if (angular.isString(vm.reason) && vm.reason.length > 0) {
        Callback(vm.reason);
        $mdDialog.hide();
      }
    }


  }

})();


(function() {
  'use strict';

  angular
    .module('connectsx.inventory', []);

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.inventory')
    .factory('AddInventoryModal', AddInventoryModal);

  AddInventoryModal.$inject = ['$mdDialog'];

  function AddInventoryModal($mdDialog) {


    function show(callback) {
      $mdDialog.show({
        locals: { 'Callback': callback || function() {}},
        controller: 'AddInventoryModalController',
        controllerAs: 'vm',
        templateUrl:'app/inventory/requests/modal/add.inventory.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('AddInventoryModalController', AddInventoryModalController);

    AddInventoryModalController.$inject = ['$log', '$mdDialog', 'Inventory', 'Callback'];

    function AddInventoryModalController($log, $mdDialog, Inventory, Callback) {

        var vm = this;
        vm.cancel = $mdDialog.hide;

        vm.add = add;
        vm.searchTrays = searchTrays;
        vm.searchDevices = searchDevices;

        activate();

        function activate() {
            $log.info('AddInventoryModalController activated.');
        }

        function add(inventory) {
            if (angular.isDefined(inventory) && angular.isString(inventory.key)) {
                Callback(inventory);
                $mdDialog.hide();
            }
        }

        function searchDevices(searchText) {

            var params = {
                type:'Device',
                search: searchText,
                unassigned: true,
                loose: true,
                limit:20
            };

            return Inventory.search(params)
                .$promise.then(function (response) {
                    return angular.isDefined(response.items) ? response.items : [];
                });
        }

        function searchTrays(searchText) {

            var params = {
                type: 'Container',
                search: searchText,
                unassigned: true,
                limit:20
            };
            return Inventory.search(params)
                .$promise.then(function (response) {
                    return angular.isDefined(response.items) ? response.items : [];
                })

        }

    }
})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('InventoryProductsEditController', InventoryProductsEditController);

    InventoryProductsEditController.$inject = ['Accounts', 'ProductTemplates', 'TrayTemplates', 'Guides', '$scope',
        '$stateParams', '$log', 'Toast', 'Show', 'currentAuth', 'Orgs', 'Inventory', 'Products', '$timeout', '$state',
    'ConfirmUnsavedChanges', '$rootScope'];

    function InventoryProductsEditController(Accounts, ProductTemplates, TrayTemplates, Guides, $scope,
                 $stateParams, $log, Toast, Show, currentAuth, Orgs, Inventory, Products, $timeout, $state,
                                             ConfirmUnsavedChanges, $rootScope) {
        $state.activeTabsInventory = "index.inventory.products";

        var vm = this;
        vm.inventoryList = [];
        vm.viewInventory = viewInventory;
        vm.finish = finish;
        vm.searchGuides = searchGuides;
        vm.manufacturer = currentAuth.org.manufacturer;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            loadProduct();

        }

        loadInventory()

        function loadInventory (){
            Inventory.search(successInv, errInv);

            function successInv(res){
                vm.inventoryAllList = res.items;
            }
            function errInv(err){

                $log.info(err)
            }
        }

        function generateTableInventory(){
            /*
                Generate table inventory with current product
             */
            if(!vm.product || !vm.inventoryAllList){
                $timeout(function(){
                    generateTableInventory()
                }, 1000)
                return
            }

            var productKey = vm.product.key;

            vm.inventoryList = vm.inventoryAllList.filter(function(invent){
               return  invent.product.key === productKey
            })

        }

        function viewInventory(key) {
            if (angular.isUndefined(key)) return;
            $state.go('index.inventory.edit', {objectKey: key})
        }

        function loadProduct() {

            Inventory.getProduct({objectKey: $stateParams.objectKey}, success, error);

            function success(response) {
                vm.product = response;

                if(!vm.product.assetUrl){
                    vm.product.assetUrl = ""
                }
                if(!vm.product.images){
                    vm.product.images = []
                }
                if(!vm.product.guides){
                    vm.product.guides = [];
                }
                if(!vm.product.ifuUrls) {
                    vm.product.ifuUrls = [];
                }
                $scope.$emit('loading', false);

                generateTableInventory()

                //Watch changes to prompt
                $timeout(function(){
                    watchChanges()
                })

            }

            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                $log.info(angular.toJson(error));
                $scope.$emit('loading', false);
                Toast.error(error);
            }

        }



        function finish(vm) {
            if(!vm){
                vm = this;
            }

            vm.isLoading = true;

            // In backend endpoint wait strings
            if(!vm.product.assetUrl){
                vm.product.assetUrl = ""
            }
            if(!vm.product.images){
                vm.product.images = []
            }
            if(!vm.product.guides){
                vm.product.guides = [];
            }
            if(!vm.product.ifuUrls) {
                vm.product.ifuUrls = [];
            }


            var params = {
                //manufacturer: vm.manufacturer.key,
                objectKey: vm.product.key
            };
            Inventory.updateProduct(params, vm.product, success, error);

            function success(response) {
                vm.product = response;
                vm.isLoading = false;
                Toast.success('Saved!');
                vm.isChange = false;
            }

            function error(error) {
                vm.isLoading = false;
                $log.error(angular.toJson(error));
                Toast.error(error);
            }

        }

        // Below Functional related with prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.product', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            if(!vm.product.assetUrl){
                vm.product.assetUrl = '';
            }
            if(!vm.product.name) {
                vm.product.name = '';
            }
            var validateArray = [vm.product.name];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;

        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

        function searchGuides(search) {
            if (angular.isUndefined(search)) return [];
            return Guides.search({search: search}).$promise.then(function (response) {
                if (angular.isUndefined(response.items)) {
                    response.items = [];
                }
                var commonItems = removeIdenticaltems(response.items, vm.product.guides);
                return commonItems
            });
        }

        /*Remove from existing in second array items
          where - object, with property name = string
          what - array strings
       */
        function removeIdenticaltems(where, what) {
            var result = [];
            where.forEach(function(v) {
                var isExist = false;
                what.every(function(w){
                    if (v.name === w.name) {
                        isExist = true;
                        return false
                    }
                    return true
                })
                if(!isExist){
                    result.push(v);
                }
            });
            return result;
        }
    }

})();

(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .factory('NewInvProductModal', NewInvProductModal);

    NewInvProductModal.$inject = ['$mdDialog'];

    function NewInvProductModal($mdDialog) {


        function show(manufactures, callback, selectedManufacture) {
            $mdDialog.show({
                locals: { 'Manufactures':manufactures, 'Callback': callback || function() {}, 'SelectedManufacture': selectedManufacture},
                controller: 'ProductCreateModalController',
                controllerAs: 'vm',
                templateUrl:'app/inventory/products/addModal/addProducts.modal.tmpl.html',
                clickOutsideToClose:true
            });
        }

        return {
            show : show,
        };

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('ProductCreateModalController', ProductCreateModalController);

    ProductCreateModalController.$inject = ['$log', '$mdDialog', 'Toast', 'Callback', 'Products', 'Manufactures',
        'SelectedManufacture', 'Guides'];

    function ProductCreateModalController($log, $mdDialog,  Toast, Callback, Products, Manufactures,
                                          SelectedManufacture, Guides) {

        var vm = this;

        vm.product = {};
        vm.cancel = $mdDialog.hide;
        vm.Manufactures = Manufactures;
        vm.saving = false;
        vm.save = save;
        vm.searchGuides = searchGuides;

        setupDefaults()

        function setupDefaults() {
            if (angular.isUndefined(vm.product.ifuUrls)) {
                vm.product.ifuUrls = [];
            }

            vm.product = {
                assetUrl: "",
                guides: [],
                ifuUrls: []
            }
            if(SelectedManufacture){
                vm.product.manufacturer = SelectedManufacture
            }
        }

        function save() {

            vm.saving = true;

            if(!vm.product.images){
                vm.product.images = []
            }
            if(!vm.product.assetUrl){
                vm.product.assetUrl = "";
            }
            if(!vm.product.guides){
                vm.product.guides = [];
            }
            //Clear excess code
            if(vm.product.guides.length){
                vm.product.guides.forEach(function(guide){
                    delete guide.steps
                })
            }
            $log.info('vm.product')
            $log.info(vm.product)

            Products.insert(vm.product, success, error);


            function success(response) {
                vm.isLoading = false;
                Callback(response);
                $mdDialog.hide();
                Toast.success('Saved!');
            }

            function error(error) {
                vm.isLoading = false;
                $log.error(error);
                Toast.error(error);
            }

        }

        function searchGuides(search) {
            if (angular.isUndefined(search)) return [];
            return Guides.search({search: search}).$promise.then(function (response) {
                if (angular.isUndefined(response.items)) {
                    response.items = [];
                }
                var commonItems = removeIdenticaltems(response.items, vm.product.guides);
                return commonItems
            });
        }

        /*Remove from existing in second array items
          where - object, with property name = string
          what - array strings
       */
        function removeIdenticaltems(where, what) {
            var result = [];
            where.forEach(function(v) {
                var isExist = false;
                what.every(function(w){
                    if (v.name === w.name) {
                        isExist = true;
                        return false
                    }
                    return true
                })
                if(!isExist){
                    result.push(v);
                }
            });
            return result;
        }

    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.import', []);

})();

(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory.import')
        .factory('ImportStatusModal', ImportStatusModal);

    ImportStatusModal.$inject = ['$mdDialog', '$log', 'Inventory', '$timeout'];

    function ImportStatusModal($mdDialog, $log, Inventory, $timeout) {


        function watchStatus(response) {

            var key = response.key || '';
            var timer;
            var error = 0;
            var count = 0;
            var timeout = 5000

            $timeout(function(){
                watchProgress()
            }, 1000)

            function watchProgress(){
                count += 1;
                timeout = count > 30 ? 10000 : 5000;
                if(key.length && error < 5){
                    Inventory.importProgress({objectKey: key}, function(res){
                        clearInterval(timer)
                        if(res.success === true){
                            modal();
                            return
                        }
                        error = res.error ? error+= 1 : error;
                        timer = setInterval(function(){
                                watchProgress();
                        }, timeout)
                    }, function(err){
                        $log.info(err)
                        error+=1;
                    })
                }
                else {
                    key = '';
                    clearInterval(timer)
                    $log.info('watchProgress else')
                    modal()
                }
            }

            function modal(){
                $mdDialog.show({
                    locals: { 'ImportKey': key},
                    controller: 'ImportStatusModalController',
                    controllerAs: 'vm',
                    templateUrl:'app/inventory/import/importStatusModal/import.status.tmpl.html',
                    clickOutsideToClose:true
                });
            }

        }

        return {
            watchStatus : watchStatus,
        };

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory.import')
        .controller('ImportStatusModalController', ImportStatusModalController);

    ImportStatusModalController.$inject = ['$mdDialog', 'ImportKey'];

    function ImportStatusModalController( $mdDialog, ImportKey) {

        var vm = this;
        vm.importKey = ImportKey;
        vm.cancel = $mdDialog.hide;

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('FilterInventoryModalController', FilterInventoryModalController);

    FilterInventoryModalController.$inject = ['$filter', '$log', '$mdDialog', 'Inventory', 'Callback', 'Accounts',
        'InventoryFilters', '$timeout', '$q'];

    function FilterInventoryModalController($filter, $log, $mdDialog, Inventory, Callback, Accounts, InventoryFilters,
                                            $timeout, $q) {

        var vm = this;
        vm.cancel = $mdDialog.hide;
        vm.values = {};

        vm.statuses = InventoryFilters.statuses;
        vm.dueBack = InventoryFilters.overdueUserNames;
        vm.expirationOptions = InventoryFilters.expirationOptions;

        activate();

        vm.searchCustody = searchCustody;
        vm.searchContainers = searchContainers;
        vm.add = add;
        vm.isSearching = null;
        vm.isSearchContainerTextChanged = false;
        vm.cacheContainers = [];

        function activate() {
            $log.info('FilterInventoryModalController activated.');
        }

        function searchCustody(searchText) {
            return Accounts.list({}).$promise.then(function (response) {
                var options = [];
                var items = response.items || [];
                angular.forEach(items, function (a) {
                    if (a.accountType === 'Individual') {
                        options.push(a);
                    }
                });

                return Accounts.me({}).$promise.then(function (me) {
                    options.push(me.org);
                    return $filter('filter')(options, searchText);
                });

            });
        }

        function sleep(ms) {
            return new Promise(function(resolve){
                vm.isSearching = setTimeout(resolve, ms)
            } );
        }

         function searchContainers(searchText) {
            clearTimeout(vm.isSearching);

            if(!vm.isSearchContainerTextChanged){
                return vm.cacheContainers
            }

            return sleep(1500).then(function(){
                var params = {
                    search: searchText,
                    type: 'Container',
                    size: 300
                };
                vm.isFocused = true;

                return  Inventory.basicSearch(params).$promise
                    .then(function (response) {
                        vm.isSearchContainerTextChanged = false;
                        vm.cacheContainers = response.items || [];
                        setTimeout(function(){
                            document.querySelector('#autoCompleteSearchContainer').focus();
                        }, 100)
                        return response.items || [];
                    })
                    .catch(function(error){
                        $log.info(error)
                    })
            })

             function requestSearchContainer(){

             }

        }


        function add() {
            if(vm.values.dueBack){
                vm.values.dueBack = changeOverdueOptionsNames(vm.values.dueBack)
            }

            Callback(InventoryFilters.init(vm.values));
            $mdDialog.cancel();

        }


        function changeOverdueOptionsNames(strname){

            if(strname === "Over 48 hours"){
                return "OVER_48_HOURS"
            }
            if(strname === "In 48 hours"){
                return "IN_48_HOURS"
            }
            if(strname === "In 24 hours"){
                return "IN_24_HOURS"
            }
            if(strname === "Overdue"){
                return "OVERDUE"
            }
            return ""
        }

    }
})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('MissedDevices', MissedDevices);

    MissedDevices.$inject = ['$log', 'Inventory', 'Toast', '$mdDialog', '$timeout', 'MissedItems', 'Callback'];

    function MissedDevices($log, Inventory, Toast, $mdDialog, $timeout, MissedItems, Callback) {

        var vm = this;
        vm.missedItems = MissedItems;
        vm.callback = Callback;
        $log.info(vm.missedItems)

        vm.cancel = function(){
            vm.callback();
            $mdDialog.hide();
        }

        document.addEventListener('keydown', function(event){
            if(event.code === 'Escape'){
                event.stopPropagation();
                return false
            }
        }, true);
    }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.procedures', []);

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.procedures')
    .factory('NewProcedureModal', NewProcedureModal);

  NewProcedureModal.$inject = ['$mdDialog'];

  function NewProcedureModal($mdDialog) {


    function show(searchText, callback) {
      $mdDialog.show({
        locals: { 'SearchText':searchText, 'Callback': callback || function() {}},
        controller: 'ProcedureModalController',
        controllerAs: 'vm',
        templateUrl:'app/directory/procedures/modal/procedure.modal.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.procedures')
    .controller('ProcedureModalController', ProcedureModalController);

  ProcedureModalController.$inject = ['$log', '$mdDialog', 'Procedures', 'Toast', 'SearchText', 'Callback'];

  function ProcedureModalController($log, $mdDialog, Procedures, Toast, SearchText, Callback) {

    var vm = this;

    vm.procedure = {
      name: SearchText
    };
    vm.cancel = $mdDialog.hide;
    vm.save = save;

    activate();

    function activate() {
      $log.info('ProcedureModalController activated.')
    }

    function save() {

      if (!(angular.isString(vm.procedure.name) && angular.isString(vm.procedure.location))) {
        Toast.error('Procedure name and location are required.');
        return;
      }

      vm.saving = true;
      Procedures.insert(vm.procedure, success, error);

      function success(response) {
        vm.saving = false;
        Callback(response);
        $mdDialog.hide();
      }

      function error(response) {
        vm.saving = false;
        Toast.error(response);
      }

    }

  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.procedures')
        .controller('ProceduresEditController', ProceduresEditController);


    ProceduresEditController.$inject = ['$state', '$scope', '$log', '$stateParams',
        'Toast', 'Show', 'Procedures', 'Products', 'currentAuth', '$filter', 'ConfirmUnsavedChanges', '$rootScope',
        '$timeout'];

    function ProceduresEditController($state, $scope, $log, $stateParams, Toast, Show, Procedures,
                                      Products, currentAuth, $filter, ConfirmUnsavedChanges, $rootScope, $timeout) {

        $state.activeTabsDirectory = "index.directory.procedures.list";

        var vm = this;
        vm.isSaving = false;
        vm.finish = finish;
        vm.allProducts = [];
        vm.transformChip = function (chip) {
            return chip.name
        };
        vm.notFound = {};
        vm.notFound.products = false;
        vm.assignedProducts = [];
        vm.buffer = {
            products: []
        };
        vm.searchCustodyProducts = searchCustodyProducts;
        vm.manufacturers = currentAuth.org.manufacturers;
        vm.procedureType = ['Orthopedic','Trauma','Spine','Cardiac','Vascular','Urologic','Thoracic',
            'Plastic/Reconstructive', 'Pediatric','Ophthalmological', 'Neuro', 'Head/Neck',
            'Hand', 'Gynecological', 'Endocrine', 'Colorectal', 'Other']

        activate();

        function activate() {

            $scope.$emit('loading', true);
            populateFields();

        }

        function populateFields() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Procedures.get(getParams, success, error);

            function success(value) {

                vm.procedure = value;
                if(!vm.procedure.products){
                    vm.procedure.products = [];
                }

                $scope.$emit('loading', false);

                vm.isChange = false;
                watchChanges()

            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }

        function finish() {

            if (angular.isUndefined(vm.procedure.key)) return;

            function isNotEmptyField(field){
                if(typeof field === 'undefined' || field === ""){
                    return true
                }
                return false
            }

            if (isNotEmptyField(vm.procedure.name ) ||
                isNotEmptyField(vm.procedure.type )) {
                Toast.error('Fill in required fields.');
                return;
            }

            var params = {
                objectKey: vm.procedure.key
            };

            vm.isSaving = true;

            Procedures.update(params, vm.procedure, success, error);

            function success(response) {
                //vm.procedure = response;
                vm.isSaving = false;
                Toast.success('Saved!');
                vm.isChange = false;
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }

        searchProducts()
        function searchProducts() {

            var index;

            for (index = 0; index < vm.manufacturers.length; ++index) {

                var params = {manufacturer: vm.manufacturers[index].key};

                var searchText = vm.searchText;

                if (angular.isDefined(vm.pageSize)) {
                    params.limit = vm.pageSize;
                }

                if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                    params.cursor = vm.previousPages[vm.previousPages.length - 1];
                }

                if (angular.isDefined(searchText) && searchText.length > 0) {
                    params.search = searchText;
                }

                Products.list(params, success, error);
            }


            function success(response) {
                vm.loading = false;
                var products = response.items || [];
                var allProducts = vm.buffer.products.concat(products)
                vm.buffer.products = allProducts

                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }
        }


        function searchCustodyProducts(searchText) {
            var commonItems = removeIdenticaltems(vm.buffer.products, vm.procedure.products);
            var res = [];
            
            commonItems.forEach(function(el){
                if(el.name.includes(searchText)){
                    res.push(el)
                }
            })
            vm.notFound.products = res.length === 0
            return res
        }

        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            // Watch changes variable
            $scope.$watch('vm.procedure', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.procedure.name, vm.procedure.type];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });
    
        /*Remove from existing in second array items
          where - array objects, with property name = string
          what - array objects
        */
        function removeIdenticaltems(where, what) {
            var result = [];
            if(!what.length) return where
            where.forEach(function(v) {
                var isPush = true;
                what.forEach(function(el){
                    if(v.name === el.name){
                        isPush = false
                        return true
                    }
                })
                if(isPush){
                    result.forEach(function(i, y){
                        if(i.name === v.name){
                            isPush = false;
                            return true
                        }
                    })
                }
                if(isPush){
                    result.push(v)
                }
            });
            return result;
        }
    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.procedures')
        .controller('ProceduresListController', ProceduresListController);

    ProceduresListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Procedures', 'currentAuth' , 'Toast', '$mdDialog'];

    function ProceduresListController($state, $stateParams, $location, $scope,
                                      $log, Procedures, currentAuth , Toast, $mdDialog) {

        $state.activeTabsDirectory = "index.directory.procedures.list";

        var vm = this;

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.searchLoading = false;
        vm.pageSize = 20;
        vm.procedureType = ['Orthopedic','Trauma','Spine','Cardiac','Vascular','Urologic','Thoracic',
            'Plastic/Reconstructive', 'Pediatric','Ophthalmological', 'Neuro', 'Head/Neck',
            'Hand', 'Gynecological', 'Endocrine', 'Colorectal', 'Other']

        vm.previousPages = [];
        var nextPageTokenFacility = null;

        vm.viewProcedure = viewProcedure;
        vm.editProcedure = editProcedure;
        vm.setPageSize = setPageSize;

        vm.hasNextPage = hasNextPage;
        vm.hasPreviousPage = hasPreviousPage;
        vm.loadNextPage = loadNextPage;
        vm.loadPreviousPage = loadPreviousPage;

        function hasNextPage() {
            return angular.isDefined(nextPageTokenFacility);
        }

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }



        function loadNextPage() {
            if (angular.isUndefined(nextPageTokenFacility)) return;
            vm.previousPages.push(nextPageTokenFacility);
            vm.nextPageTokenFacility = undefined;
            query();
        }



        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            query();
        }

        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to deactivate ' +target.name+'?')
                .targetEvent(target)
                .ok('YES')
                .cancel('Close');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                target.active = false;
                deactivate(target)
            }, function() {
                //Close
            });
        };

        function deactivate(procedure) {

            if (angular.isUndefined(procedure.key)) return;

            var params = {
                objectKey: procedure.key
            };

            vm.isSaving = true;

            Procedures.deactivate(params, procedure, success, error);

            function success(response) {
                query()
                vm.isSaving = false;
                Toast.success('Saved!');
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }
        activate();

        function activate() {

            vm.isLoading = true;
            query();

        }

        function query() {
            var params = {
                limit: vm.pageSize
            }
            if(!angular.isUndefined(nextPageTokenFacility)){
                params.cursor = nextPageTokenFacility
            }

            Procedures.search(params, success, error);

            function success(response) {
                vm.procedures = response.items;
                vm.searchLoading = false;
                vm.isLoading = false;
                nextPageTokenFacility = response.nextPageToken;
            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
                Toast.error(response)
            }

        }

        function viewProcedure(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.procedures.detail', { objectKey: deviceKey })
        }
        function editProcedure(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.procedures.edit', { objectKey: deviceKey })
        }

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            vm.previousPages = [];
            query();
        }
    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.procedures')
        .controller('ProceduresDeactivatedListController', ProceduresDeactivatedListController);

    ProceduresDeactivatedListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Procedures', 'currentAuth' , 'Toast', '$mdDialog'];

    function ProceduresDeactivatedListController($state, $stateParams, $location, $scope,
                                      $log, Procedures, currentAuth , Toast, $mdDialog) {

        $state.activeTabsDirectory = "index.directory.procedures.list";

        var vm = this;

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.searchLoading = false;
        vm.pageSize = 20;
        vm.procedureType = ['Orthopedic','Trauma','Spine','Cardiac','Vascular','Urologic','Thoracic',
            'Plastic/Reconstructive', 'Pediatric','Ophthalmological', 'Neuro', 'Head/Neck',
            'Hand', 'Gynecological', 'Endocrine', 'Colorectal', 'Other']


        vm.viewProcedure = viewProcedure;
        vm.editProcedure = editProcedure;
        vm.setPageSize = setPageSize;

        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to reactivate ' +target.name+'?')
                .targetEvent(target)
                .ok('YES')
                .cancel('Close');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                target.active = false;
                deactivate(target)
            }, function() {
                //Close
            });
        };

        function deactivate(procedure) {

            if (angular.isUndefined(procedure.key)) return;

            var params = {
                objectKey: procedure.key
            };

            vm.isSaving = true;

            //Facilities.deactivate(params, facility, success, error);

            Procedures.reactivate(params, procedure, success, error);


            function success(response) {
                query()
                vm.isSaving = false;
                Toast.success('Saved!');
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }
        activate();

        function activate() {

            vm.isLoading = true;
            query();

        }

        function query() {
            var params = {
                limit: vm.pageSize,
                active: false
            }
            Procedures.search(params, success, error);

            function success(response) {
                vm.procedures = response.items;
                vm.searchLoading = false;
                vm.isLoading = false;
            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
                Toast.error(response)
            }

        }

        function viewProcedure(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.procedures.detail', { objectKey: deviceKey })
        }
        function editProcedure(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.procedures.edit', { objectKey: deviceKey })
        }

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            query();
        }
    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.procedures')
        .controller('ProceduresDetailController', ProceduresDetailController);


    ProceduresDetailController.$inject = ['$state', '$scope', '$log', '$stateParams', 'Toast', 'Show', 'Procedures'];

    function ProceduresDetailController($state, $scope, $log, $stateParams, Toast, Show, Procedures) {

        $state.activeTabsDirectory = "index.directory.procedures.list";

        var vm = this;
        vm.procedureType = ['Orthopedic','Trauma','Spine','Cardiac','Vascular','Urologic','Thoracic',
            'Plastic/Reconstructive', 'Pediatric','Ophthalmological', 'Neuro', 'Head/Neck',
            'Hand', 'Gynecological', 'Endocrine', 'Colorectal', 'Other'];

        vm.editProcedure = editProcedure;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            query();

        }

        function query() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Procedures.get(getParams, success, error);

            function success(value) {
                $log.info(value)
                vm.procedure = value;
                $log.info(vm.procedure)
                $scope.$emit('loading', false);
            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }

        function editProcedure(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.procedures.edit', { objectKey: deviceKey })
        }

    }

})();

(function () {
    'use strict';

    /* global angular */
    
    angular
        .module('connectsx.directory.procedures')
        .controller('ProceduresAddController', ProceduresAddController);

    ProceduresAddController.$inject = ['$mdDialog', 'Toast', 'Procedures', 'Products', 'currentAuth',
        '$filter', '$log', '$state', '$scope', 'ConfirmUnsavedChanges', '$rootScope', '$timeout'];

    function ProceduresAddController( $mdDialog, Toast, Procedures, Products, currentAuth, $filter, $log, $state, $scope,
                                      ConfirmUnsavedChanges, $rootScope, $timeout) {

        $state.activeTabsDirectory = "index.directory.procedures.list";

        var vm = this;
        vm.transformChip = function (chip) {
            return chip.name
        };
        vm.procedure = {
            products: []
        };

        vm.buffer = {
            products: []
        }
        vm.notFound = {};
        vm.notFound.products = false;
        vm.finish = finish;
        vm.searchCustodyProducts = searchCustodyProducts;
        vm.manufacturers = currentAuth.org.manufacturers;
        vm.procedureType = ['Orthopedic','Trauma','Spine','Cardiac','Vascular','Urologic','Thoracic',
            'Plastic/Reconstructive', 'Pediatric','Ophthalmological', 'Neuro', 'Head/Neck',
            'Hand', 'Gynecological', 'Endocrine', 'Colorectal', 'Other']

        $scope.$emit('loading', false);
        function finish() {

            function isNotEmptyField(field){
                if(typeof field === 'undefined' || field === ""){
                    return true
                }
                return false
            }

            if (isNotEmptyField(vm.procedure.name) ||
                isNotEmptyField(vm.procedure.type)) {
                Toast.error('Fill in required fields.');
                return;
            }
            vm.saving = true;

            Procedures.insert(vm.procedure, success, error);

            function success(response) {
                onRouteChangeOff();
                vm.saving = false;
                Toast.success(response.status);
                $state.go('index.directory.procedures.detail', { objectKey: response.key })
            }

            function error(response) {
                vm.saving = false;
                Toast.error(response);
                console.log(response)
            }

        }
        
        searchProducts()
        function searchProducts() {

            var index;

            for (index = 0; index < vm.manufacturers.length; ++index) {

                var params = {manufacturer: vm.manufacturers[index].key};

                var searchText = vm.searchText;

                if (angular.isDefined(vm.pageSize)) {
                    params.limit = vm.pageSize;
                }

                if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                    params.cursor = vm.previousPages[vm.previousPages.length - 1];
                }

                if (angular.isDefined(searchText) && searchText.length > 0) {
                    params.search = searchText;
                }

                Products.list(params, success, error);
            }


            function success(response) {
                vm.loading = false;
                var items = response.items || [];
                vm.buffer.products.push.apply(vm.buffer.products, items);

                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }
        }

        function searchCustodyProducts(searchText) {
            var commonItems = removeIdenticaltems(vm.buffer.products, vm.procedure.products);
            var res = [];
            commonItems.forEach(function(el){
                if(el.name.includes(searchText)){
                    res.push(el)
                }
            })
            vm.notFound.products = res.length === 0
            return res
        }
        
        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            // Watch changes variable
            $scope.$watch('vm.procedure', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.procedure.name, vm.procedure.type];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });
    
        /*Remove from existing in second array items
          where - array objects, with property name = string
          what - array objects
        */
        function removeIdenticaltems(where, what) {
            var result = [];
            if(!what.length) return where
            where.forEach(function(v) {
                var isPush = true;
                what.forEach(function(el){
                    if(v.name === el.name){
                        isPush = false
                        return true
                    }
                })
                if(isPush){
                    result.forEach(function(i, y){
                        if(i.name === v.name){
                            isPush = false;
                            return true
                        }
                    })
                }
                if(isPush){
                    result.push(v)
                }
            });
            return result;
        }
    }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.physicians', []);

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.physicians')
    .factory('NewPhysicianModal', NewPhysicianModal);

  NewPhysicianModal.$inject = ['$mdDialog'];

  function NewPhysicianModal($mdDialog) {


    function show(searchText, callback) {
      $mdDialog.show({
        locals: { 'SearchText':searchText, 'Callback': callback || function() {}},
        controller: 'PhysicianModalController',
        controllerAs: 'vm',
        templateUrl:'app/directory/physicians/modal/physician.modal.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.physicians')
    .controller('PhysicianModalController', PhysicianModalController);

  PhysicianModalController.$inject = ['$log', '$mdDialog', 'Physicians', 'Toast', 'SearchText', 'Callback'];

  function PhysicianModalController($log, $mdDialog, Physicians, Toast, SearchText, Callback) {

    var vm = this;

    SearchText = SearchText || "";
    var components = SearchText.split(" ");
    var firstName = "";

    if (components.length > 0) {
      firstName = components[0];
    }

    var lastName = components.slice(1).join(" ");

    vm.physician = {
      firstName: firstName,
      lastName: lastName
    };
    vm.cancel = $mdDialog.hide;
    vm.save = save;

    vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
      'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
      'WY').split(' ').map(function(state) {
      return { abbrev: state };
    });

    activate();

    function activate() {
      $log.info('PhysicianModalController activated.')
    }

    function save() {

      if (!(angular.isString(vm.physician.firstName) && angular.isString(vm.physician.lastName))) {
        Toast.error('First and last name are required.');
        return;
      }

      vm.saving = true;
      Physicians.insert(vm.physician, success, error);

      function success(response) {
        vm.saving = false;
        Callback(response);
        $mdDialog.hide();
      }

      function error(response) {
        vm.saving = false;
        Toast.error(response);
      }

    }

  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('PhysiciansListController', PhysiciansListController);

    PhysiciansListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Physicians', 'currentAuth' , 'Toast', '$mdDialog'];

    function PhysiciansListController($state, $stateParams, $location, $scope,
                                     $log, Physicians, currentAuth , Toast, $mdDialog) {

        $state.activeTabsDirectory = "index.directory.physicians.list";

        var vm = this;

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.pageSize = 20;
        vm.org = currentAuth.org;

        vm.previousPages = [];
        var nextPageTokenFacility = null;

        vm.viewPhysician = viewPhysician;
        vm.editPhysician = editPhysician;
        vm.setPageSize = setPageSize;

        vm.hasNextPage = hasNextPage;
        vm.hasPreviousPage = hasPreviousPage;
        vm.loadNextPage = loadNextPage;
        vm.loadPreviousPage = loadPreviousPage;

        function hasNextPage() {
            return angular.isDefined(nextPageTokenFacility);
        }

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        function loadNextPage() {
            if (angular.isUndefined(nextPageTokenFacility)) return;
            vm.previousPages.push(nextPageTokenFacility);
            vm.nextPageTokenFacility = undefined;
            query();
        }

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            query();
        }

        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to deactivate ' +target.name+'?')
                .targetEvent(target)
                .ok('YES')
                .cancel('Close');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                target.active = false;
                deactivate(target)
            }, function() {
                //Close
            });
        };


        function deactivate(physician) {

            if (angular.isUndefined(physician.key)) return;

            var params = {
                objectKey: physician.key
            };

            vm.isSaving = true;

            Physicians.deactivate(params, physician, success, error);

            function success(response) {
                query()
                vm.isSaving = false;
                Toast.success('Saved!');
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }
        activate();

        function activate() {
            vm.isLoading = true;
            query();

        }
        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            vm.previousPages = [];
            query();
        }

        function query() {

            vm.searchLoading = true;

            var params = {
                limit: vm.pageSize
            }
            if(!angular.isUndefined(nextPageTokenFacility)){
                params.cursor = nextPageTokenFacility
            }

            Physicians.search(params, success, error);

            function success(response) {
                vm.physicians = response.items;
                vm.searchLoading = false;
                vm.isLoading = false;
                nextPageTokenFacility = response.nextPageToken;
            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
            }

        }

        function viewPhysician(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.physicians.detail', { objectKey: deviceKey })
        }
        function editPhysician(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.physicians.edit', { objectKey: deviceKey })
        }

    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('PhysiciansDetailController', PhysiciansDetailController);


    PhysiciansDetailController.$inject = ['$scope', '$log', '$stateParams', 'Physicians','Toast', '$state'];

    function PhysiciansDetailController( $scope, $log, $stateParams, Physicians, Toast, $state) {

        $state.activeTabsDirectory = "index.directory.physicians.list";

        var vm = this;
        vm.editPhysician = editPhysician;
        vm.editPhysicianNotes = null;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            populateFields();

        }

        function populateFields() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Physicians.get(getParams, success, error);

            // Load Physician Notes
            Physicians.notes(getParams, function(res){
                vm.editPhysicianNotes = res.items;
            }, error);


            function success(value) {

                vm.physicians = value;

                $log.info(vm.physicians)
                $scope.$emit('loading', false);
            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }

        function editPhysician(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.physicians.edit', { objectKey: deviceKey })
        }

    }

})();

 (function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('PhysiciansEditController', PhysiciansEditController);


    PhysiciansEditController.$inject = ['$state', '$scope', '$log', '$stateParams', 'Physicians',
        'Toast', 'Show', 'currentAuth', 'Products', '$filter', 'Facilities', 'Procedures', 'ConfirmUnsavedChanges',
    '$rootScope', '$timeout'];

    function PhysiciansEditController($state, $scope, $log, $stateParams, Physicians, Toast, Show,
                                      currentAuth, Products, $filter, Facilities, Procedures, ConfirmUnsavedChanges,
                                      $rootScope, $timeout) {

        $state.activeTabsDirectory = "index.directory.physicians.list";

        var vm = this;
        vm.isSaving = false;
        vm.searchCustodyFacilities = searchCustodyFacilities;
        vm.searchCustodyProcedures = searchCustodyProcedures;
        vm.searchCustodyProducts = searchCustodyProducts;
        vm.finish = finish;
        vm.manufacturers = currentAuth.org.manufacturers;
        vm.transformChip = function (chip) {
            return chip.name
        };
        vm.buffer = {
            products: []
        };
        vm.notFound = {};
        vm.notFound.procedures = false;
        vm.notFound.products = false;
        vm.notFound.facilities = false;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            populateFields();

        }

        function setTabIndex(){
            setTimeout(function(){
                angular.element(document.querySelector( '.setTabIndex12 input' )).attr('tabindex', '12');
                angular.element(document.querySelector( '.setTabIndex13 input' )).attr('tabindex', '13');
                angular.element(document.querySelector( '.setTabIndex14 input' )).attr('tabindex', '14');
            }, 1000)
        }
        setTabIndex();

        function populateFields() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Physicians.get(getParams, success, error);

            function success(value) {
                vm.physicians = value;
                if(!vm.physicians.facilities){
                    vm.physicians.facilities = []
                }
                if(!vm.physicians.procedures){
                    vm.physicians.procedures = []
                }
                if(!vm.physicians.products){
                    vm.physicians.products = []
                }

                $scope.$emit('loading', false);

                vm.isChange = false;
                watchChanges()

            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }

        function finish() {

            if (angular.isUndefined(vm.physicians.key)) return;

            var params = {
                objectKey: vm.physicians.key
            }

            function isNotEmptyField(field){
                if(typeof field === 'undefined' || field === ""){
                    return true
                }
                return false
            }

            if (isNotEmptyField(vm.physicians.name ) ||
                isNotEmptyField(vm.physicians.zipCode) ||
                isNotEmptyField(vm.physicians.state )||
                isNotEmptyField(vm.physicians.city ) ) {
                Toast.error('Fill in required fields.');
                return;
            }

            vm.isSaving = true;
            

            Physicians.update(params, vm.physicians, success, error);

            function success(response) {
             // Update all states
                populateFields();

                vm.isSaving = false;
                Toast.success('Saved!');
                vm.isChange = false;
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }

        function searchCustodyFacilities(searchText) {
            vm.notFound.facilities = false;
            var params = {
                search: searchText,
                limit: 40
            }
            return Facilities.search(params).$promise.then(function (response) {
    
                var items = response.items || [];
    
                var commonItems = removeIdenticaltems(items, vm.physicians.facilities);
    
                if(!commonItems.length) vm.notFound.facilities = true
                
                return commonItems

            });
        }

        function searchCustodyProcedures(searchText) {
            vm.notFound.procedures = false;
            var params = {
                search: searchText,
                limit: 40
            }
            return Procedures.search(params).$promise.then(function (response) {
                var items =  response.items || [];
                var commonItems = removeIdenticaltems(items, vm.physicians.procedures);
                if(!commonItems.length) vm.notFound.procedures = true
                return commonItems
            });
        }

        searchProducts()

        function searchProducts() {

            var index;

            for (index = 0; index < vm.manufacturers.length; ++index) {

                var params = {manufacturer: vm.manufacturers[index].key};

                var searchText = vm.searchText;

                if (angular.isDefined(vm.pageSize)) {
                    params.limit = vm.pageSize;
                }

                if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                    params.cursor = vm.previousPages[vm.previousPages.length - 1];
                }

                if (angular.isDefined(searchText) && searchText.length > 0) {
                    params.search = searchText;
                }

                Products.list(params, success, error);
            }


            function success(response) {
                vm.loading = false;
                var items = response.items || [];
                var allProducts = vm.buffer.products.concat(items);
                vm.buffer.products = allProducts;
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }
        }

        function searchCustodyProducts(searchText) {
            var commonItems = removeIdenticaltems(vm.buffer.products, vm.physicians.products);
            var res = [];
            commonItems.forEach(function(el){
                if(el.name.includes(searchText)){
                    res.push(el)
                }
            })
            vm.notFound.products = res.length === 0
            
            return res
        }

        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.physicians', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.physicians.name, vm.physicians.zipCode, vm.physicians.city,
                vm.physicians.state];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);


            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });
   
/*Remove from existing in second array items
  where - array objects, with property name = string
  what - array objects
*/
        function removeIdenticaltems(where, what) {
            var result = [];
            if(!what.length) return where
            where.forEach(function(v) {
                var isPush = true;
                what.forEach(function(el){
                    if(v.name === el.name){
                        isPush = false
                        return true
                    }
                })
                if(isPush){
                    result.forEach(function(i, y){
                        if(i.name === v.name){
                            isPush = false;
                            return true
                        }
                    })
                }
                if(isPush){
                    result.push(v)
                }
            });
            return result;
        }
    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('PhysiciansAddController', PhysiciansAddController);

    PhysiciansAddController.$inject = [ 'Toast', 'Procedures', 'Facilities', '$log', '$filter', 'Inventory',
        'Physicians', 'Products', 'currentAuth', '$state', '$scope', 'ConfirmUnsavedChanges', '$rootScope', '$timeout'];

    function PhysiciansAddController( Toast, Procedures, Facilities, $log, $filter, Inventory,
                                      Physicians, Products, currentAuth, $state, $scope, ConfirmUnsavedChanges,
                                      $rootScope, $timeout) {

        $state.activeTabsDirectory = "index.directory.physicians.list";

        var vm = this;
        vm.physicians = {
            facilities: [],
            procedures: [],
            products: []
        }
        vm.notFound = {};
        vm.notFound.procedures = false;
        vm.notFound.products = false;
        vm.notFound.facilities = false;

        vm.searchCustodyFacilities = searchCustodyFacilities;
        vm.searchCustodyProcedures = searchCustodyProcedures;
        vm.searchCustodyProducts = searchCustodyProducts;
        vm.finish = finish;
        vm.manufacturers = currentAuth.org.manufacturers;
        vm.allProducts = [];
        vm.transformChip = function (chip) {
            return chip.name
        }
        vm.searchedFacilities = [];
        vm.searchedProcedures = [];

        $scope.$emit('loading', false);


        function setTabIndex(){
           setTimeout(function(){
               angular.element(document.querySelector( '.setTabIndex12 input' )).attr('tabindex', '12');
               angular.element(document.querySelector( '.setTabIndex13 input' )).attr('tabindex', '13');
               angular.element(document.querySelector( '.setTabIndex14 input' )).attr('tabindex', '14');
           }, 1000)
        }
        setTabIndex();

        function finish() {

            function isNotEmptyField(field){
                if(typeof field === 'undefined' || field === ""){
                    return true
                }
                return false
            }

            if (isNotEmptyField(vm.physicians.name ) ||
                isNotEmptyField(vm.physicians.zipCode) ||
                isNotEmptyField(vm.physicians.state )||
                isNotEmptyField(vm.physicians.city ) ) {
                Toast.error('Fill in required fields');
                return;
            }


            var result = JSON.parse(JSON.stringify(vm.physicians));
            vm.saving = true;

            Physicians.insert(result, success, error);

            function success(response) {
                onRouteChangeOff();
                vm.saving = false;
                Toast.success(response.status);
                $state.go('index.directory.physicians.detail', { objectKey: response.key })
            }

            function error(response) {
                vm.saving = false;
                Toast.error(response);
                console.log(response)
            }

        }

        function searchCustodyFacilities(searchText) {
            vm.notFound.facilities = false;
            var params = {
                search: searchText,
                limit: 60
            }
            return Facilities.search(params).$promise.then(function (response) {
                var items = response.items || [];
    
                var commonItems = removeIdenticaltems(items, vm.physicians.facilities);
    
                if(!commonItems.length) vm.notFound.facilities = true
                
                return commonItems
            });
        }

        function searchCustodyProcedures(searchText) {
            vm.notFound.procedures = false;
            var params = {
                search: searchText,
                limit: 60
            }
            return Procedures.search(params).$promise.then(function (response) {
                var items =  response.items || [];
                var commonItems = removeIdenticaltems(items, vm.physicians.procedures);
                
                if(!commonItems.length) vm.notFound.procedures = true
                
                return commonItems
            });
        }

        searchProducts()
        function searchProducts() {

            var index;

            for (index = 0; index < vm.manufacturers.length; ++index) {

                var params = {manufacturer: vm.manufacturers[index].key};

                var searchText = vm.searchText;

                if (angular.isDefined(vm.pageSize)) {
                    params.limit = vm.pageSize;
                }

                if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                    params.cursor = vm.previousPages[vm.previousPages.length - 1];
                }

                if (angular.isDefined(searchText) && searchText.length > 0) {
                    params.search = searchText;
                }

                Products.list(params, success, error);
            }


            function success(response) {
                vm.loading = false;
                vm.products = response.items || [];
                vm.allProducts.push.apply(vm.allProducts, vm.products);

                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }
        }

        function searchCustodyProducts(searchText) {
            var commonItems = removeIdenticaltems(vm.allProducts, vm.physicians.products);
            var res = [];
            commonItems.forEach(function(el){
                if(el.name.includes(searchText)){
                    res.push(el)
                }
            })
            vm.notFound.products = res.length === 0

            return res
        }

/*Remove from existing in second array items
  where - array objects, with property name = string
  what - array objects
*/
        function removeIdenticaltems(where, what) {
            var result = [];
            if(!what.length) return where
            where.forEach(function(v) {
                var isPush = true;
                what.forEach(function(el){
                    if(v.name === el.name){
                        isPush = false
                        return true
                    }
                })
                if(isPush){
                    result.forEach(function(i, y){
                        if(i.name === v.name){
                            isPush = false;
                            return true
                        }
                    })
                }
                if(isPush){
                    result.push(v)
                }
            });
            return result;
        }


        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.physicians', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.physicians.name, vm.physicians.zipCode, vm.physicians.city,
                vm.physicians.state];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('PhysiciansDeactivatedListController', PhysiciansDeactivatedListController);

    PhysiciansDeactivatedListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Physicians', 'currentAuth' , 'Toast', '$mdDialog'];

    function PhysiciansDeactivatedListController($state, $stateParams, $location, $scope,
                                      $log, Physicians, currentAuth , Toast, $mdDialog) {

        $state.activeTabsDirectory = "index.directory.physicians.list";

        var vm = this;

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.pageSize = 20;
        vm.org = currentAuth.org;

        vm.viewPhysician = viewPhysician;
        vm.editPhysician = editPhysician;
        vm.setPageSize = setPageSize;

        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to deactivate ' +target.name+'?')
                .targetEvent(target)
                .ok('YES')
                .cancel('Close');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                target.active = false;
                deactivate(target)
            }, function() {
                //Close
            });
        };

        function deactivate(physician) {

            if (angular.isUndefined(physician.key)) return;

            var params = {
                objectKey: physician.key
            };

            vm.isSaving = true;

            Physicians.reactivate(params, physician, success, error);

            function success(response) {
                query()
                vm.isSaving = false;
                Toast.success('Saved!');
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }
        activate();

        function activate() {
            vm.isLoading = true;
            query();

        }
        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            query();
        }

        function query() {

            vm.searchLoading = true;

            var params = {
                limit: vm.pageSize,
                active: false
            }

            Physicians.search(params, success, error);

            function success(response) {
                vm.physicians = response.items;
                $log.info(vm.physicians)
                vm.searchLoading = false;
                vm.isLoading = false;
            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
            }

        }

        function viewPhysician(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.physicians.detail', { objectKey: deviceKey })
        }
        function editPhysician(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.physicians.edit', { objectKey: deviceKey })
        }

    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('FacilitiesUploadPriceController', FacilitiesUploadPriceController);


    FacilitiesUploadPriceController.$inject = ['$state', '$scope', '$log', '$stateParams', 'Toast',
        'Show', 'Accounts', 'Facilities', 'Orgs', 'currentAuth', '$timeout', '$mdDialog', 'ConfirmUnsavedChanges',
    '$rootScope'];

    function FacilitiesUploadPriceController($state, $scope, $log, $stateParams, Toast,
                                             Show, Accounts, Facilities, Orgs, currentAuth, $timeout, $mdDialog,
                                             ConfirmUnsavedChanges, $rootScope) {

        var vm = this;


        vm.isSaving = false;
        vm.finish = finish
        vm.importCsvPrice = importCsvPrice;
        vm.csvFile = [];
        vm.editCell = editCell;
        vm.totalDisplayed = 100;
        vm.deleteRowFromCSV = deleteRowFromCSV;
        vm.headers = [];
        vm.showSelectColumn = false;
        vm.catalogNumberHeader = '';
        vm.productPriceHeader = '';
        vm.updatePreviews = updatePreviews;
        vm.fullCSV = [];
        vm.catalogNumberHeaderIndex = 0;
        vm.priceHeaderIndex = 1;
        vm.isSaveButtonDisabled = true;

        vm.loadMore = function () {
            vm.totalDisplayed += 100;
        }

        vm.tableTh = {};

        activate();

        function activate() {

            $scope.$emit('loading', true);

            vm.manufacturers = currentAuth.org.manufacturers;

            populateFields();

        }



        function populateFields() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Facilities.get(getParams, success, error);

            function success(value) {

                vm.facility = value;
                $scope.$emit('loading', false);

            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }




        function finish(vm) {
            if(!vm){
                vm = this;
            }

            if (angular.isUndefined(vm.facility.key) || angular.isUndefined(vm.manufacturer) || !vm.csvFile)  return;

            // If  entity haven't price or it's can't covert to decimal, remove this entity
            angular.forEach(vm.csvFile, function(el, ind){

                var parseData = parseFloat(el.price);

                if(isNaN(parseData) || parseData === null){
                    vm.csvFile.splice(ind, 1)
                }
                else {
                    el.price = parseData
                }

            })
            // Create object to save data
            var sendEntity = {};
            sendEntity.facility = {"key":vm.facility.key};
            sendEntity.manufacturer = {"key":vm.manufacturer.key};
            sendEntity.prices = vm.csvFile;

            vm.isSaving = true;

            Facilities.uploadCSV(sendEntity, success, error);

            function success(response) {
                vm.facility = response;
                vm.isSaving = false;
                Toast.success('Saved!');
                vm.isChange = false;
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }

        function importCsvPrice(){
            var csv = [];

            var filename = document.getElementById("fileUpload");

            if (filename.files[0]) {

                var reader = new FileReader();
                reader.onload = function (event) {

                    var rows = event.target.result.split("\n");

                    vm.headers = uniqueHeaders(rows[0].split(","));

                    for (var i = 0; i < rows.length; i++) {
                        var cell = {};
                        var cells = rows[i].split(",");

                        if(i === 0){
                            //Set default value;
                            vm.tableTh = {catalogTh : cells[0], priceTh : cells[1] };
                            vm.catalogNumberHeader = cells[0];
                            vm.productPriceHeader = cells[1];
                            continue
                        }

                        if(cells.length > 1){

                            cell = {catalog : cells[0], price : cells[1] };
                            csv.push(JSON.parse(JSON.stringify(cell)));
                            cell = {}
                        }
                    }

                    saveCsvdata(csv)

                    $timeout(function(){
                        vm.fullCSV = rows;
                    }, 1000)
                }

                reader.readAsText(filename.files[0]);

            }

            function uniqueHeaders(headers) {
                var keys = {};
                for (var i=0; i < headers.length; i++) {

                    var header = headers[i];

                    //if ("" === header) continue;

                    if (angular.isUndefined(keys[header])) {
                        keys[header] = 0;
                        headers[i] = header;
                    } else {
                        keys[header] = keys[header] + 1;
                        headers[i] = header + ' ' + keys[header].toString();
                    }
                }
                return headers;
            }

        }

        function editCell(ev){
            if(!ev) return
            ev.target.parentElement.classList.add('edit')
        }

        function saveCsvdata(csv){
            //Timeout for refresh angular template
            $timeout(function(){
                vm.csvFile = csv;
                checkToDisabledSaveButton()
            })
        }

        function deleteRowFromCSV(index){

            var confirm = $mdDialog.confirm()
                .title('Delete this row ?')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                //Delete
                vm.csvFile.splice(index,1);
            }, function() {
                //Close
            });
        }


        function updatePreviews(ind, colName){
            var colIdex = vm.headers.indexOf(ind);
            if(colName === 'catalogNumberHeader') {
                vm.catalogNumberHeaderIndex = colIdex;
            }
            if(colName === 'productPriceHeader') {
                vm.priceHeaderIndex = colIdex;
            }

            var csv = [];
            var rows = vm.fullCSV;

            for (var i = 0; i <  rows.length; i++) {
                var cell = {};
                var cells = rows[i].split(",");

                if(i === 0){
                    //Set default value;
                    if(colName === 'catalogNumberHeader'){
                        vm.tableTh.catalogTh = cells[vm.catalogNumberHeaderIndex]
                    }
                    if(colName === 'productPriceHeader'){
                        vm.tableTh.priceTh = cells[vm.priceHeaderIndex] ;
                    }

                    continue
                }

                if(cells.length > 1){
                    if(cells[vm.catalogNumberHeaderIndex] || cells[vm.priceHeaderIndex]){
                        cell = {catalog : cells[vm.catalogNumberHeaderIndex], price : cells[vm.priceHeaderIndex] };
                        csv.push(JSON.parse(JSON.stringify(cell)));
                        cell = {}
                    }

                }
            }

            saveCsvdata(csv)

        }

        //Check required fields to disable save button
        function checkToDisabledSaveButton(){
            $timeout(function(){
                if(vm.catalogNumberHeaderIndex === "None" || vm.priceHeaderIndex  === "None"
                || vm.catalogNumberHeaderIndex === -1 ||  vm.priceHeaderIndex  === -1 ){
                    vm.isSaveButtonDisabled = true;
                }
                else {
                    vm.isSaveButtonDisabled = false;
                }
            })
        }


        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.csvFile', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [''];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff();
            vm.csvFile = null;
            vm.fullCSV = null;
        });

    }
})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.facilities', []);

})();

(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.facilities')
        .factory('ModalPriceEdit', ModalPriceEdit);

    ModalPriceEdit.$inject = ['$mdDialog'];

    function ModalPriceEdit($mdDialog) {


        function show(searchText,manufacture, callback) {
            $mdDialog.show({
                locals: { 'SearchText': searchText, 'manufacture': manufacture, 'Callback': callback || function() {}},
                controller: 'FacilityModalPriceEditController',
                controllerAs: 'vm',
                templateUrl:'app/directory/facilities/modalPriceEdit/facility.modalPriceEdit.tmpl.html',
                clickOutsideToClose:true
            });
        }

        return {
            show : show,
        };

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.facilities')
        .controller('FacilityModalPriceEditController', FacilityModalPriceEditController);

    FacilityModalPriceEditController.$inject = ['$log', '$mdDialog', 'Facilities', 'Toast', 'SearchText',
        'Callback',  'manufacture', 'Products', '$scope', '$timeout'];

    function FacilityModalPriceEditController($log, $mdDialog, Facilities, Toast, SearchText,
                                              Callback,  manufacture, Products, $scope, $timeout) {

        var vm = this;

        vm.facility = {
            name: SearchText
        };
        vm.cancel = $mdDialog.hide;
        vm.productsToEdit = [];
        vm.selectedManufacturer = null;
        vm.tableProducts = false;
        vm.showSelectData = true;
        vm.productsSelected = {};
        vm.isLoading = false;

        vm.showSelectedProduct = showSelectedProduct;
        vm.getProducts = getProducts;
        vm.editCell = editCell;
        vm.searchProducts = searchProducts;
        vm.saveProducts = saveProducts;

        activate();

        function activate() {
            $log.info('FacilityModalController activated.')
            vm.manufacturers = manufacture;
        }

        function searchProducts(){
            vm.isLoading = true;
            var params = {
                facilityKey: vm.facility.name.key,
                manufacturerKey: vm.selectedManufacturer.key
            };

            Facilities.getCSV(params, successSearch, errorSearch)

        }

        function successSearch(response) {
            vm.products = response.prices || [];
            vm.isLoading = false;
            vm.loading = false;
        }

        function errorSearch(response) {
            vm.loading = false;
            vm.isLoading = false;
            Toast.error(response);
            vm.products = [];
        }

        function getProducts(isGetAllProducts){
            vm.isLoading = true;
            if(vm.products.length){
                $timeout(function(){
                    vm.tableProducts = true;
                    vm.showSelectData = false;
                    vm.productsToEdit = vm.products;
                    vm.isLoading = false;
                }, 16)
            }
        }

        function editCell(ev){
            if(!ev) return
            ev.target.parentElement.classList.add('edit')
        }

        function showSelectedProduct(){

            vm.products.every(function(prod){
                if(prod.catalog === vm.productsSelected.catalog){
                    vm.productsToEdit = [];
                    vm.productsToEdit.push(prod);
                    vm.showSelectData = false;
                    vm.tableProducts = true;
                    return false
                }
                return true
            })

        }

        // Save product price per facility
        function saveProducts(){
            vm.isLoading = true;
            // If edited only 1 product
            if(vm.productsToEdit.length === 1){
                findProductToReplacePrice()
            }

            var sendEntity = {};
            sendEntity.facility = {"key":vm.facility.name.key};
            sendEntity.manufacturer = {"key":vm.selectedManufacturer.key};
            sendEntity.prices = vm.products;


            Facilities.uploadCSV(sendEntity, success, error);

            function success(response) {
                vm.isLoading = false;
                Toast.success('Saved!');
                $mdDialog.hide();
                vm.products = [];
            }

            function error(response) {
                vm.isLoading = false;
                Toast.error(response);
            }

            function findProductToReplacePrice (){
                vm.products.every(function(prod){
                    if(prod.catalog === vm.productsSelected.catalog){
                        prod = vm.productsSelected;
                        return false
                    }
                    return true
                })
            }

        }



    }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.facilities')
    .factory('NewFacilityModal', NewFacilityModal);

  NewFacilityModal.$inject = ['$mdDialog'];

  function NewFacilityModal($mdDialog) {


    function show(searchText, callback) {
      $mdDialog.show({
        locals: { 'SearchText': searchText, 'Callback': callback || function() {}},
        controller: 'FacilityModalController',
        controllerAs: 'vm',
        templateUrl:'app/directory/facilities/modal/facility.modal.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.facilities')
    .controller('FacilityModalController', FacilityModalController);

  FacilityModalController.$inject = ['$log', '$mdDialog', 'Facilities', 'Toast', 'SearchText', 'Callback'];

  function FacilityModalController($log, $mdDialog, Facilities, Toast, SearchText, Callback) {

    var vm = this;

    vm.facility = {
      name: SearchText
    };
    vm.cancel = $mdDialog.hide;
    vm.save = save;

    vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
      'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
      'WY').split(' ').map(function(state) {
      return { abbrev: state };
    });

    activate();

    function activate() {
      $log.info('FacilityModalController activated.')
    }

    function save() {

      if (!(angular.isString(vm.facility.name))) {
        Toast.error('Name is required.');
        return;
      }

      vm.saving = true;
      Facilities.insert(vm.facility, success, error);

      function success(response) {
        vm.saving = false;
        Callback(response);
        $mdDialog.hide();
      }

      function error(response) {
        vm.saving = false;
        Toast.error(response);
      }

    }

  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('FacilitiesListController', FacilitiesListController);

    FacilitiesListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Facilities', 'currentAuth' , 'Toast', 'Show', '$mdDialog', 'ModalPriceEdit' ];

    function FacilitiesListController($state, $stateParams, $location, $scope,
                                      $log, Facilities, currentAuth , Toast, Show, $mdDialog, ModalPriceEdit ) {

        $state.activeTabsDirectory = "index.directory.facilities.list";

        var vm = this;

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.searchLoading = false;

        vm.previousPages = [];
        var nextPageTokenFacility = null;

        vm.facilities = [];
        vm.pageSize = 20;
        vm.setPageSize = setPageSize;
        vm.viewFacility = viewFacility;
        vm.editFacility = editFacility;
        vm.editPrice = editPrice;

        vm.hasNextPage = hasNextPage;
        vm.hasPreviousPage = hasPreviousPage;
        vm.loadNextPage = loadNextPage;
        vm.loadPreviousPage = loadPreviousPage;

        function hasNextPage() {
            return angular.isDefined(nextPageTokenFacility);
        }

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }



        function loadNextPage() {
            if (angular.isUndefined(nextPageTokenFacility)) return;
            vm.previousPages.push(nextPageTokenFacility);
            vm.nextPageTokenFacility = undefined;
            query();
        }



        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            query();
        }




        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to deactivate ' +target.name+'?')
                .targetEvent(target)
                .ok('YES')
                .cancel('Close');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                target.active = false;
                deactivate(target)
            }, function() {
                //Close
            });
        };
        activate();

        function activate() {
            vm.isLoading = true;
            query();

        }

        function deactivate(facility) {

            if (angular.isUndefined(facility.key)) return;

            var params = {
                objectKey: facility.key
            };

            vm.isSaving = true;

            Facilities.deactivate(params, facility, success, error);

            function success(response) {
                query()
                vm.isSaving = false;
                Toast.success('Saved!');
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }

        function query() {

            vm.searchLoading = true;
            vm.isLoading = true;

            var params = {
                limit: vm.pageSize
            }

            if(!angular.isUndefined(nextPageTokenFacility)){
                params.cursor = nextPageTokenFacility
            }

            Facilities.search(params, successQuery, error);

            function successQuery(response) {
                vm.facilities = response.items;
                vm.searchLoading = false;
                vm.isLoading = false;
                nextPageTokenFacility = response.nextPageToken;
            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
                Toast.error(response)
            }

        }

        function viewFacility(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.facilities.detail', { objectKey: deviceKey })
        }
        function editFacility(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.facilities.edit', { objectKey: deviceKey })
        }

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            vm.previousPages = [];
            query();
        }

        function editPrice(facility) {
            ModalPriceEdit.show(facility, currentAuth.org.manufacturers)
        }

    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('FacilitiesEditController', FacilitiesEditController);


    FacilitiesEditController.$inject = ['$state', '$scope', '$log', '$stateParams', 'Toast',
        'Show', 'Accounts', 'Facilities', 'ConfirmUnsavedChanges', '$rootScope', '$timeout'];

    function FacilitiesEditController($state, $scope, $log, $stateParams, Toast, Show, Accounts, Facilities,
                                      ConfirmUnsavedChanges, $rootScope, $timeout) {

        $state.activeTabsDirectory = "index.directory.facilities.list";

        var vm = this;


        vm.isSaving = false;
        vm.finish = finish
        vm.viewUploadPrice = viewUploadPrice

        activate();

        function activate() {

            $scope.$emit('loading', true);
            populateFields();

        }

        function populateFields() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Facilities.get(getParams, success, error);

            function success(value) {

                vm.facility = value;
                $log.info(vm.facility )
                $scope.$emit('loading', false);

                vm.isChange = false;
                watchChanges()

            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }




        function finish() {

            if (angular.isUndefined(vm.facility.key)) return;

            var params = {
                objectKey: vm.facility.key
            };
            function isNotEmptyField(field){
                if(typeof field === 'undefined' || field === ""){
                    return true
                }
                return false
            }

            if (isNotEmptyField(vm.facility.name) ||
                isNotEmptyField(vm.facility.providerState) ||
                isNotEmptyField(vm.facility.providerZip) ||
                isNotEmptyField(vm.facility.providerCity ) ||
                isNotEmptyField(vm.facility.providerAddress) ) {
                Toast.error('Fill in required fields');
                return;
            }
            vm.isSaving = true;
            Facilities.update(params, vm.facility, success, error);

            function success(response) {
                vm.facility = response;
                vm.isSaving = false;
                Toast.success('Saved!');
                vm.isChange = false;
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }


        function viewUploadPrice(key){
            if (angular.isUndefined(key)) return;
            $state.go('index.directory.facilities.uploadprice', { objectKey: key })
        }



        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.facility', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.facility.name, vm.facility.providerState, vm.facility.providerAddress,
                vm.facility.providerCity, vm.facility.providerZip];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.facilities')
        .controller('FacilitiesDetailController', FacilitiesDetailController);


    FacilitiesDetailController.$inject = ['$state', '$scope', '$log', '$stateParams',
        'Toast', 'Show',  'Accounts', 'Facilities'];

    function FacilitiesDetailController($state, $scope, $log, $stateParams, Toast, Show, Accounts,  Facilities) {

        $state.activeTabsDirectory = "index.directory.facilities.list";

        var vm = this;
        vm.editFacility = editFacility;
        vm.viewUploadPrice = viewUploadPrice;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            query();

        }

        function query() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Facilities.get(getParams, success, error);

            function success(value) {

                vm.facility = value;
                $scope.$emit('loading', false);
            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }

        function editFacility(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.facilities.edit', { objectKey: deviceKey })
        }

        function viewUploadPrice(key){
            if (angular.isUndefined(key)) return;
            $state.go('index.directory.facilities.uploadprice', { objectKey: key })
        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.physicians')
        .controller('FacilitiesDeactivatedListController', FacilitiesDeactivatedListController);

    FacilitiesDeactivatedListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Facilities', 'currentAuth' , 'Toast', 'Show', '$mdDialog'];

    function FacilitiesDeactivatedListController($state, $stateParams, $location, $scope,
                                      $log, Facilities, currentAuth , Toast, Show, $mdDialog) {

        var vm = this;

        $state.activeTabsDirectory = "index.directory.facilities.list";

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.searchLoading = false;

        vm.facilities = [];
        vm.pageSize = 20;
        vm.setPageSize = setPageSize;
        vm.viewFacility = viewFacility;
        vm.editFacility = editFacility;

        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to reactivate ' +target.name+'?')
                .targetEvent(target)
                .ok('YES')
                .cancel('Close');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                target.active = false;
                deactivate(target)
            }, function() {
                //Close
            });
        };
        activate();

        function activate() {

            vm.isLoading = true;
            query();

        }

        function deactivate(facility) {

            if (angular.isUndefined(facility.key)) return;

            var params = {
                objectKey: facility.key
            };

            vm.isSaving = true;

            //Facilities.deactivate(params, facility, success, error);

            Facilities.reactivate(params, facility, success, error);


            function success(response) {
                query()
                vm.isSaving = false;
                Toast.success('Saved!');
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }
        function query() {

            vm.searchLoading = true;

            var params = {
                limit: vm.pageSize,
                active: false
            }

            Facilities.search(params, success, error);

            function success(response) {
                vm.facilities = response.items;
                vm.searchLoading = false;
                vm.isLoading = false;
            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
                Toast.error(response)
            }

        }

        function viewFacility(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.facilities.detail', { objectKey: deviceKey })
        }
        function editFacility(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.directory.facilities.edit', { objectKey: deviceKey })
        }

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            query();
        }

    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.facilities')
        .controller('FacilitiesAddController', FacilitiesAddController);

    FacilitiesAddController.$inject = ['Toast', 'Facilities', '$state', '$log', '$scope', 'ConfirmUnsavedChanges',
    '$rootScope', '$timeout'];

    function FacilitiesAddController( Toast, Facilities, $state, $log, $scope, ConfirmUnsavedChanges, $rootScope, $timeout) {

        $state.activeTabsDirectory = "index.directory.facilities.list";

        var vm = this;
        vm.facility = {};
        vm.finish = finish;
        $scope.$emit('loading', false);
        function finish() {

            function isNotEmptyField(field){
                if(typeof field === 'undefined' || field === ""){
                    return true
                }
                return false
            }

            if (isNotEmptyField(vm.facility.name ) ||
                isNotEmptyField(vm.facility.providerState ) ||
                isNotEmptyField( vm.facility.providerZip ) ||
                isNotEmptyField(vm.facility.providerCity ) ||
                isNotEmptyField( vm.facility.providerAddress ) ) {
                Toast.error('Fill in required fields');
                return;
            }

            vm.saving = true;
            Facilities.insert(vm.facility, success, error);

            function success(response) {
                onRouteChangeOff();
                vm.saving = false;
                Toast.success(response.status);
                $state.go('index.directory.facilities.detail', { objectKey: response.key })
                vm.isChange = false;
            }

            function error(response) {
                vm.saving = false;
                Toast.error(response);
                console.log(response)
            }

        }


        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.facility', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.facility.name, vm.facility.providerState, vm.facility.providerAddress,
                vm.facility.providerCity, vm.facility.providerZip];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.cases', []);

})();



(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .factory('PopupSelectManufacturer', PopupSelectManufacturer);

    PopupSelectManufacturer.$inject = ['$mdDialog'];

    function PopupSelectManufacturer($mdDialog) {


        function show(manufacturers, callback) {


            $mdDialog.show({
                locals: { 'manufacturers': manufacturers, 'Callback': callback || function() {}},
                templateUrl:'app/cases/edit/popupSelectManufacture/popupSelectManufacture.tmpl.html',
                controller: 'PopupSelectManufactureController',
                controllerAs: 'vm',
                clickOutsideToClose:true
            });
        }

        return {
            show : show
        };

    }

})();








(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .controller('PopupSelectManufactureController', PopupSelectManufactureController);

    PopupSelectManufactureController.$inject = ['manufacturers', 'Callback', '$mdDialog'];

    function PopupSelectManufactureController(manufacturers, Callback, $mdDialog) {
        var vm = this;

        vm.manufacturers = manufacturers;
        vm.selectedManufacturer = null;
        vm.sendManufacture = sendManufacture;
        vm.cancel = $mdDialog.hide;

        function sendManufacture(){

            Callback(vm.selectedManufacturer)
        }
    }
})();
(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .factory('PopupAddPONumber', PopupAddPONumber);

    PopupAddPONumber.$inject = ['$mdDialog'];

    function PopupAddPONumber($mdDialog) {


        function show(manufacturers, poNumbers, callback) {


            $mdDialog.show({
                locals: { 'manufacturers': manufacturers, PONumbers:poNumbers,  'Callback': callback || function() {}},
                templateUrl:'app/cases/edit/poNumber/poNumber.tmpl.html',
                controller: 'PopupAddPONumberController',
                controllerAs: 'vm',
                clickOutsideToClose:true
            });
        }

        return {
            show : show
        };

    }

})();








(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .controller('PopupAddPONumberController', PopupAddPONumberController);

    PopupAddPONumberController.$inject = ['manufacturers', 'Callback', '$mdDialog', '$log', 'PONumbers'];

    function PopupAddPONumberController(manufacturers, Callback, $mdDialog, $log, PONumbers) {
        var vm = this;

        vm.manufacturers = [];
        vm.selectedManufacturer = null;
        vm.sendPO = sendPO;
        vm.cancel = $mdDialog.hide;
        vm.poNumber = '';
        vm.selectAllManufactures = false;
        vm.selectedManufacturer = {};
        vm.choseAll = choseAll;
        vm.checkIsSelectedManufacture = checkIsSelectedManufacture;
        vm.isFilledPOMnufacture = false;


        if(PONumbers){
            console.log(PONumbers)
        }

        vm.manufacturers = manufacturers.map(function(manuf){
            Object.keys(PONumbers).forEach(function(po){
                if(po === manuf.key){
                    manuf.poNumber = PONumbers[po]
                }
            })

            return manuf
        });

        (function(){
            vm.isFilledPOMnufacture = true;
            vm.manufacturers.forEach(function(manuf){
                if(!manuf.poNumber || !manuf.poNumber.length){
                    vm.isFilledPOMnufacture = false;
                }
            })
        }());



        function choseAll(){
            var arr = vm.manufacturers.map(function(manuf){
                manuf.poNumber = vm.poNumber
                return manuf
            });

            vm.isFilledPOMnufacture = vm.poNumber.length ? true : false;

            vm.manufacturers = [];
            vm.manufacturers = arr;
        }

        function checkIsSelectedManufacture(){
            $log.info('checkIsSelectedManufacture')
            vm.isFilledPOMnufacture = true;
            vm.manufacturers.forEach(function (manuf) {
                if(!manuf.poNumber || !manuf.poNumber.length){
                    $log.info('No')
                    vm.isFilledPOMnufacture = false;
                }
            });

        }

        function sendPO(){
            var res = {};

            if(vm.selectAllManufactures && vm.poNumber.length){
                vm.manufacturers.forEach(function(man){
                    res[man.key] = vm.poNumber
                })
            }
            else {
                vm.manufacturers.forEach(function(man){
                    if(man.poNumber.length){
                        res[man.key] = man.poNumber
                    }
                })
            }

            Callback(res)

            vm.cancel();
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('connectsx.settings.personal', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.personal')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.settings.personal', {
        url: '/personal',
        templateUrl: 'app/settings/personal/personal.html',
        controller:'PersonalController',
        controllerAs:'vm'
      });

  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.settings.personal')
    .controller('PersonalController', PersonalController);

  PersonalController.$inject = ['currentAuth', 'Accounts', 'Toast', '$log', 'ConfirmUnsavedChanges', '$rootScope',
    '$timeout', '$scope'];

  function PersonalController(currentAuth, Accounts, Toast, $log, ConfirmUnsavedChanges, $rootScope, $timeout, $scope) {

    var vm = this;

    vm.save = save;
    vm.isSaving = false;

    activate();

    function activate() {
      vm.account = currentAuth;
    }

    function save(vm) {
      if(!vm){
        vm = this;
      }

      if (vm.isSaving) return;
      $log.info('Account save');
      vm.isSaving = true;

      Accounts.update({ objectKey:vm.account.key }, vm.account, success, error);

      function success(response) {
        vm.account = response;
        vm.isSaving = false;
        Toast.success('Success!')
        vm.isChange = false;
      }

      function error(response) {
        vm.isSaving = false;
        $log.error(response);
        if(response.data){
          Toast.error(response.data.error.message);
        }
        else {
          Toast.error('Error');
        }

      }

    }

    // Below Functional related to prompt when edit form & have unsaved changes
    function watchChanges() {
      vm.isChange = false;
      $scope.$watch('vm.account', function (newVal, oldVal) {
        if(newVal !== oldVal){
          $log.info('Change')
          vm.isChange = true;
        }
      }, true);
    }

    function routeChange(event, newUrl, oldUrl) {
      //Array fields to validate
      var validateArray = [vm.account.name, vm.account.email];
      return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.save, vm, validateArray)
    }

    // OnInit add event listener to change route
    var onRouteChangeOff;
    this.$onInit = function() {
      $timeout(function(){
        onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
        watchChanges()
      }, 1000)
    }

    // Stop listened event $stateChangeStart
    $scope.$on("$destroy", function(event) {
      onRouteChangeOff()
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.org', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.settings.org')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.settings.org', {
        url: '/org',
        templateUrl: 'app/settings/org/settings.org.html',
        controller: 'SettingsOrgController',
        controllerAs: 'vm'
      });
  }

})();



(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.settings.org')
        .controller('SettingsOrgController', SettingsOrgController);

    SettingsOrgController.$inject = ['$log', 'currentAuth', 'Orgs', 'Toast', 'ConfirmUnsavedChanges', '$rootScope',
        '$timeout', '$scope'];

    function SettingsOrgController($log, currentAuth, Orgs, Toast, ConfirmUnsavedChanges, $rootScope, $timeout, $scope) {

        var vm = this;

        vm.isSaving = false;
        vm.save = save;
        vm.org = {};

        activate();

        function activate() {

            Orgs.get({objectKey: currentAuth.org.key}, success, error);

            function success(org) {
                vm.org = org;
            }

            function error(response) {
                $log.error(response);
                Toast.error(response);
            }

        }

        function save() {

            $log.info('Save org');

            if (!angular.isObject(vm.org)) {
                return;
            }

            if (!angular.isString(vm.org.key)) {
                return;
            }

            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            Orgs.update({objectKey: vm.org.key}, vm.org, success, error);

            function success(response) {
                vm.org = response;
                vm.isSaving = false;
                Toast.success('Success!');
                vm.isChange = false;
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(response);
                Toast.error(response);
            }


        }


        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.org', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.org.name, vm.org.email];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.save, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings', []);

})();

(function () {
    'use strict';

    angular
        .module('connectsx.settings')
        .controller('ModalNewPasswordController', ModalNewPasswordController);

    ModalNewPasswordController.$inject = ['$scope', '$mdDialog', '$log'];

    function ModalNewPasswordController($scope, $mdDialog, $log) {

        var vm = this;

        $scope.notMatchPassword = false;

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.saveNewPassword = function(firstPassword, secondPassword) {
            if(firstPassword !== secondPassword){
                $scope.notMatchPassword = true;
                return
            }
            $scope.notMatchPassword = false;
            $mdDialog.hide(firstPassword);

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.settings')
        .controller('ModalCurrentPasswordController', ModalCurrentPasswordController);

    ModalCurrentPasswordController.$inject = ['$scope', '$mdDialog', '$log'];

    function ModalCurrentPasswordController($scope, $mdDialog, $log) {

        var vm = this;

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.sendToverifyPassword = function(currentPassword) {
            $mdDialog.hide(currentPassword);
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.facilities', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.facilities')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.settings.facilities', {
        url: '/facilities',
        templateUrl: 'app/settings/facilities/settings.facilities.html',
        controller:'SettingsFacilitiesController',
        controllerAs:'vm'
      });
  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.settings.facilities')
    .controller('SettingsFacilitiesController', SettingsFacilitiesController);

  SettingsFacilitiesController.$inject = ['Facilities', '$log'];

  function SettingsFacilitiesController(Facilities, $log) {

    var vm = this;
    vm.getFacility = getFacility;
    vm.selectFacility = selectFacility;
    vm.addFavorite = addFavorite;
    vm.removeFavorite = removeFavorite;

    activate();

    function activate() {
      loadFavorites();
    }

    function loadFavorites() {

      Facilities.favorites(success, error);

      function success(favorites) {
        vm.facilities = favorites.items;
      }

    }

    function error(response) {
      $log.error(response);
    }

    function getFacility(searchText) {
      return Facilities.search({ search: searchText }).$promise.then(function(response) {
        return response.items;
      });
    }

    function selectFacility(item) {
      vm.searchFacility = item;
      vm.searchFacilityName = item.name;
    }

    function addFavorite() {
      if (angular.isUndefined(vm.searchFacility) ||
          angular.isUndefined(vm.searchFacility.key)) return;

      var key = vm.searchFacility.key;
      Facilities.addFavorite({ objectKey: key }, {}, loadFavorites, error);

    }

    function removeFavorite(key) {
      if (angular.isUndefined(key))  return;
      Facilities.removeFavorite({objectKey:key}, {}, loadFavorites, error);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.manufacturers')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.settings.manufacturers', {
        url: '/manufacturers',
        templateUrl: 'app/settings/manufacturers/settings.manufacturers.html',
        controller:'SettingsManufacturersController',
        controllerAs:'vm'
      });

  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.settings.manufacturers')
        .controller('SettingsManufacturersController', SettingsManufacturersController);

    SettingsManufacturersController.$inject = ['Gudid', 'Toast', 'Orgs', 'Manufacturers', 'currentAuth', '$log',
    'ConfirmUnsavedChanges', '$rootScope', '$scope', '$timeout'];

    function SettingsManufacturersController(Gudid, Toast, Orgs, Manufacturers, currentAuth, $log, ConfirmUnsavedChanges,
         $rootScope, $scope, $timeout) {

        var vm = this;
        vm.isChange = false;

        vm.checkChanges = checkChanges;

        Orgs.get({objectKey: currentAuth.org.key}, function (response) {
            $log.info(angular.toJson(response));
            vm.org = response;
            var manufacturers = [];
            if (angular.isObject(vm.org.manufacturer)) {
                manufacturers.push(vm.org.manufacturer);
            }
            vm.org.manufacturers = vm.org.manufacturers || manufacturers;

            if (vm.org.manufacturers.length > 0) {
                vm.manufacturer = vm.org.manufacturers[0];
            }

        });

        vm.save = save;

        function save(vm) {
            if(!vm){
                vm = this;
            }
            var manufacturer = vm.manufacturer;

            var method = angular.isUndefined(manufacturer.key) ?
                'insert' : 'update';

            var params = {};

            if (method === 'update') {
                params.objectKey = manufacturer.key;
            }
            else {
                manufacturer.name = vm.gudidManufacturer ? vm.gudidManufacturer.name : vm.manufacturerSearchText;
            }

            Manufacturers[method](params, manufacturer, success, Toast.error);

            function success(response) {

                Toast.success('Success!');
                vm.manufacturer = response;
                if (method === 'insert') {
                    vm.org.manufacturers.push(response);
                }
                else {
                    for (var i = 0; i < vm.org.manufacturers.length; i++) {
                        var m = vm.org.manufacturers[i];
                        if (m.key === response.key) {
                            vm.org.manufacturers[i] = response;
                            return;
                        }
                    }
                }
                vm.isChange = false;
            }
        }

        vm.searchManufacturers = function (searchText) {
            return Gudid.searchManufacturers({search: searchText, limit: 50}).$promise.then(function (response) {
                return response.items || [];
            });
        }



        // Below Functional related to prompt when edit form & have unsaved changes

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.manufacturer.name];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.save, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
            }, 500)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


        function checkChanges($event,manufacturer){
            $log.info('Tabs click')
            vm.manufacturer = manufacturer;
            routeChange($event)

            $timeout(function(){
                vm.isChange = false;
            })


        }


    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.accounts', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.accounts')
    .controller('AddUserController', AddUserController);

  AddUserController.$inject = ['$scope', '$mdDialog', '$log', 'Invitations', 'Toast', 'org'];

  /* eslint-disable angular/controller-as */
  function AddUserController($scope, $mdDialog, $log, Invitations, Toast, org) {

    $scope.roles = [];

    var distributor = null;
    var manufacturer = null;
    if (org.objectType === 'Distributor') {
      $scope.roles = ['DISTRIBUTOR', 'SALES'];
      distributor = org;
    } else if (org.objectType === 'Manufacturer') {
      $scope.roles = [ 'MANUFACTURER', 'SALES' ];
      manufacturer = org;
    }


    $scope.loading = false;

    $scope.submit = function(email, role) {

      if (angular.isUndefined(email) || angular.isUndefined(role)) return;
      $scope.loading = true;

      Invitations.insert({
        email: email,
        accountType: role,
        manufacturer: manufacturer,
        distributor:distributor
      }, submitSuccess, submitError);

    };

    function submitSuccess(invitation) {
      $scope.loading = false;
      Toast.success('Successfully invited ' + invitation.email + '!');
      $mdDialog.cancel();
    }

    function submitError(response) {
      Toast.error(response);
      $log.error(angular.toJson(response));
    }

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.accounts')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.settings.accounts', {
        url: '/accounts',
        templateUrl: 'app/settings/accounts/accounts.html',
        controller:'AccountsController',
        controllerAs:'vm'
      });

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.settings.accounts')
    .controller('AccountsController', AccountsController);

  AccountsController.$inject = ['currentAuth', '$scope', '$log', '$mdDialog', 'Invitations'];

  function AccountsController(currentAuth, $scope, $log, $mdDialog, Invitations) {

    var vm = this;

    vm.addUser = addUser;

    activate();

    function activate() {

      Invitations.get(success, error);

      function success(response) {
        vm.invitations = response.items || [];
      }

      function error(response) {
        $log.error(angular.toJson(response));
      }

    }

    function addUser() {

      $mdDialog.show({
        locals: { 'org': currentAuth.manufacturer },
        controller: AddUserController,
        templateUrl:'app/settings/accounts/add.user.tmpl.html',
        clickOutsideToClose:true
      });

    }

    /* eslint-disable angular/controller-as */
    function AddUserController($scope, $mdDialog, $log, org) {


      $scope.roles = [];

      var distributor = null;
      var manufacturer = null;
      if (org.objectType === 'Distributor') {
        $scope.roles = ['DISTRIBUTOR', 'SALES'];
        distributor = org;
      } else if (org.objectType === 'Manufacturer') {
        $scope.roles = [ 'MANUFACTURER', 'SALES' ];
        manufacturer = org;
      }

      $scope.loading = false;

      $scope.submit = function(email, role) {

        if (angular.isUndefined(email) || angular.isUndefined(role)) return;
        $scope.loading = true;

        Invitations.insert({
          email: email,
          accountType: role,
          manufacturer: manufacturer,
          distributor:distributor
        }, submitSuccess, submitError);

      };

      function submitSuccess(invitation) {
        vm.invitations = vm.invitations || [];
        vm.invitations.push(invitation);
        $scope.loading = false;
        $mdDialog.cancel();
      }

      function submitError(response) {
        $scope.loading = false;
        $log.error(angular.toJson(response));
      }

      $scope.cancel = function() {
        $mdDialog.cancel();
      };

    }

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.onboarding', []);

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.onboarding')
    .controller('WelcomeController', WelcomeController);

    WelcomeController.$inject = ['$state', '$scope', '$http', 'Auth'];

  function WelcomeController($state, $scope, $http, Auth) {

    var vm = this;

    activate();

    function activate() {

      $scope.$emit('loading', false);

    }



  }
})();


(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.onboarding')
    .controller('OnboardingUsersController', OnboardingUsersController);

    OnboardingUsersController.$inject = ['$log', '$state', '$scope', '$http', 'Toast', 'Invitations'];

  function OnboardingUsersController($log, $state, $scope, $http, Toast, Invitations) {

    var vm = this;

    activate();

    vm.roles = ['Manufacturer', 'Sales'];
    vm.users = [];

    var emails = {};

    vm.addUser = addUser;
    vm.inviteUsers = inviteUsers;

    function activate() {

      $scope.$emit('loading', false);

    }

    function addUser(email, role) {

      if (emails.hasOwnProperty(email)) {
        return;
      }

      if (!angular.isString(email) || !angular.isString(role)) {
        return;
      }

      var user = { email: email, accountType: role };
      emails[email] = user;
      vm.users.push(user);

    }

    function inviteUsers() {

      angular.forEach(vm.users, function(user) {
        $log.info(angular.toJson(user));
        Invitations.insert({}, user, success, Toast.error);
      });

      function success(response) {
        Toast.success('Successfully invited ' + response.email + '!');
      }

    }



  }
})();


(function () {
    'use strict';

    angular
        .module('connectsx.inventory.transfers')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.inventory.transfers', {
                url: '/transfers?status&cursor&limit',
                controller: 'TransfersController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                templateUrl: 'app/inventory/transfers/transfers.list.html',
            })
            .state('index.transfers', {
                abstract: true,
                url: '/transfers',
                template: '<ui-view/>'
            })
            .state('index.transfers.detail', {
                url: '/:objectKey',
                templateUrl: 'app/inventory/transfers/detail/transfer.detail.html',
                controller: 'TransferDetailController',
                controllerAs: 'vm'
            });
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.transfers')
    .factory('Transfers', Transfers);

  Transfers.$inject = ['$resource', 'restUrl'];

  function Transfers($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/transfer/:objectKey';
    var notesUrl = resourceUrl + '/notes';
    var acceptUrl = resourceUrl + '/accept';
    var declineUrl = resourceUrl + '/decline';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        list: { method: 'GET' },
        getNotes: { method: 'GET', url:notesUrl },
        addNote: { method: 'POST', url:notesUrl },
        accept: { method: 'POST', url:acceptUrl },
        decline: { method:'POST', url:declineUrl }
      });
  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.inventory.transfers')
    .controller('TransfersController', TransfersController);

  TransfersController.$inject = ['$scope', '$log', '$location', '$stateParams','currentAuth',
    'TransferModal', 'Transfers', 'Show', 'Toast', 'DeclineTransferModal', 'CommentsModal', '$state'];

  function TransfersController($scope, $log, $location, $stateParams, currentAuth,
                               TransferModal, Transfers, Show, Toast, DeclineTransferModal, CommentsModal, $state) {
    $state.activeTabsInventory = "index.inventory.transfers";

    var vm = this;

    vm.show = Show;

    vm.sendInventory = sendInventory;
    vm.transferAccept = transferAccept;
    vm.transferDecline = transferDecline;
    vm.sendInventory = sendInventory;
    vm.isLoading = false;

    vm.showComments = showComments;

    vm.loading = {};

    vm.statuses = [
      'PENDING',
      'ACCEPTED',
      'DECLINED'
    ];

    vm.filters = [];
    vm.pageSize = 20;
    vm.previousPages = [];
    vm.filterObject = parseStateParams();

    vm.onRemoveFilter = onRemoveFilter;

    vm.filterOptions = [
    ];

    activate();

    $scope.$watch(
      angular.bind(vm, function () {
        return vm.filterObject;
      }),
      onNewFilter,
      true
    );

    function onNewFilter(newVal) {

      var ignore = false;

      var filters = [];
      angular.forEach(newVal, function (value, key) {

        if (ignore || value === null) {
          ignore = true;
          return;
        }

        var display = value;
        if (angular.isString(value)) {
          display = value;
        }
        else {
          return;
        }

        filters.push({"key": key, "value": value, "display": display});

      });

      vm.filters = filters;

      updateSearchParams();

    }

    function showComments(transfer) {
      if (!angular.isString(transfer.key)) {
        return;
      }
      CommentsModal.show(transfer.key, transfer.description);
    }

    function updateSearchParams() {

      var search = {
        "limit": vm.pageSize
      };

      var len = vm.previousPages.length;
      if (len > 0) {
        search.cursor = vm.previousPages[len - 1];
      }

      angular.forEach(vm.filters, function (filter) {

        var value = null;
        if (angular.isString(filter.value)) {
          value = filter.value;
        } else if (isObject(filter.value)) {
          value = filter.value.key;
        }
        if (value === null) return;
        search[filter.key] = value;

      });

      $location.search(search);
      query(search);

    }

    function query(params) {

      params = params || {};
      vm.searchLoading = true;
      params.status = vm.filterObject.status;

      Transfers.list(params, success, error);

      function success(response) {
        setTransfers(response);
        vm.isLoading = false;
        vm.searchLoading = false;
        vm.nextPageToken = response.nextPageToken;

      }

      function error(response) {
        $log.error(angular.toJson(response));
        vm.isLoading = false;
        vm.searchLoading = false;

      }

    }

    function setTransfers(response) {
      vm.transfers = response.items || [];
    }

    function activate() {

      $scope.$emit('loading', false);
      vm.isLoading = true;
      updateSearchParams();

    }

    function parseStateParams() {


      /// set default query if there are no state params..
      /// otherwise let the state params define the filters
      if (!hasKeys($stateParams)) {
        return {};
      }

      var filterObject = {};

      if (angular.isDefined($stateParams.limit)) {
        if (isFinite($stateParams.limit)) {
          vm.pageSize = parseInt($stateParams.limit);
        }
      }

      if (angular.isDefined($stateParams.cursor)) {
        vm.previousPages = [$stateParams.cursor];
      }

      if (angular.isDefined($stateParams.status)) {
        filterObject.status = $stateParams.status;
      }

      return filterObject;

    }

    function hasKeys(obj) {
      if (angular.isUndefined(obj) || !angular.isObject(obj)) return false;
      for (var key in obj) {
        if (obj.hasOwnProperty(key) && angular.isDefined(obj[key])) {
          return true;
        }
      }
      return false;
    }

    function isObject(value) {
      return (value !== null &&
        angular.isDefined(value) &&
        angular.isDefined(value.key) &&
        angular.isDefined(value.objectType));
    }

    function transferAccept(transfer) {

      var key = transfer.key;
      var params =  { objectKey: key };

      if (angular.isUndefined(vm.loading[key])) {
        vm.loading[key] = { accepting: false, declining: false };
      }
      var loading = vm.loading[key];

      if (loading.accepting || loading.declining) {
        return;
      }

      loading.accepting = true;

      Transfers.accept(params, null, transferSuccess, transferError);

    }

    function transferDecline(transfer) {

      DeclineTransferModal.show(function(reason) {

        var key = transfer.key;
        var params =  { objectKey: key };
        var body = { content: reason };
        var loading = vm.loading[key] || { accepting: false, declining: false };

        if (loading.accepting || loading.declining) {
          return;
        }

        loading.declining = true;

        Transfers.decline(params, body, transferSuccess, transferError);

      });

    }

      function sendInventory() {
          TransferModal.show(currentAuth.org.key, {}, function(transfer) {
            updateSearchParams();
          });
      }

    function transferSuccess(response) {
      angular.forEach(vm.transfers, function(transfer) {
        if (transfer.key === response.key) {
          transfer.status = response.status;
        }
      });
      resetLoading();
      Toast.success(response.status + ' transfer!');
    }

    function transferError(response) {
      $log.info(angular.toJson(response));
      Toast.error(response);
      resetLoading();
    }

    function resetLoading() {
      angular.forEach(vm.loading, function(value) {
        value.accepting = false;
        value.declining = false;
      });
    }

    vm.setPageSize = setPageSize;

    function setPageSize(pageSize) {
      vm.pageSize = pageSize;
      vm.previousPages = [];
      updateSearchParams();
    }

    vm.hasNextPage = hasNextPage;

    function hasNextPage() {
      return angular.isDefined(vm.nextPageToken);
    }

    vm.hasPreviousPage = hasPreviousPage;

    function hasPreviousPage() {
      return vm.previousPages.length > 0;
    }

    vm.loadNextPage = loadNextPage;

    function loadNextPage() {
      if (angular.isUndefined(vm.nextPageToken)) return;
      vm.previousPages.push(vm.nextPageToken);
      vm.nextPageToken = undefined;
      updateSearchParams();
    }

    vm.loadPreviousPage = loadPreviousPage;

    function loadPreviousPage() {
      if (vm.previousPages.length === 0) return;
      vm.previousPages.pop();
      updateSearchParams();
    }

    function onRemoveFilter() {

      var toRemove = {};
      angular.forEach(vm.filterObject, function (value, key) {
        toRemove[key] = true;
      });

      angular.forEach(vm.filters, function (filter) {
        var key = filter.key;
        if (toRemove.hasOwnProperty(key)) {
          toRemove[key] = false;
        }
      });

      var filterObject = angular.copy(vm.filterObject);

      angular.forEach(toRemove, function (value, key) {
        if (value) {
          delete filterObject[key];
        }
      });

      vm.filterObject = filterObject;

    }

  }

})();


(function() {
  'use strict';

  angular
    .module('connectsx.inventory.requests', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.inventory.requests')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.inventory.requests', {
        url: '/requests?status&cursor&limit',
        controller: 'RequestsController',
        controllerAs: 'vm',
        reloadOnSearch: false,
        templateUrl: 'app/inventory/requests/requests.list.html',
      })
      .state('index.requests', {
      abstract: true,
      url: '/requests',
      template: '<ui-view/>'
      })
      .state('index.requests.edit', {
        url: '/edit/:objectKey',
        templateUrl: 'app/inventory/requests/request.edit.html',
        controller: 'RequestEditController',
        controllerAs: 'vm'
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.requests')
    .factory('Requests', Requests);

  Requests.$inject = ['$resource', 'restUrl'];

  function Requests($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/inventory/request/:objectKey';
    var listUrl = restUrl + '/v1/inventory/requests';
    var fulfillUrl = resourceUrl + '/fulfill';
    var cancelUrl = resourceUrl + '/cancel';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        list: { method: 'GET', url: listUrl },
        cancel: { method: 'PUT', url: cancelUrl },
        fulfill: { method: 'POST', url:fulfillUrl }
      });
  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.inventory.requests')
    .controller('RequestsController', RequestsController);

  RequestsController.$inject = ['$scope', '$log', '$location', '$stateParams', '$state',
    'currentAuth', 'Requests', 'Show', 'Toast', 'CommentsModal'];

  function RequestsController($scope, $log, $location, $stateParams, $state,
                              currentAuth, Requests, Show, Toast, CommentsModal) {
    $state.activeTabsInventory = "index.inventory.requests";

    var vm = this;

    vm.accountKey = accessKey(currentAuth);

    vm.statuses = [
      'Created',
      'Fulfilled',
      'Cancelled'
    ];

    vm.filterObject = {};

    vm.show = Show;
    vm.requests = [];
    vm.editRequest = editRequest;
    vm.cancelRequest = cancelRequest;
    vm.showComments = showComments;
    vm.showRequest = showRequest;
    vm.isLoading = false;
    vm.searchLoading = false;

    $scope.$watch(
      angular.bind(vm, function () {
        return vm.filterObject;
      }),
      loadRequests,
      true
    );

    activate();

    function accessKey(auth) {
      if (auth.accountType === 'MANUFACTURER') {
        return auth.manufacturer.key;
      }
      if (auth.accountType === 'DISTRIBUTOR') {
        return auth.distributor.key;
      }
      return auth.key;
    }

    function showComments(request) {
      if (!angular.isString(request.key)) {
        return;
      }
      CommentsModal.show(request.key, "");
    }

    function editRequest(request) {
      if (!angular.isObject(request) || !angular.isString(request.key)) return;
      $state.go('index.requests.edit', { objectKey: request.key })
    }

    function showRequest(request) {
      $log.info(request.key);
    }

    function cancelRequest(request) {
      $log.info("Cancel request: " + request.key);
    }

    function loadRequests() {

      vm.searchLoading = true;
      Requests.list(vm.filterObject,
        function (success) {
          vm.requests = success.items || [];
          vm.isLoading = false;
          vm.searchLoading = false;
        },
        function (error) {
          vm.isLoading = false;
          vm.searchLoading = false;
          Toast.error(error);
        });
    }

    function activate() {

      $scope.$emit('loading', false);
      vm.isLoading = true;
      loadRequests();

    }
  }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory.requests')
        .controller('RequestEditController', RequestEditController);

    RequestEditController.$inject = ['$scope', '$log', '$location', '$stateParams',
        'currentAuth', 'Requests', 'Show', 'Toast', 'TransferModal', '$state', 'Inventory', '$window', '$rootScope',
        '$timeout'];

    function RequestEditController($scope, $log, $location, $stateParams,
                                   currentAuth, Requests, Show, Toast, TransferModal, $state, Inventory, $window,
                                   $rootScope, $timeout) {
        $state.activeTabsInventory = "index.inventory.requests";

        $scope.$emit('loading', true);

        var vm = this;

        vm.show = Show;
        vm.addInventory = addInventory;
        vm.fulfill = fulfill;
        vm.cancelRequest = cancelRequest;
        vm.isLoading = false;
        vm.isSaving = false;
        vm.trackingEnabled = true;
        vm.lostChanges = false

        vm.carriers = [
            {value: "ups", name: "UPS"},
            {value: "usps", name: "USPS"},
            {value: "fedex", name: "FedEx"},
            {value: "dhl_express", name: "DHL Express"},
            {value: "aramex", name: "Aramex"},
            {value: "asendia_us", name: "Asendia"},
            {value: "borderguru", name: "BorderGuru"},
            {value: "boxberry", name: "Boxberry"},
            {value: "bring", name: "Bring (also used for Posten Norge)"},
            {value: "canada_post", name: "Canada Post"},
            {value: "correios_br", name: "Correios Brazil"},
            {value: "correos_espana", name: "Correos Espana"},
            {value: "collect_plus", name: "CollectPlus"},
            {value: "couriersplease", name: "CouriersPlease"},
            {value: "deutsche_post", name: "Deutsche Post"},
            {value: "dhl_benelux", name: "DHL Benelux"},
            {value: "dhl_germany", name: "DHL Germany"},
            {value: "dhl_ecommerce", name: "DHL eCommerce"},
            {value: "dpd_germany", name: "DPD Germany"},
            {value: "dpd_uk", name: "DPD UK"},
            {value: "estafeta", name: "Estafeta"},
            {value: "fastway_australia", name: "Fastway Australia"},
            {value: "gls_de", name: "GLS Germany"},
            {value: "gls_fr", name: "GLS France"},
            {value: "globegistics", name: "Globegistics"},
            {value: "gophr", name: "Gophr"},
            {value: "gso", name: "GSO"},
            {value: "hermes_uk", name: "Hermes UK"},
            {value: "hongkong_post", name: "HongKong Post"},
            {value: "lasership", name: "Lasership"},
            {value: "mondial_relay", name: "Mondial Relay"},
            {value: "new_zealand_post", name: "New Zealand Post (also used for Pace and CourierPost)"},
            {value: "newgistics", name: "Newgistics"},
            {value: "nippon_express", name: "Nippon Express"},
            {value: "ontrac", name: "OnTrac"},
            {value: "orangeds", name: "OrangeDS"},
            {value: "parcel", name: "Parcel"},
            {value: "posti", name: "Posti"},
            {value: "rr_donnelley", name: "RR Donnelley"},
            {value: "russian_post", name: "Russian Post"},
            {value: "sendle", name: "Sendle"},
            {value: "skypostal", name: "SkyPostal"},
            {value: "stuart", name: "Stuart"},
            {value: "yodel", name: "Yodel"}
        ];

        vm.statusClass = function statusClass(status) {
            switch (status) {
                case 'Fulfilled':
                    return 'csx-closed';
                case 'Created':
                    return 'csx-open';
                case 'Cancelled':
                    return 'csx-cancelled';
            }
            return '';
        };

        activate();

        function activate() {

            $scope.$emit('loading', false);

            vm.isLoading = true;

            var params = {
                objectKey: $stateParams.objectKey
            };

            Requests.get(params,
                function (response) {
                    setRequest(response);
                },
                function (error) {
                    vm.isLoading = false;
                    Toast.error(error);
                }
            );
        }

        function cancelRequest() {
            var key = vm.request.key;
            vm.isCancelling = true;
            vm.lostChanges = false;
            if (!angular.isString(key)) {
                return;
            }
            Requests.cancel({objectKey: key}, null, function (response) {
                setRequest(response);
                vm.isCancelling = false;
            }, function (error) {
                Toast.error(error);
                vm.isCancelling = false;
            });
        }

        function setRequest(response) {
            if (angular.isArray(response.devices)) {
                var counts = {};
                var devices = [];
                angular.forEach(response.devices, function (device) {
                    if (device === null) return;
                    var ref = device.reference;
                    if (angular.isUndefined(counts[ref])) {
                        device.count = 0;
                        counts[ref] = device;
                        devices.push(device);
                    }
                    counts[ref].count = counts[ref].count + 1;
                });
                response.devices = devices;
            }

            vm.request = response;
            if (vm.request.status !== 'Created') {
                vm.trackingEnabled = false;
            }
        }

        function addInventory() {

            vm.request.source.name = vm.request.sourceName;
            vm.lostChanges = true;
            function callback(inventory, comment) {
                vm.fulfillment = [];
                vm.comment = comment;
                var fulfillment = inventory;
                vm.mismatch = false;
                vm.mismatchError = '';
                var requested = {};
                angular.forEach(vm.request.devices || [], function(d) {
                    requested[d.reference] = true;
                });

                angular.forEach(fulfillment, function(d) {
                   if (d.type === 'Device' && requested[d.reference] !== true) {
                       vm.mismatch = true;
                       vm.mismatchError = "One or more selected items does not match requested inventory."
                   }
                   Inventory.get({objectKey: d.key}, function (res) {
                       vm.fulfillment.push(res);
                   }, function(err){
                       $log.info(err)
                   })
                });
            }

            TransferModal.showForRequest(
                vm.request.target.key,
                vm.request.source,
                vm.fulfillment,
                vm.comment,
                callback
            );

        }

        function fulfill() {

            var request = vm.request;
            vm.lostChanges = false;

            if (vm.trackingEnabled) {

                request.fulfillment = request.fulfillment || {};

                request.fulfillment.tracking = request.fulfillment.tracking || {};

                var error = 'You must set carrier and tracking number or explicitly disable tracking.';
                if (!angular.isString(request.fulfillment.tracking.carrier)) {
                    Toast.error(error);
                    return;
                }
                if (!angular.isString(request.fulfillment.tracking.number)) {
                    Toast.error(error);
                    return;
                }
            }

            if (!angular.isArray(vm.fulfillment) || vm.fulfillment.length === 0) {
                Toast.error('You need to add inventory to the fulfillment section.');
                return;
            }

            if (angular.isUndefined(request) || !angular.isString(request.key)) {
                Toast.error('Something isn\'t quite right. Try reloading the page and have another go.');
                return;
            }

            if (!angular.isString(request.sourceKey) || !angular.isString(request.targetKey)) {
                Toast.error('Something isn\'t quite right. Try reloading the page and have another go.');
                return;
            }

            var inventory = vm.fulfillment;

            /// swap the source / target of the request for the transfer that will fulfill
            /// the request.
            var transfer = {
                source: {key: request.targetKey},
                target: {key: request.sourceKey},
                inventory: inventory,
                note: vm.comment,
                tracking: vm.trackingEnabled ? request.fulfillment.tracking : null
            };

            vm.isSaving = true;
            Requests.fulfill({objectKey: request.key}, transfer, function (response) {
                vm.isSaving = false;
                vm.request.status = response.status;
                vm.request.fulfillment = response.fulfillment;
            }, function (error) {
                vm.isSaving = false;
                Toast.error(error);
            });

        }

        //Confirm before leave page if it has changes

        function routeChange(event) {
            if(vm.lostChanges){
                var answer = $window.confirm("You are about to navigate away from this page. Any change will be lost." +
                    " Do you want to continue?");
                if (answer) {
                    return false
                }
                if(!answer){
                    event.preventDefault();
                    return true
                }
            }
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
            }, 500)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


    }

})
();


(function () {
    'use strict';

    /* global angular */
    /*
    * vm.product.assetUrl  - array strings
    * vm.product.images - array strings
    * */

    angular
        .module('connectsx.inventory')
        .controller('InventoryProductsCreateController', InventoryProductsCreateController);

    InventoryProductsCreateController.$inject = ['Accounts', 'Products', 'Guides', '$scope', '$stateParams', '$log',
        'Toast', 'Show', 'currentAuth', 'Orgs', 'firebase', '$state', 'ConfirmUnsavedChanges', '$rootScope', '$timeout',
    '$filter'];

    function InventoryProductsCreateController(Accounts, Products, Guides, $scope, $stateParams, $log,
                                               Toast, Show, currentAuth, Orgs, firebase, $state,
                                               ConfirmUnsavedChanges, $rootScope, $timeout, $filter) {
        $state.activeTabsInventory = "index.inventory.products";

        var vm = this;
        vm.isChange = false;

        vm.finish = finish;
        vm.searchGuides = searchGuides;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            loadProduct();

        }

        function loadProduct() {

            if (angular.isUndefined($stateParams.objectKey)) {

                vm.product = {};


                setupDefaults();

                Orgs.get({objectKey: currentAuth.org.key}, function (org) {

                    org.manufacturer.name = org.name;
                    vm.manufacturers = org.manufacturers;
                    vm.product.manufacturer = org.manufacturer;
                    if(!vm.product.images){
                        vm.product.images = []
                    }
                    $scope.$emit('loading', false);


                }, function (error) {
                    Toast.error(error);
                    $scope.$emit('loading', false);

                });

                return;
            }

            Products.get({objectKey: $stateParams.objectKey}, success, error);

            function success(response) {
                vm.product = response;
                if(!vm.product.images){
                    vm.product.images = []
                }
                setupDefaults();
                $scope.$emit('loading', false);
            }

            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                $log.info(angular.toJson(error));
                $scope.$emit('loading', false);
                Toast.error(error);
            }

        }

        function setupDefaults() {
            if (angular.isUndefined(vm.product.ifuUrls)) {
                vm.product.ifuUrls = [];
            }


            $scope.$emit('loading', false);
            vm.product = {
                assetUrl: "",
                guides: [],
                ifuUrls: []
            }
        }

            function finish(vm) {

                if(!vm){
                    vm = this
                }
                vm.isLoading = true;

                if(!vm.product.images){
                    vm.product.images = []
                }
                if(!vm.product.assetUrl){
                    vm.product.assetUrl = "";
                }
                if(!vm.product.guides){
                    vm.product.guides = [];
                }
                //Clear excess code
                if(vm.product.guides.length){
                    vm.product.guides.forEach(function(guide){
                        delete guide.steps
                    })
                }

                Products.insert(vm.product, success, error);


                function success(response) {
                    vm.isChange = false;
                    onRouteChangeOff();
                    $state.go('index.inventory.productedit', { objectKey: response.key });
                    vm.isLoading = false;
                    Toast.success('Saved!');
                }

                function error(error) {
                    vm.isLoading = false;
                    $log.error(error);
                    Toast.error(error);
                }

            }

            function searchGuides(search) {
                if (angular.isUndefined(search)) return [];
                return Guides.search({search: search}).$promise.then(function (response) {
                    if (angular.isUndefined(response.items)) {
                        response.items = [];
                    }
                    var commonItems = removeIdenticaltems(response.items, vm.product.guides);
                    return commonItems
                });
            }

        /*Remove from existing in second array items
          where - object, with property name = string
          what - array strings
       */
        function removeIdenticaltems(where, what) {
            var result = [];
            where.forEach(function(v) {
                var isExist = false;
                what.every(function(w){
                    if (v.name === w.name) {
                        isExist = true;
                        return false
                    }
                        return true
                })
                if(!isExist){
                    result.push(v);
                }
            });
            return result;
        }

        // Below Functional related with prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.product', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            if(!vm.product.assetUrl){
                vm.product.assetUrl = '';
            }
            if(!vm.product.name) {
                vm.product.name = '';
            }
            var validateArray = [vm.product.name];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;

        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
                //Init watcher here, because we create new entity
                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


    }



})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('InventoryProductsController', InventoryProductsController);

    InventoryProductsController.$inject = ['$filter', '$state', '$scope', '$log',
        'Products', 'Guides', 'Orgs', 'Inventory', 'Toast', 'currentAuth', 'Accounts'];

    function InventoryProductsController($filter, $state, $scope, $log,
                                    Products, Guides, Orgs, Inventory, Toast, currentAuth, Accounts) {

        $state.activeTabsInventory = "index.inventory.products";

        var vm = this;
        vm.device = {
            type: 'Device',
            udi: {},
            tags: []
        };

        vm.isSaving = false;
        vm.manufacturer = {};


        vm.finish = finish;
        vm.searchContainers = searchContainers;
        vm.searchCustody = searchCustody;
        vm.searchProducts = searchProducts;

        vm.allProducts = [];
        vm.editProduct = editProduct;

        activate();

        function activate() {

            $scope.$emit('loading', false);
            populateFields();
            vm.manufacturer = currentAuth.org.manufacturer;
            vm.manufacturers = currentAuth.org.manufacturers;

            searchProducts();
        }


        function populateFields() {

            Orgs.get({objectKey: currentAuth.org.key}, function (org) {
                // vm.manufacturers = org.manufacturers || [];
                // if (org.manufacturers.length > 0) {
                //     vm.device.manufacturer = org.manufacturers[0];
                // }
                vm.device.custody = org;

            }, Toast.error);

        }


        function finish() {

            vm.isSaving = true;
            Inventory.insert(null, vm.device, success, error);

            function success(response) {
                vm.isSaving = false;
                var count = (response.items || []).length;
                var message = count === 1 ? 'item!' : 'items!';
                Toast.success('Successfully added ' + count + message);
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }
        }

        function searchCustody(searchText) {
            return Accounts.list({}).$promise.then(function (response) {
                var options = [];
                var items = response.items || [];
                angular.forEach(items, function (a) {
                    if (a.accountType === 'Individual') {
                        options.push(a);
                    }
                });

                return Accounts.me({}).$promise.then(function (me) {
                    options.push(me.org);
                    return $filter('filter')(options, searchText);
                });

            });
        }


        function searchProducts() {
            // var params = {};
            var index;

            for (index = 0; index < vm.manufacturers.length; ++index) {

                var params = {manufacturer: vm.manufacturers[index].key};

                var searchText = vm.searchText;

                if (angular.isDefined(vm.pageSize)) {
                    params.limit = vm.pageSize;
                }

                if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                    params.cursor = vm.previousPages[vm.previousPages.length - 1];
                }

                if (angular.isDefined(searchText) && searchText.length > 0) {
                    params.search = searchText;
                }

                Products.list(params, success, error);
            }


            function success(response) {
                vm.loading = false;
                vm.products = response.items || [];
                vm.allProducts.push.apply(vm.allProducts, vm.products);
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }
        }

        function searchContainers(custody, manufacturer, searchText) {

            var params = {
                search: searchText,
                custody: custody,
                manufacturer: manufacturer,
                type: 'Container',
                limit: 20
            };
            return Inventory.search(params).$promise.then(function (response) {
                return response.items || [];
            });
        }

        function editProduct(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.inventory.productedit', {objectKey: deviceKey})
        }
    }
})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('InventoryListController', InventoryListController);

    InventoryListController.$inject = ['$state', '$stateParams', '$location',
        '$scope', '$log', 'Inventory', 'currentAuth', 'InventoryFilters', 'Toast', 'InventoryExport'];

    function InventoryListController($state, $stateParams, $location, $scope,
                                     $log, Inventory, currentAuth, InventoryFilters, Toast, InventoryExport) {
        $state.activeTabsInventory = "index.inventory.list";

        var vm = this;

        $scope.$emit('loading', false);
        vm.isLoading = false;
        vm.searchLoading = false;

        if ($stateParams.clear === 'true') {
            InventoryFilters.removeAllFilters();
        }

        vm.filters = InventoryFilters.init($stateParams);
        vm.pageSize = 20;
        vm.previousPages = [];
        vm.org = currentAuth.org;

        vm.viewDevice = viewDevice;
        vm.viewCase = viewCase;
        vm.onRemoveFilter = onRemoveFilter;
        vm.addFilter = addFilter;
        vm.exportInventory = exportInventory;
        vm.isShowExportButton = function(){
            //return true
            return currentAuth.name === 'Josh Day'
        }

        vm.date = new Date()
        activate();

        function activate() {

            vm.isLoading = true;
            parseStateParams();
            query();

        }


        function changeOverdueOptionsNames(strName){

            if(strName === "OVER_48_HOURS"){
                return "Over 48 hours"
            }
            if(strName === "IN_48_HOURS"){
                return "In 48 hours"
            }
            if(strName === "IN_24_HOURS"){
                return "In 24 hours"
            }
            if(strName === "OVERDUE"){
                return "Overdue"
            }
            return ""
        }

        function changeFilternames(){
            angular.forEach(vm.filters, function(el) {
                if(el.key === "dueBack"){
                    el.display = changeOverdueOptionsNames(el.value).substring(0,8) + '...'
                }
            });
        }

        function paramsFromFilters(){
            //Change name for user friendly
            changeFilternames()

            var params = {};

            angular.forEach(vm.filters, function(filter) {
                params[filter.key] = filter.value;
            });

            params.limit = vm.pageSize;

            var len = vm.previousPages.length;
            if (len > 0) {
                params.cursor = vm.previousPages[len - 1];
            }

            return params;
        }

        function query() {

            vm.searchLoading = true;

            var params = paramsFromFilters();

            Inventory.search(params, success, error);
            $location.search(params);

            function success(response) {
                // $log.info(angular.toJson(response));
                vm.devices = response.items;
                vm.searchLoading = false;
                vm.isLoading = false;
                vm.nextPageToken = response.nextPageToken;

            }

            function error(response) {
                $log.error('Device  error: ' + angular.toJson(response));
                vm.searchLoading = false;
                vm.isLoading = false;
            }

        }

        function viewDevice(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.inventory.edit', { objectKey: deviceKey })
        }

        function viewCase(caseKey) {
            if (angular.isUndefined(caseKey)) return;
            $state.go('index.cases.edit', {objectKey: caseKey})
        }

        function parseStateParams() {


            if (angular.isDefined($stateParams.limit)) {
                if (isFinite($stateParams.limit)) {
                    vm.pageSize = parseInt($stateParams.limit);
                }
            }

            if (angular.isDefined($stateParams.cursor)) {
                vm.previousPages = [$stateParams.cursor];
            }

        }


        function addFilter() {
            InventoryFilters.showAddFilterModal(function(filters) {
                vm.previousPages = [];
                vm.filters = filters;
                query();
            });
        }

        vm.setPageSize = setPageSize;

        function setPageSize(pageSize) {
            $log.info(pageSize);
            vm.pageSize = pageSize;
            vm.previousPages = [];
            query();
        }

        vm.hasNextPage = hasNextPage;

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        vm.hasPreviousPage = hasPreviousPage;

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        vm.loadNextPage = loadNextPage;

        function loadNextPage() {
            if (!angular.isString(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            query();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            query();
        }


        function onRemoveFilter(filter) {
            InventoryFilters.removeFilter(filter);
            query();
        }

        function exportInventory () {
            InventoryExport.show()
        }
    }

})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx')
        .factory('InventoryFilters', InventoryFilters);

    InventoryFilters.$inject = ['$log', '$mdDialog', '$state'];

    function InventoryFilters($log, $mdDialog, $state) {

        //$state.activeTabsInventory = "index.inventory.list";

        var statuses = [
            "Unused",
            "Used",
            "Implanted",
            "Explanted",
            "Damaged",
            "Missing",
            "Other"
        ];

        var overdue = [
            "OVER_48_HOURS",
            "IN_48_HOURS",
            "IN_24_HOURS",
            "OVERDUE"
        ];

        var overdueUserNames = [
            "Over 48 hours",
            "In 48 hours",
            "In 24 hours",
            "Overdue"
        ];

        var expirationOptions = [
            {value: 'Expired', display: 'Expired'},
            {value: 'ExpiringSoon', display: 'Expiring Soon'}
        ];

        var filters = {};

        function showAddFilterModal(callback) {
            $mdDialog.show({
                locals: {
                    'Callback': callback || function () {
                    }
                },
                controller: 'FilterInventoryModalController',
                controllerAs: 'vm',
                templateUrl: 'app/inventory/list/filter/inventory.filter.tmpl.html',
                clickOutsideToClose: true
            });
        }

        function init(params) {

            var custody = params.custody;
            var type = params.type;
            var loose = params.loose;
            var basic = params.basic;
            var status = params.status;
            var expiration = params.expiration;
            var manufacturer = params.manufacturer;
            var container = params.container;
            var inactive = params.inactive;
            var billable = params.billable;
            var nolot = params.nolot;
            var dueBack = params.dueBack;

            setObjectOrKeyFilter('custody', custody);
            setObjectOrKeyFilter('manufacturer', manufacturer);
            setObjectOrKeyFilter('container', container);

            setStringFilter('type', type);
            setStringFilter('search', basic);
            setStringFilter('status', status);
            setStringFilter('dueBack', dueBack);


            if (angular.isObject(expiration)) {
                filters.expiration = {'key': 'expiration', 'value': expiration.value, "display": expiration.display};
            }
            else if (angular.isString(expiration)) {
                var lExpiration = expiration.toLowerCase();
                for (var i = 0; i < expirationOptions.length; i++) {
                    var option = expirationOptions[i];
                    var lValue = option.value.toLowerCase();
                    if (lExpiration === lValue) {
                        filters.expiration = {'key': 'expiration', 'value': option.value, "display": option.display};
                        break;
                    }
                }
            }

            setBoolFilter('loose', loose);
            setBoolFilter('nolot', nolot);
            setBoolFilter('billable', billable);
            setBoolFilter('active', inactive, false);

            var chips = [];
            angular.forEach(filters, function(item) {
                chips.push(item);
            });

            return chips;

        }

        function setBoolFilter(key, value, filterValue) {

            if (!angular.isString(key)) {
                return;
            }

            if (angular.isString(value)) {
                value = value === "true";
            }

            if (typeof(value) === "boolean") {
                if (value) {
                    if (typeof(filterValue) === "boolean") {
                        value = filterValue;
                    }
                    filters[key] = {'key': key, 'value': value, "display": value ? 'Yes' : 'No'};
                }
            }

        }

        function setStringFilter(key, value) {

            if (!angular.isString(key) || !angular.isString(value)) {
                return;
            }

            if (value.length === 0) {
                return;
            }

            filters[key] = {'key': key, 'value': value, "display": truncate(value)};


        }

        function removeAllFilters() {
            filters = {};
        }
        function removeFilter(filter) {
            delete filters[filter.key];
        }

        function truncate(value) {

            var display = value;

            if (value.length > 8) {
                display = value.substring(0, 8) + '...';
            }

            return display;

        }

        function setObjectOrKeyFilter(key, value) {

            if (!angular.isString(key)) {
                return;
            }

            if (angular.isObject(value) && angular.isString(value.key) && angular.isString(value.name)) {
                filters[key] = {'key': key, 'value': value.key, "display": value.name};
                return;
            }

            setStringFilter(key, value);

        }


        return {
            showAddFilterModal: showAddFilterModal,
            statuses: statuses,
            overdue: overdue,
            overdueUserNames: overdueUserNames,
            expirationOptions: expirationOptions,
            filters: filters,
            removeFilter: removeFilter,
            removeAllFilters: removeAllFilters,
            init:init
        };


    }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.inventory.import')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.inventory.import', {
                url: '/import',
                controller: 'ImportController',
                controllerAs: 'vm',
                templateUrl: 'app/inventory/import/import.html',
            })
            .state('index.inventory.progress', {
                url: '/import/:objectKey',
                templateUrl: 'app/inventory/import/import.html',
                controller: 'ImportController',
                controllerAs: 'vm'
            });
    }

})();

(function () {
    'use strict';

    /* global angular, moment */

    angular
        .module('connectsx.inventory.import')
        .controller('ImportController', ImportController);

    ImportController.$inject = ['$scope', '$state', '$stateParams', '$log', '$timeout', '$mdToast', 'Toast',
        'currentAuth', 'Inventory', 'Orgs', 'ConfirmUnsavedChanges', '$rootScope', 'ImportStatusModal', '$mdDialog'];

    function ImportController($scope, $state, $stateParams, $log, $timeout, $mdToast, Toast,
                              currentAuth, Inventory, Orgs, ConfirmUnsavedChanges, $rootScope, ImportStatusModal, $mdDialog) {

        $state.activeTabsInventory = "index.inventory.import";

        $scope.$emit('loading', false);

        var vm = this;

        vm.progressVisible = false;
        vm.errors = [];
        vm.parseDateErrorCount = 0;
        vm.parseDateErrorShow = false;
        vm.showLoading = false;
        vm.missedDevices = [];

        vm.importInventory = importInventory;
        vm.updatePreviews = updatePreviews;
        vm.validateDate = validateDate;

        vm.rollback = function(i) {
            var params = { objectKey:i.key };
            Inventory.rollbackImport(params, null, function(response) {
                i.rollback = response.rollback;
            }, Toast.error);
        };

        if (angular.isString($stateParams.objectKey)) {
            showProgress($stateParams.objectKey);
        }

        activate();

        function activate() {

            if (!(angular.isObject(currentAuth.org) &&
                    angular.isString(currentAuth.org.key))) {
                Toast.error('Unauthorized. Organization account required.');
                return ;
            }

            vm.orgDisabled = false;
            vm.org = currentAuth.org;

            Orgs.get({ objectKey: vm.org.key }, function(org){

                vm.manufacturers = org.manufacturers || [];
                if (vm.manufacturers.length > 0) {
                    vm.manufacturer = vm.manufacturers[0];
                }
                vm.manufacturerDisabled = vm.manufacturers.length === 1;
            }, Toast.error);

        }

        function updatePreviews(header, previewKey) {

            /// reset previews
            vm[previewKey] = [];

            if (angular.isUndefined(header) || angular.isUndefined(previewKey) || angular.isUndefined(vm.rows)) {
                return;
            }

            var preview = [];

            for (var i=0; i < vm.rows.length; i++) {
                if (preview.length > 2) {
                    break;
                }

                if (angular.isArray(header)) {
                    var values = [];
                    for (var j=0; j < header.length; j++) {
                        var v = vm.rows[i][header[j]];
                        if (angular.isString(v) && v.length > 0) {
                            values.push(v);
                        }
                    }
                    preview.push(values.join(", "));
                }
                else {
                    var v = vm.rows[i][header];
                    if (angular.isString(v) && v.length > 0) {
                        preview.push(v);
                    }
                }
            }

            vm[previewKey] = preview;


        }

        function validate(){
            if(vm.udiHeader){
                if(!vm.quantityHeader){
                    vm.importError = 'All fields must be mapped to import data.';
                    Toast.error('Quantity field is required. Please ensure all required fields are mapped to columns ' +
                        'in your spreadsheet. If you are using a valid UDI, you only need to add quantity; the remainder will ' +
                        'be imported from FDA GUDID.');
                    return
                }
            }
            else {
                var emptyFields = '';
                if(typeof vm.referenceHeader === 'undefined' || vm.referenceHeader === 'None'){
                    emptyFields += 'Reference'
                }
                if(typeof vm.productHeader === 'undefined'  || vm.productHeader === 'None'){
                    emptyFields.length ? emptyFields += ', Product' : emptyFields += 'Product';
                }
                if(typeof vm.descriptionHeader === 'undefined'  || vm.descriptionHeader === 'None'){
                    emptyFields.length ? emptyFields += ', Description' : emptyFields += 'Description';
                }
                if(emptyFields.length){
                    vm.importError = 'All fields must be mapped to import data.';
                    Toast.error(emptyFields + ' are required fields. Please ensure all required fields are mapped to columns ' +
                        'in your spreadsheet. If you are using a valid UDI, you only need to add quantity; the remainder will ' +
                        'be imported from FDA GUDID.');
                    return;
                }

            }
            return true
        }

        function importInventory(vm) {
            if(!vm){
                vm = this;
            }
            vm.errors =[];

            var manufacturer = vm.manufacturer;
            if (angular.isUndefined(manufacturer)) {
                vm.importError = 'Manufacturer is required to import data.';
                return;
            }

            if(!validate()){
                return;
            }

            vm.importError = null;
            vm.importMessage = null;

            var devices = [];
            var length = vm.rows.length;

            for (var i = 0; i < length; i++) {

                var row = vm.rows[i];
                var device = { type: 'Device' };
                var udi = {};
                var container = { type: 'Container' };
                var product = {};
                var expDate = vm.validateDate(row[vm.expirationDateHeader]);

                if (angular.isDefined(vm.quantityHeader) &&
                    angular.isString(row[vm.quantityHeader])) {
                    var quantityPattern = new RegExp(/[A-Za-z~`!.,#%\^&*+$=\-\[\]\\\@\(\)';/{}|\\":<>\?]/);
                    if(quantityPattern.test(row[vm.quantityHeader])){
                        vm.importError = 'Quantity fields must contain numeric values only, without periods, alphabetic characters or commas.';
                        vm.missedDevices.push({row: row, quantity: vm.quantityHeader, str: i, udi: vm.udiHeader, ref: vm.referenceHeader, name: vm.descriptionHeader});
                        continue
                    }
                    else {
                        if(row[vm.quantityHeader] === 0 || row[vm.quantityHeader] === '' || row[vm.quantityHeader] === '0'){
                            vm.missedDevices.push({row: row, quantity: vm.quantityHeader, str: i, udi: vm.udiHeader, ref: vm.referenceHeader, name: vm.descriptionHeader});
                            continue
                        }
                        setIfDefined('quantity', parseInt(row[vm.quantityHeader]), device);
                    }
                }

                if (angular.isDefined(vm.priceHeader) &&
                    angular.isString(row[vm.priceHeader])) {
              
                    var pricePattern = new RegExp(/[A-Za-z~`!#%\^&*+=\[\]\\';/{}|\\":<>\?]/);
                    if(pricePattern.test(row[vm.priceHeader])){
                        vm.importError = 'Price must be set to numeric values only. Text and special characters (e.g. "$") are not supported.';
                        vm.errors.push(vm.importError);
                        // return;
                    }
                    else {
                        if(row[vm.priceHeader].toString().includes(',')){
                            if(row[vm.priceHeader].toString().lastIndexOf(',') + 3 >=  row[vm.priceHeader].length){
                                var indexOfInd = row[vm.priceHeader].lastIndexOf(',');
                                row[vm.priceHeader] = row[vm.priceHeader].substr(0, indexOfInd ) + '.' + row[vm.priceHeader].substr(indexOfInd + 1, row[vm.priceHeader].length)
                            }
                            row[vm.priceHeader] = row[vm.priceHeader].replace(/,/g, "");
                        }
                        var price = row[vm.priceHeader].replace(/\&\-,|\$/g, '').replace(/\-/g, '').replace(/\s/g, '');
                        if(price === '' || isNaN(price) || typeof price === 'undefined' || price === null){
                            price = '0';
                        }
                        setIfDefined('price', parseFloat(price).toFixed(2), device);
                    }
                }

                if (angular.isDefined(vm.tagHeader) &&
                    angular.isArray(vm.tagHeader) &&
                    vm.tagHeader.length > 0) {
                    var tags = [];
                    angular.forEach(vm.tagHeader, function (header) {
                        if (angular.isDefined(row[header])) {
                            tags.push(row[header]);
                        }
                    });
                    device['tags'] = tags;
                }

                setBillable('billable', row[vm.billableHeader], device);

                setIfDefined('reference', row[vm.referenceHeader], device);
                setIfDefined('tempCustody', row[vm.custodyHeader], device);
                setIfDefined('name', row[vm.productHeader], product);
                setIfDefined('reference', row[vm.containerHeader], container);
                setIfDefined('lot', row[vm.lotHeader], udi);
                setIfDefined('serial', row[vm.serialHeader], udi);
                setIfDefined('name', row[vm.descriptionHeader], device);
                setIfDefined('raw', row[vm.udiHeader], udi);
                setIfDefined('barcode', row[vm.barcodeHeader], device);

                if(expDate){
                    setIfDefined('expiration', expDate, udi);
                }

                device.udi = udi;
                device.container = container;
                device.product = product;
                devices.push(device);
            }

            vm.progressVisible = true;
            vm.parseDateErrorShow = vm.parseDateErrorCount > 0;

            var importBody = {
                manufacturer: manufacturer,
                inventory: devices
            };

            Inventory.importInventory(importBody, successCallback, errorCallback);

            function successCallback(value) {
                Toast.success("Import in progress")
                vm.inventory = value;
                vm.importError = '';
                vm.progressVisible = false;
                vm.rows = null;
                vm.showLoading = true;

                $timeout(function() {
                    vm.parseDateErrorShow = false;
                    vm.parseDateErrorCount = 0;
                    vm.importError = '';
                    vm.isChange = false;
                    $timeout(function() {
                        vm.isChange = false;
                    }, 3000)
                }, 5000);

                $timeout(function(){
                    vm.isChange = false;
                    if(vm.missedDevices.length){
                        $mdDialog.show({
                            locals: { 'MissedItems': vm.missedDevices, 'Callback': CallBackClearVariables },
                            controller: 'MissedDevices',
                            controllerAs: 'vm',
                            templateUrl:'app/inventory/import/missedDevicesModal/missedDevices.status.tmpl.html',
                            clickOutsideToClose:false,
                            disableClose: true
                        });
                    }
                    else {
                        CallBackClearVariables()
                    }

                });

                function CallBackClearVariables (){
                    ImportStatusModal.watchStatus(value);
                    //Clear variables, because we show a message after import and can't reload component
                    vm.missedDevices = [];
                    var fileElement = angular.element('#fileUpload');
                    angular.element(fileElement).val(null);
                    vm.headers = [];

                    vm.custodyHeader = '';vm.udiHeader = ''; vm.referenceHeader = ''; vm.productHeader = '';
                    vm.descriptionHeader = ''; vm.tagHeader = ''; vm.quantityHeader = ''; vm.containerHeader = '';
                    vm.billableHeader  = ''; vm.priceHeader = ''; vm.lotHeader = ''; vm.barcodeHeader = '';
                    vm.serialHeader = ''; vm.expirationDateHeader  = '';;

                    vm.referencePreview = []; vm.custodyPreview = []; vm.udiPreview = []; vm.referencePreview = [];
                    vm.productPreview = []; vm.descriptionPreview = []; vm.tagPreview = []; vm.quantityPreview = [];
                    vm.containerPreview = []; vm.billablePreview = []; vm.pricePreview = []; vm.lotPreview = [];
                    vm.barcodePreview = []; vm.serialHeaderPreview = []; vm.expirationDate = [];
                    vm.isChange = false;
                }



            }

            function errorCallback(httpResponse) {
                Toast.error(httpResponse.data.error.message)
                ImportStatusModal.watchStatus(httpResponse)
                vm.importError = 'Something went wrong during the import.';
                vm.progressVisible = false;
                $log.error(httpResponse);
                $timeout(function(){
                    vm.importError = ''
                }, 5000)
            }
        }

        function validateDate(date){
            if(!date) return false
            //Correct format 2019-12-31T00:00:00.000Z
            var checkDate = moment(date).format();
            if (checkDate !== 'Invalid date'){
                return checkDate
            }
            else {
                vm.parseDateErrorCount +=1;
                return false
            }
        }



        function setIfDefined(key, value, obj) {
            if (angular.isDefined(value)) {
                obj[key] = value;
            }
        }

        function setBillable(key, value, obj) {
            if (!angular.isString(value)) {
                return;
            }
            var b = false;
            value = value.toLowerCase();

            if (value === "yes" || value === "true") {
                b = true;
            }

            obj[key] = b;

        }

        function showProgress(key) {

            vm.progressVisible = true;

            Inventory.importProgress({ objectKey: key }, progressSuccess);

            function progressSuccess(response) {

                vm.progressValue = (response.progress / response.batchIds.length) * 100;
                if (response.success) {
                    // Toast.success('Import completed successfully');
                    vm.importMessage = 'Success!';
                    vm.progressVisible = false;
                    return;
                }
                if (angular.isDefined(response.error)) {

                    Toast.error(response.error);  // renders "Invalid product"
                    vm.importError = response.error;
                    vm.progressVisible = false;
                    return;
                }

                $timeout(function () {
                    Inventory.importProgress({objectKey: key }, progressSuccess);
                }, 5000);

            }

        }

        // Below Functional related with prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.rows', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [""]
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, function(){}, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
                //Init watcher here, because we create new entity
                watchChanges()
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }

})();


(function() {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .factory('InventoryExport', InventoryExport);

    InventoryExport.$inject = ['$mdDialog'];

    function InventoryExport($mdDialog) {


        function show(searchText, callback) {
            $mdDialog.show({
                controller: 'InventoryExportController',
                controllerAs: 'vm',
                templateUrl:'app/inventory/export/inventory.export.tmpl.html',
                clickOutsideToClose:true
            });
        }

        return {
            show : show,
        };

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('InventoryExportController', InventoryExportController);

    InventoryExportController.$inject = ['$log', 'Inventory', 'Toast', '$mdDialog', '$timeout'];

    function InventoryExportController($log, Inventory, Toast, $mdDialog, $timeout) {

        var vm = this;
        vm.type = 'UNUSED';
        vm.submit = submit;
        vm.saving = false;
        vm.cancel = $mdDialog.hide;


        function submit(){
            vm.saving = true;
            Inventory.inventoryExport({type:vm.type}, success, error)

            function success(data){

                var link=document.createElement('a');
                document.body.appendChild(link);
                link.href=data.url;
                link.click();
                document.body.removeChild(link);
                vm.saving = false;
                $timeout(function(){
                    vm.cancel()

                    $timeout(function(){
                        $mdDialog.show({
                            controller: 'InventoryExportController',
                            controllerAs: 'vm',
                            templateUrl:'app/inventory/export/inventory.export.success.html',
                            clickOutsideToClose:true
                        });
                    })
                })
            }
            function error(err){
                $log.info(err)
                vm.saving = false;
                Toast.error('Error generate csv file')
            }
        }



    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.catalog', []);

})();

(function () {
    'use strict';

    angular
        .module('connectsx.inventory.catalog')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.inventory.catalog', {
                abstract: true,
                url: '/catalog',
                template: '<ui-view/>'
            })
            .state('index.inventory.catalog.list', {
                url: '',
                templateUrl: 'app/inventory/catalog/device.templates.html',
                controller: 'DeviceTemplatesController',
                controllerAs: 'vm'
            })
            .state('index.inventory.catalog.edit', {
                url: '/edit/:objectKey',
                templateUrl: 'app/inventory/catalog/device.template.edit.html',
                controller: 'DeviceTemplateEditController',
                controllerAs: 'vm'
            });
    }

})();



(function() {
  'use strict';

  angular
    .module('connectsx.inventory.catalog')
    .factory('DeviceTemplates', DeviceTemplates);

  DeviceTemplates.$inject = ['$resource', 'restUrl', 'oldUrl', 'coreUrl'];

  function DeviceTemplates($resource, restUrl, oldUrl, coreUrl) {

    var resourceUrl = restUrl + '/v1/inventory/template/:objectKey';
    var searchUrl = coreUrl + '/v1/template/search';
    var oldResource = oldUrl + '/v3/device/template/:objectKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        search: { method: 'GET', url: searchUrl, isArray:false },
        oldSearch: { method: 'GET', url:oldResource, isArray:false },
        query:  { method:'GET', isArray:false }

      });
  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory.catalog')
        .controller('DeviceTemplatesController', DeviceTemplatesController);

    DeviceTemplatesController.$inject = ['DeviceTemplates', '$scope', '$log', 'Toast', 'Orgs', 'currentAuth', '$state'];

    function DeviceTemplatesController(DeviceTemplates, $scope, $log, Toast, Orgs, currentAuth, $state) {

        $scope.$emit('loading', false);
        $state.activeTabsInventory = "index.inventory.catalog.list";

        var vm = this;

        /// these defaults will be overwritten by state params if present
        vm.pageSize = 20;
        vm.previousPages = [];
        vm.manufacturer = {};
        vm.loading = false;
        vm.goToCreatePage = goToCreatePage;

        vm.search = search;

        vm.copyFromProd = copyFromProd;

        var cache = {};

        function copyFromProd(manufacturer, cursor) {

            if (angular.isUndefined(manufacturer)) {
                Orgs.get({objectKey: currentAuth.org.key}, function (org) {
                    $log.info('Manufacturer: ' + org.manufacturer.key);
                    copyFromProd(org.manufacturer);
                }, Toast.error);
                return;
            }

            DeviceTemplates.oldSearch({limit: 100, cursor: cursor}, function (response) {

                var items = response.items || [];
                angular.forEach(items, function (item) {

                    $log.info(item.referenceNumber + ':' + item.name);

                    if (!cache.hasOwnProperty(item.referenceNumber)) {

                        DeviceTemplates.search({search: item.referenceNumber}, function (response) {

                            var results = response.items || [];
                            if (results.length === 0) {

                                item.reference = item.referenceNumber;
                                item.manufacturer = undefined;
                                item.type = 'Device';
                                $log.info(item.reference);
                                DeviceTemplates.insert(null, item, function (response) {
                                    $log.info('Inserted: ' + response.reference);
                                    cache[item.referenceNumber] = true;
                                }, function (error) {
                                    $log.error(angular.toJson(error));
                                    $log.info('Error: ' + item.reference);
                                });

                            } else {
                                cache[item.referenceNumber] = true;
                            }

                        }, function (error) {
                            $log.error(angular.toJson(error));
                            $log.error(item.referenceNumber);
                        });
                    }


                });

                if (angular.isString(response.nextPageToken) && response.nextPageToken.length > 0) {
                    copyFromProd(manufacturer, response.nextPageToken);
                }

            }, Toast.error);


        }

        activate();

        function search() {


            var params = {manufacturer: vm.manufacturer.key, count:true };
            $log.info(params);

            var searchText = vm.searchText;

            if (angular.isDefined(vm.pageSize)) {
                params.limit = vm.pageSize;
            }

            if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                params.cursor = vm.previousPages[vm.previousPages.length - 1];
            }

            if (angular.isDefined(searchText) && searchText.length > 0) {
                params.search = searchText;
            }

            DeviceTemplates.search(params, success, error);

            function success(response) {
                vm.loading = false;
                vm.devices = response.items || [];
                vm.devices.forEach(function (device) {
                    var products = device.products || [];
                    var names = products.map(function (product) {
                        return product.name;
                    });
                    var uniqueNames = Array.from(new Set(names));
                    device.productLines = uniqueNames.join(', ');
                });
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }

        function activate() {
            vm.loading = true;
            var org = currentAuth.org.key;
            Orgs.get({objectKey: org}, function (org) {
                org.manufacturers = org.manufacturers || [];
                if (org.manufacturers.length > 0) {
                    vm.manufacturer = org.manufacturers[0];
                }
                vm.manufacturers = org.manufacturers;
                search();
            }, function (error) {
                vm.loading = false;
                Toast.error(error);
            });
        }

        vm.setPageSize = setPageSize;

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            search();
        }

        vm.hasNextPage = hasNextPage;

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        vm.hasPreviousPage = hasPreviousPage;

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        vm.loadNextPage = loadNextPage;

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            search();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            search();
        }

        function goToCreatePage(){
            $state.go('index.inventory.catalog.edit', { objectKey: null })
        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory.catalog')
        .controller('DeviceTemplateEditController', DeviceTemplateEditController);

    DeviceTemplateEditController.$inject = ['$scope', '$stateParams', '$state', '$log',
        'currentAuth', 'Orgs', 'DeviceTemplates', 'Toast', 'ConfirmUnsavedChanges', '$rootScope', '$timeout',
        'Products', '$mdDialog'];

    function DeviceTemplateEditController($scope, $stateParams, $state, $log,
                                          currentAuth, Orgs, DeviceTemplates, Toast, ConfirmUnsavedChanges, $rootScope,
                                          $timeout, Products, $mdDialog) {

        $state.activeTabsInventory = "index.inventory.catalog.list";

        $scope.$emit('loading', false);

        var vm = this;

        vm.errorMessage = '';
        vm.template = { type: 'Device' };
        vm.product = [];
        vm.isSearching = null;
        vm.disabledCatalogReference = true;
        vm.disabledCatalogName = true;
        vm.disabledCatalogProductLine = true;
        vm.allowEdit = allowEdit;

        if (angular.isString($stateParams.objectKey) && $stateParams.objectKey !== "") {
            vm.key = $stateParams.objectKey;
        }
        if(!vm.template.images){
            vm.template.images = []
        }
        vm.finish = finish;
        vm.searchProducts = searchProducts;

        activate();

        function activate() {


            function onSuccess(value) {

                vm.isLoading = false;
                vm.template = value;
                if(!vm.template.images){
                    vm.template.images = []
                }
                if(!vm.template.products){
                    vm.template.products = []
                }
                vm.manufacturers = [value.manufacturer];

                if(vm.template.products) {
                    vm.template.products = vm.template.products[0]
                }

                watchChanges()

            }

            if (angular.isString(vm.key)) {
                var params = {
                    objectKey: vm.key
                };

                DeviceTemplates.get(params, onSuccess, onError);

                return;
            }


            Orgs.get({objectKey:currentAuth.org.key }, function (response) {

                var manufacturers = response.manufacturers || [];
                if (manufacturers.length > 0) {
                    vm.manufacturers = manufacturers;
                }
                else if (angular.isObject(response.manufacturer)) {
                    vm.manufacturers = [response.manufacturer];
                }
                else {
                    ///
                    var message = "User does not have any manufacturers to create a new device template.";
                    Toast.error(message);
                    $log.error(message);
                }

                vm.template.manufacturer = vm.manufacturers[0];
                if(!vm.template.products) vm.template.products = [];


            });

        }

        function validateCatalog(){
            var err = '';
            if(!vm.template.reference || !vm.template.reference.length){
                err += 'Reference Number'
            }

            if(!vm.template.products || !Object.keys(vm.template.products).length){
                if(err.length){
                    err += ', '
                }
                err += 'Product Line'
            }
            if(!vm.template.name || !vm.template.name.length){
                if(err.length){
                    err += ' and '
                }
                err += 'Device Name'
            }
            if(err.length){
                err += ' are required for all Catalog items.'
            }
            if(err.length){
                Toast.error(err);
                return false
            }
            else {
                return true
            }
        }

        function finish(vm) {
            if(!vm){
                vm = this;
            }

            if(!validateCatalog()){
                return
            }

            if (angular.isUndefined(vm.template.reference) || angular.isUndefined(vm.template.name)) {
                vm.errorMessage = 'Must set both reference number and name.';
            }
            
            var res = JSON.parse(JSON.stringify(vm.template));
            if(res.products){
                res.products = [res.products];
            }
            if (angular.isString(vm.template.key)) {
                var params = { objectKey: vm.template.key };
                DeviceTemplates.update(params, res, onSave, onError);
            }
            else {
                DeviceTemplates.insert({}, res, onInsert, onError);
            }

            vm.isLoading = true;
        


            function onSave(value) {
                    $log.info(value)
                vm.isLoading = false;
                // vm.template = value;
                // vm.manufacturers = [value.manufacturer];

                Toast.success('Saved!');
                vm.isChange = false;
            }

            function onInsert(value) {
                onRouteChangeOff();
                vm.isLoading = false;
                //vm.template = value;

                $timeout(function() {
                    vm.key = value.key;
                    $state.go('index.inventory.catalog.edit', { objectKey: value.key }, false);
                }, 500)

                Toast.success('Saved!');

            }

        }


        function onError(error) {

            vm.isLoading = false;
            $log.error(error);

            Toast.error(error);

        }


        // Below Functional related with prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.template', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.template.reference];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;

        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
                //Init watcher here, because we create new entity
                if(!vm.key){
                    watchChanges()
                }

            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


        function sleep(ms) {
            return new Promise(function(resolve){
                vm.isSearching = setTimeout(resolve, ms)
            } );
        }

        function searchProducts(searchText){

            clearTimeout(vm.isSearching);

            return sleep(1000).then(function(){

                var manufactureKey = vm.template.manufacturer.key;

                var params = {
                    search: searchText,
                    manufacturer: manufactureKey,
                    limit: 20
                };

                return Products.search(params).$promise.then(function (response) {
                    return response.items || [];

                }).catch(function(error){
                    $log.info(error)
                    return []
                })
            })

        }

        function allowEdit(el){

                var confirm = $mdDialog.confirm()
                    .title('You are making changed to a catalog item. These changes will be pushed to all devices ' +
                        'sharing the same catalog number in your database. Are you sure you want to continue?')
                    //.targetEvent(target)
                    .ok('OK')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function() {
                    if(el === 'vm.disabledCatalogReference'){
                        vm.disabledCatalogReference = false;
                    }
                    if(el === 'vm.disabledCatalogName'){
                        vm.disabledCatalogName = false;
                    }
                    if(el === 'vm.disabledCatalogProductLine'){
                        vm.disabledCatalogProductLine = false;
                    }
                }, function() {
                    //Close
                });

        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('InventoryEditController', InventoryEditController);


    InventoryEditController.$inject = ['$state', '$scope', '$log', '$stateParams', 'Inventory', 'Cases',
        'TransferModal', 'Toast', 'Show', 'Transfers', 'DeclineTransferModal', '$mdDialog', 'Notifications',
        'DeviceTemplates', '$rootScope', '$timeout', 'ConfirmUnsavedChanges'];

    function InventoryEditController($state, $scope, $log, $stateParams, Inventory, Cases,
                                     TransferModal, Toast, Show, Transfers, DeclineTransferModal, $mdDialog,
                                     Notifications, DeviceTemplates, $rootScope, $timeout, ConfirmUnsavedChanges) {

        var vm = this;

        $state.activeTabsInventory = "index.inventory.list";

        vm.device = {};
        vm.isVerifyingUDI = false;
        vm.verificationErrorMessage = "";
        vm.isSaving = false;
        vm.gudidError = "";
        vm.isReleasingFromTray = false;
        vm.catalogImages = [];
        vm.isChange = false;
        vm.isFirstlyAddUDI = false;
        vm.isSearching = null;
        vm.history = [];
        vm.historyPageSize = 10;
        vm.previousHistoryPages = [];
        vm.nextHistoryPageToken = [];
        vm.isHistoryLoading = false;
        vm.disableEditableFields = true;
        vm.allowedTransfer = true;
        vm.isExistUdi = false;
        vm.imageUrlValue = '';
        vm.allowedTransferDevice = true;

        vm.viewCase = viewCase;
        vm.viewDevice = viewDevice;
        vm.viewUDI = viewUDI;
        vm.verifyUDI = verifyUDI;
        vm.finish = finish;
        vm.initiateTransfer = initiateTransfer;
        vm.releaseFromTray = releaseFromTray;
        vm.setHistorySize = setHistorySize;
        vm.loadPreviousHistory = loadPreviousHistory;
        vm.loadNextHistoryPage = loadNextHistoryPage;
        vm.hasNextHistoryPage = hasNextHistoryPage;
        vm.checkToDisableEditFields = checkToDisableEditFields;
        vm.checkTransferButton = checkTransferButton;
        vm.changeParamsLocation = changeParamsLocation;
        vm.addImageUrl = addImageUrl;
        vm.viewProduct = viewProduct;



        vm.searchCases = function (searchText) {
            return Cases.search({search: searchText}).$promise.then(function (response) {
                return response.items || [];
            });
        };
    
        //Search containers
        function sleep(ms) {
            return new Promise(function(resolve){
                vm.isSearching = setTimeout(resolve, ms)
            } );
        }

        vm.searchContainers = function(searchText) {
            clearTimeout(vm.isSearching);
            
            return sleep(500).then(function() {
                var params = {
                    search: searchText,
                    type: 'Container',
                    custody: vm.device.custody.key
                };
                return Inventory.basicSearch(params).$promise.then(function (response) {
                    return response.items || [];
                });
            });

        };


        vm.showConfirm = function(target) {
            var confirm = $mdDialog.confirm()
                .title('You are about to deactivate this inventory. Typically this happens when an item is damaged, expired, or has been used and cannot be reused. This action cannot be undone. Are you sure you want to continue?')
                //.targetEvent(target)
                .ok('Continue')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                //Deactivate
                deactivate(target)
            }, function() {
                //Close
            });
        };


        function deactivate(){
            var params = {
                objectKey: vm.device.key
            };

            vm.isSaving = true;
            Inventory.deactivate(params, {key: vm.device.key}, function(res){
                Toast.success('Deactivated!');
                vm.isSaving = false;
                location.reload()

            }, function(err){
                $log.error(err);
                Toast.error(err.data.error.message);
                vm.isSaving = false;
            });
        }

        vm.custodyTypes = [
            {value: "Possession", name: "Possession"},
            {value: "Consigned", name: "Consigned"},
            {value: "Loaned", name: "Loaned"},
            {value: "Other", name: "Other"},
        ];

        activate();

        function activate() {

            $scope.$emit('loading', true);
            populateFields();

        }

        function populateFields() {

            var getParams = {
                objectKey: $stateParams.objectKey
            };

            Inventory.get(getParams, success, error);

            function success(value) {

                vm.device = value;

                if (angular.isString(vm.device.description)) {
                    var desc = vm.device.description.replace(/�/g, '');
                    if (desc.length > 0) {
                        vm.device.name = desc;
                    }
                }
                vm.device.tags = Array.from(new Set(vm.device.tags || []));

                $scope.$emit('loading', false);
                vm.isFirstlyAddUDI = vm.device.udi.raw;

                if (vm.device.type === 'Container') {
                    loadDevices(null);
                }

                //Check edit/disable edit fields camparably with case status
                vm.checkToDisableEditFields(vm.device)
                // Check enable/disable "Initialize transfer button"
                vm.checkTransferButton(vm.device);
                vm.isExistUdi = angular.isDefined(vm.device.udi) && angular.isDefined(vm.device.udi.raw);

                //Load History for inventory
                loadHistory();

                // Get images from assigned catalog
                if(vm.device.template){
                    var params = {
                        objectKey: vm.device.template.key
                    }

                    DeviceTemplates.get(params, success, error);
                }
                
                function success(response) {
                    $log.info('response')
                    $log.info(response)
                    vm.catalogImages = response.images || [];
                    vm.nextPageToken = response.nextPageToken;
                    $timeout(function(){
                        watchChanges()
                    }, 500)

                }

                function error(response) {
                    vm.loading = false;
                    $log.error(response);
                    Toast.error(response);
                }

            }

            function error(response) {

                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error('DeviceApi Error: ' + angular.toJson(response));
                Toast.error(error);
            }
        }

        //History load
        function setHistorySize(historySize) {
            vm.historyPageSize = historySize;
            vm.previousHistoryPages = [];
            loadHistory();
        }

        function loadPreviousHistory() {
            if (vm.previousHistoryPages.length === 0) return;
            vm.previousHistoryPages.pop();
            loadHistory();
        }

        function loadNextHistoryPage() {
            if (!angular.isString(vm.nextHistoryPageToken)) return;
            vm.previousHistoryPages.push(vm.nextHistoryPageToken);
            vm.nextHistoryPageToken = [];
            loadHistory();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousHistoryPages.length === 0) return;
            vm.previousHistoryPages.pop();
            loadHistory();
        }

        function hasNextHistoryPage() {
            return angular.isDefined(vm.nextHistoryPageToken);
        }

        function loadHistory (){
            vm.isHistoryLoading = true;

            var len = vm.previousHistoryPages.length;
            var params = {
                objectKey: vm.device.key,
                limit: vm.historyPageSize,
                cursor: vm.previousHistoryPages[len - 1]
            };
            Inventory.history(params, successHistoryLoad, errorHistoryLoad);

            function successHistoryLoad(res){
                vm.history = res.items || [];
                vm.nextHistoryPageToken = res.nextPageToken;
                vm.isHistoryLoading = false;
            }
            function errorHistoryLoad(err){
                Toast.error('Error history load');
            }

        }
        // </>  End History load

        vm.transferDeclining = false;
        vm.transferAccepting = false;

        vm.acceptTransfer = acceptTransfer;
        vm.declineTransfer = declineTransfer;

        function setDeviceStats() {
            if (vm.devices.length > 0) {
                var assignedLotCount = 0;
                var unassignedLotCount = 0;
                var usedDeviceCount = 0;
                var damagedDeviceCount = 0;
                var unusedDeviceCount = 0;
                angular.forEach(vm.devices, function (device) {

                    var quantity = 1;

                    if (angular.isDefined(device.udi) && (angular.isDefined(device.udi.raw) || angular.isDefined(device.udi.lot))) {
                        assignedLotCount += quantity;
                    } else {
                        unassignedLotCount++;
                    }

                    switch (device.status) {
                        case "Used":
                            usedDeviceCount += quantity;
                            break;
                        case "Damaged":
                            damagedDeviceCount += quantity;
                            break;
                        case "Unused":
                            unusedDeviceCount += quantity;
                            break;
                    }
                    vm.assignedLotCount = assignedLotCount;
                    vm.unassignedLotCount = unassignedLotCount;
                    vm.usedDeviceCount = usedDeviceCount;
                    vm.unusedDeviceCount = unusedDeviceCount;
                    vm.damagedDeviceCount = damagedDeviceCount;

                });
            }

        }


        vm.loadingDevices = false;
        vm.devices = [];


        function loadDevices(cursor) {

            vm.loadingDevices = true;

            var params = {
                container: $stateParams.objectKey,
                cursor:cursor,
                active: vm.device.active,
                limit: 100
            };

            Inventory.search(params, success, error);

            function success(response) {

                if (angular.isUndefined(vm.devices)) {
                    vm.devices = [];
                }

                response.items = response.items || [];
                Array.prototype.push.apply(vm.devices, response.items);

                if (angular.isString(response.nextPageToken)) {
                    loadDevices(response.nextPageToken);
                }
                else {
                    vm.loadingDevices = false;
                    setDeviceStats()
                }
            }

            function error(response) {
                Toast.error(response)
            }


        }

        function releaseFromTray() {
            if(vm.device.dueBackDate){
                var confirm = $mdDialog.confirm()
                    .title('You are releasing a device from a container with a “Due Back” date set. ' +
                        'The current due date will remain on this device until custody has been transferred or the ' +
                        'device has been marked as used. Do you want to continue?')
                    .ok('YES')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function() {
                    //Deactivate
                    vm.device.container = undefined;
                    vm.device.removeFromContainer = true;
                   // finish();
                }, function() {
                    //Close
                });
            }
            else {
                vm.device.container = undefined;
                vm.device.removeFromContainer = true;
                //finish();
            }


        }

        function acceptTransfer(transfer) {

            var key = transfer.key;
            var params = {objectKey: key};

            if (angular.isUndefined(key)) {
                return;
            }

            if (vm.transferAccepting || vm.transferDeclining) {
                return;
            }

            vm.transferAccepting = true;

            Transfers.accept(params, null, transferSuccess, transferError);

        }

        function declineTransfer(transfer) {

            DeclineTransferModal.show(function (reason) {

                var key = transfer.key;
                var params = {objectKey: key};

                if (angular.isUndefined(key)) {
                    return;
                }

                if (vm.transferAccepting || vm.transferDeclining) {
                    return;
                }

                var body = {content: reason};

                vm.transferDeclining = true;

                Transfers.decline(params, body, transferSuccess, transferError);

            });


        }

        function transferSuccess(response) {
            vm.device.transfer.status = response.status;
            vm.transferAccepting = false;
            vm.transferDeclining = false;
            Toast.success(response.status + ' transfer!');
        }

        function transferError(response) {
            Toast.error(response);
            vm.transferAccepting = false;
            vm.transferDeclining = false;
        }

        function initiateTransfer() {
            if(vm.disableEditableFields && !vm.device.reusable){
                return
            }
            TransferModal.show(null, vm.device, function (transfer) {
                vm.device.transfer = transfer;
            });
        }

        function viewCase(caseKey) {
            if (angular.isUndefined(caseKey)) return;
            $state.go('index.cases.edit', {objectKey: caseKey})
        }

        function viewProduct(prodKey) {
            if (angular.isUndefined(prodKey)) return;
            $state.go('index.inventory.productedit', {objectKey: prodKey})
        }

        function viewUDI(udiKey) {
            if (angular.isUndefined(udiKey)) return;
            $state.go('index.udis.edit', {objectKey: udiKey})
        }

        function viewDevice(key) {
            if (angular.isUndefined(key)) return;
            $state.go('index.inventory.edit', {objectKey: key})
        }

        function verifyUDI(raw) {

            if (angular.isUndefined(raw)) return;
            if (raw.length === 0) return;

            vm.isVerifyingUDI = true;
            //if UDI changer, reset all UDI related fields
            if(vm.isExistUdi){
                vm.device.udi.lot = null;
                vm.device.udi.serial = null;
                vm.device.udi.expiration = null;
                vm.device.udi.expirationValue = null;
                vm.device.udi.di = null;
                vm.device.udi.raw = null;
                vm.device.udi.readable = null;
                vm.device.udi.symbology =  null;
                vm.device.udi.data = null;
            }
            Inventory.verifyUDI(null, {raw: raw}, success, error);

            function success(response) {
                vm.isVerifyingUDI = false;
                if (angular.isDefined(response.message)) {
                    vm.verificationErrorMessage = response.message;
                } else {
                    
                    if(vm.isFirstlyAddUDI){
                        //if vm.device.udi [n] properties empty, from backend came null
                        vm.device.udi.lot = response.lot || vm.device.udi.lot || null;
                        vm.device.udi.serial = response.serial || vm.device.udi.serial || null;
                        vm.device.udi.expiration = response.expiration || vm.device.udi.expiration || null;
                        vm.device.udi.expirationValue = response.expirationValue || vm.device.udi.expiration || null;
                        vm.device.udi.di = response.di || vm.device.udi.di || null;
                        vm.device.udi.raw = response.raw || vm.device.udi.raw || null;
                        vm.device.udi.readable = response.readable || vm.device.udi.readable  || null;
                        vm.device.udi.symbology = response.symbology || vm.device.udi.symbology || null;
                        vm.device.udi.data = response.data || vm.device.udi.data || null;
                        vm.isFirstlyAddUDI = false;
                    }
                    else {
                        vm.device.udi.lot = response.lot || null;
                        vm.device.udi.serial = response.serial || null;
                        vm.device.udi.expiration = response.expiration || null;
                        vm.device.udi.expirationValue = response.expirationValue || null;
                        vm.device.udi.di = response.di || null;
                        vm.device.udi.raw = response.raw || null;
                        vm.device.udi.readable = response.readable || null;
                        vm.device.udi.symbology = response.symbology || null;
                        vm.device.udi.data = response.data || null;
                    }

                    Toast.success('Successfully parsed UDI.');
                    finish(vm);
                    vm.verificationErrorMessage = null;
                }
            }

            function error(response) {
                $log.error(angular.toJson(response));
                vm.isVerifyingUDI = false;
                vm.verificationErrorMessage = 'Something went wrong.';
            }

        }

        function finish(vm) {
            if(!vm){
                vm = this
            }

            if (angular.isUndefined(vm.device.key)) return;

            var params = {
                objectKey: vm.device.key
            };

            if(vm.device.location){
                vm.device.location = vm.changeParamsLocation(vm.device.location)
            }

            vm.isSaving = true;
            Inventory.update(params, vm.device, success, error);

            function success(response) {
                vm.device = response;
                vm.device.tags = Array.from(new Set(vm.device.tags || []));
                vm.isSaving = false;
                Toast.success('Saved!');
                vm.isChange = false;
                //Reload data, because backend send invalida data in respoce after update
                activate();
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(response);
                Toast.error(response);
            }

        }

        /*
        * Changed location data to format which expect backend, vTract has also identical data
        * */
        function changeParamsLocation (place) {
            if(!place) return {}

            var location = {};
            location.placeId = place.place_id;
            location.name = place.name;
            location.street = place.formatted_address;

            if(place.geometry){
                if(typeof place.geometry.location.lat === "function"){
                    location.latitude = place.geometry.location.lat().toString();
                }
                else {
                    location.latitude = place.geometry.location.toString();
                }
                if(typeof place.geometry.location.lng === "function"){
                    location.longitude = place.geometry.location.lng().toString();
                }
                else {
                    location.longitude = place.geometry.location.toString();
                }
            }

            var addressComp = place.address_components || [];

            addressComp.forEach(function(c){
                c.types.forEach(function(type){
                    if(type === "locality"){
                        location.city = c.long_name;
                        return true
                    }
                    if(type === "administrative_area_level_1"){
                        location.state = c.long_name;
                        return true
                    }
                    if(type === "country"){
                        location.country = c.long_name;
                        return true
                    }
                    if(type === "postal_code"){
                        location.postalCode = c.long_name
                    }
                })
            })

            return location
        }


        // Below Functional related with prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.device', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.device.reference, vm.device.name, vm.device.custody, vm.device.manufacturer,vm.device.product]
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

        //Check to edit/disable fields
        function checkToDisableEditFields(inventoryCase){
            //Don't allow to transfer devices which are in container
            if(inventoryCase.type === 'Device'){
                vm.allowedTransferDevice = angular.isUndefined(inventoryCase.container)
            }
            if(!vm.device.active){
                vm.disableEditableFields = true;
                return
            }

            if(!inventoryCase.caze) {
                vm.disableEditableFields = false
                return
            }
            vm.disableEditableFields =  (inventoryCase.caze.status === 'Closed' ||
                                      inventoryCase.caze.status === 'Cancelled' ||
                                     inventoryCase.caze.status === 'Completed') &&
                                                        !inventoryCase.reusable;



        }

        //Check enable/disable transfer button
        function checkTransferButton(device){
            vm.allowedTransfer = device.status === 'Unused' && angular.isUndefined(device.caze) && vm.device.active
        }

        function addImageUrl(){
            if(!vm.device.images){
                vm.device.images = [];
            }
            vm.device.images.push(vm.imageUrlValue);
            vm.imageUrlValue = '';
        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.inventory')
        .controller('InventoryAddController', InventoryAddController);

    InventoryAddController.$inject = ['$filter', '$state', '$scope', '$log',
        'Products', 'Orgs', 'Inventory', 'Toast', 'currentAuth', 'Accounts', 'UDI', 'ConfirmUnsavedChanges',
        '$timeout', '$rootScope', 'NewManufactureModal', 'NewInvProductModal'];

    function InventoryAddController($filter, $state, $scope, $log,
                                    Products, Orgs, Inventory, Toast, currentAuth, Accounts, UDI, ConfirmUnsavedChanges,
                                    $timeout, $rootScope, NewManufactureModal, NewInvProductModal) {

        $state.activeTabsInventory = "index.inventory.list";

        var vm = this;
        vm.device = {
            type:'Device',
            udi:{},
            tags:[]
        };

        vm.manufacturers = [];

        vm.isSaving = false;
        vm.isChange = false;
        vm.cacheContainers = null;
        vm.isSearchContainerTextChanged = false;
        vm.cacheContainers = [];

        vm.finish = finish;
        vm.searchContainers = searchContainers;
        vm.searchCustody = searchCustody;
        vm.searchProducts = searchProducts;
        vm.verifyUDI = verifyUDI;
        vm.addManufacture = addManufacture;
        vm.addNewProduct = addNewProduct;

        activate();

        function activate() {

            $scope.$emit('loading', false);
            populateFields();

        }

        function populateFields(recentlyAddedManufacture) {

            Orgs.get({ objectKey: currentAuth.org.key }, function (org) {
                vm.manufacturers = org.manufacturers || [];
                if (org.manufacturers.length > 0) {
                    vm.device.manufacturer = org.manufacturers[0];
                }
                vm.device.custody = org;

                if(recentlyAddedManufacture){
                    vm.device.manufacturer = recentlyAddedManufacture
                }

            }, Toast.error);

        }

        function validate(){
            var err = '';
            if(!vm.device.reference || !vm.device.reference.length ){
                err += 'Reference'
            }
            if(!vm.device.name || !vm.device.name.length ){
                if(err.length){
                    err += ', name'
                } else {
                    err += 'Name'
                }

            }
            if(!vm.device.product || !Object.keys(vm.device.product).length ){
                if(err.length){
                    err += ', product'
                } else {
                    err += 'Product'
                }
            }
            if(!vm.device.manufacturer || !Object.keys(vm.device.manufacturer).length ){
                if(err.length){
                    err += ', manufacture'
                } else {
                    err += 'Manufacture'
                }
            }
            if(!vm.device.custody || !Object.keys(vm.device.custody).length ){
                if(err.length){
                    err += ', custody'
                } else {
                    err += 'Custody'
                }
            }
            if(err.length){
                if(err.includes(',')){
                    err += ' are required'
                } else {
                    err += ' is required'
                }
                Toast.error(err)
                return false
            }
            else {
                return true
            }
        }

        function finish(vm) {
            if(!vm){
                vm = this
            }

            if(!validate()){
                return
            }

            vm.isSaving = true;
            Inventory.insert(null, vm.device, success, error);

            function success(response) {
                onRouteChangeOff();
                vm.isSaving = false;
                var count = (response.items || []).length;
                var message = count === 1 ? ' item! ' : ' items! ';
                Toast.success('Successfully added ' + count + ' '+ message);
                vm.isChange = false;
                // Go to detail page
                if(count === 1 && response.items){
                    if(response.items.length){
                        $state.go('index.inventory.edit', { objectKey: response.items[0].key });
                    }
                }
            }

            function error(response) {
                vm.isSaving = false;
                $log.error(angular.toJson(response));
                Toast.error(response);
            }

        }

        function searchCustody(searchText) {
            return Accounts.list({}).$promise.then(function (response) {
                var options = [];
                var items = response.items || [];
                angular.forEach(items, function (a) {
                    if (a.accountType === 'Individual') {
                        options.push(a);
                    }
                });

                return Accounts.me({}).$promise.then(function (me) {
                    options.push(me.org);
                    return $filter('filter')(options, searchText);
                });

            });
        }

        function searchProducts(manufacturer, searchText) {

            var params = {
                search: searchText,
                manufacturer: manufacturer,
                limit: 20
            };
            return Products.search(params).$promise.then(function (response) {
                return response.items || [];
            });
        }

        //Search containers
        function sleep(ms) {
            return new Promise(function(resolve){
                vm.isSearching = setTimeout(resolve, ms)
            } );
        }

        function searchContainers(custody, manufacturer, searchText) {

            clearTimeout(vm.isSearching);

            if(!vm.isSearchContainerTextChanged){
                return vm.cacheContainers
            }

            return sleep(1500).then(function() {
                var params = {
                    search: searchText,
                    custody: custody,
                    manufacturer: manufacturer,
                    type: 'Container',
                    size: 20
                };
                return Inventory.basicSearch(params).$promise.then(function (response) {
                    vm.isSearchContainerTextChanged = false;
                    vm.cacheContainers = response.items || [];
                    return response.items || [];
                }).catch(function(err){
                    $log.info(err);
                })
            }).catch(function(err){
                $log.info(err)
            })
        }
        // </>

        function verifyUDI(raw) {

            if (!angular.isString(raw)) return;
            if (raw.length === 0) return;

            vm.isVerifyingUDI = true;
            UDI.parse({udi: raw, history: false}, success, error);

            function success(response) {
                vm.isVerifyingUDI = false;
                if (angular.isDefined(response.message)) {
                    vm.verificationErrorMessage = response.message;
                } else {
                    vm.device.udi = {};
                    vm.device.udi.raw = response.raw || null;
                    vm.device.udi.expirationDate = response.expirationDate || null;
                    vm.device.udi.expiration = response.expiration || null;
                    vm.device.udi.serial = response.serial || null;
                    vm.device.udi.lot = response.lot || null;
                    vm.device.udi.di = response.di || null;
                    vm.device.udi.created = response.created || null;
                    var gudid = response.gudid;
                    vm.device.gudidDeviceEntitiy = gudid;
                    if (angular.isObject(gudid)) {
                        vm.device.reference = gudid.catalogNumber || gudid.versionModelNumber;
                        vm.device.name = gudid.deviceDescription;
                        vm.device.product = {
                            name: gudid.brandName,
                            objectId:gudid.productKey
                        };
                        for (var i=0; i < vm.manufacturers.length; i++){
                            var m = vm.manufacturers[i];
                            if (gudid.manufacturerKey === m.objectId) {
                                vm.device.manufacturer = m;
                                break;
                            }
                        }
                    }

                    Toast.success('Successfully parsed UDI.');
                    vm.verificationErrorMessage = null;
                }
            }

            function error(response) {
                $log.error(response);
                vm.isVerifyingUDI = false;
                vm.verificationErrorMessage = 'Something went wrong.';
            }

        }


        // Below Functional related with prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.device', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.device.reference, vm.device.name, vm.device.custody, vm.device.manufacturer,vm.device.product]
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                //Init watcher here, because we create new entity
                watchChanges()

            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

        function addManufacture(){
            function callbackAddedManufacture(manufacture){
                $log.info(manufacture)
                populateFields(manufacture)
            }
            NewManufactureModal.show('', callbackAddedManufacture)
        }

        function addNewProduct(){

            function callbackAddedNewProduct(prod){
                $log.info('callbackAddedNewProduct')
                $log.info(prod)
                $log.info(vm.device.manufacturer.key)
                if(prod.manufacturer.key === vm.device.manufacturer.key){
                    $log.info('DO')
                    vm.device.product = prod
                }
            }

            NewInvProductModal.show(vm.manufacturers, callbackAddedNewProduct, vm.device.manufacturer)
        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory.procedures')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.directory.procedures', {
                abstract: false,
                url: '/procedures',
                template: ' <ui-view></ui-view>',
                controllerAs: 'vm'
            })
            .state('index.directory.procedures.add', {
                url: '/add',
                templateUrl: 'app/directory/procedures/add/procedures.add.html',
                controller: 'ProceduresAddController',
                controllerAs: 'vm'
            }).state('index.directory.procedures.list', {
                url: '/?cursor&clear&limit&nolot&custody&type&loose&billable&active&search&status&expiration&manufacturer&container',
                templateUrl: 'app/directory/procedures/list/procedures.list.html',
                controller: 'ProceduresListController',
                controllerAs: 'vm'
            })
            .state('index.directory.procedures.detail', {
                url: '/:objectKey/detail',
                templateUrl: 'app/directory/procedures/detail/procedures.detail.html',
                controller: 'ProceduresDetailController',
                controllerAs: 'vm',
                resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
            })
            .state('index.directory.procedures.edit', {
                url: '/:objectKey/edit',
                templateUrl: 'app/directory/procedures/edit/procedures.edit.html',
                controller: 'ProceduresEditController',
                controllerAs: 'vm',
                resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
            })
            .state('index.directory.procedures.deactivated', {
                url: '/deactivated',
                templateUrl: 'app/directory/procedures/deactivated/procedures.deactivated.html',
                controller: 'ProceduresDeactivatedListController',
                controllerAs: 'vm',
                resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
            });
    }

})();



(function() {
  'use strict';

  angular
    .module('connectsx.directory.procedures')
    .factory('Procedures', Procedures);

  Procedures.$inject = ['$resource', 'restUrl'];

  function Procedures($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/procedure/:objectKey';
    var searchUrl = restUrl + '/v1/procedure';
    var deactivate = restUrl + '/v1/procedure/:objectKey/deactivate';
    var reactivate = restUrl + '/v1/procedure/:objectKey/reactivate';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        search: { method:'GET', url: searchUrl },
        deactivate: {
          method:'PUT',
          url:deactivate
        },
        reactivate: {
          method:'PUT',
          url:reactivate
        }

      });
  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.physicians')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.directory.physicians', {
        abstract: false,
        url: '/physicians',
        templateUrl: 'app/directory/physicians/physician.html',
        controller: 'PhysiciansController',
        controllerAs: 'vm'
      })
      .state('index.directory.physicians.add', {
        url: '/add',
        templateUrl: 'app/directory/physicians/add/physicians.add.html',
        controller: 'PhysiciansAddController',
        controllerAs: 'vm'
    }).state('index.directory.physicians.list', {
        url: '/?cursor&clear&limit&nolot&custody&type&loose&billable&active&search&status&expiration&manufacturer&container',
        templateUrl: 'app/directory/physicians/list/physicians.list.html',
        controller: 'PhysiciansListController',
        controllerAs: 'vm'
    })
      .state('index.directory.physicians.edit', {
        url: '/:objectKey/edit',
        templateUrl: 'app/directory/physicians/edit/physician.edit.html',
        controller: 'PhysiciansEditController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      })
        .state('index.directory.physicians.detail', {
        url: '/:objectKey/detail',
        templateUrl: 'app/directory/physicians/detail/physician.detail.html',
        controller: 'PhysiciansDetailController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      })
      .state('index.directory.physicians.deactivated', {
        url: '/deactivated',
        templateUrl: 'app/directory/physicians/deactivated/physicians.deactivated.html',
        controller: 'PhysiciansDeactivatedListController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      });
  }

})();



(function() {
  'use strict';

  angular
    .module('connectsx.directory.physicians')
    .factory('Physicians', Physicians);

  Physicians.$inject = ['$resource', 'restUrl'];

  function Physicians($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/physician/:objectKey';
    var searchUrl = restUrl + '/v1/physician/search';
    var favoritesUrl = restUrl + '/v1/physician/favorites';
    var favoritesActionUrl = resourceUrl + '/favorite';
    var deactivate = restUrl + '/v1/physician/:objectKey/deactivate';
    var reactivate = restUrl + '/v1/physician/:objectKey/reactivate';
    var notes = restUrl + '/v1/notes/:objectKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        search: { method:'GET', url: searchUrl },
        favorites: {
          method:'GET',
          url:favoritesUrl
        },
        removeFavorite: {
          method:'DELETE',
          url: favoritesActionUrl
        },
        addFavorite: {
          method:'POST',
          url:favoritesActionUrl
        },
        deactivate: {
          method:'PUT',
          url:deactivate
        },
        reactivate: {
          method:'PUT',
          url:reactivate
        },
        notes: {
          method:'GET',
          url:notes
        }

      });
  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.directory.physicians')
        .controller('PhysiciansController', PhysiciansController);

    PhysiciansController.$inject = ['$state', 'Physicians', '$stateParams', '$log', 'Toast'];

    function PhysiciansController($state, Physicians, $stateParams, $log, Toast) {

        $state.activeTabsDirectory = "index.directory.physicians.list";

        var vm = this;

        activate();

        function activate() {

            if (!angular.isString($stateParams.objectKey)) {
                return
            }

            var params = { objectKey: $stateParams.objectKey };

            function success(response) {
                $log.info(angular.toJson(response));
            }

            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                Toast.error(error);

            }

            Physicians.get(params, success, error);

        }
    }
})();


// (function () {
//   'use strict';
//
//   /* global angular */
//
//   angular
//     .module('connectsx.directory.facilities')
//     .controller('FacilityDetailController', FacilityDetailController);
//
//   FacilityDetailController.$inject = ['$scope', '$log', '$stateParams', 'Facilities', 'Toast', 'Show'];
//
//   function FacilityDetailController($scope, $log, $stateParams, Facilities, Toast, Show) {
//
//     $scope.$emit('loading', false);
//
//     var vm = this;
//
//     vm.facility = {};
//
//     activate();
//
//     function activate() {
//
//       if (!angular.isString($stateParams.objectKey)) {
//         return;
//       }
//
//       var params = { objectKey: $stateParams.objectKey };
//
//       function success(response) {
//         $log.info(angular.toJson(response));
//         vm.facility = response;
//       }
//
//       function error(error) {
//
//         if (error.status === 404 || error.status === 400) {
//           Show.notFound();
//           return;
//         }
//
//         $log.error(angular.toJson(error));
//         Toast.error(error);
//
//       }
//
//       Facilities.get(params, success, error);
//
//     }
//   }
//
// })();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.facilities')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.directory.facilities', {
        abstract: false,
        url: '/facilities',
        templateUrl: 'app/directory/facilities/facility.html',
        controllerAs: 'vm',
        controller: 'FacilitiesController'
      })
      .state('index.directory.facilities.add', {
        url: '/add',
        templateUrl: 'app/directory/facilities/add/facilities.add.html',
        controller: 'FacilitiesAddController',
        controllerAs: 'vm'
      })
      .state('index.directory.facilities.list', {
        url: '/?cursor&clear&limit&nolot&custody&type&loose&billable&active&search&status&expiration&manufacturer&container',
        templateUrl: 'app/directory/facilities/list/facilities.list.html',
        controller: 'FacilitiesListController',
        controllerAs: 'vm'
      })
      .state('index.directory.facilities.edit', {
        url: '/:objectKey/edit',
        templateUrl: 'app/directory/facilities/edit/facilities.edit.html',
        controller: 'FacilitiesEditController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      })
      .state('index.directory.facilities.detail', {
        url: '/:objectKey/detail',
        templateUrl: 'app/directory/facilities/detail/facilities.detail.html',
        controller: 'FacilitiesDetailController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      })
      .state('index.directory.facilities.deactivated', {
        url: '/deactivated',
        templateUrl: 'app/directory/facilities/deactivated/facilities.deactivated.html',
        controller: 'FacilitiesDeactivatedListController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      })
        .state('index.directory.facilities.uploadprice', {
        url: '/uploadprice/:objectKey/',
        templateUrl: 'app/directory/facilities/uploadprice/facilities.uploadprice.html',
        controller: 'FacilitiesUploadPriceController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      });
  }

})();



(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.directory.facilities')
    .factory('Facilities', Facilities);

  Facilities.$inject = ['$resource', 'restUrl'];

  function Facilities($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/facility/:objectKey';
    var searchUrl = restUrl + '/v1/facility';
    var favoritesUrl = restUrl + '/v1/facility/favorites';
    var favoritesActionUrl = resourceUrl + '/favorite';
    var deactivate = restUrl + '/v1/facility/:objectKey/deactivate';
    var reactivate = restUrl + '/v1/facility/:objectKey/reactivate';
    var uploadCSV = restUrl + "/v1/facility/prices";
    var getCSV = restUrl + "/v1/facility/:facilityKey/prices/:manufacturerKey";

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        search: {
          method: 'GET',
          url: searchUrl
        },
        favorites: {
          method:'GET',
          url:favoritesUrl
        },
        removeFavorite: {
          method:'DELETE',
          url: favoritesActionUrl
        },
        addFavorite: {
          method:'POST',
          url:favoritesActionUrl
        },
        deactivate: {
          method:'PUT',
          url:deactivate
        },
        reactivate: {
          method:'PUT',
          url:reactivate
        },
        uploadCSV: {
          method:'POST',
          url:uploadCSV
        },
        getCSV: {
          method:'GET',
          url:getCSV
        }
      });
  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.directory.facilities')
        .controller('FacilitiesController', FacilitiesController);

    FacilitiesController.$inject = ['$state', '$stateParams', '$log', 'Toast', 'Facilities', 'Invitations'];

    function FacilitiesController($state, $stateParams, $log, Toast, Facilities, Invitations) {

        $state.activeTabsDirectory = "index.directory.facilities.list";

        var vm = this;

        activate();

        function activate() {
            var params = { objectKey: $stateParams.objectKey };

            Facilities.get({}, function (facilities) {
                var items = [];
                console.log(facilities)
                facilities.items = facilities.items || [];
                angular.forEach(facilities.items, function (i) {
                    if (i.accountType !== 'Connectsx') {
                        items.push(i);
                    }
                });
                vm.facilities = items;
            }, Toast.error);


            Invitations.list({claimed: false}, function (invitations) {
                vm.invitations = invitations.items || [];
            }, Toast.error);

            if (!angular.isString($stateParams.objectKey)) {
                return
            }

            function success(response) {
                $log.info(angular.toJson(response));
            }

            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                Toast.error(error);

            }

            Facilities.get(params, success, error);

        }
    }
})();


(function() {
  'use strict';
  /* global angular */

  angular
    .module('connectsx')
    .directive('xlsImport', xlsImport);

  xlsImport.$inject = ['$log'];

  // Start from https://gist.github.com/iwek/7154578#file-csv-to-json-js and fix the issue with double quoted values

  var EOL = {};
  var EOF = {};
  var QUOTE = 34;
  var NEWLINE = 10;
  var RETURN = 13;

  function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
      return angular.toJson(name) + ": d[" + i + "]";
    }).join(",") + "}");
  }

  function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
      return f(object(row), i, columns);
    };
  }

// Compute unique columns in order of discovery.
//   function inferColumns(rows) {
//     var columnSet = Object.create(null),
//       columns = [];
//
//     rows.forEach(function(row) {
//       for (var column in row) {
//         if (!(column in columnSet)) {
//           columns.push(columnSet[column] = column);
//         }
//       }
//     });
//
//     return columns;
//   }

  function uniqueHeaders(headers) {
    var keys = {};
    for (var i=0; i < headers.length; i++) {

      var header = headers[i];

      if ("" === header) continue;

      if (angular.isUndefined(keys[header])) {
        keys[header] = 0;
        headers[i] = header;
      } else {
        keys[header] = keys[header] + 1;
        headers[i] = header + ' ' + keys[header].toString();
      }
    }
    return headers;
  }

  function xlsImport($log) {

    return {
      link: function ($scope, $elm) {

        $elm.on('change', function (changeEvent) {

          var reader = new FileReader();

          reader.onload = function (evt) {
            $scope.$apply(function () {

              var raw = evt.target.result;

              var rows = csv.parseRows(raw);

              if (angular.isArray(rows) && rows.length > 1) {
                $scope.vm.headers = uniqueHeaders(rows[0]);
                $scope.vm.rows = rows.slice(1);
              }
              else {
                $scope.vm.headers = [];
                $scope.vm.rows = [[]];
              }

            });
          };

          reader.readAsBinaryString(changeEvent.target.files[0]);
        });
      }
    }
  }


  /**
   * derive from https://d3js.org/d3.v4.js
   *
   * @param delimiter
   * @returns {{parse: parse, parseRows: parseRows}}
   */
  var dsv = function(delimiter) {

    var DELIMITER = delimiter.charCodeAt(0);

    function parse(text, f) {
      var convert, columns, rows = parseRows(text, function(row, i) {
        if (convert) return convert(row, i - 1);
        columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
      });
      rows.columns = columns || [];
      return rows;
    }

    function parseRows(text, f) {
      var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

      // Strip the trailing newline.
      if (text.charCodeAt(N - 1) === NEWLINE) --N;
      if (text.charCodeAt(N - 1) === RETURN) --N;

      function token() {
        if (eof) return EOF;
        if (eol) return eol = false, EOL;

        // Unescape quotes.
        var i, j = I, c;
        if (text.charCodeAt(j) === QUOTE) {
          while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
          if ((i = I) >= N) eof = true;
          else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
          else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
          return text.slice(j + 1, i - 1).replace(/""/g, "\"");
        }

        // Find next delimiter or newline.
        while (I < N) {
          if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
          else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
          else if (c !== DELIMITER) continue;
          return text.slice(j, i);
        }

        // Return last token before EOF.
        return eof = true, text.slice(j, N);
      }

      while ((t = token()) !== EOF) {
        var row = [];
        while (t !== EOL && t !== EOF) row.push(t), t = token();
        if (f && (row = f(row, n++)) == null) continue;
        rows.push(row);
      }

      return rows;
    }


    return {
      parse: parse,
      parseRows: parseRows
    };
  };

  var csv = dsv(",");


})();

(function() {
'use strict';

  angular
    .module('connectsx')
    .directive('csxWasher', csxWasher);

  function csxWasher() {
    return {
      restrict: 'EA',
      templateUrl: 'app/directives/washer/washer.html',
      controller: 'WasherController',
      controllerAs: 'vm',
      scope: {
        washer: '=',
        size: '@',
      },
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .controller('WasherController', WasherController);

  WasherController.$inject = ['systemImagePath'];

  function WasherController(systemImagePath) {
    var vm = {
      imagePath: systemImagePath
    };
    return vm;
  }

})();

// (function() {
//     'use strict';
//     /* global angular */
//
//     angular
//         .module('connectsx')
//         .directive('numbersOnly', numbersOnly)
//
//     numbersOnly.$inject = [];
//
//     function numbersOnly() {
//         return {
//             restrict: 'EA',
//             require: 'ngModel',
//             link: function (scope, element, attr, ngModelCtrl) {
//                 function fromUser(text) {
//                     if (text) {
//                         var transformedInput = text.replace(/[^0-9\.\d]/gi, '');
//
//                         if (transformedInput !== text) {
//                             ngModelCtrl.$setViewValue(transformedInput);
//                             ngModelCtrl.$render();
//                         }
//                         return transformedInput;
//                     }
//                     return undefined;
//                 }
//                 ngModelCtrl.$parsers.push(fromUser);
//             }
//         }
//     }
// })();
(function() {
    'use strict';
/*
    Directive `upload-file`
    Attributes:
   1. (optional) upload-only-images=""  if true will be uploader only images, if false all files,
    it binding attribute accept in input type="file"

   2. (optional) upload-folder=""  folder in cloudStorage

   3. (Important attribute) ng-model="" binding variable in component, into it variable will be save result work directive

   4. (optional) loading=""  usually vm.loading, just preloader for show process uploading files
 */
    angular
        .module('connectsx')
        .directive('uploadFile', uploadFile);
    uploadFile.$inject = ['$firebaseAuth', '$q', 'firebase', '$timeout', '$log']
    function uploadFile($firebaseAuth, $q, firebase, $timeout, $log) {
        return {
            restrict: 'EA',
            templateUrl: 'app/directives/file-uploader/file-uploader.html',
            controller: 'UploadFileController',
            controllerAs: 'vm',
            scope: {
                ngModel: '=',
                loading: '=',
                uploadOnlyImages: '<'

            },
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                scope.files = [];
                scope.acceptFiles = scope.uploadOnlyImages ? 'image/*' : '*';
                scope.buttonText = scope.uploadOnlyImages ? 'Upload images' : 'Upload file';
                scope.fileName = '';
                scope.removeFile = removeFile;

                function removeFile(index){
                    var files = Array.prototype.slice.call(scope.files);
                    files.splice(index, 1)
                    scope.ngModel.splice(index, 1)
                    scope.files = files;
                }

                element.bind('change', function (event) {
                    scope.$apply(function () {
                        if(!event) return

                        var newFiles = Array.prototype.slice.call(event.target.files);
                        var oldFiles = scope.files ? Array.prototype.slice.call(scope.files) : [];
                        var concatenated = oldFiles.concat(newFiles);

                        scope.files = concatenated;
                        // upload files
                        scope.uploadFile()
                    });
                });

                scope.uploadFile = function(){
                    function UploadFilesAsPromise (imageFile, folder, i) {
                            scope.loading = true;
                            if(!folder){
                                // save to string because folder name can be undefined
                                folder = ''
                            }
                            // Added milliseconds in file name, because firebase can replace old file with identical name
                            var d = new Date();
                            var milliseconds = d.getTime();
                            var storageRef = firebase.storage().ref('/' + $firebaseAuth().$getAuth().uid + '/' + folder + '/' + milliseconds + imageFile.name);
                            console.log(imageFile)
                            //Upload file
                            var task = storageRef.put(imageFile);

                            task.on('state_changed',
                                function progress(snapshot) {
                                    var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                                    console.log(percentage)
                                },
                                function error(err) {
                                    console.log('Error')
                                    console.log(err)
                                },
                                function complete() {
                                console.log('complete')
                                // $timeout need for angular update scope
                                    $timeout(function(){
                                        console.log('complete')
                                        var downloadURL = task.snapshot.downloadURL
                                        scope.files.splice(i, 1)

                                        if(typeof scope.ngModel === 'undefined'){
                                            scope.ngModel = [];
                                            scope.ngModel.push(downloadURL)
                                        }
                                        else {
                                            scope.ngModel.push(downloadURL)
                                        }


                                        scope.loading = false

                                    })
                                }
                            );
                    }


                    if (scope.files) {

                        for (var i = 0; i < scope.files.length; i++) {
                            var file = scope.files[i];
                            if(typeof file !== "string"){
                                UploadFilesAsPromise(file, attrs.uploadFolder, i);
                            }
                        }
                    }

                };
            }
        }
    }

})();



(function() {
    'use strict';

    angular
        .module('connectsx')
        .controller('UploadFileController', UploadFileController)


    UploadFileController.$inject = ['$scope', '$timeout', '$log'];

    function UploadFileController($scope, $timeout, $log) {
        $timeout(function(){
            if(!$scope.ngModel){
                $timeout(function(){
                    $scope.files = $scope.ngModel;
                    if(!$scope.ngModel){
                        $timeout(function(){
                            $scope.files = $scope.ngModel;
                        }, 3000)
                    }
                }, 3000)
            }
            else {
                $scope.files = $scope.ngModel;
            }

        })
    }
})();

(function() {
'use strict';

  angular
    .module('connectsx')
    .directive('csxDatepicker', csxDatepicker);

  function csxDatepicker() {
    return {
      restrict: 'EA',
      templateUrl: 'app/directives/datepicker/datepicker.html',
      controller: 'DatepickerController',
      controllerAs: 'vm',
      scope: {
        ngModel: '='
      },
      require: 'ngModel',
      link: function($scope, element, attrs, ngModelCtrl) {
        $scope.$watch('ngModel', function(newVal){
          if (newVal && angular.isString(newVal)) {zz
            ngModelCtrl.$setViewValue(new Date(newVal));
          }
        })
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .controller('DatepickerController', DatepickerController);

  DatepickerController.$inject = ['$scope'];

  function DatepickerController($scope) {

    var vm = this;
    vm.open = false;
    vm.options = {
      minDate: new Date(),
    };
    vm.date = new Date($scope.ngModel);
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.udis', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.udis')
    .controller('UDIsWasherEditController',
      UDIsWasherEditController);

  UDIsWasherEditController.$inject = ['systemImagePath'];

  function UDIsWasherEditController(systemImagePath) {

    var vm = this;

    vm.imagePath = systemImagePath;

    vm.colors = [
      '#9ab4ff',
      '#a4ff9a',
      '#e84747',
      '#7f47e8',
    ];
    vm.codes = [
      'AA',
      'BB',
      'CC',
      'DD',
      'EE',
    ];
    vm.images = [
      'CAMEL',
      'ELEPHANT',
      'KANGAROO',
      'WOLF',
    ];

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.udis')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.inventory.udis', {
        abstract: true,
        url: '/udis',
        template: '<ui-view/>'
      })
      .state('index.udis', {
        abstract: true,
        url: '/udi',
        template: '<ui-view/>'
      })
      .state('index.inventory.udis.list', {
        url: '',
        templateUrl: 'app/inventory/udis/udis.list.html',
        controller:'UDIsController',
        controllerAs:'vm'
      })
      .state('index.udis.edit', {
        url: '/edit/:objectKey',
        templateUrl: 'app/inventory/udis/udi.edit.html',
        controller: 'UDIEditController',
        controllerAs: 'vm'
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.inventory.udis')
    .factory('UDIs', UDIs);

  UDIs.$inject = ['$resource', 'restUrl'];

  function UDIs($resource, restUrl) {

    var resourceUrl = restUrl + '/v3/udi/:objectKey';

    return $resource(resourceUrl, null,
      {
        get:    { method: 'GET' },
        query:  { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' }
      });
  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.inventory.udis')
    .controller('UDIsController', UDIsController);

  UDIsController.$inject = ['UDIs', '$scope', '$log'];

  function UDIsController(UDIs, $scope, $log) {

    var vm = this;

    $scope.$emit('loading', false);

    vm.isLoading = false;
    vm.pageSize = 20;
    vm.previousPages = [];

    activate();

    function activate() {
      vm.isLoading = true;
      query();
    }

    function query() {

      var params = {
        limit: vm.pageSize
      };

      var pageCount = vm.previousPages.length;
      if (pageCount > 0) {
        params.cursor = vm.previousPages[pageCount - 1];
      }

      UDIs.get(params, success, error);

      function success(response) {
        vm.udis = response.items;
        vm.isLoading = false;
        vm.nextPageToken = response.nextPageToken;
      }

      function error(response) {
        $log.error(angular.toJson(response));
        vm.isLoading = false;
      }
    }

    vm.setPageSize = setPageSize;

    function setPageSize(pageSize) {
      vm.pageSize = pageSize;
      vm.previousPages = [];
      query()
    }

    vm.hasNextPage = hasNextPage;

    function hasNextPage() {
      return angular.isDefined(vm.nextPageToken);
    }

    vm.hasPreviousPage = hasPreviousPage;

    function hasPreviousPage() {
      return vm.previousPages.length > 0;
    }

    vm.loadNextPage = loadNextPage;

    function loadNextPage() {
      if (angular.isUndefined(vm.nextPageToken)) return;
      vm.previousPages.push(vm.nextPageToken);
      vm.nextPageToken = undefined;
      query();
    }

    vm.loadPreviousPage = loadPreviousPage;

    function loadPreviousPage() {
      if (vm.previousPages.length === 0) return;
      vm.previousPages.pop();
      query();
    }

  }
})();


(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.inventory.udis')
    .controller('UDIEditController', UDIEditController);

  UDIEditController.$inject = ['UDIs', '$scope', '$stateParams', '$log', 'currentAuth', 'Toast', 'Show', '$state'];

  function UDIEditController(UDIs, $scope, $stateParams, $log, currentAuth, Toast, Show, $state) {

    var vm = this;
    vm.isSaving = false;

    vm.icons = ['KANGAROO', 'CAMEL', 'DIAMOND', 'CLOVER', 'UMBRELLA', 'BULB',
      'FISH', 'PAW', 'DOG', 'SQUARE', 'MOUNTAIN', 'CIRCLE', 'PERSON'];

    vm.methods = [
      { name:'Barcode', value:'Barcode'},
      { name:'RFID Data Carrier', value:'RFID' },
      { name: 'Direct Marking', value:'Direct' },
      { name: 'Cross Reference', value:'XReference' }
      ];

    vm.finish = finish;

    activate();
 
    $log.info(angular.toJson(currentAuth));

    function activate() {

      var getParams = {
        objectKey: $stateParams.objectKey
      };

      $scope.$emit('loading', true);
      UDIs.get(getParams, success, getErrorCallback);

    }

    function finish() {

      if (angular.isUndefined(vm.udi) || angular.isUndefined(vm.udi.key)) {
        return;
      }

      vm.isSaving = true;
      var params = {
        objectKey: vm.udi.key
      };

      UDIs.update(params, vm.udi, successCallback, errorCallback);

    }

    function success(value) {
      $log.info(angular.toJson(value));
        $scope.$emit('loading', false);
        vm.udi = value;
        vm.isSaving = false;
    }

    function successCallback(value) {
      $scope.$emit('loading', false);
      vm.udi = value;
      vm.isSaving = false;
      Toast.success('Saved!');
      if(angular.isUndefined($stateParams.objectKey)){
        $state.go('index.udis.edit', { objectKey: response.key })
      }

    }

    function getErrorCallback(response) {

      if (response.status === 404 || response.status === 400) {
        Show.notFound();
        return;
      }
      errorCallback(response)
    }

    function errorCallback(httpResponse) {

      $scope.$emit('loading', false);
      $log.error('UDIApi Error: ' + angular.toJson(httpResponse));
      vm.isSaving = false;
      Toast.error(httpResponse);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('connectsx.catalog.trays', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.catalog.trays')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.catalog.trays', {
        abstract: true,
        url: '/trays',
        template: '<ui-view/>'
      })
      .state('index.tray-templates', {
        abstract: true,
        url: '/catalog/trays',
        template: '<ui-view/>'
      })
      .state('index.catalog.trays.list', {
        url: '',
        templateUrl: 'app/catalog/trays/tray.templates.html',
        controller: 'TrayTemplatesController',
        controllerAs: 'vm'
      })
      .state('index.tray-templates.create', {
        url: '/create',
        templateUrl: 'app/catalog/trays/tray.template.edit.html',
        controller: 'TrayTemplateEditController',
        controllerAs: 'vm'
      })
      .state('index.tray-templates.edit', {
        url: '/edit/:objectKey',
        templateUrl: 'app/catalog/trays/tray.template.edit.html',
        controller: 'TrayTemplateEditController',
        controllerAs: 'vm'
      });
  }

})();



(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.catalog.trays')
        .controller('TrayTemplatesController', TrayTemplatesController);

    TrayTemplatesController.$inject = ['TrayTemplates', '$scope', '$log', 'Toast'];

    function TrayTemplatesController(TrayTemplates, $scope, $log, Toast) {

        $scope.$emit('loading', false);

        var vm = this;

        /// these defaults will be overwritten by state params if present
        vm.pageSize = 20;
        vm.previousPages = [];
        vm.loading = false;

        vm.search = search;
        vm.copyFromProd = copyFromProd;

        activate();

        function copyFromProd() {

            TrayTemplates.oldSearch({limit: 100}, function (response) {
                var items = response.items || [];
                $log.info(items.length);
                $log.info(angular.toJson(items[0]));
                angular.forEach(items, function (item) {
                    insert(item);
                    $log.info(item.name);
                });
            }, Toast.error);

        }

        function wait(ms){
            var start = new Date().getTime();
            var end = start;
            while(end < start + ms) {
                end = new Date().getTime();
            }
        }

        function insert(item) {
            wait(1000);
            item.manufacturer = null;
            TrayTemplates.insert(null, item, function (response) {
                $log.info('Inserted: ' + response.name);
            }, Toast.error);
        }

        function search() {

            var params = {};

            var searchText = vm.searchText;

            if (angular.isDefined(vm.pageSize)) {
                params.limit = vm.pageSize;
            }

            if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                params.cursor = vm.previousPages[vm.previousPages.length - 1];
            }

            if (angular.isDefined(searchText) && searchText.length > 0) {
                params.search = searchText;
            }

            TrayTemplates.search(params, success, error);

            function success(response) {
                vm.loading = false;
                vm.items = response.items || [];
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }

        }

        function activate() {
            vm.loading = true;
            search();
        }

        vm.setPageSize = setPageSize;

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            search();
        }

        vm.hasNextPage = hasNextPage;

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        vm.hasPreviousPage = hasPreviousPage;

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        vm.loadNextPage = loadNextPage;

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            search();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            search();
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.catalog.trays')
        .factory('TrayTemplates', TrayTemplates);

    TrayTemplates.$inject = ['$resource', 'restUrl', 'oldUrl'];

    function TrayTemplates($resource, restUrl, oldUrl) {

        var oldResource = oldUrl + '/v1/tray/template/:objectKey';

        var resourceUrl = restUrl + '/v1/tray/template/:objectKey';

        return $resource(resourceUrl, null,
            {
                get: {method: 'GET'},
                remove: {method: 'DELETE'},
                insert: {method: 'POST'},
                update: {method: 'PUT'},
                search: {method: 'GET', isArray: false},
                oldSearch: {method: 'GET', url: oldResource, isArray: false},
                query: {method: 'GET', isArray: false}
            });

    }

})();

(function () {
    'use strict';
    /* global angular*/

    angular
        .module('connectsx.catalog.trays')
        .controller('TrayTemplateEditController', TrayTemplateEditController);

    TrayTemplateEditController.$inject = ['Accounts', 'TrayTemplates', 'LayerTemplates', '$stateParams', '$scope',
        '$log', 'Toast', 'Show', 'currentAuth', 'Orgs', 'ConfirmUnsavedChanges', '$rootScope', '$timeout', '$state'];


    function TrayTemplateEditController(Accounts, TrayTemplates, LayerTemplates, $stateParams, $scope, $log, Toast,
                                        Show, currentAuth, Orgs, ConfirmUnsavedChanges, $rootScope, $timeout, $state) {

        var vm = this;

        vm.finish = finish;
        vm.searchLayers = searchLayers;
        vm.addLayer = addLayer;
        vm.removeLayer = removeLayer;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            loadTray();

        }

        function loadTray() {

            if (angular.isUndefined($stateParams.objectKey)) {

                vm.tray = {layers: []};

                Orgs.get({objectKey: currentAuth.org.key}, function (org) {

                    org.manufacturer.name = org.name;
                    vm.manufacturers = [org.manufacturer];
                    vm.tray.manufacturer = org.manufacturer;
                    $scope.$emit('loading', false);


                }, function (error) {

                    Toast.error(error);
                    $scope.$emit('loading', false);

                });

                return;
            }


            TrayTemplates.get({objectKey: $stateParams.objectKey}, success, error);

            function success(response) {
                vm.tray = response;
                if (angular.isUndefined(vm.tray.layers)) {
                    vm.tray.layers = [];
                }
                $scope.$emit('loading', false);

                vm.isChange = false;
                watchChanges()
            }

            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                $log.info(angular.toJson(error));
                $scope.$emit('loading', false);
                Toast.error(error);
            }

        }

        function searchLayers(search) {
            if (angular.isUndefined(search)) return [];
            return LayerTemplates.search({search: search}).$promise.then(function (response) {
                var items = response.items || [];
                var commonItems = removeIdenticaltems(items, vm.tray.layers || []);
                return commonItems || []
            });
        }

        function addLayer(layer) {

            if (angular.isUndefined(vm.tray.layers)) {
                vm.tray.layers = [];
            }

            vm.tray.layers.push(layer);
        }

        function removeLayer(index) {
            vm.tray.layers.splice(index, 1);
        }

        function finish() {

            vm.isLoading = true;

            if (angular.isDefined(vm.tray.key)) {
                var params = {objectKey: vm.tray.key};
                TrayTemplates.update(params, vm.tray, success, error);
            } else {
                TrayTemplates.insert(vm.tray, success, error);
                onRouteChangeOff();
            }

            function success(response) {
                vm.tray = response;
                if (angular.isUndefined(vm.tray.layers)) {
                    vm.tray.layers = [];
                }
                vm.isLoading = false;
                $log.info(angular.toJson(response));
                Toast.success('Saved!');
                vm.isChange = true;
                if(angular.isUndefined($stateParams.objectKey)){
                    $state.go('index.tray-templates.edit', { objectKey: response.key })
                }

            }

            function error(error) {
                vm.isLoading = false;
                $log.error(angular.toJson(error));
                Toast.error(error);
            }

        }

/*Remove from existing in second array items
  where - array objects, with property name = string
  what - array objects
*/
        function removeIdenticaltems(where, what) {
            var result = [];
            if(!what.length) return where
            where.forEach(function(v) {
                var isPush = true;
                what.forEach(function(el){
                    if(v.name === el.name){
                        isPush = false
                        return true
                    }
                })
                if(isPush){
                    result.forEach(function(i, y){
                        if(i.name === v.name){
                            isPush = false;
                            return true
                        }
                    })
                }
                if(isPush){
                    result.push(v)
                }
            });
            return result;
        }

        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.tray', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.tray.name];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                if(!vm.tray.name){
                    watchChanges()
                }

            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog.products', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog.products')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.catalog.products', {
        abstract: true,
        url: '/products',
        template: '<ui-view/>'
      })
      .state('index.products', {
        abstract: true,
        url: '/products',
        template: '<ui-view/>'
      })
      .state('index.catalog.products.list', {
        url: '',
        templateUrl: 'app/catalog/products/product.html',
        controller: 'ProductController',
        controllerAs: 'vm'
      })
      .state('index.products.create', {
        url: '/create',
        templateUrl: 'app/catalog/products/product.edit.html',
        controller: 'ProductEditController',
        controllerAs: 'vm'
      })

      .state('index.products.edit', {
        url: '/edit/:objectKey',
        templateUrl: 'app/catalog/products/product.edit.html',
        controller: 'ProductEditController',
        controllerAs: 'vm'
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog.products')
    .factory('ProductTemplates', ProductTemplates);

    ProductTemplates.$inject = ['$resource', 'restUrl'];

  function ProductTemplates($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/product/template/:objectKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        search: { method: 'GET', isArray:false },
        query:  { method:'GET', isArray:false }
      });
  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.catalog.products')
        .controller('ProductEditController', ProductEditController);

    ProductEditController.$inject = ['Accounts', 'ProductTemplates', 'TrayTemplates', 'Guides', '$scope', '$stateParams',
        '$log', 'Toast', 'Show', 'currentAuth', 'Orgs', 'ConfirmUnsavedChanges', '$rootScope', '$timeout', '$state'];

    function ProductEditController(Accounts, ProductTemplates, TrayTemplates, Guides, $scope, $stateParams, $log,
                                   Toast, Show, currentAuth, Orgs, ConfirmUnsavedChanges, $rootScope, $timeout, $state) {

        var vm = this;

        vm.finish = finish;
        vm.searchTrays = searchTrays;
        vm.searchGuides = searchGuides;

        activate();

        function activate() {

            $scope.$emit('loading', true);
            loadProduct();

        }

        function loadProduct() {

            if (angular.isUndefined($stateParams.objectKey)) {

                vm.product = {};
                setupDefaults();

                Orgs.get({objectKey: currentAuth.org.key}, function (org) {

                    org.manufacturer.name = org.name;
                    vm.manufacturers = [org.manufacturer];
                    vm.product.manufacturer = org.manufacturer;
                    $scope.$emit('loading', false);


                }, function (error) {

                    Toast.error(error);
                    $scope.$emit('loading', false);

                });

                return;
            }


            ProductTemplates.get({objectKey: $stateParams.objectKey}, success, error);

            function success(response) {
                vm.product = response;

                setupDefaults();
                $scope.$emit('loading', false);

                vm.isChange = false;
                watchChanges()
            }

            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                $log.info(angular.toJson(error));
                $scope.$emit('loading', false);
                Toast.error(error);
            }

        }

        function searchTrays(search) {
            if (angular.isUndefined(search)) return [];
            return TrayTemplates.search({search: search}).$promise.then(function (response) {

                var items = response.items || [];
                var commonItems = removeIdenticaltems(items, vm.product.trays || []);
                return commonItems || []
            });
        }

        function searchGuides(search) {
            if (angular.isUndefined(search)) return [];
            return Guides.search({search: search}).$promise.then(function (response) {
                var items = response.items || [];
                var commonItems = removeIdenticaltems(items, vm.product.guides || []);
                return commonItems || []
            });
        }

/*Remove from existing in second array items
  where - array objects, with property name = string
  what - array objects
*/
        function removeIdenticaltems(where, what) {
            var result = [];
            if(!what.length) return where
            where.forEach(function(v) {
                var isPush = true;
                what.forEach(function(el){
                    if(v.name === el.name){
                        isPush = false
                        return true
                    }
                })
                if(isPush){
                    result.forEach(function(i, y){
                        if(i.name === v.name){
                            isPush = false;
                            return true
                        }
                    })
                }
                if(isPush){
                    result.push(v)
                }
            });
            return result;
        }

        function setupDefaults() {
            if (angular.isUndefined(vm.product.guides)) {
                vm.product.guides = [];
            }

            if (angular.isUndefined(vm.product.trays)) {
                vm.product.trays = [];
            }

            if (angular.isUndefined(vm.product.ifuUrls)) {
                vm.product.ifuUrls = [];
            }

        }

        function finish() {

            vm.isLoading = true;

            if (angular.isDefined(vm.product.key)) {
                var params = {objectKey: vm.product.key};
                ProductTemplates.update(params, vm.product, success, error);
            } else {
                ProductTemplates.insert(vm.product, success, error);
                onRouteChangeOff();
            }

            function success(response) {
                vm.product = response;

                vm.isLoading = false;
                Toast.success('Saved!');
                setupDefaults();
                $log.info(angular.toJson(response));
                vm.isChange = false;

                if(angular.isUndefined($stateParams.objectKey)){
                    $state.go('index.products.edit', { objectKey: response.key })
                }


            }

            function error(error) {
                vm.isLoading = false;
                $log.error(angular.toJson(error));
                Toast.error(error);
            }

        }

        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.product', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.product.name];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                if(!vm.product.name){
                    watchChanges()
                }

            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.catalog.products')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['ProductTemplates', '$scope', '$log', 'Toast', 'currentAuth'];

    function ProductController(ProductTemplates, $scope, $log, Toast, currentAuth) {

        $scope.$emit('loading', false);

        var vm = this;

        /// these defaults will be overwritten by state params if present
        vm.pageSize = 20;
        vm.previousPages = [];
        vm.manufacturer = {};
        vm.loading = false;

        vm.search = search;

        activate();

        function search() {

            var params = { manufacturer: vm.manufacturer.key };

            var searchText = vm.searchText;

            if (angular.isDefined(vm.pageSize)) {
                params.limit = vm.pageSize;
            }

            if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                params.cursor = vm.previousPages[vm.previousPages.length - 1];
            }

            if (angular.isDefined(searchText) && searchText.length > 0) {
                params.search = searchText;
            }

            ProductTemplates.search(params, success, error);

            function success(response) {
                vm.loading = false;
                vm.items = response.items || [];
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                vm.loading = false;
                Toast.error(response);
                $log.error(angular.toJson(response));
            }
        }

        function activate() {
            vm.loading = true;
            vm.manufacturer = currentAuth.org.manufacturer;
            search();
        }


        vm.setPageSize = setPageSize;

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            search();
        }

        vm.hasNextPage = hasNextPage;

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        vm.hasPreviousPage = hasPreviousPage;

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        vm.loadNextPage = loadNextPage;

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            search();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            search();
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog.layers', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.catalog.layers')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.catalog.layers', {
        abstract: true,
        url: '/layers',
        template: '<ui-view/>'
      })
      .state('index.layer-templates', {
        abstract: true,
        url: '/layers',
        template: '<ui-view/>'
      })
      .state('index.catalog.layers.list', {
        url: '',
        templateUrl: 'app/catalog/layers/layers.html',
        controller: 'LayerTemplateController',
        controllerAs: 'vm'
      })
      .state('index.layer-templates.create', {
        url: '/create',
        templateUrl: 'app/catalog/layers/layer.template.edit.html',
        controller: 'LayerTemplateEditController',
        controllerAs: 'vm'
      })
      .state('index.layer-templates.edit', {
        url: '/edit/:objectKey',
        templateUrl: 'app/catalog/layers/layer.template.edit.html',
        controller: 'LayerTemplateEditController',
        controllerAs: 'vm'
      });

  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.catalog.layers')
        .factory('LayerTemplates', LayerTemplates);

    LayerTemplates.$inject = ['$resource', 'restUrl', 'oldUrl'];

    function LayerTemplates($resource, restUrl, oldUrl) {

        var resourceUrl = restUrl + '/v1/layer/template/:objectKey';
        var oldResource = oldUrl + '/v1/layer/template/:objectKey';

        return $resource(resourceUrl, null,
            {
                get: {method: 'GET'},
                remove: {method: 'DELETE'},
                insert: {method: 'POST'},
                update: {method: 'PUT'},
                search: {method: 'GET', isArray: false},
                oldSearch: {method: 'GET', url: oldResource, isArray: false},
                query: {method: 'GET', isArray: false}
            });
    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.catalog.layers')
        .controller('LayerTemplateEditController', LayerTemplateEditController);

    LayerTemplateEditController.$inject = ['LayerTemplates', 'DeviceTemplates', 'Accounts', '$stateParams', '$mdDialog',
        '$document', '$scope', '$log', 'Toast', 'Show', 'Orgs', 'currentAuth', 'ConfirmUnsavedChanges', '$rootScope',
    '$timeout', '$state'];

    function LayerTemplateEditController(LayerTemplates, DeviceTemplates, Accounts, $stateParams, $mdDialog, $document,
                                         $scope, $log, Toast, Show, Orgs, currentAuth, ConfirmUnsavedChanges, $rootScope,
                                         $timeout, $state) {

        $scope.$emit('loading', false);

        var vm = this;

        vm.searchDevices = searchDevices;
        vm.addDevice = addDevice;
        vm.editDevice = editDevice;
        vm.isDeviceIncomplete = isDeviceIncomplete;
        vm.removeDevice = removeDevice;
        vm.newOverlay = newOverlay;
        vm.removeOverlay = removeOverlay;
        vm.editOverlay = editOverlay;
        vm.finish = finish;

        activate();

        function activate() {

            $scope.$emit('loading', true);

            if (angular.isUndefined($stateParams.objectKey)) {

                vm.layer = { overlays: [], devices: [] };

                Orgs.get({ objectKey : currentAuth.org.key }, function(org) {

                    org.manufacturer.name = org.name;
                    vm.manufacturers = [org.manufacturer];
                    vm.layer.manufacturer = org.manufacturer;
                    $scope.$emit('loading', false);


                }, function(error) {

                    Toast.error(error);
                    $scope.$emit('loading', false);

                });

                return;
            }

            LayerTemplates.get({objectKey: $stateParams.objectKey}, success, error);

            function success(response) {
                vm.layer = response;
                setupDeviceLocations();
                if (angular.isUndefined(vm.layer.overlays)) {
                    vm.layer.overlays = [];
                }
                angular.forEach(vm.layer.devices, function (device) {
                    $log.info("key: " + device.key + " name: " + device.reference);
                });
                $scope.$emit('loading', false);

                vm.isChange = false;
                watchChanges()
            }

            vm.syncDevice = function syncDevice(device) {

                var key = device.key;
                if (angular.isUndefined(key)) {
                    $log.error("No device key.");
                    return;
                }

                DeviceTemplates.get({objectKey: key}, function (template) {
                    $log.info(angular.toJson(template));
                    angular.forEach(vm.layer.devices, function(d) {
                       if (d.reference === template.reference) {
                           d.name = template.name;
                       }
                    });
                }, function(error) {
                    $log.error(error);
                });
            };


            function error(error) {

                if (error.status === 404 || error.status === 400) {
                    Show.notFound();
                    return;
                }

                $log.info(angular.toJson(error));
                $scope.$emit('loading', false);
            }

        }

        function searchDevices(search) {
            if (angular.isUndefined(search)) return [];

            var params = {
                manufacturer: vm.layer.manufacturer.key,
                search: search,
                limit: 200
            };
            return DeviceTemplates.search(params).$promise.then(function (response) {
                if (angular.isUndefined(response.items)) {
                    response.items = [];
                }
                return response.items;
            });
        }

        function addDevice(device) {

            if (device === null || angular.isUndefined(device.key)) {
                return;
            }

            if (angular.isUndefined(vm.layer.devices)) {
                vm.layer.devices = [];
            }

            device.location = {deviceId: vm.layer.devices.length};

            vm.layer.devices.unshift(device);
            /// reset typeahead
            vm.selectedDevice = null;
            vm.deviceSearchText = null;

        }

        function newOverlay(overlayKey) {
            return {overlayKey: overlayKey};
        }

        function removeDevice(index) {
            vm.layer.devices.splice(index, 1);
        }

        function removeOverlay(index) {
            vm.layer.overlays.splice(index, 1);
        }

        function editOverlay(event, overlay) {
            $mdDialog.show({
                locals: {'overlay': overlay},
                controller: OverlayDialogController,
                templateUrl: 'app/catalog/layers/location.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: event,
                clickOutsideToClose: true
            });
        }

        function editDevice(event, device) {
            $mdDialog.show({
                locals: {'device': device, 'overlays': vm.layer.overlays},
                controller: DeviceDialogController,
                templateUrl: 'app/catalog/layers/location.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: event,
                clickOutsideToClose: true
            });
        }

        function isDeviceIncomplete(device) {
            return angular.isUndefined(device.location) || (angular.isUndefined(device.location.overlayKey) && (
                angular.isUndefined(device.location.x) ||
                angular.isUndefined(device.location.y) ||
                angular.isUndefined(device.location.width) ||
                angular.isUndefined(device.location.height)
            ));
        }

        /* eslint-disable angular/controller-as */
        function DeviceDialogController($scope, $mdDialog, device, overlays) {

            $scope.objectType = 'device';
            $scope.editObject = device.location;
            $scope.overlays = overlays;
            $scope.title = device.name;

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.hasOverlayKey = function () {
                return angular.isDefined($scope.editObject.overlayKey);
            }
        }

        /* eslint-disable angular/controller-as */
        function OverlayDialogController($scope, $mdDialog, overlay) {

            $scope.objectType = 'overlay';
            $scope.editObject = overlay;
            $scope.title = overlay.overlayKey;

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.hasOverlayKey = function () {
                return false;
            }

        }

        function finish() {

            vm.isLoading = true;

            vm.layer.deviceLocations = [];
            /// split device locations from devices for storage
            angular.forEach(vm.layer.devices, function (device) {
                vm.layer.deviceLocations.push(device.location);
            });

            if (angular.isDefined(vm.layer.key)) {
                var params = {objectKey: vm.layer.key};
                LayerTemplates.update(params, vm.layer, success, error);
            } else {
                LayerTemplates.insert(vm.layer, success, error);
                onRouteChangeOff();
            }

            function success(response) {
                Toast.success('Success!')
                vm.layer = response;
                setupDeviceLocations();
                vm.isLoading = false;
                $log.info(angular.toJson(response));
                vm.isChange = false;
                if(angular.isUndefined($stateParams.objectKey)){
                    $state.go('index.layer-templates.edit', { objectKey: response.key })
                }

            }

            function error(error) {
                vm.isLoading = false;
                $log.error(angular.toJson(error));
                Toast.error(error.message)
            }

        }

        function setupDeviceLocations() {
            if (!angular.isArray(vm.layer.devices) || !angular.isArray(vm.layer.deviceLocations)) return;
            if (vm.layer.devices.length !== vm.layer.deviceLocations.length) return;
            for (var i = 0; i < vm.layer.devices.length; i++) {
                vm.layer.devices[i].location = vm.layer.deviceLocations[i];
            }
        }



        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.layer', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.layer.name];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                if(!vm.layer.name){
                    watchChanges()
                }

            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.catalog.layers')
        .controller('LayerTemplateController', LayerTemplateController);

    LayerTemplateController.$inject = ['LayerTemplates', '$scope', '$log', 'Toast', 'currentAuth', 'Orgs'];

    function LayerTemplateController(LayerTemplates, $scope, $log, Toast, currentAuth, Orgs) {

        $scope.$emit('loading', false);

        var vm = this;

        /// these defaults will be overwritten by state params if present
        vm.pageSize = 20;
        vm.previousPages = [];
        vm.manufacturer = {};
        vm.loading = false;

        var changes = [
            "101NCAP-16-001TI,101CAP-16-01TI",
            "101NAIL-125-180TI,101NAIL-125-180TI",
            "101NAIL-130-180TI,101NAIL-130-180TI",
            "101NAIL-125-220TI,101NAIL-125-220TI",
            "101NAIL-130-220TI,101NAIL-130-220TI",
            "101ARSC-050-050TI,A50",
            "101ARSC-050-060TI,A60",
            "101ARSC-050-070TI,A70",
            "101ARSC-050-080TI,A80",
            "101ARSC-050-090TI,A90",
            "101ARSC-050-100TI,A100",
            "101CSCR-105-020TI,C20",
            "101CSCR-105-022TI,C22",
            "101CSCR-105-024TI,C24",
            "101CSCR-105-026TI,C26",
            "101CSCR-105-028TI,C28",
            "101CSCR-105-030TI,C30",
            "101CSCR-105-032TI,C32",
            "101CSCR-105-034TI,C34",
            "101CSCR-105-036TI,C36",
            "101CSCR-105-038TI,C38",
            "101CSCR-105-040TI,C40",
            "101CSCR-105-042TI,C42",
            "101CSCR-105-044TI,C44",
            "101CSCR-105-046TI,C46",
            "101CSCR-105-048TI,C48",
            "101CSCR-105-050TI,C50",
            "101CSCR-105-052TI,C52",
            "101CSCR-105-054TI,C54",
            "101CSCR-105-056TI,C56",
            "101CSCR-105-058TI,C58",
            "101CSCR-105-060TI,C60",
            "101CSCR-105-065TI,C65",
            "101CSCR-105-070TI,C70",
            "101CSCR-105-075TI,C75",
            "101CSCR-105-080TI,C80",
            "101LSCR-105-080TI,101LSCR-1080TI",
            "101LSCR-105-085TI,101LSCR-1085TI",
            "101LSCR-105-090TI,101LSCR-1090TI",
            "101LSCR-105-095TI,101LSCR-1095TI",
            "101LSCR-105-100TI,101LSCR-1100TI",
            "101LSCR-105-105TI,101LSCR-1105TI",
            "101LSCR-105-110TI,101LSCR-1110TI",
            "101LSCR-105-115TI,101LSCR-1115TI",
            "101LSCR-105-120TI,101LSCR-1120TI",
            "102-65-2020T,65-2020",
            "102-65-2025T,65-2025",
            "102-65-2030T,65-2030",
            "102-65-2035T,65-2035",
            "102-65-2040T,65-2040",
            "102-65-2045T,65-2045",
            "102-65-2050T,65-2050",
            "102-65-2055T,65-2055",
            "102-65-2060T,65-2060",
            "102-65-2065T,65-2065",
            "102-65-2070T,65-2070",
            "102-65-2075T,65-2075",
            "102-65-2080T,65-2080",
            "102-65-2085T,65-2085",
            "102-65-2090T,65-2090",
            "102-65-2095T,65-2095",
            "102-65-2100T,65-2100",
            "102-65-2105T,65-2105",
            "102-65-2110T,65-2110",
            "102-65-2115T,65-2115",
            "102-65-2120T,65-2120",
            "102-65-2125T,65-2125",
            "102-65-2130T,65-2130",
            "102-65-2135T,65-2135",
            "102-65-2140T,65-2140",
            "102-65-2145T,65-2145",
            "102-65-2150T,65-2150",
            "102-65-1020T,65-1020",
            "102-65-1025T,65-1025",
            "102-65-1030T,65-1030",
            "102-65-1035T,65-1035",
            "102-65-1040T,65-1040",
            "102-65-1045T,65-1045",
            "102-65-1050T,65-1050",
            "102-65-1055T,65-1055",
            "102-65-1060T,65-1060",
            "102-65-1065T,65-1065",
            "102-65-1070T,65-1070",
            "102-65-1075T,65-1075",
            "102-65-1080T,65-1080",
            "102-65-1085T,65-1085",
            "102-65-1090T,65-1090",
            "102-65-1095T,65-1095",
            "102-65-1100T,65-1100",
            "102-65-1105T,65-1105",
            "102-65-1110T,65-1110",
            "102-65-1115T,65-1115",
            "102-65-1120T,65-1120",
            "102-65-1125T,65-1125",
            "102-65-1130T,65-1130",
            "102-65-1135T,65-1135",
            "102-65-1140T,65-1140",
            "102-65-1145T,65-1145",
            "102-65-1150T,65-1150",
            "102-65-0020T,65-0020",
            "102-65-0025T,65-0025",
            "102-65-0030T,65-0030",
            "102-65-0035T,65-0035",
            "102-65-0040T,65-0040",
            "102-65-0045T,65-0045",
            "102-65-0050T,65-0050",
            "102-65-0055T,65-0055",
            "102-65-0060T,65-0060",
            "102-65-0065T,65-0065",
            "102-65-0070T,65-0070",
            "102-65-0075T,65-0075",
            "102-65-0080T,65-0080",
            "102-65-0085T,65-0085",
            "102-65-0090T,65-0090",
            "102-65-0095T,65-0095",
            "102-65-0100T,65-0100",
            "102-65-0105T,65-0105",
            "102-65-0110T,65-0110",
            "102-65-0115T,65-0115",
            "102-65-0120T,65-0120",
            "102-65-0125T,65-0125",
            "102-65-0130T,65-0130",
            "102-65-0135T,65-0135",
            "102-65-0140T,65-0140",
            "102-65-0145T,65-0145",
            "102-65-0150T,65-0150",
            "102-73-2020T,73-2020",
            "102-73-2025T,73-2025",
            "102-73-2030T,73-2030",
            "102-73-2035T,73-2035",
            "102-73-2040T,73-2040",
            "102-73-2045T,73-2045",
            "102-73-2050T,73-2050",
            "102-73-2055T,73-2055",
            "102-73-2060T,73-2060",
            "102-73-2065T,73-2065",
            "102-73-2070T,73-2070",
            "102-73-2075T,73-2075",
            "102-73-2080T,73-2080",
            "102-73-2085T,73-2085",
            "102-73-2090T,73-2090",
            "102-73-2095T,73-2095",
            "102-73-2100T,73-2100",
            "102-73-2105T,73-2105",
            "102-73-2110T,73-2110",
            "102-73-2115T,73-2115",
            "102-73-2120T,73-2120",
            "102-73-2125T,73-2125",
            "102-73-2130T,73-2130",
            "102-73-2135T,73-2135",
            "102-73-2140T,73-2140",
            "102-73-2145T,73-2145",
            "102-73-2150T,73-2150",
            "102-73-1020T,73-1020",
            "102-73-1025T,73-1025",
            "102-73-1030T,73-1030",
            "102-73-1035T,73-1035",
            "102-73-1040T,73-1040",
            "102-73-1045T,73-1045",
            "102-73-1050T,73-1050",
            "102-73-1055T,73-1055",
            "102-73-1060T,73-1060",
            "102-73-1065T,73-1065",
            "102-73-1070T,73-1070",
            "102-73-1075T,73-1075",
            "102-73-1080T,73-1080",
            "102-73-1085T,73-1085",
            "102-73-1090T,73-1090",
            "102-73-1095T,73-1095",
            "102-73-1100T,73-1100",
            "102-73-1105T,73-1105",
            "102-73-1110T,73-1110",
            "102-73-1115T,73-1115",
            "102-72-1120T,73-1120",
            "102-73-1125T,73-1125",
            "102-73-1130T,73-1130",
            "102-73-1135T,73-1135",
            "102-73-1140T,73-1140",
            "102-73-1145T,73-1145",
            "102-73-1150T,73-1150",
            "102-73-0020T,73-0020",
            "102-73-0025T,73-0025",
            "102-73-0030T,73-0030",
            "102-73-0035T,73-0035",
            "102-73-0040T,73-0040",
            "102-73-0045T,73-0045",
            "102-73-0050T,73-0050",
            "102-73-0055T,73-0055",
            "102-73-0060T,73-0060",
            "102-73-0065T,73-0065",
            "102-73-0070T,73-0070",
            "102-73-0075T,73-0075",
            "102-73-0880T,73-0080",
            "102-73-0085T,73-0085",
            "102-73-0090T,73-0090",
            "102-73-0095T,73-0095",
            "102-73-0100T,73-0100",
            "102-73-0105T,73-0105",
            "102-73-0110T,73-0110",
            "102-73-0115T,73-0115",
            "102-73-0120T,73-0120",
            "102-73-0125T,73-0125",
            "102-73-0130T,73-0130",
            "102-73-0135T,73-0135",
            "102-73-0140T,73-0140",
            "102-73-0145T,73-0145",
            "102-73-0150T,73-0150",
            "102-55-2020T,55-2020",
            "102-55-2022T,55-2022",
            "102-55-2024T,55-2024",
            "102-55-2026T,55-2026",
            "102-55-2028T,55-2028",
            "102-55-2030T,55-2030",
            "102-55-2032T,55-2032",
            "102-55-2034T,55-2034",
            "102-55-2036T,55-2036",
            "102-55-2038T,55-2038",
            "102-55-2040T,55-2040",
            "102-55-2042T,55-2042",
            "102-55-2044T,55-2044",
            "102-55-2046T,55-2046",
            "102-55-2048T,55-2048",
            "102-55-2050T,55-2050",
            "102-55-2052T,55-2052",
            "102-55-2054T,55-2054",
            "102-55-2056T,55-2056",
            "102-55-2058T,55-2058",
            "102-55-2060T,55-2060",
            "102-55-2065T,55-2065",
            "102-55-2070T,55-2070",
            "102-55-2075T,55-2075",
            "102-55-2080T,55-2080",
            "102-55-2085T,55-2085",
            "102-55-2090T,55-2090",
            "102-55-2095T,55-2095",
            "102-55-2100T,55-2100",
            "102-55-2105T,55-2105",
            "102-55-2110T,55-2110",
            "102-55-2115T,55-2115",
            "102-55-2120T,55-2120",
            "102-55-1044T,55-1044",
            "102-55-1046T,55-1046",
            "102-55-1048T,55-1048",
            "102-55-1050T,55-1050",
            "102-55-1052T,55-1052",
            "102-55-1054T,55-1054",
            "102-55-1056T,55-1056",
            "102-55-1058T,55-1058",
            "102-55-1060T,55-1060",
            "102-55-1065T,55-1065",
            "102-55-1070T,55-1070",
            "102-55-1075T,55-1075",
            "102-55-1080T,55-1080",
            "102-55-1085T,55-1085",
            "102-55-1090T,55-1090",
            "102-55-1095T,55-1095",
            "102-55-1100T,55-1100",
            "102-55-1105T,55-1105",
            "102-55-1110T,55-1110",
            "102-55-1115T,55-1115",
            "102-55-1120T,55-1120",
            "102-55-0030T,55-0030",
            "102-55-0032T,55-0032",
            "102-55-0034T,55-0034",
            "102-55-0036T,55-0036",
            "102-55-0038T,55-0038",
            "102-55-0040T,55-0040",
            "102-55-0042T,55-0042",
            "102-55-0044T,55-0044",
            "102-55-0046T,55-0046",
            "102-55-0048T,55-0048",
            "102-55-0050T,55-0050",
            "102-55-0052T,55-0052",
            "102-55-0054T,55-0054",
            "102-55-0056T,55-0056",
            "102-55-0058T,55-0058",
            "102-55-0060T,55-0060",
            "102-55-0065T,55-0065",
            "102-55-0070T,55-0070",
            "102-55-0075T,55-0075",
            "102-55-0080T,55-0080",
            "102-55-0085T,55-0085",
            "102-55-0090T,55-0090",
            "102-55-0095T,55-0095",
            "102-55-0100T,55-0100",
            "102-55-0105T,55-0105",
            "102-55-0110T,55-0110",
            "102-55-0115T,55-0115",
            "102-55-0120T,55-0120",
            "102-45-2010T,45-2010",
            "102-45-2012T,45-2012",
            "102-45-2014T,45-2014",
            "102-45-2016T,45-2016",
            "102-45-2018T,45-2018",
            "102-45-2020T,45-2020",
            "102-45-2022T,45-2022",
            "102-45-2024T,45-2024",
            "102-45-2026T,45-2026",
            "102-45-2028T,45-2028",
            "102-45-2030T,45-2030",
            "102-45-2032T,45-2032",
            "102-45-2034T,45-2034",
            "102-45-2036T,45-2036",
            "102-45-2038T,45-2038",
            "102-45-2040T,45-2040",
            "102-45-2042T,45-2042",
            "102-45-2044T,45-2044",
            "102-45-2046T,45-2046",
            "102-45-2048T,45-2048",
            "102-45-2050T,45-2050",
            "102-45-2052T,45-2052",
            "102-45-2054T,45-2054",
            "102-45-2056T,45-2056",
            "102-45-2058T,45-2058",
            "102-45-2060T,45-2060",
            "102-45-0014T,45-0014",
            "102-45-0016T,45-0016",
            "102-45-0018T,45-0018",
            "102-45-0020T,45-0020",
            "102-45-0022T,45-0022",
            "102-45-0024T,45-0024",
            "102-45-0026T,45-0026",
            "102-45-0028T,45-0028",
            "102-45-0030T,45-0030",
            "102-45-0032T,45-0032",
            "102-45-0034T,45-0034",
            "102-45-0036T,45-0036",
            "102-45-0038T,45-0038",
            "102-45-0040T,45-0040",
            "102-45-0042T,45-0042",
            "102-45-0044T,45-0044",
            "102-45-0046T,45-0046",
            "102-45-0048T,45-0048",
            "102-45-0050T,45-0050",
            "102-45-0052T,45-0052",
            "102-45-0054T,45-0054",
            "102-45-0056T,45-0056",
            "102-45-0058T,45-0058",
            "102-45-0060T,45-0060",
            "102-35-2010T,35-2010",
            "102-35-2012T,35-2012",
            "102-35-2014T,35-2014",
            "102-35-2016T,35-2016",
            "102-35-2018T,35-2018",
            "102-35-2020T,35-2020",
            "102-35-2022T,35-2022",
            "102-35-2024T,35-2024",
            "102-35-2026T,35-2026",
            "102-35-2028T,35-2028",
            "102-35-2030T,35-2030",
            "102-35-2032T,35-2032",
            "102-35-2034T,35-2034",
            "102-35-2036T,35-2036",
            "102-35-2038T,35-2038",
            "102-35-2040T,35-2040",
            "102-35-2042T,35-2042",
            "102-35-2044T,35-2044",
            "102-35-2046T,35-2046",
            "102-35-2048T,35-2048",
            "102-35-2050T,35-2050",
            "102-35-0012T,35-0012",
            "102-35-0014T,35-0014",
            "102-35-0016T,35-0016",
            "102-35-0018T,35-0018",
            "102-35-0020T,35-0020",
            "102-35-0022T,35-0022",
            "102-35-0024T,35-0024",
            "102-35-0026T,35-0026",
            "102-35-0028T,35-0028",
            "102-35-0030T,35-0030",
            "102-35-0032T,35-0032",
            "102-35-0034T,35-0034",
            "102-35-0036T,35-0036",
            "102-35-0038T,35-0038",
            "102-35-0040T,35-0040",
            "102-35-0042T,35-0042",
            "102-35-0044T,35-0044",
            "102-35-0046T,35-0046",
            "102-35-0048T,35-0048",
            "102-35-0050T,35-0050",
            "102-10-65,102-10-65",
            "101-70,101-70",
            "101-06,101-06",
            "102-30-02,102-30-02",
            "101-52,101-52",
            "101-62,101-62",
            "101-24,101-24",
            "102-50-02 ,102-50-02",
            "103-1-03,103-1-03",
            "103-1-04,103-1-04",
            "103-1-05,103-1-05",
            "BIO05-SK001,BIO05-SK001",
            "BIO10-SK001,BIO10-SK001",
            "102-01-02,102-01-02",
            "102-30-01,102-30-01",
            "102-01-03,102-01-03",
            "102-01-01,102-01-01",
            "102-30-00,102-30-00",
            "102-50-01,102-50-01",
            "102-50-00,102-50-00",
            "102-80-45,102-80-45",
            "102-80-55,102-80-55",
            "102-80-65,102-80-65",
        ];

        var changesObject = {};
        angular.forEach(changes, function(change) {
            var components = change.split(",");
            changesObject[components[0].trim()] = components[1].trim();
        });

        var layerCache = {};

        vm.search = search;
        vm.copyFromProd = copyFromProd;
        // vm.applyReferenceChanges = applyReferenceChanges;

        var manufacturer = {};
        Orgs.get({objectKey: currentAuth.org.key}, function (response) {
            manufacturer = response.manufacturer;
        });

        // function applyReferenceChanges() {
        //     LayerTemplates.oldSearch({ limit:100 }, function (response) {
        //         var items = response.items || [];
        //         $log.info(items.length);
        //     }, Toast.error);
        // }

        function wait(ms){
            var start = new Date().getTime();
            var end = start;
            while(end < start + ms) {
                end = new Date().getTime();
            }
        }

        function copyFromProd() {

            LayerTemplates.oldSearch({ limit:100 }, function (response) {
                var items = response.items || [];
                $log.info(angular.toJson(items[0]));
                angular.forEach(items, function (item) {
                    insert(item);
                    $log.info(item.name);
                });
            }, Toast.error);

        }

        function insert(item) {
            if (layerCache[item.name] === true) {
                return;
            }
            item.manufacturer = null;
            angular.forEach(item.devices, function (d) {
                // d.reference = d.referenceNumber;
                // if (changesObject.hasOwnProperty(d.reference)) {
                //     d.reference = changesObject[d.reference];
                // }
                // d.type = 'Device';
                d.manufacturer = manufacturer;
            });

            wait(1000);
            
            LayerTemplates.insert(null, item, function (response) {
                layerCache[item.name] = true;
                $log.info('Inserted: ' + response.name);
            }, Toast.error);
        }

        activate();

        function search() {

            var params = {manufacturer: vm.manufacturer.key};

            var searchText = vm.searchText;

            if (angular.isDefined(vm.pageSize)) {
                params.limit = vm.pageSize;
            }

            if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                params.cursor = vm.previousPages[vm.previousPages.length - 1];
            }

            if (angular.isDefined(searchText) && searchText.length > 0) {
                params.search = searchText;
            }

            LayerTemplates.search(params, success, error);

            function success(response) {
                vm.loading = false;
                vm.items = response.items || [];
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                Toast.error(response);
                vm.loading = false;
                $log.error(angular.toJson(response));
            }

        }

        function activate() {
            vm.loading = true;
            vm.manufacturer = currentAuth.org.manufacturer;
            search();
        }

        vm.setPageSize = setPageSize;

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            search();
        }

        vm.hasNextPage = hasNextPage;

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        vm.hasPreviousPage = hasPreviousPage;

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        vm.loadNextPage = loadNextPage;

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            search();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            search();
        }


    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog.guides', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog.guides')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.catalog.guides', {
        abstract: true,
        url: '/guides',
        template: '<ui-view/>'
      })
      .state('index.guides', {
        abstract: true,
        url: '/guides',
        template: '<ui-view/>'
      })
      .state('index.catalog.guides.list', {
        url: '',
        templateUrl: 'app/catalog/guides/guide.html',
        controller: 'GuideController',
        controllerAs: 'vm'
      })
      .state('index.guides.create', {
        url: '/create',
        templateUrl: 'app/catalog/guides/guide.edit.html',
        controller: 'GuideEditController',
        controllerAs: 'vm'
      })
      .state('index.guides.edit', {
        url: '/edit/:objectKey',
        templateUrl: 'app/catalog/guides/guide.edit.html',
        controller: 'GuideEditController',
        controllerAs: 'vm'
      });

  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.catalog.guides')
        .factory('Guides', Guides);

    Guides.$inject = ['$resource', 'restUrl', 'oldUrl'];

    function Guides($resource, restUrl, oldUrl) {

        var resourceUrl = restUrl + '/v1/guide/:objectKey';
        var oldResource = oldUrl + '/v1/guide/:objectKey';

        return $resource(resourceUrl, null,
            {
                get: {method: 'GET'},
                remove: {method: 'DELETE'},
                insert: {method: 'POST'},
                update: {method: 'PUT'},
                search: {method: 'GET', isArray: false},
                oldSearch: {method: 'GET', url:oldResource, isArray: false },
                query: {method: 'GET', isArray: false }
            });
    }

})();

(function () {
        'use strict';

        /* global angular */

        angular
            .module('connectsx.catalog.guides')
            .controller('GuideEditController', GuideEditController);

        GuideEditController.$inject = ['Accounts', 'Guides', '$mdConstant', 'Toast', 'Show', '$stateParams', '$mdDialog',
            '$scope', '$document', '$log', 'currentAuth', 'Orgs', 'ConfirmUnsavedChanges', '$rootScope', '$timeout',
            '$state'];

        function GuideEditController(Accounts, Guides, $mdConstant, Toast, Show, $stateParams, $mdDialog, $scope,
                                     $document, $log, currentAuth, Orgs, ConfirmUnsavedChanges, $rootScope, $timeout,
                                     $state) {

            var vm = this;

            vm.finish = finish;
            vm.addStep = addStep;
            vm.editStep = editStep;
            vm.removeStep = removeStep;

            activate();

            function activate() {


                vm.guide = {};

                if (angular.isUndefined($stateParams.objectKey)) {

                    vm.layer = {overlays: [], devices: []};

                    Orgs.get({objectKey: currentAuth.org.key}, function (org) {

                        org.manufacturer.name = org.name;
                        vm.manufacturers = [org.manufacturer];
                        vm.guide.manufacturer = org.manufacturer;
                        $scope.$emit('loading', false);


                    }, function (error) {

                        Toast.error(error);
                        $scope.$emit('loading', false);

                    });

                    return;
                }

                Guides.get({objectKey: $stateParams.objectKey}, success, error);

                function success(response) {
                    vm.guide = response;
                    setDefaults(vm.guide);
                    $scope.$emit('loading', false);

                    vm.isChange = false;

                    watchChanges()
                }

                function error(error) {

                    if (error.status === 404 || error.status === 400) {
                        Show.notFound();
                        return;
                    }


                    $log.info(angular.toJson(error));
                    $scope.$emit('loading', false);
                    Toast.error(error);
                }

            }


            function addStep() {

                if (angular.isUndefined(vm.guide.steps)) {
                    vm.guide.steps = [];
                }
                var step = {devices: [], devicePrefixes: [], deviceParents: [], images: [], videos: []};
                vm.guide.steps.push(step);
                editStep(null, step);

            }

            function editStep(event, step) {

                $mdDialog.show({
                    locals: {'step': step},
                    controller: DialogController,
                    templateUrl: 'app/catalog/guides/step.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: event,
                    clickOutsideToClose: true
                });

            }

            function removeStep(event, index) {
                vm.guide.steps.splice(index, 1);
            }

            /* eslint-disable angular/controller-as */
            function DialogController($scope, $mdDialog, $mdConstant, step) {

                $scope.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
                $scope.step = step;

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

            }

            function setDefaults(guide) {
                if (angular.isUndefined(guide.steps)) {
                    guide.steps = [];
                }
                for (var i = 0; i < guide.steps.length; i++) {
                    var step = guide.steps[i];
                    if (angular.isUndefined(step.devices)) {
                        step.devices = [];
                    }
                    if (angular.isUndefined(step.images)) {
                        step.images = [];
                    }
                    if (angular.isUndefined(step.videos)) {
                        step.videos = [];
                    }
                }
            }

            function finish() {

                vm.isLoading = true;

                if (angular.isDefined(vm.guide.key)) {
                    var params = {objectKey: vm.guide.key};
                    Guides.update(params, vm.guide, success, error);
                } else {
                    Guides.insert(vm.guide, success, error);
                    onRouteChangeOff();
                }

                function success(response) {
                    vm.guide = response;
                    setDefaults(vm.guide);
                    vm.isLoading = false;
                    Toast.success('Saved!');
                    $log.info(angular.toJson(response));
                    vm.isChange = false;
                    if(angular.isUndefined($stateParams.objectKey)){
                        $state.go('index.guides.edit', { objectKey: response.key })
                    }

                }

                function error(error) {
                    vm.isLoading = false;
                    Toast.error(error);
                    $log.error(angular.toJson(error));
                }

            }

            // Below Functional related to prompt when edit form & have unsaved changes
            function watchChanges() {
                vm.isChange = false;
                $scope.$watch('vm.guide', function (newVal, oldVal) {
                    if(newVal !== oldVal){
                        $log.info('Change')
                        vm.isChange = true;
                    }
                }, true);
            }

            function routeChange(event, newUrl, oldUrl) {
                //Array fields to validate
                var validateArray = [vm.guide.name];
                return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
            }

            // OnInit add event listener to change route
            var onRouteChangeOff;
            this.$onInit = function() {
                $timeout(function(){
                    onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                    if(!vm.guide.name){
                        watchChanges()
                    }

                }, 1000)
            }

            // Stop listened event $stateChangeStart
            $scope.$on("$destroy", function(event) {
                onRouteChangeOff()
            });

        }

    })();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.catalog.guides')
        .controller('GuideController', GuideController);

    GuideController.$inject = ['Guides', '$scope', '$log', 'Toast'];

    function GuideController(Guides, $scope, $log, Toast) {

        $scope.$emit('loading', false);

        var vm = this;

        /// these defaults will be overwritten by state params if present
        vm.pageSize = 20;
        vm.previousPages = [];
        vm.loading = false;

        vm.search = search;

        vm.copyFromProd = copyFromProd;

        function copyFromProd() {
            Guides.oldSearch({}, function (response) {
                var items = response.items || [];
                angular.forEach(items, function (item) {
                    insert(item);
                    $log.info(item.name);
                });
            }, Toast.error);

        }

        function insert(item) {
            item.manufacturer = null;
            Guides.insert(null, item, function (response) {
                $log.info('Inserted: ' + response.name);
            }, Toast.error);
        }

        activate();

        function search() {

            var params = {};

            var searchText = vm.searchText;

            if (angular.isDefined(vm.pageSize)) {
                params.limit = vm.pageSize;
            }

            if (angular.isDefined(vm.previousPages) && vm.previousPages.length > 0) {
                params.cursor = vm.previousPages[vm.previousPages.length - 1];
            }

            if (angular.isDefined(searchText) && searchText.length > 0) {
                params.search = searchText;
            }

            Guides.search(params, success, error);

            function success(response) {
                vm.loading = false;
                vm.items = response.items || [];
                vm.nextPageToken = response.nextPageToken;
            }

            function error(response) {
                Toast.error(response);
                vm.loading = false;
                $log.error(angular.toJson(response));
            }

        }

        function activate() {
            vm.loading = true;
            search();
        }

        vm.setPageSize = setPageSize;

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            search();
        }

        vm.hasNextPage = hasNextPage;

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        vm.hasPreviousPage = hasPreviousPage;

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        vm.loadNextPage = loadNextPage;

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            search();
        }

        vm.loadPreviousPage = loadPreviousPage;

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            search();
        }


    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.cases')
    .directive('csxCaseNotes', csxCaseNotes);

  function csxCaseNotes() {
    return {
      restrict: 'EA',
      templateUrl: 'app/cases/notes/case.notes.html',
      controller: 'CaseNotesController',
      controllerAs: 'vm',
      scope: {
        caseObject: '='
      },
      bindToController: true
    }
  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .controller('CaseNotesController', CaseNotesController);

  CaseNotesController.$inject = ['$log', 'Cases'];

  function CaseNotesController($log, Cases) {

    var vm = this;

    vm.isLoadingNotes = false;
    vm.saveNote = saveNote;
    vm.removeNote = removeNote;

    function removeNote(caseKey, noteKey) {

      if (angular.isUndefined(noteKey) || angular.isUndefined(caseKey)) return;

      var params = { objectKey:caseKey, noteKey:noteKey };
      Cases.removeNote(params, success, error);

      vm.isLoadingNotes = true;

      function success(value) {
        vm.caseObject = value;
        vm.caseObject.trays = vm.caseObject.trays || [];
        vm.caseObject.devices = vm.caseObject.devices || [];
        vm.isLoadingNotes = false;
      }

      function error(response) {
        $log.info(angular.toJson(response));
        vm.isLoadingNotes = false;
      }

    }
    function saveNote(caseKey, noteContent) {

      if (angular.isUndefined(caseKey)) return;

      if (angular.isUndefined(noteContent) || !noteContent.length > 0) {
        return;
      }

      var note = { content: noteContent };

      vm.isLoadingNotes = true;
      Cases.addNote({ objectKey: caseKey }, note, success, error);

      function success(caseObject) {
        vm.caseObject = caseObject;
        vm.caseObject.trays = vm.caseObject.trays || [];
        vm.caseObject.devices = vm.caseObject.devices || [];
        vm.noteContent = null;
        vm.isLoadingNotes = false;
      }

      function error(response) {
        $log.info(angular.toJson(response));
        vm.isLoadingNotes = false;
      }

    }
  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .controller('SignatureController', SignatureController);


  SignatureController.$inject = ['$log', '$mdDialog', 'SignatureCallback'];

  function SignatureController($log, $mdDialog, SignatureCallback) {

    var vm = this;

    vm.cancel = $mdDialog.hide;
    vm.submitForBilling = submitForBilling;

    activate();

    function activate() {
      $log.info('Activating SignatureController');
    }

    function submitForBilling() {
      if ((angular.isString(vm.signature) && vm.signature.length > 0)
        && (angular.isString(vm.hospitalSignature) && vm.hospitalSignature.length > 0)) {
        SignatureCallback(vm.signature, vm.hospitalSignature);
        $mdDialog.hide();
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.cases')
    .factory('Invoices', Invoices);

  Invoices.$inject = ['$resource', 'restUrl'];

  function Invoices($resource, restUrl) {

    var resourceUrl = restUrl + '/v3/invoice/:objectKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        update: { method:'PUT' },
        email: { method:'POST', url: resourceUrl + '/email' }
      });

  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .controller('InvoiceController', InvoiceController);

  InvoiceController.$inject = ['$scope', '$log', '$stateParams', 'Invoices', 'Toast', 'Show'];

  function InvoiceController($scope, $log, $stateParams, Invoices, Toast, Show) {


    var vm = this;
    var invoiceKey = $stateParams.objectKey;
    vm.isLoading = false;
    vm.emailLoading = false;

    vm.amount = amount;
    vm.deviceCost = deviceCost;
    vm.save = save;
    vm.email = email;

    activate();

    function activate() {
      query();
    }

    function email() {

      vm.emailLoading = true;
      save(function(invoice) {
        Invoices.email({ objectKey: invoice.key }, null, function () {
          vm.emailLoading = false;
          vm.invoice.sent = true;
          Toast.success('Successfully emailed invoice!')
        }, function(error) {
          vm.emailLoading = false;
          Toast.error(error);
        })
      });
    }

    function query() {

      $scope.$emit('loading', true);

      Invoices.get({ objectKey: invoiceKey }, success, error);

      function success(response) {

        $scope.$emit('loading', false);

        setup(response);
      }

      function error(response) {

        $scope.$emit('loading', false);

        if (response.status === 404 || response.status === 400) {
          Show.notFound();
          return;
        }

        Toast.error(response);

        $log.error(angular.toJson(response));
      }

    }

    function setup(invoice) {

      vm.invoice = invoice;
      vm.items = [];
      var groups = {};

      angular.forEach(vm.invoice.devices, function(device) {
        if (!groups.hasOwnProperty(device.referenceNumber)){
          groups[device.referenceNumber] = [];
        }
        groups[device.referenceNumber].push(device);
      });

      angular.forEach(groups, function(value) {
        var item = angular.copy(value[0]);
        item.quantity = value.length;
        vm.items.push(item);
      });


    }

    function amount() {

      if (angular.isUndefined(vm.invoice) || angular.isUndefined(vm.invoice.amount)) {
        return 0;
      }

      var amount = 0;

      angular.forEach(vm.items, function (item) {
        amount += (item.deviceCost * item.quantity);
      });


      var discount = vm.invoice.discount || 0;
      var discountAmount = (discount / 100) * amount;
      return amount - discountAmount;

    }

    function deviceCost(item) {

      if (angular.isUndefined(item)) return;

      var amount = item.quantity * item.deviceCost;
      var discount = vm.invoice.discount || 0;
      var discountAmount = (discount / 100) * amount;
      return amount - discountAmount;

    }

    function save(callback) {

      if (angular.isUndefined(vm.invoice) || angular.isUndefined(vm.invoice.key)) {
        return;
      }

      vm.invoice.amount = amount();

      var prices = {};
      angular.forEach(vm.items, function(item) {
        prices[item.referenceNumber] = item.deviceCost;
      });

      angular.forEach(vm.invoice.devices, function(device) {
        if (angular.isDefined(prices[device.referenceNumber])) {
          device.deviceCost = prices[device.referenceNumber];
        }
      });

      vm.isLoading = true;

      Invoices.update({ objectKey: vm.invoice.key}, vm.invoice, saveSuccess, saveError);

      function saveSuccess(response) {
        setup(response);
        vm.isLoading = false;
        if (angular.isFunction(callback)) {
          callback(response);
        } else {
          Toast.success('Saved!');
        }
      }

      function saveError(response) {
        vm.isLoading = false;
        vm.emailLoading = false;
        $log.error(angular.toJson(response));
        Toast.error(response);
      }

    }

  }
})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .factory('MarkInventoryModal', MarkInventoryModal);

    MarkInventoryModal.$inject = ['$mdDialog'];

  function MarkInventoryModal($mdDialog) {


    function show(caseObject, callback) {
      $mdDialog.show({
        locals: { 'CaseObject':caseObject || {}, 'Callback': callback || function() {}},
        controller: 'MarkInventoryModalController',
        controllerAs: 'vm',
        templateUrl:'app/cases/inventory/mark.inventory.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function () {
    'use strict';
/* global angular*/
    angular
        .module('connectsx.cases')
        .controller('MarkInventoryModalController', MarkInventoryModalController);

    MarkInventoryModalController.$inject = ['$log', '$mdDialog', 'CaseInventory', 'Inventory', 'CaseObject', 'Callback'];

    function MarkInventoryModalController($log, $mdDialog, CaseInventory, Inventory, CaseObject, Callback) {

        var vm = this;
        vm.inventory = [];
        vm.inventoryKeys = {};
        vm.isSearchContainerTextChanged = false;
        vm.cacheContainers = [];
        vm.cancel = $mdDialog.hide;

        vm.removeInventory = removeInventory;
        vm.searchInventory = searchInventory;
        vm.searchContainers = searchContainers;
        vm.addInventory = addInventory;
        vm.markAndAssign = markAndAssign;
        vm.isStringLength = isStringLength;
        

        function removeInventory(item) {
            for (var i=0; i < vm.inventory.length ; i++){
                if (vm.inventory[i].key === item.key) {
                    vm.inventory.splice(i, 1);
                    vm.inventoryKeys[item.key] = false;
                    return;
                }
            }
        }

        function success(response) {
            vm.updateLoading = false;
            Callback(response);
            $mdDialog.hide();
        }

        function error(error) {
            $log.error(error);
            vm.error = error.data.error.message;
            vm.updateLoading = false;
            vm.loading = false;
        }

        function addInventory(item) {

            if (!angular.isObject(item) || !angular.isString(item.key)) {
                return;
            }

            for (var i=0; i < vm.inventory.length; i++){
                if (vm.inventory[i].key === item.key) {
                    return;
                }
            }

            if (vm.inventoryKeys[item.key] === true) {
                return;
            }

            vm.inventoryKeys[item.key] = true;

            vm.inventory.push(item);
            vm.selectedInventory = undefined;
        }

        //Search containers
    
        function sleep(ms) {
            return new Promise(function(resolve){
                vm.isSearching = setTimeout(resolve, ms)
            } );
        }
        
        function searchContainers(searchText) {
            
            clearTimeout(vm.isSearching);

            return sleep(1500).then(function() {

                var params = {
                    search: searchText,
                    type: 'Container',
                    unassigned: true,
                    custody: CaseObject.account.key,
                    limit: 300,
                    extendedInfo: true
                };

                if (vm.inventory.length > 0) {
                    params.manufacturer = vm.inventory[0].manufactureKey;
                }

                return Inventory.basicSearch(params).$promise.then(function (response) {
                    var items = response.items || [];
                    vm.isSearchContainerTextChanged = false;
                    vm.cacheContainers = items;
                    angular.forEach(items, function (item) {
                        item.description = item.name;
                    });
                    return items;
                });
            });
        }
        // </>

        function searchInventory(searchText) {
    
            clearTimeout(vm.isSearching);
    
            return sleep(1500).then(function() {

                var params = {
                    search: searchText,
                    type: 'Device',
                    unassigned: true,
                    custody: CaseObject.account.key,
                    extendedInfo: true,
                    size: 1000
                };

                if (angular.isObject(vm.selectedContainer) &&
                    angular.isString(vm.selectedContainer.key)) {
                    params.container = vm.selectedContainer.key;
                } else {
                    params.loose = true;
                }
    
                if (vm.inventory.length > 0) {
                    params.manufacturer = vm.inventory[0].manufactureKey;
                }

                return Inventory.basicSearch(params).$promise.then(function (response) {
                    var items = response.items || [];
                    var results = [];
                    angular.forEach(items, function (item) {
                        if(angular.isDefined(item.transferStatus) &&
                            angular.isString(item.transferStatus) &&
                            item.transferStatus ==='Pending'){
                            return true
                        }
                        item.description = item.name;
                        if (item.name !== item.reference) {
                            item.description += ' (' + item.reference + ')';
                        }
                        if (vm.inventoryKeys[item.key] !== true) {
                            results.push(item);
                        }
                    });
                    return results;
                });
            });
        }

        function markAndAssign() {

            if (vm.updateLoading) {
                return;
            }

            if (vm.inventory.length === 0) {
                return;
            }

            if (!angular.isString(CaseObject.key)) {
                return;
            }

            var updates = {};
            angular.forEach(vm.inventory, function(i) {
                updates[i.key] = 'Used';
            });

            vm.updateLoading = true;
            CaseInventory.updateStatuses({ caseKey: CaseObject.key }, { statuses: updates }, success, error);

        }

        function isStringLength(el){
            if(typeof el === 'string'){
                return el.length > 0
            }
            else {
                return false
            }
        }


    }

})();


(function() {
  'use strict';

  angular
    .module('connectsx.cases')
    .factory('CaseInventory', CaseInventory);

  CaseInventory.$inject = ['$resource', 'restUrl'];

  function CaseInventory($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/case/:caseKey/inventory';
    var bomUrl = restUrl + '/v1/case/:caseKey/bom';
    var updateStatusesUrl = restUrl + '/v1/inventory/:caseKey/statuses';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        devices: { method: 'GET', url: resourceUrl + '/devices' },
        update: { method:'PUT' },
        updateStatuses: { method:'PUT', url: updateStatusesUrl },
        bom: { method: 'GET', url: bomUrl },
        generateBom: { method: 'POST', url: bomUrl },
        getBomUrl: { method: 'GET', url: bomUrl + '/url' }
      });

  }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .controller('CaseInventoryController', CaseInventoryController);

  CaseInventoryController.$inject = [ '$scope' , '$stateParams', 'CaseInventory', '$log', 'Toast', 'Show'];

  function CaseInventoryController($scope, $stateParams, CaseInventory, $log, Toast, Show) {

    var vm = this;
    var caseKey = $stateParams.objectKey;
    vm.caseKey = caseKey;

    vm.devices = [];
    vm.show = Show;

    vm.statuses = ['Unused', 'Used', 'Implanted', 'Damaged', 'Missing', 'Other'];
    vm.otherStatuses = ['Damaged', 'Missing', 'Other'];

    vm.filterOtherStatuses = filterOtherStatuses;
    vm.updateStatus = updateStatus;

    activate();

    function activate() {

      query();

    }

    function query() {

      $scope.$emit('loading', true);

      CaseInventory.get({ caseKey:caseKey }, inventorySuccess, inventoryError);

      function inventorySuccess(inventory) {
        vm.devices = inventory.devices || [];
        vm.trays = inventory.trays || [];
        angular.forEach(vm.trays, function(tray) {
          vm.devices = vm.devices.concat(tray.devices);
        });

        $scope.$emit('loading', false);

      }

      function inventoryError(error) {

        if (error.status === 404 || error.status === 400) {
          Show.notFound();
          return;
        }

        Toast.error(error);
        $log.info(angular.toJson(error));

        $scope.$emit('loading', false);

      }

    }

    function filterOtherStatuses(device) {
        return (vm.otherStatuses.indexOf(device.deviceStatus) !== -1);
    }

    function updateStatus(device) {

      if (angular.isUndefined(device) || angular.isUndefined(caseKey)) {
        return;
      }

      var params = { caseKey: caseKey };
      var statuses = [{
        key: device.key,
        manufacturer: device.manufacturer,
        deviceStatus:device.deviceStatus
      }];

      CaseInventory.updateStatuses(params, { devices: statuses }, updateStatusesSuccess, updateStatusesError);

      function updateStatusesSuccess(response) {
        Toast.success("Device status successfully updated.");
        $log.info(angular.toJson(response));
      }

      function updateStatusesError(response) {
        Toast.error(response);
        $log.error(angular.toJson(response));
      }

    }

  }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .controller('CaseDetailController', CaseDetailController);

    CaseDetailController.$inject = ['$scope', '$log', '$stateParams', '$state',
        '$mdDialog', 'Cases', 'CaseInventory', 'Toast', 'Show'];

    function CaseDetailController($scope, $log, $stateParams, $state,
                                  $mdDialog, Cases, CaseInventory, Toast, Show) {

        var vm = this;
        vm.caseObject = {};

        $state.get()
            .map(function (state) {
                $log.info(state.name);
                return $state.href(state.name)
            });

        vm.isInventoryLoading = false;
        vm.isSubmittingCase = false;
        vm.statusClass = statusClass;

        vm.viewAccessDetail = viewAccessDetail;
        vm.viewDevice = viewDevice;

        function viewDevice(key) {
            $log.info(key);
            if (angular.isUndefined(key)) return;
            $state.go('index.inventory.edit', {objectKey: key})
        }

        activate();

        function activate() {
            populateFields();
        }

        function viewAccessDetail(access) {
            switch (access.type) {
                case 'FacilityEntity':
                    $state.go('index.facilities.detail', {objectKey: access.key});
                    return;
                case 'ManufacturerEntity':
                    Toast.error('No manufacturer detail pages yet.');
                    return;
                case 'AccountEntity':
                    Toast.error('No account detail pages yet.');
                    return;
                case 'DistributorEntity':
                    Toast.error('No distributor detail pages yet.');
                    return;
            }
        }

        function populateFields() {

            $scope.$emit('loading', true);

            var caseKey = $stateParams.objectKey;

            var params = {
                objectKey: caseKey
            };

            Cases.get(params, successCallback, errorCallback);

            function successCallback(value) {
                $log.info(angular.toJson(value));
                vm.caseObject = value;
                $scope.$emit('loading', false);
            }

            function errorCallback(response) {
                if (response.status === 404 || response.status === 400) {
                    Show.notFound();
                    return;
                }
                $log.error('CaseApi Error: ' + response);
                $scope.$emit('loading', false);
                var message = angular.isDefined(response.data.error.message) ?
                    response.data.error.message : 'Something went wrong!';
                Toast.error(message);
            }

            vm.isInventoryLoading = false;

            Cases.inventory(params, inventorySuccess, inventoryError);

            function inventorySuccess(value) {
                vm.inventory = value;

                vm.inventory.containers = vm.inventory.containers || [];
                vm.inventory.devices = vm.inventory.devices || [];

                var counts = {
                    'Unused': 0,
                    'Used': 0,
                    'Implanted': 0,
                    'Explanted': 0,
                    'Damaged': 0,
                    'Other': 0,
                };

                function addStatus(d, aggregator) {
                    if (aggregator.hasOwnProperty(d.status)) {
                        aggregator[d.status] += 1;
                    } else {
                        aggregator['Other'] += 1;
                    }
                }

                var devices = [];
                angular.forEach(vm.inventory.containers, function (c) {
                    devices.push(c.container);
                    addStatus(c.container, counts);
                   angular.forEach(c.devices || [], function(d) {
                       devices.push(d);
                       addStatus(d, counts);
                   })
                });

                angular.forEach(vm.inventory.devices, function(d) {
                    devices.push(d);
                    addStatus(d, counts);
                });

                vm.devices = devices;
                vm.counts = counts;
                vm.isInventoryLoading = false;

            }

            function inventoryError(response) {
                vm.isInventoryLoading = false;
                vm.inventoryLoadingError = angular.isDefined(response.data.error.message) ?
                    response.data.error.message : 'Something went wrong loading inventory for this case!';
                $log.error('CaseInventory Error: ' + angular.toJson(response));
            }
        }


        function statusClass(status) {
            switch (status) {
                case 'Closed':
                    return 'csx-closed';
                case 'Open':
                    return 'csx-open';
                case 'Pending':
                    return 'csx-pending';
                case 'Rescheduled':
                    return 'csx-rescheduled';
                case 'Cancelled':
                    return 'csx-cancelled';
            }
            return '';
        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .controller('CaseEditController', CaseEditController);

    CaseEditController.$inject = ['MarkInventoryModal',
        'Cases', 'Inventory', 'Facilities', 'CaseInventory', 'Physicians', 'Procedures', 'Products',
        '$window', '$mdDialog', '$state', '$scope', '$log', '$stateParams', 'Toast', '$location', 'Show',
        'NewPhysicianModal', 'NewFacilityModal', 'NewProcedureModal', 'ConfirmUnsavedChanges', '$rootScope', '$timeout',
        'PopupSelectManufacturer', 'PopupAddPONumber'];

    function CaseEditController(MarkInventoryModal, Cases, Inventory, Facilities, CaseInventory, Physicians,
                                Procedures, Products, $window, $mdDialog, $state, $scope, $log, $stateParams,
                                Toast, $location, Show, NewPhysicianModal, NewFacilityModal, NewProcedureModal,
                                ConfirmUnsavedChanges, $rootScope, $timeout, PopupSelectManufacturer, PopupAddPONumber) {

        var vm = this;
        vm.caseObject = {};
        vm.caseInventory = {};
        vm.isLoadingInventory = false;
        vm.isLoading = false;
        vm.isAddingDevice = false;
        vm.isAddingTray = false;
        vm.isChange = false;
        vm.poManufacture = [];
        vm.notes = [];
        vm.counts = {
            Used : 0,
            Implanted: 0,
            Explanted: 0,
            Damaged: 0,
            Missing: 0,
            Other: 0
        };

        var caseKey = $stateParams.objectKey;

        vm.submit = submit;
        vm.getDutUrl = getDutUrl;

        vm.show = Show;

        vm.statusClass = function statusClass(status) {
            switch (status) {
                case 'Closed':
                    return 'csx-closed';
                case 'Open':
                    return 'csx-open';
                case 'Pending':
                    return 'csx-pending';
                case 'Rescheduled':
                    return 'csx-rescheduled';
                case 'Cancelled':
                    return 'csx-cancelled';
            }
            return '';
        };

        vm.statuses = [
            "Open",
            "Closed",
            "Cancelled",
            "Pending",
            "Rescheduled"
        ];

        vm.deviceStatuses = [
            "Unused",
            "Used",
            "Implanted",
            "Explanted",
            "Damaged",
            "Missing",
            "Other"
        ];

        vm.trackingStatuses = [
            'Not Started',
            'Preparing',
            'Shipped',
            'Received'
        ];

        vm.selectPhysician = selectPhysician;
        vm.searchPhysicians = searchPhysicians;

        vm.selectFacility = selectFacility;
        vm.searchFacilities = searchFacilities;

        vm.selectProcedure = selectProcedure;
        vm.searchProcedures = searchProcedures;
        vm.physicianDisplayName = physicianDisplayName;
        vm.searchProducts = searchProducts;


        vm.createPhysician = createPhysician;
        vm.createFacility = createFacility;
        vm.createProcedure = createProcedure;
        vm.updateStatus = updateStatus;
        vm.markUsedInventory = function () {
            MarkInventoryModal.show(vm.caseObject, function () {
                vm.poManufacture = [];
                getPONumbers();
                activate();

            });
        };

        vm.hasDut = hasDut;
        vm.reopen = reopen;
        vm.addPONumber = addPONumber;
        vm.getPONumbers = getPONumbers;
        vm.calculateCounts = calculateCounts;

        function addPONumber(ev) {

            vm.isCompleting = false;


            PopupAddPONumber.show(vm.caseObject.manufacturers, vm.caseObject.poNumbers || {}, completeCase);

            function completeCase(poNumbers){

                    vm.caseObject.poNumbers = poNumbers;
                    vm.isCompleting = true;
                    Cases.complete({objectKey: vm.caseObject.key }, vm.caseObject, function (updated) {
                        vm.caseObject.status = updated.status;
                        vm.isCompleting = false;
                        Toast.success('Successfully completed case!');
                        vm.getPONumbers();

                    }, errorCallback)
            }



        }

        function hasDut(caseObject) {
            return caseObject.status === 'Closed' ||
                caseObject.status === 'Completed';
        }

        vm.viewDevice = viewDevice;
        vm.updateDevice = updateDevice;

        function createPhysician() {

            NewPhysicianModal.show(vm.physicianSearchText, function (physician) {
                vm.caseObject.physician = physician;
            });

            vm.physicianSearchText = undefined;

        }

        function createFacility() {

            NewFacilityModal.show(vm.facilitySearchText, function (facility) {
                vm.caseObject.facility = facility;
            });

            vm.facilitySearchText = undefined;

        }

        function createProcedure() {

            NewProcedureModal.show(vm.procedureSearchText, function (procedure) {
                vm.caseObject.procedure = procedure;
            });

            vm.procedureSearchText = undefined;

        }

        vm.finish = finish;

        activate();

        function activate() {
            populateFields();
        }

        function searchProcedures(searchText) {
            return Procedures.search({search: searchText, limit:1000}).$promise.then(function (response) {
                return angular.isDefined(response.items) ? response.items : [];
            });
        }

        function searchFacilities(searchText) {
            return Facilities.search({search: searchText, limit:1000}).$promise.then(function (response) {
                return angular.isDefined(response.items) ? response.items : [];
            });
        }

        function physicianDisplayName(physician) {
            physician.displayName = physician.name;
            if (angular.isString(physician.state)) {
                physician.displayName += ' (' + physician.state + ')';
            }
            return physician.displayName;
        }

        function searchPhysicians(searchText) {
            searchText = searchText.toLowerCase();
            return Physicians.search({search: searchText, limit:1000}).$promise.then(function (response) {
                return angular.isDefined(response.items) ? response.items : [];
            });
        }

        function selectProcedure(item) {
            vm.caseObject.procedure = item;
        }

        function selectPhysician(item) {
            vm.caseObject.physician = item;
        }

        function selectFacility(item) {
            vm.caseObject.facility = item;
        }

        function viewDevice(deviceKey) {
            if (angular.isUndefined(deviceKey)) return;
            $state.go('index.inventory.edit', {objectKey: deviceKey})
        }

        function populateFields(isShowPreloade) {

            if(!isShowPreloade){
                $scope.$emit('loading', true);
            }


            var caseKey = $stateParams.objectKey;

            var params = {
                objectKey: caseKey
            };

            Cases.get(params, successCallback, errorCallback);
            loadNotes(params);

            function successCallback(value) {
                if (angular.isObject(value.account)) {
                    value.account.display = value.account.name + ' (' + value.account.email + ')';
                }
                value.procedureTime = new Date(value.procedureTime);
                vm.caseObject = value;
                vm.caseObject.products = vm.caseObject.products || [];
                $scope.$emit('loading', false);
                vm.getPONumbers();
                vm.isChange = false;
                $timeout(function(){
                    watchChanges()
                }, 1000)

            }

            // Load devices
            CaseInventory.get({caseKey: caseKey}, successCaseCallback, errorCaseCallback);

            function successCaseCallback(caseInventory){
                vm.devices = [];
                // initialize empty device/tray arrays for later use
                if (angular.isUndefined(caseInventory.devices)) {
                    vm.caseInventory.devices = [];
                }

                if (angular.isUndefined(caseInventory.containers)) {
                    vm.caseInventory.containers = [];
                }

                angular.forEach(caseInventory.containers, function (container) {
                    var devices = container.devices || [];
                    angular.forEach(devices, function (device) {
                        vm.devices.push(device);
                    })
                });

                angular.forEach(caseInventory.devices, function (device) {
                    vm.devices.push(device);
                })
            }

            function loadNotes(params) {
                params.size = 100;
                Cases.getNotes(params, function(note) {
                    vm.notes = note.items;
                })
            }

            function errorCaseCallback(httpResponse) {

                if (httpResponse.status === 404 || httpResponse.status === 400) {
                    Show.notFound();
                    return;
                }

                $scope.$emit('loading', false);
                $log.error(angular.toJson(httpResponse));
                Toast.error(httpResponse);

            }
        }

        function searchProducts(searchText) {
            var params = {
                manufacturer: vm.caseObject.manufacturer.key,
                search: searchText,
                limit:1000
            };
            return Products.search(params).$promise.then(function (response) {
                if (angular.isUndefined(response.items)) {
                    response.items = [];
                }
                return response.items;
            });
        }

        function finish() {

            if (vm.isLoading) {
                return;
            }

            vm.isLoading = true;

            var params = {
                objectKey: vm.caseObject.key
            };

            Cases['update'](params, vm.caseObject, successCallback, errorCallback);

            function successCallback(value) {
                vm.isLoading = false;
                populateFields(true)
                Toast.success('Saved!');
                vm.poManufacture = [];
                getPONumbers()
            }


            function errorCallback(httpResponse) {
                vm.isLoading = false;
                $log.error('CaseApi Error: ' + httpResponse);
                Toast.error(httpResponse.data.error.message);
            }

        }

        function getDutUrl(ev) {

            //Select Manufacture
            PopupSelectManufacturer.show(vm.caseObject.manufacturers, sendManufacture)

            function sendManufacture (selectedManufacture){
                vm.isGenerating = true;
                
                var params = {
                    caseKey: vm.caseObject.key,
                    manufacturer: selectedManufacture.key
                };

                CaseInventory.getBomUrl(params, success, error);
            }


            function success(response) {
                vm.isGenerating = false;
                // Appending dialog to document.body to cover sidenav in docs app
                var confirm = $mdDialog.confirm()
                    .title('Device Usage Ticket PDF')
                    .textContent('We have generated a PDF of this DUT. Would you like to open this PDF in another tab?')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');

                $mdDialog.show(confirm).then(function () {
                    $window.open(response.url, '_blank');
                });
            }

            function error(response) {
                vm.isGenerating = false;
                Toast.error(response);
            }

        }

        function submit() {

            function callback(signature, hospitalSignature) {

                if (angular.isUndefined(caseKey)) {
                    return;
                }

                if (!angular.isString(signature)) {
                    return;
                }
                if (!angular.isString(hospitalSignature)) {
                    return;
                }

                var caseObject = {
                    key: caseKey,
                    signatureName: signature,
                    hospitalSignatureName: hospitalSignature
                };

                var params = {
                    objectKey: caseKey
                };

                vm.isSubmitting = true;

                Cases.submit(params, caseObject, function (response) {
                    populateFields(true)
                    vm.isSubmitting = false;
                    Toast.success('Successfully submitted ' + response.name);
                    vm.poManufacture = [];
                    getPONumbers();
                }, function (error) {
                    vm.isSubmitting = false;
                    Toast.error(error);
                    $log.error(angular.toJson(error));
                });

            }

            $mdDialog.show({
                locals: {
                    'SignatureCallback': callback || function () {
                    }
                },
                controller: 'SignatureController',
                controllerAs: 'vm',
                templateUrl: 'app/cases/signature/signature.tmpl.html',
                clickOutsideToClose: true
            });

        }

        function updateStatus(device) {

            if (angular.isUndefined(device) || angular.isUndefined(caseKey)) {
                return;
            }

            var params = {caseKey: caseKey};
            var updates = {};
            updates[device.key] = device.status;

            CaseInventory.updateStatuses(
                params,
                {statuses: updates},
                updateStatusesSuccess,
                updateStatusesError);

            function updateStatusesSuccess(response) {
                Toast.success("Device status successfully updated.");
                $log.info(angular.toJson(response));
                vm.poManufacture = [];
                getPONumbers();
            }

            function updateStatusesError(response) {
                Toast.error(response);
                $log.error(angular.toJson(response));
            }

        }

        function updateDevice(device) {

            if (angular.isUndefined(device) || !angular.isString(device.key)) {
                return;
            }

            var params = {objectKey: device.key};

            Inventory.update(
                params,
                device,
                updateSuccess,
                updateError);

            function updateSuccess() {
                Toast.success("Device successfully updated.");
                vm.poManufacture = [];
                getPONumbers()
            }

            function updateError(response) {
                Toast.error(response);
            }

        }

        function errorCallback(httpResponse) {
            vm.isReopening = false;
            vm.isLoading = false;
            vm.isCompleting = false;
            $log.error('CaseApi Error: ' + httpResponse);
            Toast.error(httpResponse);
        }

        function reopen() {

            if (vm.isReopening) {
                return;
            }

            vm.isReopening = true;

            var params = {
                objectKey: vm.caseObject.key
            };

            Cases.reopen(params, null, successCallback, errorCallback);

            function successCallback(value) {
                vm.isReopening = false;
                vm.caseObject = value;
                Toast.success('Success');
                vm.poManufacture = [];
                getPONumbers()
            }

        }

        function getPONumbers(){
            $timeout(function(){
                vm.calculateCounts();
            });
            if(!vm.caseObject.manufacturers || !vm.caseObject.poNumbers) {
                return
            }
            vm.poManufacture = [];
            vm.caseObject.manufacturers.forEach(function(man){

                for(var i in vm.caseObject.poNumbers) {
                    if(i === man.key){
                        vm.poManufacture.push({name: man.name, poNumber: vm.caseObject.poNumbers[i]})
                    }
                }
            });

        }

        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.caseObject', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    $log.info('Change')
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.caseObject.name, vm.caseObject.procedure, vm.caseObject.procedureDate,
                vm.caseObject.procedureTime, vm.caseObject.physician, vm.caseObject.facility ];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });


        function calculateCounts(){
            vm.counts = {
                Used : 0,
                Implanted: 0,
                Explanted: 0,
                Damaged: 0,
                Missing: 0,
                Other: 0
            };
            vm.devices.forEach(function(dev){
                $log.info(dev)
                if(dev.status === 'Used'){
                    vm.counts.Used = vm.counts.Used+=1
                }
                else if(dev.status === 'Implanted'){
                    vm.counts.Implanted = vm.counts.Implanted+=1
                }
                else if(dev.status === 'Explanted'){
                    vm.counts.Explanted = vm.counts.Explanted+=1
                }
                else if(dev.status === 'Damaged'){
                    vm.counts.Damaged = vm.counts.Damaged+=1
                }
                else if(dev.status === 'Missing'){
                    vm.counts.Missing = vm.counts.Missing+=1
                }
                else {
                    vm.counts.Other = vm.counts.Other+=1
                }
            });
        };
    }
})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.cases')
        .controller('CaseCreateController', CaseCreateController);

    CaseCreateController.$inject = [
        'Cases', 'Facilities', 'Physicians', 'Procedures', 'Products', 'Accounts', 'Orgs',
        'NewPhysicianModal', 'NewFacilityModal', 'NewProcedureModal', '$log', 'Toast', '$scope', '$state',
        'currentAuth', '$templateCache', 'ConfirmUnsavedChanges', '$rootScope', '$timeout'];

    function CaseCreateController(Cases, Facilities, Physicians, Procedures, Products, Accounts, Orgs,
                                  NewPhysicianModal, NewFacilityModal, NewProcedureModal, $log, Toast, $scope, $state,
                                  currentAuth, $templateCache, ConfirmUnsavedChanges, $rootScope, $timeout) {

        var vm = this;
        vm.caseObject = {};
        vm.isLoading = false;
        vm.isChange = false;

        vm.searchPhysicians = searchPhysicians;
        vm.selectPhysician = selectPhysician;

        vm.searchFacilities = searchFacilities;
        vm.selectFacility = selectFacility;

        vm.searchProcedures = searchProcedures;
        vm.selectProcedure = selectProcedure;
        vm.searchProducts = searchProducts;

        vm.finish = finish;
        vm.createPhysician = createPhysician;
        vm.createFacility = createFacility;
        vm.createProcedure = createProcedure;

        var orgManufacturers = {};

        activate();

        function activate() {

            if (angular.isArray(currentAuth.org.manufacturers)) {
                angular.forEach(currentAuth.org.manufacturers, function(m) {
                    orgManufacturers[m.key] = true
                })
            }
            if (angular.isObject(currentAuth.org.manufacturer)) {
                orgManufacturers[currentAuth.org.manufacturer.key] = true;
            }

            loadOrg();

        }

        function loadAccounts() {
            Accounts.list({}, success, onError);

            function success(response) {
                var accounts = [];
                angular.forEach(response.items || [], function (item) {
                    if (item.accountType === 'Individual') {
                        accounts.push(item);
                    }
                });

                if (angular.isObject(currentAuth.org)) {
                    accounts.push(currentAuth.org);
                    vm.caseObject.account = currentAuth.org;
                }
                vm.accounts = accounts;

                $scope.$emit('loading', false);
            }
        }

        function loadOrg() {
            Orgs.get({ objectKey: currentAuth.org.key }, function (org) {
                currentAuth.org = org;
                loadAccounts();
            }, Toast.error);
        }

        vm.selectAccount = function(account) {

            $log.info(account);

            var manufacturers = account.manufacturers || [];
            var filtered = [];
            angular.forEach(manufacturers, function(m) {
                if (orgManufacturers[m.key] === true) {
                    filtered.push(m);
                }
            });

            vm.manufacturers = filtered;
            if (vm.manufacturers.length > 0) {
                vm.caseObject.manufacturer = vm.manufacturers[0];
            }

        };


        function createPhysician() {


            NewPhysicianModal.show(vm.physicianSearchText, function (physician) {
                physician.displayName = physician.name;
                if (angular.isString(physician.state)) {
                    physician.displayName += ' (' + physician.state + ')';
                }
                vm.caseObject.physician = physician;
            });

            vm.physicianSearchText = undefined;

        }

        function createFacility() {

            NewFacilityModal.show(vm.facilitySearchText, function (facility) {
                vm.caseObject.facility = facility;
            });

            vm.facilitySearchText = undefined;

        }

        function createProcedure() {

            NewProcedureModal.show(vm.procedureSearchText, function (procedure) {
                vm.caseObject.procedure = procedure;
            });

            vm.procedureSearchText = undefined;

        }

        function searchProcedures(searchText) {
            var st = searchText.toLowerCase();
            return Procedures.search({search: st, limit:1000}).$promise.then(function (response) {
                return response.items || [];
            });
        }

        function searchFacilities(searchText) {
            var st = searchText.toLowerCase();
            return Facilities.search({search: st, limit:1000 }).$promise.then(function (response) {
                return response.items || [];
            });
        }

        function searchProducts(searchText) {
            var st = searchText.toLowerCase();
            var params = {
                manufacturer: vm.caseObject.manufacturer.key,
                search: st,
                limit:1000
            };
            return Products.search(params).$promise.then(function (response) {
                return response.items || [];
            });
        }

        function searchPhysicians(searchText) {
            searchText = searchText.toUpperCase();
            return Physicians.search({search: searchText, limit:1000 }).$promise.then(function (response) {
                var items = response.items;
                if (angular.isUndefined(items)) {
                    items = [];
                }
                angular.forEach(items, function (item) {
                    item.displayName = item.firstName + ' ' + item.lastName;
                    if (angular.isString(item.state)) {
                        item.displayName += ' (' + item.state + ')';
                    }
                });
                return items;
            });
        }

        function selectPhysician(item) {
            vm.caseObject.physician = item;
        }

        function selectFacility(item) {
            vm.caseObject.facility = item;
        }

        function selectProcedure(item) {
            vm.caseObject.procedure = item;
        }


        function finish() {

            var method = 'insert';

            Cases[method]({}, vm.caseObject, onSuccess, onError);

            vm.isLoading = true;

            function onSuccess(value) {
                onRouteChangeOff();
                vm.isLoading = false;
                vm.caseObject = value;

                var successMessage = vm.caseObject.name + ' was created.';
                Toast.success(successMessage);
                $state.go('index.cases.edit', {objectKey: value.key});
            }

        }

        function onError(error) {

            vm.isLoading = false;
            $log.error('CaseApi Error: ' + angular.toJson(error));
            Toast.error(error.data.error.message);
            $scope.$emit('loading', false);
        }


        // Below Functional related to prompt when edit form & have unsaved changes
        function watchChanges() {
            vm.isChange = false;
            $scope.$watch('vm.caseObject', function (newVal, oldVal) {
                if(newVal !== oldVal){
                    vm.isChange = true;
                }
            }, true);
        }

        function routeChange(event, newUrl, oldUrl) {
            //Array fields to validate
            var validateArray = [vm.caseObject.name, vm.caseObject.procedure, vm.caseObject.procedureDate,
                vm.caseObject.procedureTime, vm.caseObject.physician, vm.caseObject.facility ];
            return ConfirmUnsavedChanges.routeChange(event, newUrl, oldUrl, vm.isChange, vm.finish, vm, validateArray)
        }

        // OnInit add event listener to change route
        var onRouteChangeOff;
        this.$onInit = function() {
            $timeout(function(){
                onRouteChangeOff = $rootScope.$on('$stateChangeStart', routeChange);

                watchChanges(

                )
            }, 1000)
        }

        // Stop listened event $stateChangeStart
        $scope.$on("$destroy", function(event) {
            onRouteChangeOff()
        });

    }
})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .controller('BomController', BomController);

  BomController.$inject = ['$window', '$scope', '$log', '$stateParams', '$mdDialog', 'Cases', 'CaseInventory', 'Toast', 'Show'];

  function BomController($window, $scope, $log, $stateParams, $mdDialog, Cases, CaseInventory, Toast, Show) {


    var vm = this;
    var caseKey = $stateParams.objectKey;

    vm.show = Show;

    vm.isSubmitting = false;
    vm.isGenerating = false;
    vm.submit = submit;
    vm.getDutUrl = getDutUrl;

    activate();

    function activate() {
      query();
    }

    function query() {

      $scope.$emit('loading', true);

      Cases.get({objectKey: caseKey}, function (response) {
        vm.caseObject = response;
      }, function (error) {
        $log.error(angular.toJson(error));
      });

      CaseInventory.bom({caseKey: caseKey}, success, error);

      function success(response) {
        vm.devices = response.items || [];
        $scope.$emit('loading', false);
      }

      function error(response) {

        $scope.$emit('loading', false);
        if (response.status === 404 || response.status === 400) {
          Show.notFound();
          return;
        }
        $log.error(angular.toJson(response));
        Toast.error(response);
      }

    }

    function getDutUrl(ev) {

      vm.isGenerating = true;

      CaseInventory.getBomUrl({ caseKey: caseKey }, success, error);

      function success(response) {
        vm.isGenerating = false;
        $log.info(angular.toJson(response));
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = $mdDialog.confirm()
          .title('Device Usage Ticket PDF')
          .textContent('We have generated a PDF of this DUT. Would you like to open this PDF in another tab?')
          .targetEvent(ev)
          .ok('Yes')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(function() {
          $window.open(response.url, '_blank');
        });

      }

      function error(response) {
        vm.isGenerating = false;
        Toast.error(response);
      }

    }


    function submit() {

      function callback(signature, hospitalSignature) {

        if (angular.isUndefined(caseKey)) {
          return;
        }

        if (!angular.isString(signature)) {
          return;
        }
        if (!angular.isString(hospitalSignature)) {
          return;
        }

        var caseObject = {
          key: caseKey,
          signatureName: signature,
          hospitalSignatureName: hospitalSignature
        };

        var params = {
          objectKey: caseKey
        };

        vm.isSubmitting = true;

        Cases.submit(params, caseObject, function (response) {
          vm.caseObject = response;
          vm.isSubmitting = false;
          $log.info(angular.toJson(response));
          Toast.success('Successfully submitted ' + response.name);
        }, function (error) {
          vm.isSubmitting = false;
          Toast.error(error);
          $log.error(angular.toJson(error));
        });

      }

      $mdDialog.show({
        locals: {
          'SignatureCallback': callback || function () {
          }
        },
        controller: 'SignatureController',
        controllerAs: 'vm',
        templateUrl: 'app/cases/signature/signature.tmpl.html',
        clickOutsideToClose: true
      });

    }

  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.accounts', []);

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.accounts')
        .controller('AccountDetailController', AccountDetailController);

    AccountDetailController.$inject = ['$scope', '$log', '$stateParams', '$state', 'currentAuth', 'Toast', 'Accounts', 'Orgs'];

    function AccountDetailController($scope, $log, $stateParams, $state, currentAuth, Toast, Accounts, Orgs) {

        $scope.$emit('loading', false);

        var vm = this;
        vm.manufacturers = [];
        vm.addManufacturer = addManufacturer;
        vm.removeManufacturer = removeManufacturer;

        activate();

        function activate() {

            Accounts.get({objectKey: $stateParams.objectKey}, success, Toast.error);

            function success(account) {
                vm.account = account;
                updateManufacturers();
            }

        }

        function updateManufacturers() {

            Orgs.get({objectKey: currentAuth.org.key}, function (response) {
                var manufacturers = response.manufacturers || [];
                var manufacturerKeys = {};
                angular.forEach(vm.account.manufacturers, function(m) {
                    manufacturerKeys[m.key] = true;
                });

                var addable = [];
                angular.forEach(manufacturers, function (m) {
                    if (manufacturerKeys[m.key] !== true) {
                        addable.push(m);
                    }
                });
                vm.manufacturers = addable;
            }, Toast.error);

        }

        function addManufacturer(key) {
            var params = {
                objectKey: $stateParams.objectKey,
                manufacturerKey: key
            };
            Accounts.addManufacturer(params, null, function(response){
                vm.account = response;
                updateManufacturers();
            }, Toast.error);
        }

        function removeManufacturer(key) {
            var params = {
                objectKey: $stateParams.objectKey,
                manufacturerKey: key
            };
            Accounts.removeManufacturer(params, null, function(response){
                vm.account = response;
                updateManufacturers();
            }, Toast.error);
        }

    }

})();

(function () {
  'use strict';

  angular
    .module('connectsx.settings')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.settings', {
        abstract: true,
        url: '/settings',
        templateUrl: 'app/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'vm'
      });
  }

})();



(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.settings')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$state', '$scope', '$window', '$http', 'currentAuth', 'Auth', '$mdDialog', '$log', '$q', '$stateParams', 'Toast', '$timeout' ];

    function SettingsController($state, $scope, $window, $http, currentAuth, Auth, $mdDialog, $log, $q, $stateParams, Toast, $timeout) {

        var vm = this;
        var orgDetailsHeading = currentAuth.org.name || 'Organization';
        vm.errorResetPasswordMessage = "";
        vm.loading = false;

        vm.tabs = [
            {heading: 'Personal', active: false, state: 'index.settings.personal'},
            {heading: orgDetailsHeading, active: false, state: 'index.settings.org'},
            {heading: 'Manufacturers', active: false, state: 'index.settings.manufacturers'}
        ];

        vm.onTabSelected = onTabSelected;
        vm.logout = logout;
        vm.resetPassword = resetPassword;

        activate();

        function activate() {

            $scope.$emit('loading', false);

            /// derive current tab from state
            for (var i = 0; i < vm.tabs.length; i++) {
                var tab = vm.tabs[i];
                if (tab.state === $state.current.name) {
                    onTabSelected(vm.tabs[i], false);
                    break;
                }
            }
        }

        function logout() {
            $http.defaults.headers.common['Authorization'] = '';
            Auth.$signOut();
            $window.Intercom('shutdown');
            $state.go('auth.login');
        }

        function onTabSelected(tab, changeState) {

            if (angular.isUndefined(changeState)) {
                changeState = true;
            }

            for (var i = 0; i < vm.tabs.length; i++) {
                vm.tabs[i].active = false;
            }
            tab.active = true;
            vm.title = tab.heading;

            if (changeState) {
                $state.go(tab.state);
            }
        }

        function resetPassword(){

            $mdDialog.show({
                templateUrl: 'app/settings/modalresetpassword/modal.currentpassword.html',
                controller: 'ModalCurrentPasswordController',
                clickOutsideToClose:true,
                parent: angular.element(document.body),
            }).then(function(currentPassword) {
                firebase.auth().currentUser.reauthenticateWithCredential(
                    firebase.auth.EmailAuthProvider.credential(
                        firebase.auth().currentUser.email,
                        currentPassword
                    )
                ).then(function(){
                    $log.info('Success')
                    Toast.success("Success")

                    $scope.$emit('loading', false);
                    changePassword()
                })
                    .catch(function(error){
                        $log.info('Error')
                        Toast.error(JSON.stringify(error.message))
                        $scope.$emit('loading', false);
                    })

            }, function(){
                //close

            })

            function changePassword(){
                $mdDialog.show({
                    templateUrl: 'app/settings/modalresetpassword/modal.newpassword.html',
                    controller: 'ModalNewPasswordController',
                    clickOutsideToClose:true,
                    parent: angular.element(document.body),
                }).then(function(newpassword) {
                    //Save
                    vm.loading = true;

                    var user = firebase.auth().currentUser;

                    user.updatePassword(newpassword).then(function(res) {
                        // Update successful.
                        $log.info(res)
                        $scope.$emit('loading', false);
                        Toast.success("Saved")
                        vm.loading = false;

                    }).catch(function(error) {
                        // An error happened.
                        vm.errorResetPasswordMessage = error.message;
                        $log.info(error)
                        $scope.$emit('loading', false);
                        Toast.error(JSON.stringify(error.message))
                        vm.loading = false;
                        $timeout(function(){
                            vm.errorResetPasswordMessage = "";
                        }, 10000)
                    });

                }, function() {
                    //Close
                });
            }
        }
    }
})();


(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx')
        .factory('Toast', Toast);

    Toast.$inject = ['$mdToast', '$document', '$log'];

    function Toast($mdToast, $document, $log) {


        function success(message) {

            if (!angular.isString(message)) {
                message = 'Success!';
            }

            var parent = angular.element($document[0].getElementById('footer'));
            $log.info(angular.toJson(parent));

            $mdToast.show(
                $mdToast.simple()
                    .parent(parent)
                    .toastClass('csx-toast')
                    .hideDelay(5000)
                    .textContent(message)
            );
        }

        function error(error) {


            var parent = angular.element($document[0].getElementById('footer'));
            $log.info(angular.toJson(parent));

            var message = 'Something went wrong!';
            if (angular.isString(error)) {
                message = error;
            }
            else if (angular.isObject(error)) {
                if (angular.isObject(error.data) &&
                    angular.isObject(error.data.error) &&
                    angular.isString(error.data.error.message)) {
                    message = error.data.error.message;
                }
                else if (angular.isString(error.message)) {
                    message = error.message;
                }
            }

            $mdToast.show(
                $mdToast.simple()
                    .parent(parent)
                    .toastClass('csx-toast error-toast')
                    .hideDelay(5000)
                    .textContent(message)
            );

        }

        return {
            success: success,
            error: error
        };
    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx')
        .factory('Show', Show);

    Show.$inject = ['$state', '$log'];

    function Show($state, $log) {

        $log.info("show.service.js init.");

        var types = {
            'Account': {
                objectType: 'Account',
                route: 'index.accounts.detail'
            },
            'AccountEntity': {
                objectType: 'AccountEntity',
                route: 'index.accounts.detail'
            },
            'Manufacturer': {
                objectType: 'Manufacturer',
                route: 'index.manufacturers.detail'
            },
            'Facility': {
                objectType: 'Facility',
                route: 'index.facilities.detail'
            },
            'Distributor': {
                objectType: 'Distributor',
                route: 'index.distributors.detail'
            }
        };

        function showDevice(device) {
            if (angular.isDefined(device) && angular.isDefined(device.key)) {
                $state.go('index.inventory.edit', {objectKey: device.key});
            }
        }

        function showTray(tray) {
            if (angular.isDefined(tray) && angular.isDefined(tray.key)) {
                $state.go('index.inventory.edit', {objectKey: tray.key});
            }
        }

        function showTransfer(transfer) {
            $state.go('index.transfers.detail', {objectKey: transfer.key});
        }

        function showRequest(request) {
            $state.go('index.requests.edit', {objectKey: request.key});
        }

        function transferSource(transfer) {
            sourceOrTarget(transfer, 'source');
        }

        function transferTarget(transfer) {
            sourceOrTarget(transfer, 'target');
        }

        function sourceOrTarget(transfer, key) {

            var o = transfer[key];
            if (angular.isObject(o) &&
                angular.isString(o.type) &&
                angular.isString(o.key)) {
                var type = types[o.type];
                if (angular.isObject(type)) {
                    $state.go(type.route, { 'objectKey': o.key });
                }
            }

        }

        function showNotFound() {
            $state.go('index.404');
        }

        function showCase(caze) {

            var key = null;
            if (angular.isString(caze)) {
                key = caze;
            }

            if (angular.isObject(caze) && angular.isString(caze.key)) {
                key = caze.key;
            }

            if (key === null) {
                return;
            }

            $state.go('index.cases.edit', {'objectKey': key});

        }

        return {
            notFound: showNotFound,
            device: showDevice,
            tray: showTray,
            showCase: showCase,
            transfer: showTransfer,
            request: showRequest,
            transferSource: transferSource,
            transferTarget: transferTarget
        };

    }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx')
    .factory('Pagination', Pagination);

    Pagination.$inject = ['$log'];

  function Pagination($log) {

    return {};

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .factory('UDI', UDI);

    UDI.$inject = ['$resource', 'udiUrl'];

  function UDI($resource, udiUrl) {

    var resourceUrl = udiUrl + '/api/v3/parse';

    return $resource(resourceUrl, null,
      {
        parse: { method: 'GET' }
      });
  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx')
        .factory('Products', Products);

    Products.$inject = ['$resource', 'restUrl'];

    function Products($resource, restUrl) {

        var listUrl = restUrl + '/v1/products';
        var createUrl = restUrl + '/v1/products/create';
        // var searchUrl = restUrl + '/v1/product/search';
        var searchUrl = restUrl + '/v1/products';
        var resourceUrl = restUrl + '/v1/product/:objectKey';

        return $resource(resourceUrl, null,
            {
                list: {url: listUrl, method: 'GET'},
                remove: { method: 'DELETE' },
                insert: { url: createUrl, method: 'POST' },
                update: { method:'PUT' },
                search: {url: searchUrl, method: 'GET'}
            });
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .factory('Orgs', Orgs);

    Orgs.$inject = ['$resource', 'restUrl'];

  function Orgs($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/org/:objectKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        update: { method:'PUT' }
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('connectsx')
        .factory('Notifications', Notifications);

    Notifications.$inject = ['$resource', 'restUrl'];

    function Notifications($resource, restUrl) {

        var resourceUrl = restUrl + '/v1/notifications';
        var readUrl = resourceUrl + '/read';


        return $resource(resourceUrl, null,
            {
                get: { method: 'GET' },
                read: { method: 'POST', url:readUrl },
                search: { method: 'GET', url:resourceUrl }
            });
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .factory('Manufacturers', Manufacturers);

    Manufacturers.$inject = ['$resource', 'restUrl'];

  function Manufacturers($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/manufacturer/:objectKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        update: { method:'PUT' },
        insert: { method:'POST' },
        deactivate: { method:'PUT' }
      });
  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx')
        .factory('Invitations', Invitations);

    Invitations.$inject = ['$resource', 'restUrl'];

    function Invitations($resource, restUrl) {

        var resourceUrl = restUrl + '/v1/invitation/:objectKey';
        var resendUrl = restUrl + '/v1/invitation/:objectKey/resend';

        return $resource(resourceUrl, null,
            {
                get: {method: 'GET'},
                list: {method: 'GET'},
                resend: {url: resendUrl, method: 'PUT'},
                remove: {method: 'DELETE'},
                insert: {method: 'POST'}
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('connectsx')
        .factory('Gudid', Gudid);

    Gudid.$inject = ['$resource', 'gudidUrl'];

    function Gudid($resource, gudidUrl) {

        var resourceUrl = gudidUrl + '/v1/org/:objectKey';
        var manufacturerSearchUrl = gudidUrl + '/v1/manufacturers';

        return $resource(resourceUrl, null,
            {
                get: {method: 'GET'},
                update: {method: 'PUT'},
                searchManufacturers: {method: 'GET', url: manufacturerSearchUrl}
            });
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$resource', 'restUrl'];

  function Dashboard($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/dashboard';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('connectsx.onboarding')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.onboarding', {
        abstract: true,
        url: '/onboarding',
        templateUrl: 'app/onboarding/onboarding.html',
        controller: 'OnboardingController',
        controllerAs: 'vm'
      }).state('index.onboarding.welcome', {
        url: '/welcome',
        templateUrl: 'app/onboarding/welcome/welcome.html',
        controller: 'WelcomeController',
        controllerAs: 'vm'
    }).state('index.onboarding.users', {
        url: '/users',
        templateUrl: 'app/onboarding/users/users.html',
        controller: 'OnboardingUsersController',
        controllerAs: 'vm'
    }).state('index.onboarding.inventory', {
        url: '/inventory',
        templateUrl: 'app/inventory/import/import.html',
        controller: 'ImportController',
        controllerAs: 'vm'
    });
  }

})();



(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.onboarding')
    .controller('OnboardingController', OnboardingController);

    OnboardingController.$inject = ['$state', '$log', '$scope', '$http', 'Auth'];

  function OnboardingController($state, $log, $scope, $http, Auth) {

    var vm = this;

    activate();

    function activate() {

        $scope.$emit('loading', false);

        if ($state.current.name === 'index.onboarding.inventory'){
          vm.title = 'Import Inventory';
        } else {
          vm.title = '';
        }

    }



  }
})();


(function() {
    'use strict';

    angular
        .module('connectsx.notifications', []);
})();
(function () {
    'use strict';

    angular
        .module('connectsx.notifications')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];


    function routerConfig($stateProvider) {

        $stateProvider

            .state('index.notifications', {
                abstract: true,
                url: '/notifications',
                template: '<ui-view/>'
            })

            .state('index.notifications.list', {
                url: '?limit',
                templateUrl: 'app/notifications/notifications.html',
                reloadOnSearch: false,
                controller: 'NotificationsController',
                controllerAs: 'vm',
                resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
            })
    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx')
        .controller('NotificationsController', NotificationsController);


    NotificationsController.$inject = ['$scope', '$location', '$stateParams', '$state', '$log', 'currentAuth', 'Toast', 'Notifications'];

    function NotificationsController($scope, $location, $stateParams, $state, $log, currentAuth, Toast, Notifications) {

        var vm = this;

        $scope.$emit('loading', true);

        vm.account = currentAuth;
        vm.accountType = currentAuth.accountType;

        vm.isLoading = false;
        vm.pageSize = 20;
        vm.filterObject = parseStateParams();
        vm.previousPages = [];

        vm.hasNextPage = hasNextPage;
        vm.hasPreviousPage = hasPreviousPage;
        vm.loadNextPage = loadNextPage;
        vm.loadPreviousPage = loadPreviousPage;
        vm.setPageSize = setPageSize;

        $scope.$watch(
            angular.bind(vm, function () {
                return vm.filterObject;
            }),
            updateSearchParams,
            true
        );

        updateSearchParams();


        function handleError(error) {
            Toast.error(error);
            $scope.$emit('loading', false);
        }

        // Notifications.get(function (response) {
        //     vm.notifications = response.items || [];
        //     $scope.$emit('loading', false);
        // }, handleError);


        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            updateSearchParams();
        }

        function parseStateParams() {

            $scope.$emit('loading', true);

            /// set default query if there are no state params..
            /// otherwise let the state params define the filters

            var filterObject = {};

            if (angular.isDefined($stateParams.limit)) {

                if (isFinite($stateParams.limit)) {
                    vm.pageSize = parseInt($stateParams.limit);
                }
            }

            if (angular.isDefined($stateParams.cursor)) {
                vm.previousPages = [$stateParams.cursor];
            }

            return filterObject;

        }

        function updateSearchParams() {
            if(vm.isLoading) return
            var search = {
                "limit": vm.pageSize
            };

            var len = vm.previousPages.length;
            if (len > 0) {
                search.cursor = vm.previousPages[len - 1];
            }

            angular.forEach(vm.filters, function (filter) {

                var value = null;
                if (angular.isString(filter.value)) {
                    value = filter.value;
                } else if (isObject(filter.value)) {
                    value = filter.value.key;
                }
                if (value === null) return;
                search[filter.key] = value;

            });

            $location.search(search);
            query(search);

        }

        function onNewFilter(newVal) {

            // var ignore = false;
            //
            // var filters = [];
            // // angular.forEach(newVal, function (value, key) {
            // //
            // //     if (ignore || value === null) {
            // //         ignore = true;
            // //         return;
            // //     }
            // //
            // //     var display = value;
            // //     if (angular.isString(value)) {
            // //         display = value;
            // //     }
            // //     else {
            // //         return;
            // //     }
            // //
            // //     filters.push({"key": key, "value": value, "display": display});
            // //
            // // });
            //
            // vm.filters = filters;
            // $log.info(vm.filters);
            // vm.searchText = undefined;

            updateSearchParams();

        }

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            updateSearchParams();
        }

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            updateSearchParams();
        }

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            updateSearchParams();
        }

        function query(params) {

            vm.isLoading = true;
            //
            // var date = vm.filterObject.date;
            // if (angular.isDefined(date) && angular.isDate(date)) {
            //     params.date = $filter('date')(date, "yyyyMMddZ");
            // }

            // Notifications.search(params, successCallback, errorCallback);

            Notifications.get(params, successCallback, errorCallback);

            function successCallback(value) {
                $scope.$emit('loading', false);
                vm.nextPageToken = value.nextPageToken;
                var b = value.items
                b.forEach(function(el){
                    el.read = false
                });
                vm.notifications = b;
                vm.isLoading = false;
            }

            function errorCallback(httpResponse) {
                $scope.$emit('loading', false);
                $log.error('NotificationsAPI Error: ' + angular.toJson(httpResponse));
                vm.isLoading = false;
                Toast.error('An unexpected error has occurred. Please reload the page and try again.');
            }
        }


    }
})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx')
        .config(function($mdIconProvider) {
            $mdIconProvider
                .iconSet('communication', 'img/icons/sets/communication-icons.svg', 24);
        })
        .controller('MainController', MainController);


    MainController.$inject = ['$http', '$templateCache', '$state', '$document', '$log', '$window', 'currentAuth',
        'intercomAppId', '$mdPanel', '$mdSticky', 'Toast', 'Notifications', 'filterFilter',  'orderByFilter',
        '$stateParams', '$scope', 'Auth'];

    function MainController($http, $templateCache, $state, $document, $log, $window, currentAuth, intercomAppId,
                            $mdPanel, $mdSticky, Toast, Notifications, filterFilter, orderBy, $stateParams, $scope, Auth) {

        var vm = this;

        vm.account = currentAuth;
        vm.accountType = currentAuth.accountType;
        vm.showUserSettings = showUserSettings;
        vm.logout = logout;
        vm.toggleMobileNav = toggleMobileNav;
        vm.isMobMenuActive = false;

        $scope.$on('notificationCount', function(event, count) {
            vm.notificationCount = count;
        });

        $window.Intercom("boot", {
            app_id: intercomAppId,
            email: currentAuth.email,
            user_id: currentAuth.key,
            name: currentAuth.name
        });

        vm.filterObject = vm.notifications;

        //Get notifications when loading page
        getNotReadNotifications()

        setInterval(function(){
            getNotReadNotifications()
        }, 180000)

        function getNotReadNotifications(){
            Notifications.get({ read: false }, function (response) {
                vm.notifications = response.items || [];
                vm.notificationCount = vm.notifications.length;
            }, Toast.error);
        }


        vm.showMenu = function(){

            var position = $mdPanel.newPanelPosition()
                .relativeTo('#notification-nav-item')
                .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: NotificationPanelController,
                controllerAs: 'vm',
                templateUrl: 'app/notifications/notifications.tmpl.html',
                position:position,
                clickOutsideToClose: true
            };

            $mdPanel.open(config);

            // Save unread notifications
            vm.notifications.forEach(function(el){
               Notifications.read(el);
            })
            vm.notificationCount = 0

        };


        var NotificationPanelController = ['mdPanelRef', function (mdPanelRef) {

            var panel = this;
            panel._mdPanelRef = mdPanelRef;
            panel.notifications = vm.notifications || [];

            $log.info("Notifications");

            function closePanel() {
                if (panel._mdPanelRef) {
                    panel._mdPanelRef.close();
                    panel._mdPanelRef.destroy();
                }
            }

            panel.viewAll = function() {
                closePanel();
                $state.go('index.notifications.list');
                panel.notifications = [];
                vm.notifications = [];
            };

            panel.close = closePanel;
        }];

        function showUserSettings ($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        function logout (){
            $http.defaults.headers.common['Authorization'] = '';
            Auth.$signOut();
            $window.Intercom('shutdown');
            $state.go('auth.login');
        }

        function toggleMobileNav (){
            vm.isMobMenuActive = !vm.isMobMenuActive;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('connectsx.inventory')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.inventory', {
                abstract: true,
                url: '/inventory',
                templateUrl: 'app/inventory/inventory.html',
                controller: 'InventoryController',
                controllerAs: 'vm'
            })
            .state('index.inventory.list', {
                url: '?cursor&clear&limit&nolot&custody&type&loose&billable&active&search&status&expiration&manufacturer&container',
                templateUrl: 'app/inventory/list/inventory.list.html',
                reloadOnSearch:false,
                controller: 'InventoryListController',
                controllerAs: 'vm'
            })
            .state('index.inventory.add', {
                url: '/add',
                templateUrl: 'app/inventory/add/inventory.add.html',
                controller: 'InventoryAddController',
                controllerAs: 'vm'
            })
            .state('index.inventory.products', {
                url: '/products',
                templateUrl: 'app/inventory/products/inventory.products.html',
                controller: 'InventoryProductsController',
                controllerAs: 'vm'
            })
            .state('index.inventory.productcreate', {
                url: '/products/create',
                templateUrl: 'app/inventory/products/inventory.products.create.html',
                controller: 'InventoryProductsCreateController',
                controllerAs: 'vm'
            })

            .state('index.inventory.edit', {
                url: '/edit/:objectKey',
                templateUrl: 'app/inventory/edit/inventory.edit.html',
                controller: 'InventoryEditController',
                controllerAs: 'vm'
            })

            .state('index.inventory.productedit', {
                url: '/products/edit/:objectKey/',
                templateUrl: 'app/inventory/products/edit/products.edit.html',
                controller: 'InventoryProductsEditController',
                controllerAs: 'vm',
            })
    }

})();



(function() {
  'use strict';

  angular
    .module('connectsx.inventory')
    .factory('Inventory', Inventory);

    Inventory.$inject = ['$resource', 'restUrl', 'coreUrl'];

  function Inventory($resource, restUrl, coreUrl) {

    var statsUrl = restUrl + '/v1/inventory/stats';
    var countUrl = restUrl + '/v1/inventory/count';
    var resourceUrl = restUrl + '/v1/inventory/:objectKey';
    var importUrl = restUrl + '/v1/inventory/import';
    var productsUrl = restUrl + '/v1/inventory/products';
    var productsUrlPut = restUrl + '/v1/products/:objectKey';
    var verifyUDIUrl = coreUrl + '/v1/udi/parse';
    var importProgressUrl = restUrl + '/v1/import/:objectKey';
    var rollbackUrl = importProgressUrl + '/rollback';
    var insertProductUrl =  '/v1/inventory/products/create';
    var inventoryExport =  restUrl + '/v1/inventory/export?type=:type';
    var basicSearch =  restUrl + '/v1/inventory/basic';
    var history =  restUrl + '/v1/inventory/:objectKey/action/history';
    var diactivate =  restUrl + '/v1/inventory/:objectKey/deactivate';

    return $resource(resourceUrl, null,
      {

        insertProduct: {method:'POST', url:insertProductUrl},

        get: { method: 'GET' },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        count: {method:'GET', url:countUrl },
        importProgress: { method: 'GET', url:importProgressUrl },
        getImports: { method: 'GET', url:importProgressUrl },

        getProducts: { method: 'GET', url:productsUrl },
        updateProduct: { method: 'PUT', url:productsUrlPut },
        getProduct: { method: 'GET', url:productsUrlPut },

        rollbackImport: { method: 'PUT', url:rollbackUrl },
        stats: { method: 'GET', url:statsUrl },
        search: { method: 'GET', isArray:false },
        verifyUDI: { method: 'POST', url:verifyUDIUrl },
        importInventory: { method:'POST', url:importUrl },
        inventoryExport: { method:'GET', url:inventoryExport },
        basicSearch: { method: 'GET', isArray:false, url: basicSearch },
        history: { method: 'GET',  url: history },
        deactivate: { method: 'PUT',  url: diactivate }

      });
  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.inventory')
        .controller('InventoryController', InventoryController);

    InventoryController.$inject = ['$state', '$log', '$scope', '$timeout', '$rootScope'];

    function InventoryController($state, $log, $scope, $timeout, $rootScope) {

        var vm = this;

        $state.activeTabsInventory = "index.inventory.list";

        vm.tabs = [
            {heading: 'Search', active: false, state: 'index.inventory.list'},
            {heading: 'Requests', active: false, state: 'index.inventory.requests'},
            {heading: 'Transfers', active: false, state: 'index.inventory.transfers'},
            {heading: 'Import', active: false, state: 'index.inventory.import'},
            {heading: 'Products', active: false, state: 'index.inventory.products'},
            {heading: 'Catalog', active: false, state: 'index.inventory.catalog.list'}
        ];

        $scope.$on("$stateChangeSuccess", function (event, toState, fromState) {
            $timeout(function(){
                if($state.activeTabsInventory){
                    activateHistoryTab($state.activeTabsInventory)
                }
            }, 100)
        });


        vm.onTabSelected = onTabSelected;
        vm.state = $state.current;

        activate();

        function activateHistoryTab(a) {
            /// derive current tab from state
            for (var i = 0; i < vm.tabs.length; i++) {
                var tab = vm.tabs[i];
                if (tab.state === a) {
                    onTabSelect(vm.tabs[i]);
                    break;
                }
            }
        }

        function activate() {
            /// derive current tab from state
            for (var i = 0; i < vm.tabs.length; i++) {
                var tab = vm.tabs[i];
                if (tab.state === $state.current.name) {
                    onTabSelected(vm.tabs[i], false);
                    break;
                }
            }
        }

        function onTabSelected(tab, changeState) {

            if (angular.isUndefined(changeState)) {
                changeState = true;
            }

            for (var i = 0; i < vm.tabs.length; i++) {
                vm.tabs[i].active = false;
            }
            tab.active = true;
            vm.title = tab.heading;

            if (changeState) {
                $state.go(tab.state);
            }
        }

        function onTabSelect(tab) {

            for (var i = 0; i < vm.tabs.length; i++) {
                vm.tabs[i].active = false;
            }

            tab.active = true;
            vm.title = tab.heading;


        }
    }
})();


(function() {
  'use strict';

  angular
    .module('connectsx.home', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.home')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.home', {
        url: '/home',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'vm',
        resolve: { 'currentAuth' : ['AuthResolver', function(AuthResolver){ return AuthResolver(); }]}
      })
      
  }

})();



(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.home')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$log', '$filter', 'currentAuth', 'Transfers', 'Requests', 'Toast', 'Show',
        'DeclineTransferModal', 'Dashboard', 'TransferModal', 'Cases', '$state'];

    function HomeController($scope, $log, $filter, currentAuth, Transfers, Requests, Toast, Show,
                            DeclineTransferModal, Dashboard, TransferModal, Cases, $state) {

        $scope.$emit('loading', true);

        var vm = this;

        vm.dashboard = {};
        vm.transfers = [];
        vm.show = Show;

        vm.cases = [];

        vm.accept = accept;
        vm.decline = decline;
        vm.declineRequest = declineRequest;
        vm.sendInventory = sendInventory;

        vm.loading = {};
        vm.gotToInventoryPage = gotToInventoryPage;

        activate();

        function activate() {

            // loadTransfers();

            Dashboard.get({}, function (dashboard) {
                vm.dashboard = dashboard;
                vm.transfers = dashboard.transfers.items || [];
                vm.requests = dashboard.requests.items || [];
                vm.dashboard.welcome = (!dashboard.hasUsers || !dashboard.hasInventory);
                $scope.$emit('loading', false);
            }, function (error) {
                $scope.$emit('loading', false);
                Toast.error(error);
            });


            var params = { date: $filter('date')(new Date(), "yyyyMMddZ") };

            Cases.search(params, successCallback, errorCallback);

            function successCallback(response) {
                // $log.info(angular.toJson(response));
                vm.cases = response.items || [];
            }

            function errorCallback() {
                Toast.error('Failed to load today\'s cases');
            }

        }

        function accept(transfer) {

            var key = transfer.key;
            var params = {objectKey: key};

            if (angular.isUndefined(vm.loading[key])) {
                vm.loading[key] = {accepting: false, declining: false};
            }
            var loading = vm.loading[key];

            if (loading.accepting || loading.declining) {
                return;
            }

            loading.accepting = true;

            Transfers.accept(params, null, transferSuccess, transferError);

        }

        function decline(transfer) {

            DeclineTransferModal.show(function (reason) {

                var key = transfer.key;
                var params = {objectKey: key};
                var loading = vm.loading[key] || {accepting: false, declining: false};

                if (loading.accepting || loading.declining) {
                    return;
                }

                var body = {content: reason};
                loading.declining = true;

                Transfers.decline(params, body, transferSuccess, transferError);

            });

        }

        function declineRequest(request) {

            var key = request.key;
            var params = { objectKey: key };
            var loading = vm.loading[key] || { declining: false };

            if (loading.declining) {
                return;
            }

            loading.declining = true;

            Requests.cancel(params, null, requestSuccess, requestError);


        }

        function requestSuccess(response) {
            angular.forEach(vm.requests, function (request) {
                if (request.key === response.key) {
                    request.status = response.status;
                }
            });
            resetLoading();
            Toast.success(response.status + ' request!');
        }

        function requestError(response) {
            $log.info(angular.toJson(response));
            Toast.error(response);
            resetLoading();
        }

        function transferSuccess(response) {
            angular.forEach(vm.transfers, function (transfer) {
                if (transfer.key === response.key) {
                    transfer.status = response.status;
                }
            });
            resetLoading();
            Toast.success(response.status + ' transfer!');
        }

        function transferError(response) {
            $log.info(angular.toJson(response));
            Toast.error(response);
            resetLoading();
        }

        function resetLoading() {
            angular.forEach(vm.loading, function (value) {
                value.accepting = false;
                value.declining = false;
            });
        }

        function sendInventory() {
            TransferModal.show(currentAuth.org.key, {}, function(transfer) {

            });
        }

        function gotToInventoryPage(transfer){
            $state.go('index.transfers.detail', { objectKey: transfer.key })
        }

    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.errors', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.errors')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.404', {
        url:'/404',
        templateUrl:'app/errors/404.html',
        controller: 'ErrorsController',
        controllerAs: 'vm',
      });
  }

})();



(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.errors')
    .controller('ErrorsController', ErrorsController);

  ErrorsController.$inject = ['$scope', '$log'];

  function ErrorsController($scope, $log) {

    $scope.$emit('loading', false);

    var vm = this;


    activate();

    function activate() {
      vm.null = null;
      $log.info("errors.controller.js init");
    }

  }

})();

(function() {
    'use strict';

    angular
        .module('connectsx.directory', []);

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.directory')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.directory', {
                abstract: false,
                url: '/directory',
                templateUrl: 'app/directory/directory.html',
                controller:'DirectoryController',
                controllerAs:'vm'
            })

    }

})();



(function () {
    'use strict';

    angular
        .module('connectsx.directory')
        .controller('DirectoryController', DirectoryController);

    DirectoryController.$inject = ['$scope', '$log', '$state', '$timeout'];

    function DirectoryController($scope, $log, $state, $timeout) {

        var vm = this;
        vm.tabs = [
            {heading: 'Physicians', active: true, state: 'index.directory.physicians.list'},
            {heading: 'Facilities', active: false, state: 'index.directory.facilities.list'},
            {heading: 'Procedures', active: false, state: 'index.directory.procedures.list'}
        ];

        vm.onTabSelected = onTabSelected;
        vm.state = $state.current;

        activate();

        function activate() {
            /// derive current tab from state
            for (var i = 0; i < vm.tabs.length; i++) {
                var tab = vm.tabs[i];
                if (tab.state === $state.current.name) {
                    onTabSelected(vm.tabs[i], false);
                    break;
                }
            }
        }

        function onTabSelected(tab, changeState) {

            if (angular.isUndefined(changeState)) {
                changeState = true;
            }

            for (var i = 0; i < vm.tabs.length; i++) {
                vm.tabs[i].active = false;
            }
            tab.active = true;
            vm.title = tab.heading;

            if (changeState) {
                $state.go(tab.state);
            }
        }
        $log.info('directory Controller');

        vm.loading = false;

        $scope.$on('loading', function (event, isLoading) {
            vm.loading = isLoading;
        });

        $scope.$on("$stateChangeSuccess", function (event, toState, fromState) {
            $timeout(function(){
                if($state.activeTabsDirectory){
                    activateHistoryTab($state.activeTabsDirectory)
                }
            }, 100)
        });

        function activateHistoryTab(a) {
            /// derive current tab from state
            for (var i = 0; i < vm.tabs.length; i++) {
                var tab = vm.tabs[i];
                if (tab.state === a) {
                    onTabSelect(vm.tabs[i]);
                    break;
                }
            }
        }

        function onTabSelect(tab) {

            for (var i = 0; i < vm.tabs.length; i++) {
                vm.tabs[i].active = false;
            }
            tab.active = true;
            vm.title = tab.heading;
            
        }

    }

})();

(function () {
  'use strict';

  angular.module('connectsx')
    .directive('csxLoading', csxLoading);

  csxLoading.$inject = [];

  function csxLoading() {
    return {
      restrict: 'A',
      transclude:true,
      scope: {
        loading: '=csxIsLoading'
      },
      templateUrl: 'app/directives/loading.template.html',
      link: function(scope, element, attrs) {
        /// keep width based on initial content so that loading state doesn't
        /// jump around
        var width = element.prop('offsetWidth');
        var diameter = (element.prop('offsetHeight') || 35) - 10;
        scope.diameter = Math.max(15, diameter);
        var otherCss = element.css('cssText');
        attrs.$set('style', 'width: ' + width + 'px;' + otherCss);
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('connectsx')
    .directive('csxBack', csxBack);

  csxBack.$inject = ['$window'];

  function csxBack($window) {
    return {
      restrict: 'A',
      link: function (scope, elem) {
        elem.bind('click', function () {
          $window.history.back();
        });
      }
    };
  }

})();

(function() {
    'use strict';

    angular
        .module('connectsx.confirmUnsavedChanges', []);

})();
(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.confirmUnsavedChanges')
        .factory('ConfirmUnsavedChanges', ConfirmUnsavedChanges);


    ConfirmUnsavedChanges.$inject = [ '$window', '$log' ];

    function ConfirmUnsavedChanges( $window, $log) {

        var vm = this;

        vm.routeChange = routeChange;

        function validate(arr){
            // arr - array required fields
            if(!arr) return false
            return arr.every(function(el){
                if(!el || el === ""){
                    return false
                }
                return true

            })
        }

        function routeChange(event, newUrl, oldUrl, isChange, finish, vm, validateArray) {
            if(!event.defaultPrevented && isChange) {
                //Validate required fields
                var isValid = validate(validateArray);
                if(!isValid){
                    var answer = $window.confirm("You are about to navigate away from this page. Any change will be lost." +
                        " Do you want to continue?");
                    if (answer) {
                        return false
                    }
                    if(!answer){
                        event.preventDefault();
                        return true
                    }
                    event.preventDefault();
                }
                else {
                    finish(vm)
                }
            }
            return false
        }

        return {
            routeChange: vm.routeChange
        }
    }

})();

(function () {
  'use strict';
  /* global angular */

  angular
    .module('connectsx')
    .filter('bigNum', bigNum);

  function bigNum() {

    return function (number) {

      if (number === null) return null;
      if (number === 0) return "0";
      if (angular.isUndefined(number)) return "0";

      var fractionSize = 1;

      var abs = Math.abs(number);
      var rounder = Math.pow(10, fractionSize);
      var isNegative = number < 0;
      var key = '';
      var powers = [
        {key: "Q", value: Math.pow(10, 15)},
        {key: "T", value: Math.pow(10, 12)},
        {key: "B", value: Math.pow(10, 9)},
        {key: "M", value: Math.pow(10, 6)},
        {key: "K", value: 1000}
      ];

      for (var i = 0; i < powers.length; i++) {

        var reduced = abs / powers[i].value;

        reduced = Math.round(reduced * rounder) / rounder;

        if (reduced >= 1) {
          abs = reduced;
          key = powers[i].key;
          break;
        }
      }

      return (isNegative ? '-' : '') + abs + key;

    }
  }

})();

// (function () {
//   'use strict';
//
//   // angular
//   //   .module('connectsx')
//   //   .filter("bigNum", bigNum);
//   //
//   // function bigNum() {
//   //   return (number, fractionSize) => {
//   //
//   //     if (number === null) return null;
//   //     if (number === 0) return "0";
//   //
//   //     if (!fractionSize || fractionSize < 0)
//   //       fractionSize = 1;
//   //
//   //     var abs = Math.abs(number);
//   //     var rounder = Math.pow(10, fractionSize);
//   //     var isNegative = number < 0;
//   //     var key = '';
//   //     var powers = [
//   //       {key: "Q", value: Math.pow(10, 15)},
//   //       {key: "T", value: Math.pow(10, 12)},
//   //       {key: "B", value: Math.pow(10, 9)},
//   //       {key: "M", value: Math.pow(10, 6)},
//   //       {key: "K", value: 1000}
//   //     ];
//   //
//   //     for (var i = 0; i < powers.length; i++) {
//   //
//   //       var reduced = abs / powers[i].value;
//   //
//   //       reduced = Math.round(reduced * rounder) / rounder;
//   //
//   //       if (reduced >= 1) {
//   //         abs = reduced;
//   //         key = powers[i].key;
//   //         break;
//   //       }
//   //     }
//   //
//   //     return (isNegative ? '-' : '') + abs + key;
//   //   };
//   // }
//
// })();

(function() {
  'use strict';

  angular
    .module('connectsx.catalog', []);

})();

(function () {
  'use strict';

  angular
    .module('connectsx.catalog')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.catalog', {
        abstract: true,
        url: '/vtray',
        templateUrl: 'app/catalog/catalog.html',
        controller: 'CatalogController',
        controllerAs: 'vm'
      });

  }

})();

(function () {
  'use strict';

  angular
    .module('connectsx.catalog')
    .controller('CatalogController', CatalogController);

  CatalogController.$inject = ['$state'];

  function CatalogController($state) {

    var vm = this;

    vm.tabs = [
      { heading: 'Product Templates', active: false, state:'index.catalog.products.list' },
      { heading: 'Technique Guides', active: false, state:'index.catalog.guides.list' },
      { heading: 'Tray Templates', active: false, state:'index.catalog.trays.list' },
      { heading: 'Layer Templates', active: false, state:'index.catalog.layers.list' },
    ];

    vm.onTabSelected = onTabSelected;

    activate();

    function activate() {
      /// derive current tab from state
      for (var i=0; i< vm.tabs.length; i++) {
        var tab = vm.tabs[i];
        if (tab.state === $state.current.name) {
          onTabSelected(vm.tabs[i], false);
          break;
        }
      }
    }

    function onTabSelected(tab, changeState) {

      if (angular.isUndefined(changeState)) {
        changeState = true;
      }

      for (var i=0; i< vm.tabs.length; i++) {
        vm.tabs[i].active = false;
      }
      tab.active = true;
      vm.title = tab.heading;

      if (changeState) {
        $state.go(tab.state);
      }
    }
  }
})();


(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.comments', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.comments')
    .factory('Comments', Comments);

  Comments.$inject = ['$resource', 'restUrl'];

  function Comments($resource, restUrl) {

    var resourceUrl = restUrl + '/v1/note/:objectKey';
    var listUrl = restUrl + '/v1/notes/:parentKey';

    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        insert: { method: 'POST' },
        list: { method:'GET', url: listUrl }
      });
  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.comments')
    .factory('CommentsModal', CommentsModal);

  CommentsModal.$inject = ['$mdDialog'];

  function CommentsModal($mdDialog) {


    function show(key, title) {
      $mdDialog.show({
        locals: { 'Key': key, 'Title': title },
        controller: 'CommentsModalController',
        controllerAs: 'vm',
        templateUrl:'app/comments/comments.tmpl.html',
        clickOutsideToClose:true
      });
    }

    return {
      show : show,
    };

  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.comments')
    .controller('CommentsModalController', CommentsModalController);

  CommentsModalController.$inject = ['$log', '$mdDialog', 'Comments', 'Toast', 'Key', 'Title'];

  function CommentsModalController($log, $mdDialog, Comments, Toast, Key, Title) {

    var vm = this;
    vm.cancel = $mdDialog.hide;
    vm.title = Title;
    vm.loading = false;

    vm.addComment = addComment;

    activate();

    function activate() {
      vm.loading = true;
      Comments.list({ parentKey: Key }, success, error);
      $log.info('CommentsModalController activated.');
    }

    function success(response) {
      vm.comments = response.items || [];
      vm.loading = false;
    }

    function error(response) {
      vm.loading = false;
      vm.isAddingComment = false;
      Toast.error(response);
    }

    function addComment(content) {

      if (!angular.isString(content) || content.length === 0) {
        return;
      }

      vm.isAddingComment = true;
      Comments.insert(null,
          { parent: Key, content: content }, insertSuccess, error);

    }

    function insertSuccess(response) {
      vm.isAddingComment = false;
      vm.addContent = undefined;
      vm.comments = vm.comments || [];
      vm.comments.unshift(response);
    }



  }

})();


(function() {
  'use strict';

  angular
    .module('connectsx.auth', []);

})();

(function() {
  'use strict';

  angular
    .module('connectsx.auth')
    .factory('targetService', targetService);

  targetService.$inject = [];

  function targetService() {

    var instance = {
      targetState: undefined,
      targetParams: undefined
    };

    instance.reset = function() {
      instance.targetState = undefined;
      instance.targetParams = undefined;
    };

    return instance;

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.auth')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['$scope', '$q', '$log', '$state', 'Auth', 'Accounts', 'targetService'];

  function LoginController($scope, $q, $log, $state, Auth, Accounts, targetService) {

    var vm = this;

    vm.user = {};
    vm.error = '';
    vm.login = login;
    vm.loading = false;

    function login(form, user) {

      if (!form.$valid) return;

      vm.error = '';
      vm.loading = true;
      $scope.$emit('loading', true);



      Auth.$signInWithEmailAndPassword(user.email, user.password)
        .then( ensureAccountExists )
        .then( finish )
        .catch( showError );

      function finish() {

        if (angular.isDefined(targetService.targetState) &&
          angular.isDefined(targetService.targetState.name))
            $state.go('index.home');

        // {
        //
        //   $state.go(targetService.targetState.name, targetService.targetParams);
        //   targetService.reset();
        //
        // }
        else {
          $state.go('index.home');
        }
      }
    }

    function showError(error) {

      vm.loading = false;
      $scope.$emit('loading', false);
      vm.error = error.message || error;
      $log.error("Authentication failed:", error);

    }

    function ensureAccountExists(firebaseUser) {
      return Accounts.me().$promise.then(function () {
        return firebaseUser;
      }, function(error) {
        if (error === null) {
            return $q.reject({ message: 'Unknown error. Try again in a moment.'});
        }
        return $q.reject(error.data.error);
      });
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.auth')
        .factory('Individuals', Individuals);

    Individuals.$inject = ['$resource', 'coreUrl'];

    function Individuals($resource, coreUrl) {

        var baseUrl = coreUrl + '/v1/account/';
        var resourceUrl = baseUrl + ':objectKey';
        var signupUrl = baseUrl + 'signup';
        var linkUrl = baseUrl + 'link';


        return $resource(resourceUrl, null,
            {
                signup: {url: signupUrl, method: 'POST'},
                link: {url: linkUrl, method: 'POST'}

            });
    }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.auth')
        .controller('IndividualClaimController', IndividualClaimController);

    IndividualClaimController.$inject = ['Auth', 'Individuals', '$state', '$stateParams', '$scope', '$log', '$http'];

    function IndividualClaimController(Auth, Individuals, $state, $stateParams, $scope, $log, $http) {

        var vm = this;

        vm.user = {};
        vm.error = '';
        vm.loading = false;
        vm.hasAccount = false;

        if (angular.isDefined($stateParams.email)) {
            vm.user.email = $stateParams.email;
        }

        vm.register = register;
        vm.link = link;

        vm.complete = false;

        vm.roles = ['Inventory',
            'Distribution',
            'Administration',
            'Provider',
            'Scheduling',
            'Finance',
            'Other'];

        function register(form, user) {

            if (!form.$valid) return;

            vm.loading = true;
            $scope.$emit('loading', true);

            Auth.$createUserWithEmailAndPassword(user.email, user.password)
                .then(function (currentAuth) {
                    return currentAuth.getToken(false);
                })
                .then(function (token) {
                    $http.defaults.headers.common.Authorization = 'Bearer ' + token;
                    return Individuals.signup({invitation: $stateParams.invitation}, vm.user).$promise;
                })
                .then(function () {
                    $scope.$emit('loading', false);
                    vm.complete = true;
                })
                .catch(function (error) {
                    handleOrLogin(user, error);
                });

        }

        function link (form, user) {

            if (!form.$valid) return;

            vm.loading = true;
            $scope.$emit('loading', true);

            Auth.$signInWithEmailAndPassword(user.email, user.password)
                .then(function (currentAuth) {
                    return currentAuth.getToken(false);
                })
                .then(function (token) {
                    $http.defaults.headers.common.Authorization = 'Bearer ' + token;
                    return Individuals.link({invitation: $stateParams.invitation}, user).$promise;
                })
                .then(function () {
                    $scope.$emit('loading', false);
                    vm.complete = true;
                })
                .catch(handleError);

        }

        function handleOrLogin(user, error) {

            if ('auth/email-already-in-use' !== error.code) {
                handleError(error);
                return;
            }

            Auth.$signInWithEmailAndPassword(user.email, user.password)
                .then(function (currentAuth) {
                    return currentAuth.getToken(false);
                })
                .then(function (token) {
                    $http.defaults.headers.common.Authorization = 'Bearer ' + token;
                    return Individuals.signup({invitation: $stateParams.invitation}, user).$promise;
                })
                .then(function () {
                    $scope.$emit('loading', false);
                    vm.complete = true;
                })
                .catch(handleError);
        }

        function handleError(error) {
            vm.loading = false;
            $scope.$emit('loading', false);
            $log.error("Error: ", error);
            $log.info(angular.toJson(error));
            $log.error(error.message);
            if (angular.isString(error.message)) {
                vm.error = error.message;
            } else if (angular.isObject(error.data) && angular.isString(error.data.message)) {
                vm.error = error.data.message;
            } else if (angular.isObject(error.data) && angular.isObject(error.data.error) && angular.isString(error.data.error.message)) {
                vm.error = error.data.error.message;
            } else {
                vm.error = "Unknown error.";
            }
        }

    }

})();


(function() {
  'use strict';

  angular
    .module('connectsx.auth')
    .controller('ForgotController', ForgotController);

  ForgotController.$inject = ['$scope', '$log', 'Auth'];

  function ForgotController($scope, $log, Auth) {

    var vm = this;

    vm.resetPassword = resetPassword;

    function resetPassword(form, email) {

      if (!form.$valid || angular.isUndefined(email)) return;

      vm.loading = true;
      $scope.$emit('loading', true);

      Auth.$sendPasswordResetEmail(email).then(function() {

        $scope.$emit('loading', false);
        $log.info('Password reset email sent');
        vm.message = "Sent! Check your email.";
        vm.loading = false;
        vm.error = "";

      }).catch(function(error) {
        $log.error("Error: ", error);
        vm.error = error.message;
        vm.loading = false;
        vm.message = "";
        $scope.$emit('loading', false);
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.auth')
    .factory('Auth', Auth);

  Auth.$inject = ['$firebaseAuth'];

  function Auth($firebaseAuth) {
    return $firebaseAuth();
  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.auth')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('auth', {
        url:'',
        templateUrl:'app/auth/auth.html',
        controller:'AuthController',
        controllerAs:'vm'
      })
      .state('auth.login', {
        url:'/login',
        templateUrl:'app/auth/login.html',
        controller:'LoginController',
        controllerAs:'vm'})
      .state('auth.claim', {
        url:'/claim?email&invitation',
        templateUrl:'app/auth/auth.claim.html',
        controller:'AuthClaimController',
        controllerAs:'vm'})
      .state('auth.individual', {
          url:'/individual/claim?email&invitation',
          templateUrl:'app/auth/individual.claim.html',
          controller:'IndividualClaimController',
          controllerAs:'vm'})
      .state('auth.forgot', {
        url:'/forgot',
        templateUrl:'app/auth/forgot.html',
        controller:'ForgotController',
        controllerAs:'vm'})
      .state('auth.action', {
        url: '/auth/action?mode&oobCode',
        templateUrl: 'app/auth/auth.action.html',
        controller: 'AuthActionController',
        controllerAs: 'vm'
      });
  }

})();



'use strict';

(function () {

  angular
    .module('connectsx')
    .factory('AuthResolver', AuthResolver);

  AuthResolver.$inject = ['Auth', 'Accounts', '$q'];

  function AuthResolver(Auth, Accounts, $q) {

    return function () {

      function onAuth() {
        return Accounts.me().$promise;
      }

      function onError() {
        return $q.reject('AUTH_REQUIRED');
      }

      /// rejects with AUTH_REQUIRED
      return Auth.$requireSignIn()
        .then(onAuth)
        .catch(onError);

    };
  }

})();

'use strict';

(function () {

  angular
    .module('connectsx')
    .factory('FirebaseTokenInterceptor', FirebaseTokenInterceptor);

  FirebaseTokenInterceptor.$inject = ['Auth', '$q'];

  function FirebaseTokenInterceptor(Auth, $q) {

    return {

      request: function(config) {

        if (!(~config.url.indexOf('appspot.com'))) {
          return config;
        }

        var deferred = $q.defer();

        function onAuth(currentAuth) {
          return currentAuth.getToken(false).then(onToken, onError);
        }

        function onToken(token) {
          config.headers['Authorization'] = 'Bearer ' + token;
          deferred.resolve(config);
        }

        function onError() {
          return deferred.resolve(config);
        }

        Auth.$requireSignIn().then(onAuth, onError);
        return deferred.promise;

      }
    };
  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.auth')
        .controller('AuthController', AuthController);

    AuthController.$inject = ['$scope', '$log', '$window', 'intercomAppId'];

    function AuthController($scope, $log, $window, intercomAppId) {

        var vm = this;

        $log.info('Auth Controller');

        vm.loading = false;

        $scope.$on('loading', function (event, isLoading) {
            vm.loading = isLoading;
        });

        $window.Intercom("boot", {
            app_id: intercomAppId
        });
        //
        // vm.getSelection = function() {
        //     var word = $window.getSelection().toString();
        //     $log.info(word);
        //     /// now you have the selection and you need to
        //     // do whatever to load the page for that word
        // }


    }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.auth')
        .controller('AuthClaimController', AuthClaimController);

    AuthClaimController.$inject = ['Auth', 'Accounts', '$state', '$stateParams', '$scope', '$log', '$http'];

    function AuthClaimController(Auth, Accounts, $state, $stateParams, $scope, $log, $http) {

        var vm = this;

        vm.user = {};
        vm.error = '';
        vm.loading = false;
        vm.emailDisabled = false;

        if (angular.isDefined($stateParams.email)) {
            vm.user.email = $stateParams.email;
            vm.emailDisabled = true;
        }

        vm.register = register;

        function register(form, user) {

            if (!form.$valid) return;

            vm.loading = true;
            $scope.$emit('loading', true);

            Auth.$createUserWithEmailAndPassword(user.email, user.password)
                .then(function (currentAuth) {
                    return currentAuth.getToken(false);
                })
                .then(function (token) {
                    $http.defaults.headers.common.Authorization = 'Bearer ' + token;
                    return Accounts.signup({invitation: $stateParams.invitation}, vm.user).$promise;
                })
                .then(function () {
                    $scope.$emit('loading', false);
                    $state.go('index.home');
                })
                .catch(function (error) {
                    handleOrLogin(user, error);
                });

        }

        function handleOrLogin(user, error) {

            if ('auth/email-already-in-use' !== error.code) {
                handleError(error);
                return;
            }

            Auth.$signInWithEmailAndPassword(user.email, user.password)
                .then(function (currentAuth) {
                    return currentAuth.getToken(false);
                })
                .then(function (token) {
                    $http.defaults.headers.common.Authorization = 'Bearer ' + token;
                    return Accounts.signup({invitation: $stateParams.invitation}, user).$promise;
                })
                .then(function () {
                    $scope.$emit('loading', false);
                    $state.go('index.home');
                })
                .catch(handleError);

        }

        function handleError(error) {
            vm.loading = false;
            $scope.$emit('loading', false);
            $log.error("Error: ", error);
            vm.error = error.message || error.data.message;
        }

    }

})();

(function() {
  'use strict';
  /* global firebase */
  /* global angular */

  angular
    .module('connectsx.auth')
    .controller('AuthActionController', AuthActionController);

  AuthActionController.$inject = ['$scope', '$stateParams', '$state', '$q', '$log', 'Auth'];

  function AuthActionController($scope, $stateParams, $state, $q, $log, Auth) {

    var vm = this;

    /// TODO: Check back with https://github.com/firebase/angularfire/issues/764 for when
    /// 3.x.x methods are made available in angular fire, or figure out a better way to wrap
    /// these methods in our own service.
    var __auth = firebase.auth();

    vm.mode = $stateParams.mode;
    var oobCode = $stateParams.oobCode;

    if (angular.isUndefined(vm.mode) || angular.isUndefined(oobCode)) {
      $state.go('auth.login');
      return;
    }

    vm.password = '';
    vm.error = '';
    vm.verify = verify;
    vm.resetPassword = resetPassword;

    activate();

    function activate() {

      if (vm.mode === 'verifyEmail') {

        $scope.$emit('loading', true);
        $q.when(__auth.applyActionCode(oobCode)).then(function() {
          $state.go('index.home');
        }).catch(showError);

      } else if (vm.mode === 'resetPassword') {

        $scope.$emit('loading', true);
        $q.when(__auth.verifyPasswordResetCode(oobCode)).then(function(email) {
          $scope.$emit('loading', false);
          vm.email = email;
        }).catch(showError);

      }
    }

    function showError(error) {
      $scope.$emit('loading', false);
      $log.error(error.message);
      vm.error = error.message;
    }

    function verify() {
      var firebaseUser = Auth.$getAuth();
      if (firebaseUser === null) {
        $state.go('auth.login');
        return;
      }
      firebaseUser.sendEmailVerification().then(function() {
        vm.message = "Sent! Check your email.";
      });
    }

    function resetPassword() {

      if (angular.isUndefined(vm.email) || angular.isUndefined(vm.password)) {
        return;
      }

      $scope.$emit('loading', true);

      $q.when(__auth.confirmPasswordReset(oobCode, vm.password)).then(function() {
        Auth.$signInWithEmailAndPassword(vm.email, vm.password).then(function() {
          $state.go('index.home');
          $scope.$emit('loading', false);
        }).catch(showError);
      }).catch(showError);

    }

  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx.auth')
        .factory('Accounts', Accounts);

    Accounts.$inject = ['$resource', 'restUrl'];

    function Accounts($resource, restUrl) {

        var baseUrl = restUrl + '/v1/account/';
        var resourceUrl = baseUrl + ':objectKey';
        var meUrl = baseUrl + 'me';
        var signupUrl = baseUrl + 'signup';
        var byManufacturerUrl = restUrl + '/v1/manufacturer/:objectKey/accounts';
        var manufacturerUrl = resourceUrl + '/:manufacturerKey';
        return $resource(resourceUrl, null,
            {
                me: {url: meUrl, method: 'GET'},
                get: {method: 'GET'},
                remove: {method: 'DELETE'},
                signup: {url: signupUrl, method: 'POST'},
                insert: {method: 'POST'},
                update: {method: 'PUT'},
                list: {method: 'GET'},
                addManufacturer: { method:'POST', url: manufacturerUrl },
                removeManufacturer: { method:'DELETE', url: manufacturerUrl },
                byManufacturer: {method: 'GET', url: byManufacturerUrl}
            });
    }

})();

(function() {
  'use strict';

  angular
    .module('connectsx.cases')
    .run(runBlock);

  runBlock.$inject = ['$log'];

  function runBlock($log) {

    $log.debug('Cases runBlock end');
  }

})();

(function() {
  'use strict';

  /* global angular */

  angular
    .module('connectsx.cases')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {

    $stateProvider
      .state('index.cases', {
        abstract: true,
        url: '/cases',
        template: '<ui-view/>'
      })
      .state('index.cases.list', {
        url: '?number&date&status&physician&facility&procedure&order&cursor&limit',
        templateUrl: 'app/cases/cases.html',
        reloadOnSearch: false,
        controller: 'CasesController',
        controllerAs: 'vm'
      })
      .state('index.cases.create', {
        url: '/new',
        templateUrl: 'app/cases/create/case.create.html',
        controller: 'CaseCreateController',
        controllerAs: 'vm'
      })
      .state('index.cases.edit', {
        url: '/:objectKey/edit',
        templateUrl: 'app/cases/edit/case.edit.html',
        controller: 'CaseEditController',
        controllerAs: 'vm'
      })
      .state('index.cases.bom', {
        url: '/:objectKey/bom',
        templateUrl: 'app/cases/bom/case.bom.html',
        controller: 'BomController',
        controllerAs: 'vm'
      })
      .state('index.invoices', {
        url: '/invoices/:objectKey',
        templateUrl: 'app/cases/invoice/case.invoice.html',
        controller: 'InvoiceController',
        controllerAs: 'vm'
      })
      .state('index.cases.inventory', {
        url: '/:objectKey/inventory',
        templateUrl: 'app/cases/inventory/case.inventory.html',
        controller: 'CaseInventoryController',
        controllerAs: 'vm'
      })
      .state('index.cases.detail', {
        url: '/:objectKey/detail',
        templateUrl: 'app/cases/detail/case.detail.html',
        controller: 'CaseDetailController',
        controllerAs: 'vm'
      });

  }

})();



(function() {
  'use strict';

  angular
    .module('connectsx.cases')
    .factory('Cases', Cases);

  Cases.$inject = ['$resource', 'restUrl'];

  function Cases($resource, restUrl) {

    var statsUrl = restUrl + '/v1/case/stats';
    var resourceUrl = restUrl + '/v1/case/:objectKey';
    var inventoryUrl = resourceUrl + '/inventory';
    var submitUrl = restUrl + '/v1/case/:objectKey/submit';
    var completeUrl = restUrl + '/v1/case/:objectKey/complete';
    var reopenUrl = restUrl + '/v1/case/:objectKey/reopen';

    var historyUrl = resourceUrl + '/history';
    var searchUrl = restUrl + '/v1/case';
    var noteUrl = resourceUrl + '/note';
    var getNotes =  restUrl + '/v1/notes/:objectKey';
    var removeNoteUrl = noteUrl + '/:noteKey';
    return $resource(resourceUrl, null,
      {
        get: { method: 'GET' },
        inventory: { method: 'GET', url:inventoryUrl },
        stats: { method: 'GET', url:statsUrl },
        remove: { method: 'DELETE' },
        insert: { method: 'POST' },
        update: { method:'PUT' },
        submit: { method: 'POST', url: submitUrl },
        complete: { method: 'POST', url: completeUrl },
        reopen: { method: 'POST', url: reopenUrl },
        addNote: { method:'POST', url:noteUrl },
        getNotes: { method:'GET', url:getNotes },
        removeNote: { method:'DELETE', url:removeNoteUrl },
        history: { method:'GET', url:historyUrl },
        search: { method: 'GET', url: searchUrl }
      });
  }

})();

(function () {
    'use strict';

    /* global angular, moment */

    angular
        .module('connectsx.cases')
        .controller('CasesController', CasesController);


    CasesController.$inject = ['Cases', 'Facilities', 'Procedures', 'Physicians', 'Toast', '$scope', '$location', '$stateParams', '$filter', '$log'];

    function CasesController(Cases, Facilities, Procedures, Physicians, Toast, $scope, $location, $stateParams, $filter, $log) {

        var vm = this;

        // // List
        vm.cases = [];
        vm.filters = [];

        vm.filterOptions = [
            {"key": "search", "display": "Case name"},
            {"key": "facilityName", "display": "Facility"},
            {"key": "procedureName", "display": "Procedure"},
            {"key": "physicianName", "display": "Physician"},
        ];

        vm.statuses = [
            "Open",
            "Closed",
            "Cancelled",
            "Completed",
        ];

        /// these defaults will be overwritten by state params if present
        vm.pageSize = 20;

        vm.filterObject = parseStateParams();

        vm.isLoading = false;
        vm.filterType = vm.filterOptions[0].key;
        vm.previousPages = [];

        vm.statusClass = statusClass;

        vm.hasNextPage = hasNextPage;
        vm.hasPreviousPage = hasPreviousPage;
        vm.loadNextPage = loadNextPage;
        vm.loadPreviousPage = loadPreviousPage;
        vm.setPageSize = setPageSize;

        vm.onSubmit = onSubmit;
        vm.onSelectItem = onSelectItem;
        vm.sort = sort;
        vm.resetDatepicker = resetDatepicker;

        vm.onRemoveFilter = onRemoveFilter;

        $scope.$watch(
            angular.bind(vm, function () {
                return vm.filterObject;
            }),
            onNewFilter,
            true
        );

        function sort(key) {

            if (angular.isUndefined(vm.filterObject.order) ||
                !vm.filterObject.order.endsWith(key) ||
                vm.filterObject.order.startsWith("-")) {
                vm.filterObject.order = key;
                return;
            }

            $log.info('This is key: ' + key);
            vm.filterObject.order = '-' + key;

        }

        function parseStateParams() {

            $scope.$emit('loading', true);


            /// set default query if there are no state params..
            /// otherwise let the state params define the filters
            if (!hasKeys($stateParams)) {
                return {
                    status: "Open",
                }
            }

            var filterObject = {};

            if (angular.isDefined($stateParams.limit)) {
                if (isFinite($stateParams.limit)) {
                    vm.pageSize = parseInt($stateParams.limit);
                }
            }

            if (angular.isDefined($stateParams.date)) {
                var m = moment($stateParams.date);
                if (m.isValid()) {
                    filterObject.date = m._d;
                }
            }

            if (angular.isDefined($stateParams.cursor)) {
                vm.previousPages = [$stateParams.cursor];
            }

            if (angular.isDefined($stateParams.physician)) {
                filterObject.physician = byKeyObject($stateParams.physician, 'Physician');
            }

            if (angular.isDefined($stateParams.facility)) {
                filterObject.facility = byKeyObject($stateParams.facility, 'Facility');
            }

            if (angular.isDefined($stateParams.procedure)) {
                filterObject.procedure = byKeyObject($stateParams.procedure, 'Procedure');
            }

            if (angular.isDefined($stateParams.number) && angular.isString($stateParams.number)) {
                filterObject.number = $stateParams.number;
            }

            if (angular.isDefined($stateParams.status)) {
                filterObject.status = $stateParams.status;
            }

            return filterObject;

        }

        function byKeyObject(key, type) {
            var shortKey = ' ...' + key.substring(key.length - 8);
            return {
                key: key,
                objType: type,
                name: shortKey
            };
        }

        function hasKeys(obj) {
            if (angular.isUndefined(obj) || !angular.isObject(obj)) return false;
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && angular.isDefined(obj[key])) {
                    return true;
                }
            }
            return false;
        }

        function isFacility(value) {
            return isObjectType(value, 'Facility');
        }

        function isProcedure(value) {
            return isObjectType(value, 'Procedure');
        }

        function isPhysician(value) {
            return isObjectType(value, 'Physician');
        }

        function isObjectType(value, type) {
            if (!isObject(value)) return false;
            return value.objType === type;
        }

        function isObject(value) {
            return (value !== null &&
                angular.isDefined(value) &&
                angular.isDefined(value.key) &&
                angular.isDefined(value.objType));
        }

        function onSelectItem(item) {
            if (isFacility(item)) {
                vm.filterObject.facilityName = item;
            }
            else if (isProcedure(item)) {
                vm.filterObject.procedureName = item;
            }
            else if (isPhysician(item)) {
                vm.filterObject.physicianName = item;
            }
        }

        function onNewFilter(newVal) {

            var ignore = false;

            var filters = [];
            angular.forEach(newVal, function (value, key) {

                if (ignore || value === null) {
                    ignore = true;
                    return;
                }

                var display = value;
                if (angular.isString(value)) {
                    display = value;
                }
                else if (angular.isDate(value)) {
                    display = $filter('date')(value, "MM/dd/yyyy");
                } else if (isFacility(value) || isProcedure(value) || isPhysician(value)) {
                    display = value.name;
                }
                else {
                    return;
                }

                filters.push({"key": key, "value": value, "display": display});

            });

            vm.filters = filters;
            vm.searchText = undefined;

            updateSearchParams();

        }

        function updateSearchParams() {

            var search = {
                "limit": vm.pageSize
            };

            var len = vm.previousPages.length;
            if (len > 0) {
                search.cursor = vm.previousPages[len - 1];
            }

            angular.forEach(vm.filters, function (filter) {

                var value = null;
                if (angular.isString(filter.value)) {
                    value = filter.value;
                } else if (angular.isDate(filter.value)) {
                    value = $filter('date')(filter.value, "yyyyMMdd");
                } else if (isObject(filter.value)) {
                    value = filter.value.key;
                }
                if (value === null) return;
                search[filter.key] = value;

            });

            $location.search(search);
            query(search);

        }

        function onSubmit() {

            if (angular.isUndefined(vm.searchText)) return;
            if (!angular.isString(vm.searchText)) return;
            if (vm.searchText.length === 0) return;

            vm.filterObject[vm.filterType] = vm.searchText;
            vm.searchText = undefined;

        }

        function statusClass(status) {
            switch (status) {
                case 'Closed':
                    return 'csx-closed';
                case 'Completed':
                    return 'csx-closed';
                case 'Open':
                    return 'csx-open';
                case 'Cancelled':
                    return 'csx-cancelled';
            }
            return '';
        }

        function query(params) {

            vm.isLoading = true;

            var date = vm.filterObject.date;
            if (angular.isDefined(date) && angular.isDate(date)) {
                params.date = $filter('date')(date, "yyyyMMddZ");
            }

            Cases.search(params, successCallback, errorCallback);

            function successCallback(value) {
                $scope.$emit('loading', false);
                vm.nextPageToken = value.nextPageToken;
                vm.cases = value.items;
                vm.isLoading = false;
            }

            function errorCallback(httpResponse) {
                $scope.$emit('loading', false);
                $log.error('CasesApi Error: ' + angular.toJson(httpResponse));
                vm.isLoading = false;
                Toast.error('An unexpected error has occurred. Please reload the page and try again.');
            }
        }

        function onRemoveFilter() {

            var toRemove = {};
            angular.forEach(vm.filterObject, function (value, key) {
                toRemove[key] = true;
            });

            angular.forEach(vm.filters, function (filter) {
                var key = filter.key;
                if (toRemove.hasOwnProperty(key)) {
                    toRemove[key] = false;
                }
            });

            var filterObject = angular.copy(vm.filterObject);

            angular.forEach(toRemove, function (value, key) {
                if (value) {
                    delete filterObject[key];
                }
            });

            vm.filterObject = filterObject;

        }

        function setPageSize(pageSize) {
            vm.pageSize = pageSize;
            updateSearchParams();
        }

        function hasNextPage() {
            return angular.isDefined(vm.nextPageToken);
        }

        function hasPreviousPage() {
            return vm.previousPages.length > 0;
        }

        function loadNextPage() {
            if (angular.isUndefined(vm.nextPageToken)) return;
            vm.previousPages.push(vm.nextPageToken);
            vm.nextPageToken = undefined;
            updateSearchParams();
        }

        function loadPreviousPage() {
            if (vm.previousPages.length === 0) return;
            vm.previousPages.pop();
            updateSearchParams();
        }

        function resetDatepicker(data){
            data = null;
            $scope.$broadcast('md-calendar-change', data);
        }

    }

})();

(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.accounts')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {

        $stateProvider
            .state('index.accounts', {
                abstract: true,
                url: '/users',
                template: '<ui-view/>'
            })
            .state('index.accounts.list', {
                url: '',
                templateUrl: 'app/accounts/accounts.html',
                controller: 'AccountsController',
                controllerAs: 'vm'
            })
            .state('index.accounts.detail', {
            url: '/:objectKey',
            templateUrl: 'app/accounts/detail/account.detail.html',
            controller: 'AccountDetailController',
            controllerAs: 'vm'
        });
    }

})();



(function () {
    'use strict';

    /* global angular */

    angular
        .module('connectsx.accounts')
        .controller('AccountsController', AccountsController);

    AccountsController.$inject = ['$scope', '$log', 'Toast', 'Accounts', 'Invitations', 'currentAuth'];

    function AccountsController($scope, $log, Toast, Accounts, Invitations, currentAuth) {

        $scope.$emit('loading', false);

        var vm = this;

        vm.orgAccountType = currentAuth.accountType || 'Manufacturer';

        vm.roles = [vm.orgAccountType, 'Sales'];
        vm.users = [];
        vm.sending = false;

        vm.addUser = addUser;
        vm.remove = remove;
        vm.resend = resend;

        activate();

        function activate() {

            Accounts.list({}, function (accounts) {
                var items = [];
                accounts.items = accounts.items || [];
                angular.forEach(accounts.items, function (i) {
                    if (i.accountType !== 'Connectsx') {
                        items.push(i);
                    }
                });
                vm.accounts = items;
            }, Toast.error);

            Invitations.list({claimed: false}, function (invitations) {
                vm.invitations = invitations.items || [];
            }, Toast.error);

        }

        function resend(invitation) {
            Invitations.resend({objectKey: invitation}, null, function (response) {
                Toast.success('Resent invitation to ' + response.email + '!');
            }, Toast.error);
        }

        function remove(invitation) {
            Invitations.remove({objectKey: invitation}, function () {
                for (var i=0; i < vm.invitations.length; i++) {
                    if (vm.invitations[i].key === invitation) {
                        vm.invitations.splice(i, 1);
                        return;
                    }
                }
            }, Toast.error);
        }


        function addUser(email, role) {

            if (!angular.isString(email) || !angular.isString(role)) {
                return;
            }

            var user = {email: email, accountType: role};
            vm.sending = true;
            Invitations.insert({}, user, success, function (error) {
                vm.sending = false;
                Toast.error(error);
            });

            function success(response) {
                vm.invitations.unshift(response);
                Toast.success('Successfully invited ' + response.email + '!');
                vm.sending = false;
                delete vm.email;
                delete vm.role;
            }

        }


    }

})();

(function () {
  'use strict';

  /* global angular */

  angular
    .module('connectsx')
    .run(runBlock);

  runBlock.$inject = ['$rootScope', '$log', '$state', 'targetService'];

  function runBlock($rootScope, $log, $state, targetService) {

    /// We can catch the error thrown when the $requireSignIn promise is rejected and redirect.
    var destroyCallback = $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {

      if (error && angular.isString(error)) {

        event.preventDefault();

        /// cache target state to go there after login
        targetService.targetState = toState;
        targetService.targetParams = toParams;

        switch (error) {
          case 'AUTH_REQUIRED':
            $state.go('auth.login');
            return;
          case 'EMAIL_NOT_VERIFIED':
            $state.go('auth.action', { mode: "needsVerification" });
            return;
        }
        $state.go('auth.login');
      }
    });

    $rootScope.$on('$destroy', destroyCallback);

    $log.debug('Connectsx runBlock end');

  }

})();

(function() {
  'use strict';

  angular
    .module('connectsx')
    .controller('IndexController', IndexController);

  IndexController.$inject = ['$scope'];

  function IndexController($scope) {
    var vm = this;
    vm.isLoading = true;

    $scope.$on('loading', function(event, isLoading) {
      vm.isLoading = isLoading;
    });

  }

})();

(function () {
    'use strict';

    angular
        .module('connectsx')
        /**
         * This can be safely ignored. We migrated over to a new environment at some
         * point in the past and I was using this to access the old environment.
         */
        .constant('oldUrl', '')
        /// INTERCOM PROD APP_ID
        .constant('intercomAppId', 'q6pnziko')
        /// INTERCOM TEST APP_ID
        // .constant('intercomAppId', 's0kcbhez')

        /*
        * Prod
        * */
        .constant('restUrl', 'https://connectsx-core.appspot.com/_ah/api/org')
        .constant('gudidUrl', 'https://api-dot-connectsx-gudid.appspot.com')
        .constant('udiUrl', 'https://udidentify-v2-dot-connectsx-core.appspot.com')
        .constant('coreUrl', 'https://connectsx-core.appspot.com/_ah/api/connectsx')

        /*
        *Stage
        *
        * */

        // .constant('restUrl', 'https://connectsx-core-stage.appspot.com/_ah/api/org')
        // .constant('gudidUrl', 'https://api-dot-connectsx-gudid.appspot.com')
        // .constant('udiUrl', 'https://udidentify-v2-dot-connectsx-core.appspot.com')
        // .constant('coreUrl', 'https://connectsx-core-stage.appspot.com/_ah/api/connectsx')

        /*
        Dev
         */
        // .constant('restUrl', 'https://dev-dot-connectsx-core-stage.appspot.com/_ah/api/org')
        // .constant('gudidUrl', 'https://api-dot-connectsx-gudid.appspot.com')
        // .constant('udiUrl', 'https://udidentify-v2-dot-connectsx-core.appspot.com')
        // .constant('coreUrl', 'https://dev-dot-connectsx-core-stage.appspot.com/_ah/api/connectsx')

        /**
         * Anytime you see a 20190207t182639-dot- as a part of the sub domain that URL is pointing
         * to a specific deployment version of the API. These versioned URLs should not be used in production.
         */

        /**
         * restUrl is the constant that is used for the Org Api that is the main API for the console
         * connectsx-core is the production environment for this API.
         */

        /**
         * coreUrl is the constant that is used for the ConnectSx Api. This API is predominately used
         * in vTrakr but it is used in a few places in the console as well.
         * connectsx-core is the production environment for this API.
         */

        /**
         * gudidUrl is the user facing API for our copy of the AccessGUDID database.
         * More information about AccessGUDID can be found here: https://accessgudid.nlm.nih.gov
         * Currently this API is only used to search for GUDID manufacturers in the console.
         * This API is also used to implement the FDA search in vTrakr and a similar feature
         * may be implemented in the console in the future.
         * There is only one environment for the GUDID Api. Which is why I am using a versioned URL
         * below to test some changes that I made without serving those changes to end users.
         */

        /**
         * udiUrl is the udidentify url, which is used in the console to parse UDIs
         */

        /**
         * These are the stage versions of the org and core APIs that are documented above.
         * These should be uncommented when deploying to stage.console.connectsx.com
         */

})();

/* global firebase */
'use strict';

(function () {

  angular
      .module('connectsx')
      .config(routerConfig);

  routerConfig.$inject = ['$stateProvider', '$httpProvider', '$urlRouterProvider', '$locationProvider', '$mdThemingProvider'];

  function routerConfig($stateProvider, $httpProvider, $urlRouterProvider, $locationProvider, $mdThemingProvider) {

    $mdThemingProvider.definePalette('connectsxPalette', {
      '50': 'ede7f6',
      '100': 'd1c4e9',
      '200': 'b39ddb',
      '300': '9575cd',
      '400': '7e57c2',
      '500': '5B2D61',
      '600': '5e35b1',
      '700': '512da8',
      '800': '4527a0',
      '900': '311b92',
      'A100': 'b388ff',
      'A200': '7c4dff',
      'A400': '651fff',
      'A700': '6200ea',
      // '50': '5B2D61',
      // '100': '5B2D61',
      // '200': '5B2D61',
      // '300': '5B2D61',
      // '400': '5B2D61',
      // '500': '5B2D61',
      // '600': '5B2D61',
      // '700': '5B2D61',
      // '800': '5B2D61',
      // '900': '5B2D61',
      // 'A100': '5B2D61',
      // 'A200': '5B2D61',
      // 'A400': '5B2D61',
      // 'A700': '5B2D61',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                          // on this palette should be dark or light

      'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.theme('default')
        .primaryPalette('connectsxPalette');


    // Initialize Firebase
    var config = {
      apiKey: "AIzaSyBdH1qnELts_qZpEuP_w5ONNttqdiGda6U",
      authDomain: "connectsx-production.firebaseapp.com",
      databaseURL: "https://connectsx-production.firebaseio.com",
      projectId: "connectsx-production",
      storageBucket: "connectsx-production.appspot.com",
      messagingSenderId: "764280099480"
    };

    firebase.initializeApp(config);

    $locationProvider.html5Mode(true);

    $httpProvider.interceptors.push('FirebaseTokenInterceptor');

    $stateProvider
        .state('index', {
          abstract: true,
          url: '/index',
          templateUrl: 'app/components/common/content.html',
          controller: 'MainController',
          controllerAs: 'main',
          resolve: {
            'currentAuth': ['AuthResolver', function (AuthResolver) {
              return AuthResolver();
            }]
          }
        })



    ;


      $urlRouterProvider.otherwise('/index/home');



  }

})();

angular.module("connectsx").run(["$templateCache", function($templateCache) {$templateCache.put("app/accounts/accounts.html","<div class=\"animated padding-left-5-desktop\" style=\"margin-bottom: 0\"><div class=\"row\"><div class=\"col-lg-12\"><h2 class=\"title\">Users</h2></div></div><div layout=\"row\"><div><div class=\"wrap-first-icon\"><md-button class=\"md-fab\"><md-tooltip md-visible=\"false\" style=\"max-width: 200px;\" md-direction=\"right\">Users added below will receive an email invitation to claim their account.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button><h3 class=\"subTitle\">Invitations</h3></div></div></div><div class=\"row padding-left-10-desktop\"><div class=\"onboarding-horizontal-form col-md-4\"><md-input-container flex=\"\" class=\"full-width placeholder big-fontSize\"><label>Email</label> <input required=\"\" name=\"userEmail\" ng-model=\"vm.email\"><div ng-messages=\"createForm.userEmail.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div class=\"col-xs-12 col-md-4\"><md-input-container flex=\"\" class=\"full-width placeholder big-fontSize\"><label>Role</label><md-select required=\"\" ng-model=\"vm.role\" style=\"min-width: 152px;\"><md-option ng-repeat=\"option in vm.roles\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12 col-md-4\"><br><button class=\"btn btn-primary btn-outline\" csx-loading=\"\" csx-is-loading=\"vm.sending\" ng-click=\"vm.addUser(vm.email, vm.role)\"><i class=\"fa fa-send\"></i> Invite</button></div></div></div><div class=\"row mobi padding-left-10-desktop\" ng-show=\"vm.invitations.length > 0\"><div class=\"col-md-12 col-xs-12\"><table class=\"table no-border mobileFriendlyTable\"><thead><tr class=\"positionUserstable lastTdCommon\"><th>Email</th><th></th><th>Role</th><th>Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"invitation in vm.invitations\"><td>{{ invitation.email }}</td><td><a ng-click=\"vm.resend(invitation.key)\" style=\"margin-left:24px;\" class=\"primary\">Resend</a></td><td>{{ invitation.accountType }}</td><td>{{ invitation.createdDate | date: \'MM/dd/yyyy\' }}</td><td><a ng-click=\"vm.remove(invitation.key)\" class=\"text-danger\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div><div><div ng-repeat=\"user in vm.users\">{{ user.email }} ({{user.accountType }})</div></div><br><div layout=\"row\" class=\"padding-left-null-desktop\"><div><div class=\"wrap-first-icon\"><md-button class=\"md-fab\"><md-tooltip md-visible=\"false\" style=\"max-width: 200px;\" md-direction=\"right\"><p>{{ vm.orgAccountType }} users have org-level access.</p><p>Individual users use vTrakr and vTray to manage inventory and cases.</p></md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button><h3 class=\"subTitle\">Users</h3></div></div></div><div class=\"row padding-left-5-desktop\"><div class=\"col-xs-12 col-md-12\"><table class=\"table no-border mobileFriendlyTable\"><thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"account in vm.accounts\"><td><a ui-sref=\"index.accounts.detail({objectKey: account.key })\" class=\"primary\">{{ account.name }}</a></td><td>{{ account.email }}</td><td>{{ account.accountType }}</td><td>{{ account.createdDate | date: \'MM/dd/yyyy\' }}</td><td></td></tr></tbody></table></div></div>");
$templateCache.put("app/cases/cases.html","<div class=\"wrapper wrapper-content animated\"><div class=\"flexJustify\"><h2 class=\"title\">Cases</h2><div><button class=\"btn btn-outline btn-primary header-button\" ui-sref=\"index.cases.create\"><i class=\"fa fa-plus\"></i> Create</button></div></div><div style=\"margin-top:16px;\" layout=\"row\"><div flex=\"auto\" class=\"case-search\" layout=\"row\"><md-input-container flex=\"none\" class=\"margin-right-20 big-fontSize placeholder\"><label>Status</label><md-select class=\"big-fontSize\" ng-model=\"vm.filterObject.status\" md-placeholder=\"Status\" style=\"min-width:120px;\"><md-option ng-repeat=\"option in vm.statuses\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container><md-input-container flex=\"none\" class=\"datePickerClearButton margin-right-20 mobile-fullWidth-datepicker big-fontSize placeholder-filter\"><label>Procedure Date</label><md-datepicker class=\"\" ng-model=\"vm.filterObject.date\" md-placeholder=\"Select date\" md-open-on-focus=\"\"></md-datepicker></md-input-container><md-input-container flex=\"none\" class=\"md-no-underline caseSearchInput margin-left-null margin-right-20-import big-fontSize placeholder\"><label>Search By</label><md-select class=\"big-fontSize\" ng-model=\"vm.filterType\" style=\"min-width:120px;\"><md-option ng-repeat=\"option in vm.filterOptions\" ng-value=\"option.key\">{{ option.display }}</md-option></md-select></md-input-container><div ng-switch=\"vm.filterType\" flex=\"\" class=\"placeholder-filter\"><md-autocomplete class=\"big-fontSize\" ng-keydown=\"$event.keyCode === 13 && vm.onSubmit()\" ng-switch-when=\"search\" flex=\"\" md-input-name=\"numberField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-items=\"item in []\" md-require-match=\"false\" md-floating-label=\"Search by Case Name\"></md-autocomplete><md-autocomplete class=\"big-fontSize\" ng-keydown=\"$event.keyCode === 13 && vm.onSubmit(item.key)\" ng-switch-when=\"facilityName\" flex=\"\" md-input-name=\"facilityField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-selected-item-change=\"vm.onSelectItem(item)\" md-search-text=\"vm.searchText\" md-items=\"item in []\" md-item-text=\"item.name\" md-require-match=\"true\" md-floating-label=\"Search by Facility Name\"><md-item-template><span>{{item.name}}</span></md-item-template></md-autocomplete><md-autocomplete class=\"big-fontSize\" ng-keydown=\"$event.keyCode === 13 && vm.onSubmit(item.key)\" ng-switch-when=\"physicianName\" flex=\"\" md-input-name=\"physicianField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-selected-item-change=\"vm.onSelectItem(item)\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-items=\"item in []\" md-item-text=\"item.name\" md-require-match=\"true\" md-floating-label=\"Search by Physician Name\"><md-item-template><span>{{item.name}}</span></md-item-template></md-autocomplete><md-autocomplete class=\"big-fontSize\" ng-keydown=\"$event.keyCode === 13 && vm.onSubmit(item.key)\" ng-switch-when=\"procedureName\" flex=\"\" md-input-name=\"procedureField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-selected-item-change=\"vm.onSelectItem(item)\" md-no-cache=\"true\" md-search-text=\"vm.searchText\" md-items=\"item in []\" md-item-text=\"item.name\" md-require-match=\"true\" md-floating-label=\"Search by Procedure\"><md-item-template><span>{{item.name}}</span></md-item-template></md-autocomplete></div></div></div><div layout=\"row\" style=\"margin-top:-60px; height:88px;\"><h4 ng-show=\"vm.filters.length === 0\" style=\"position:relative; top:30px;color: #000;\">No Filters</h4><md-input-container flex=\"auto\" style=\"height:52px;box-shadow: none\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key}}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" style=\"height:5px;\"><md-progress-linear style=\"margin-top:-20px;\" ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-mode=\"indeterminate\"></md-progress-linear></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable mobileFriendlyBitTable\"><thead><tr><th>Case Name</th><th>Facility</th><th>Physician</th><th>Procedure</th><th ng-click=\"vm.sort(\'procedureDate\')\">Procedure Date <i class=\"fa fa-sort\" aria-hidden=\"true\" ng-if=\"vm.filterObject.order !== \'procedureDate\' && vm.filterObject.order !== \'-procedureDate\'\"></i> <i ng-show=\"vm.filterObject.order === \'procedureDate\'\" class=\"fa fa-sort-asc\"></i> <i ng-show=\"vm.filterObject.order === \'-procedureDate\'\" class=\"fa fa-sort-desc\"></i></th><th>Status</th><th ng-click=\"vm.sort(\'modifiedDate\')\">Last Updated <i class=\"fa fa-sort\" aria-hidden=\"true\" ng-if=\"vm.filterObject.order !== \'modifiedDate\' && vm.filterObject.order !== \'-modifiedDate\'\"></i> <i ng-show=\"vm.filterObject.order === \'modifiedDate\'\" class=\"fa fa-sort-asc\"></i> <i ng-show=\"vm.filterObject.order === \'-modifiedDate\'\" class=\"fa fa-sort-desc\"></i></th></tr></thead><tbody><tr ng-repeat=\"c in vm.cases\"><td><a ui-sref=\"index.cases.edit({objectKey: c.key})\">{{ c.name }}</a></td><td>{{ c.facilityName }}</td><td>{{ c.physicianName }}</td><td>{{ c.procedureName }}</td><td>{{ c.procedureDate | date:\'MM/dd/yyyy\' }} {{c.procedureTime | date:\'h:mm a\' }}</td><td><div ng-class=\"vm.statusClass(c.status)\" class=\"csx-status\">{{ c.status | uppercase }}</div></td><td>{{ c.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div><div class=\"row\" ng-hide=\"vm.cases.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>It looks like no cases match your search. Check your information and try again.</h3></div></div><div class=\"row pagination\"><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"margin-bottom:35px;\"></div></div></div>");
$templateCache.put("app/auth/auth.action.html","<div ng-switch=\"vm.mode\"><div ng-switch-when=\"resetPassword\"><h3>Reset Password</h3><span class=\"help-block m-b-none\">{{vm.email}}</span><form class=\"m-t\" role=\"form\"><md-input-container class=\"md-block\" style=\"margin-top: 35px;\"><label>Password</label> <input type=\"password\" ng-model=\"vm.password\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><button type=\"submit\" ng-click=\"vm.resetPassword()\" class=\"btn btn-outline btn-primary full-width m-b\" ng-disabled=\"vm.loading\">Login</button></form></div><div ng-switch-when=\"needsVerification\"><h3>Verify Email Address</h3><a class=\"btn btn-sm btn-white btn-block\" ng-click=\"vm.verify()\">Resend Verification Email</a></div><div ng-switch-when=\"verifyEmail\"><h3>Verifying Email Address</h3></div></div><span class=\"help-block m-b-none error-block\">{{vm.error}}</span>");
$templateCache.put("app/auth/auth.claim.html","<h3>Claim Invitation</h3><form name=\"form\" class=\"m-t\" role=\"form\" style=\"margin-top: 45px;\"><md-input-container class=\"md-block\"><label>Name</label> <input type=\"text\" ng-model=\"vm.user.name\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Password</label> <input type=\"password\" ng-model=\"vm.user.password\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"help-block m-b-none error-block\">{{ vm.error }}</span></md-input-container><button type=\"submit\" ng-click=\"vm.register(form, vm.user)\" class=\"btn btn-outline btn-primary full-width m-b\" ng-disabled=\"vm.loading\">Sign Up</button></form>");
$templateCache.put("app/auth/auth.html","<div class=\"loginColumns animated\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\" style=\"text-align:center;\"><div class=\"image-logo loading-logo\" ng-switch=\"vm.loading\"><div ng-switch-when=\"true\"><div class=\"sk-spinner sk-spinner-chasing-dots\"><div class=\"sk-dot1\"></div><div class=\"sk-dot2\"></div></div></div><div ng-switch-default=\"\" class=\"default-logo\"><img src=\"../../assets/images/Logos-ConnectSx.svg\"></div></div><p class=\"text-center\">The future of medical device inventory<br>and information management.</p></div><div class=\"col-md-6 col-xs-12\"><ui-view></ui-view></div></div><hr><div class=\"row\"><div class=\"col-md-6 col-xs-12\">ConnectSx</div><div class=\"col-md-6 text-right col-xs-12\">&copy; 2019</div></div></div>");
$templateCache.put("app/auth/forgot.html","<h3>Forgot password</h3><p>Enter your email address and we will send you a link to reset you password.</p><div class=\"row\"><div class=\"col-lg-12\"><form class=\"m-t\" role=\"form\" name=\"form\"><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.email\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"help-block m-b-none error-block\">{{ vm.error }}</span></md-input-container><button type=\"submit\" ng-click=\"vm.resetPassword(form, vm.email)\" class=\"btn btn-outline btn-primary full-width m-b\" ng-disabled=\"vm.loading\">Reset Password</button> <span class=\"help-block m-b-none primary\">{{ vm.message }}</span></form></div></div>");
$templateCache.put("app/auth/individual.claim.html","<h3>Claim Invitation</h3><form name=\"loginForm\" role=\"form\" ng-show=\"vm.hasAccount\"><div class=\"md-block\" style=\"margin-bottom:36px;\"><a class=\"primary\" ng-click=\"vm.hasAccount = false\">Don\'t have an account?</a></div><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Password</label> <input type=\"password\" ng-model=\"vm.user.password\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"help-block m-b-none error-block\">{{ vm.error }}</span></md-input-container><button type=\"submit\" ng-click=\"vm.link(loginForm, vm.user)\" class=\"btn btn-outline btn-primary full-width m-b\" ng-disabled=\"vm.loading\">Login</button></form><form name=\"form\" role=\"form\" ng-hide=\"vm.hasAccount\"><div class=\"md-block\" style=\"margin-bottom:36px;\"><a class=\"primary\" ng-click=\"vm.hasAccount = true\">Already have an account?</a></div><md-input-container class=\"md-block\"><label>Name</label> <input type=\"text\" ng-model=\"vm.user.name\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Password</label> <input type=\"password\" ng-model=\"vm.user.password\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"help-block m-b-none error-block\">{{ vm.error }}</span></md-input-container><md-input-container class=\"md-block\"><label>Role</label><md-select required=\"\" ng-model=\"vm.user.role\" style=\"min-width: 152px;\"><md-option ng-repeat=\"option in vm.roles\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container><button type=\"submit\" ng-click=\"vm.register(form, vm.user)\" class=\"btn btn-outline btn-primary full-width m-b\" ng-disabled=\"vm.loading\">Sign Up</button></form><p class=\"text-success\" ng-show=\"vm.complete\">You have successfully accepted the invitation!</p>");
$templateCache.put("app/auth/login.html","<h3>Sign in</h3><form name=\"form\" class=\"m-t\" role=\"form\" style=\"margin-top: 45px;\"><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-disabled=\"vm.loading\"></md-input-container><md-input-container class=\"md-block\"><label>Password</label> <input type=\"password\" ng-model=\"vm.user.password\" required=\"\" ng-disabled=\"vm.loading\"> <span class=\"help-block m-b-none error-block\">{{vm.error}}</span></md-input-container><button type=\"submit\" ng-click=\"vm.login(form, vm.user)\" class=\"btn btn-outline btn-primary full-width m-b\" ng-disabled=\"vm.loading\">Login</button><p class=\"text-center\"><a ui-sref=\"auth.forgot\"><small>Forgot password?</small></a></p></form>");
$templateCache.put("app/catalog/catalog.html","<div layout=\"row\" class=\"padding-left-10-desktop\"><uib-tabset type=\"pills\"><uib-tab ng-repeat=\"tab in vm.tabs\" heading=\"{{tab.heading}}\" active=\"tab.active\" select=\"vm.onTabSelected(tab)\"></uib-tab></uib-tabset><hr style=\"margin:0;\"></div><div class=\"wrapper wrapper-content animated\"><div class=\"row\"><div class=\"col-sm-12\"><ui-view></ui-view></div></div></div>");
$templateCache.put("app/comments/comments.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px; height:600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">{{ vm.title }} Comments</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular ng-show=\"vm.loading\" ng-disabled=\"!vm.loading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div><div layout=\"column\" ng-repeat=\"comment in vm.comments\"><div layout=\"row\"><a class=\"text-primary\">{{ comment.createdByName }}</a> &nbsp; commented on {{ comment.createdDate | date:\'MM/dd/yyyy hh:mm a\' }}</div><p style=\"margin-top:8px; margin-bottom:8px;\">{{ comment.content }}</p><hr style=\"margin:0; width:100%;\"></div><div layout=\"row\" style=\"margin-top:24px;\"><md-input-container class=\"md-block\" flex=\"\"><textarea placeholder=\"Comment\" ng-model=\"vm.addContent\" max-rows=\"4\" md-maxlength=\"500\" md-select-on-focus=\"\" flex=\"\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><div flex=\"\"></div><md-progress-circular ng-show=\"vm.isAddingComment\" ng-disabled=\"!vm.isAddingComment\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"md-primary\" ng-click=\"vm.addComment(vm.addContent)\" ng-disabled=\"!vm.addContent\">Add Comment</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/directives/loading.template.html","<div layout=\"row\" flex=\"\" layout-align=\"center\"><div ng-show=\"loading\"><md-progress-circular ng-show=\"loading\" md-diameter=\"{{ diameter }}\"></md-progress-circular></div><div ng-hide=\"loading\" ng-transclude=\"\"></div></div>");
$templateCache.put("app/errors/404.html","<div class=\"wrapper wrapper-content animated\" layout-align=\"center center\"><h1>404</h1><p>The page you are looking for cannot be found.</p><p>Check the URL and try again.</p><p>If you think something is wrong let us know <a>here</a>.</p></div>");
$templateCache.put("app/directory/directory.html","<div layout=\"row\" class=\"padding-left-10-desktop\"><uib-tabset type=\"pills\"><uib-tab ng-repeat=\"tab in vm.tabs\" heading=\"{{tab.heading}}\" active=\"tab.active\" tabindex=\"-1\" ng-click=\"vm.onTabSelected(tab)\"></uib-tab></uib-tabset><hr style=\"margin:0 0 20px;\"></div><div class=\"animated padding-left-10-desktop\"><ui-view></ui-view></div>");
$templateCache.put("app/home/home.html","<md-content class=\"animated\"><div ng-show=\"vm.dashboard.welcome\"><div layout=\"row\" layout-align=\"center\"><div class=\"onboarding-heading\"><h1>Welcome to ConnectSx</h1></div></div><div layout=\"row\"><div class=\"col-md-6 col-md-offset-3 onboarding-box\"><h2>Get Started</h2><div class=\"row\"><div class=\"col-xs-2\"><a ui-sref=\"index.onboarding.users\"><i class=\"fa fa-users\"></i></a></div><div class=\"col-xs-10\"><h4><a ui-sref=\"index.onboarding.users\">Invite Users</a></h4><p>Invite sales or manufacturer users to your account. Sales users are reps out in the field with your inventory. Manufacturer users administer this account from the console.</p><p>If you want to assign custody to inventory as you import it into ConnectSx you will need to add sales users first.</p></div></div><div class=\"row\"><div class=\"col-xs-2\"><a ui-sref=\"index.onboarding.inventory\"><i class=\"fa fa-barcode\"></i></a></div><div class=\"col-xs-10\"><h4><a ui-sref=\"index.onboarding.inventory\">Import Inventory</a></h4><p>Import inventory by uploading a CSV file here in the console. If you have a lot of inventory to manage you should look into integrating with our Api.</p></div></div></div></div><div layout=\"row\" style=\"margin-bottom:48px;\"><div class=\"col-md-6 col-md-offset-3 onboarding-box\"><h2>Need Help?</h2><div class=\"row\"><div class=\"col-xs-2\"><a href=\"#\"><i class=\"fa fa-comment\"></i></a></div><div class=\"col-xs-10\"><h4><a href=\"#\">Messaging</a></h4><p>If you have any questions or feedback click on the chat bubble at the bottom right of your screen. This should appear on any page in the console and it\'s the quickest way for us to help.</p></div></div><div class=\"row\"><div class=\"col-xs-2\"><a href=\"#\"><i class=\"fa fa-phone\"></i></a></div><div class=\"col-xs-10\"><h4><a href=\"#\">Phone Call</a></h4><p>We are also happy to field any questions you have over the phone while you are getting up-to-speed.</p></div></div><div class=\"row\"><div class=\"col-xs-2\"><a href=\"https://www.connectsx.com/knowledge-base/\"><i class=\"fa fa-file-text\"></i></a></div><div class=\"col-xs-10\"><h4><a href=\"https://www.connectsx.com/knowledge-base/\">Read Documentation</a></h4><p>We have extensive documentation for all of our products in our knowledge base. Check it out!</p></div></div></div></div></div><div ng-hide=\"vm.dashboard.welcome\"><div layout=\"row\" flex=\"\"><md-card flex=\"\" style=\"box-shadow: none; margin-top: 30px;\"><b class=\"md-headline title\">Requests | Transfers</b><div layout-padding=\"\" style=\"padding-left:18px;\" flex=\"\"><table class=\"table no-border mobileFriendlyTable\"><thead><tr><th>Type</th><th>Inventory</th><th>From</th><th>Date Created</th><th>Action</th></tr></thead><tbody><tr ng-hide=\"vm.requests.length > 0 || vm.transfers.length > 0\"><td>No inventory requests or custody transfers</td><td></td><td></td><td></td><td></td></tr><tr ng-repeat=\"transfer in vm.transfers\"><td>Transfer</td><td><a ng-click=\"vm.gotToInventoryPage(transfer)\">{{ transfer.description }}</a></td><td>{{ transfer.source.name }}</td><td>{{ transfer.createdDate | date: \'MM/dd/yyyy\' }}</td><td><div layout=\"row\"><button ng-click=\"vm.accept(transfer)\" class=\"btn btn-xs btn-primary accept transfer-button\" csx-loading=\"\" ng-hide=\"transfer.status !== \'Pending\'\" csx-is-loading=\"vm.loading[transfer.key].accepting || false\">Accept</button> <button ng-click=\"vm.decline(transfer)\" ng-hide=\"transfer.status !== \'Pending\'\" class=\"btn btn-xs btn-danger decline transfer-button\" csx-loading=\"\" csx-is-loading=\"vm.loading[transfer.key].declining || false\">Decline</button> <a ng-show=\"transfer.status !== \'Pending\'\" ng-click=\"vm.show.transfer(transfer)\">View</a></div></td></tr><tr ng-repeat=\"request in vm.requests\"><td>Request</td><td>{{ request.description }}</td><td><a ui-sref=\"index.accounts.detail({ objectKey: request.source.key } )\">{{ request.sourceName }}</a></td><td>{{ request.createdDate | date: \'MM/dd/yyyy\' }}</td><td><div layout=\"row\" ng-hide=\"request.status !== \'Created\'\"><a ui-sref=\"index.requests.edit({ objectKey: request.key } )\">View</a></div></td></tr></tbody></table></div></md-card></div><div layout=\"row\" flex=\"\"><md-card flex=\"\" style=\"box-shadow: none;\"><b class=\"md-headline title\">Open Cases</b><div layout-padding=\"\" style=\"padding-left:18px;\" flex=\"\"><table class=\"table no-border mobileFriendlyTable\"><thead><tr><th>Case Name</th><th>Facility</th><th>Time</th><th>Status</th><th>Actions</th></tr></thead><tbody><tr ng-hide=\"vm.cases.length > 0 || vm.cases.length > 0\"><td>No open cases scheduled for today.</td><td></td><td></td><td></td><td></td></tr><tr ng-repeat=\"case in vm.cases\"><td>{{ case.name }}</td><td>{{ case.facilityName }}</td><td>{{ case.createdDate | date: \'MM/dd/yyyy\' }}</td><td>{{ case.status }}</td><td><a ui-sref=\"index.cases.edit({ objectKey: case.key})\">View</a></td></tr></tbody></table></div></md-card></div><div layout=\"row\" flex=\"\"><div flex=\"\"><div layout=\"row\" class=\"card-title-row\"><div class=\"md-headline\" flex=\"50\"><b class=\"title\">Inventory</b></div><div flex=\"50\"><md-button ng-click=\"vm.sendInventory()\" style=\"float: right;\" class=\"btn btn-outline btn-primary marginless hover-bg\"><i class=\"fa fa-send\"></i> Transfer</md-button></div></div><div layout=\"row\" class=\"card-title-row rowPositionBetweenSpace\"><div><div><a class=\"big-number\" ui-sref=\"index.inventory.list({ clear: \'true\' })\">{{ vm.dashboard.deviceStats.count | bigNum }}</a></div><div>Total Items</div></div><div><div><a ui-sref=\"index.inventory.list({ clear: \'true\', loose:\'true\' })\" class=\"big-number\">{{ vm.dashboard.deviceStats.loose | bigNum }}</a></div><div>Loose Items</div></div><div><div><a ui-sref=\"index.inventory.list({ clear: \'true\', nolot:\'true\' })\" class=\"big-number text-danger\">{{ vm.dashboard.deviceStats.withoutLot | bigNum }}</a></div><div>No Lot/UDI</div></div><div style=\"margin-bottom:24px;\"><a ui-sref=\"index.inventory.list({ clear: \'true\', billable:\'true\' })\" class=\"big-number csx-open\">${{ vm.dashboard.deviceStats.price | bigNum }}</a><div>Total Value</div></div></div></div></div></div><div layout=\"row\"><div style=\"height:64px;\"></div></div></md-content>");
$templateCache.put("app/inventory/inventory.html","<div layout=\"row\" class=\"padding-left-10-desktop\"><uib-tabset type=\"pills\"><uib-tab ng-repeat=\"tab in vm.tabs\" heading=\"{{tab.heading}}\" active=\"tab.active\" ng-click=\"vm.onTabSelected(tab)\"></uib-tab></uib-tabset><hr class=\"hr\"></div><div class=\"wrapper wrapper-content animated\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12 padding-left-null-desktop\"><ui-view></ui-view></div></div></div>");
$templateCache.put("app/notifications/notifications.html","<div class=\"wrapper wrapper-content animated\"><div style=\"margin-top:16px;\" layout=\"row\" class=\"margin-bottom-30\"><h2 style=\"display:inline-block;\" class=\"title\">Notification History</h2></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Notification</th><th>Message</th><th>Date Created</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"n in vm.notifications track by $index\"><td>{{ n.category }}</td><td>{{ n.message }}</td><td>{{ n.createdDate | date:\'short\' }}</td><td><div layout=\"row\"><button ng-hide=\"n.objType !== \'InsertCase\'\" class=\"btn btn-xs btn-primary notificationlink\"><a ui-sref=\"index.cases.edit({objectKey: n.objKey})\">View</a></button> <button ng-hide=\"n.objType !== \'InsertTransfer\'\" class=\"btn btn-xs btn-primary notificationlink\"><a ui-sref=\"index.transfers.detail({objectKey: n.objKey})\">View</a></button> <button ng-hide=\"n.objType !== \'UpdateInventory\'\" class=\"btn btn-xs btn-primary notificationlink\"><a ui-sref=\"index.inventory.edit({objectKey: n.objKey})\">View</a></button> <button ng-hide=\"n.objType !== \'FulfillRequest\'\" class=\"btn btn-xs btn-primary notificationlink\"><a ui-sref=\"index.transfers.detail({objectKey: n.objKey})\">View</a></button></div></td></tr></tbody></table></div><div class=\"row pagination\"><div class=\"col-md-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div>");
$templateCache.put("app/notifications/notifications.tmpl.html","<div class=\"menu-panel\" md-whiteframe=\"4\" aria-label=\"Select notification.\"><div class=\"notifications-toolbar\" layout-padding=\"\"><h3 style=\"margin-bottom:8px !important;\">Notifications</h3></div><md-content flex=\"\"><md-list class=\"md-dense menu-content\"><md-list-item class=\"emptynotification\" ng-hide=\"vm.notifications.length > 0\"><h4>You have no new notifications. Click \"View All\" to see more.</h4></md-list-item><md-list-item ng-hide=\"vm.notifications.length === 0\"><h4>To see more detail, click \"View All.\"</h4></md-list-item><md-list-item class=\"md-3-line\" ng-repeat=\"notification in vm.notifications\"><div class=\"md-list-item-text notificationtext notification-item\" layout=\"column\"><h3>{{ notification.category }}</h3><h4>{{ notification.message }}</h4><p>{{ notification.createdDate | date:\'short\' }}</p></div><md-divider ng-hide=\"$index === vm.notifications.length - 1\"></md-divider></md-list-item></md-list></md-content><div layout=\"row\"><hr style=\"margin:0\"><div flex=\"\"><md-button class=\"md-primary notification\" ng-click=\"vm.viewAll()\">View All</md-button></div><div flex=\"\"></div><div flex=\"\"><md-button class=\"md-primary notification\" ng-click=\"vm.close()\">Close</md-button></div></div></div>");
$templateCache.put("app/onboarding/onboarding.html","<div class=\"wrapper wrapper-content animated\"><div layout=\"row\" layout-padding=\"20px;\" style=\"padding-left:0;\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left\"></i></a></div><h2 style=\"margin-top:0;\">{{ vm.title }}</h2></div><div class=\"row\"><div class=\"col-md-12\"><ui-view></ui-view></div></div></div>");
$templateCache.put("app/settings/settings.html","<div class=\"wrapper wrapper-content animated\"><div layout=\"row\" style=\"height:5px;\"><md-progress-linear style=\"margin-top:-20px;\" ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-mode=\"indeterminate\"></md-progress-linear></div><div layout=\"row\"><div flex=\"\" style=\"margin-bottom:30px;\"><h2 class=\"title\">Settings</h2><div style=\"color:red; float: right\">{{vm.errorResetPasswordMessage}}</div></div><div style=\"margin-top:20px;\"><button class=\"btn btn-sm btn-outline btn-primary\" ng-click=\"vm.resetPassword()\">Reset password</button> <button class=\"btn btn-sm btn-outline btn-primary\" ng-click=\"vm.logout()\">Logout</button></div></div><div class=\"row\"><div class=\"col-md-12\"><uib-tabset><uib-tab ng-repeat=\"tab in vm.tabs\" heading=\"{{tab.heading}}\" active=\"tab.active\" select=\"vm.onTabSelected(tab)\"></uib-tab></uib-tabset><ui-view></ui-view></div></div></div>");
$templateCache.put("app/accounts/detail/account.detail.html","<div class=\"wrapper wrapper-content animated\"><div class=\"row margin-bottom-40\" style=\"padding-top: 30px\"><div class=\"col-lg-12\"><div layout=\"row\" class=\"layout-row margin-40-desktop\"><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a><div style=\"padding-left:20px;\" flex=\"\" class=\"flex\"><h2 class=\"title\" style=\"margin-top:0;\">{{ vm.account.name }}</h2></div></div></div></div><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Updated By</p><p class=\"text\">{{ vm.account.modifiedByName }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Last Updated</p><p class=\"text\">{{ vm.account.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Account Type</p><p class=\"text\">{{ vm.account.accountType }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title\">Email</p><p class=\"text\">{{ vm.account.email }}</p></div></div><div class=\"row margin-bottom-40\"><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Created By</p><p class=\"text\">{{ vm.account.createdByName }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Created</p><p class=\"text\">{{ vm.account.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Phone</p><p class=\"text\">{{ vm.account.phone || \'Not set\'}}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"detail-field-title subSubTitle\">Role</p><p class=\"text\">{{ vm.account.role || \'Not set\'}}</p></div></div><div class=\"row\" ng-show=\"vm.account.accountType === \'Individual\'\"><div class=\"col-md-3 col-xs-12\"><h4 class=\"subTitle\">Manufacturers</h4><div ng-repeat=\"manufacturer in vm.account.manufacturers\"><p>{{ manufacturer.name }} <a ng-click=\"vm.removeManufacturer(manufacturer.key)\" class=\"text-danger\">Remove</a></p></div></div><div class=\"col-md-3 col-xs-12\"><h4 class=\"subTitle\">Add Manufacturer</h4><div ng-repeat=\"manufacturer in vm.manufacturers\"><a class=\"primary margin-bottom-5\" ng-click=\"vm.addManufacturer(manufacturer.key)\">{{ manufacturer.name }}</a></div><p ng-hide=\"vm.manufacturers.length > 0\">No manufacturers to add.</p></div></div></div>");
$templateCache.put("app/cases/bom/case.bom.html","<div class=\"wrapper wrapper-content animated cases-edit\"><div layout=\"row\" style=\"margin-top:10px;\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\">Device Usage Ticket</h2></div><div><button ng-show=\"vm.caseObject.status !== \'Closed\'\" ng-click=\"vm.submit()\" csx-loading=\"\" csx-is-loading=\"vm.isSubmitting\" class=\"btn btn-outline btn-default create pull-right margin-right-20\"><i class=\"fa fa-checkmark\"></i> Submit for Billing</button></div><div><button ng-click=\"vm.getDutUrl()\" csx-loading=\"\" csx-is-loading=\"vm.isGenerating\" class=\"btn btn-outline btn-default create pull-right margin-right-20\"><i class=\"fa fa-checkmark\"></i> View PDF</button></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-4\"><h3>Search</h3><p class=\"detail-field-title\">&nbsp;</p><md-input-container md-no-float=\"\" class=\"md-block\"><input ng-model=\"vm.deviceSearch\" type=\"text\" placeholder=\"Filter Devices\"></md-input-container></div><div class=\"col-md-3\"><h3><i class=\"fa fa-bar-chart\"></i> Device Status</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-3\"><p class=\"detail-field-title\">Used</p><p>{{ vm.usedDeviceCount || \'--\' }}</p></div><div class=\"col-sm-3\"><p class=\"detail-field-title\">Implanted</p><p>{{ vm.implantedDeviceCount || \'--\' }}</p></div><div class=\"col-sm-3\"><p class=\"detail-field-title\">Damaged</p><p>{{ vm.damagedDeviceCount || \'--\' }}</p></div><div class=\"col-sm-3\"><p class=\"detail-field-title\">Other</p><p>{{ vm.otherDeviceCount || \'--\' }}</p></div></div></div></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=\"row\"><div class=\"col-sm-6\"><p class=\"detail-field-title\">Patient</p><p>{{ vm.caseObject.patientName }}</p></div><div class=\"col-sm-6\"><p class=\"detail-field-title\">DOB</p><p>{{ vm.caseObject.patientDateOfBirth | date:\'MM/dd/yyyy\' }}</p></div><div class=\"col-sm-6\"><p class=\"detail-field-title\">Health Record Id</p><p>{{ vm.caseObject.patientRecordId }}</p></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th>Reference #</th><th>UDI</th><th>Description</th><th>Status</th><th>Billable</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices | filter:vm.deviceSearch\"><td><a ng-click=\"vm.show.device(device)\">{{ device.referenceNumber }}</a></td><td>{{ device.udi.lotNumber || device.udi.raw }}<csx-washer class=\"pull-right\" ng-show=\"device.udi.washer\" washer=\"device.udi.washer\" size=\"list\"></csx-washer></td><td>{{ device.deviceName }}</td><td>{{ device.deviceStatus }}</td><td>{{ device.billable ? \'Yes\' : \'No\' }}</td></tr></tbody></table></div></div><div class=\"row\" ng-hide=\"vm.devices.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>No devices have been recorded as Used, Implanted, or Damaged.</h3><h3>If you believe this is an error please refresh the page or contact your administrator.</h3></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div ng-show=\"vm.caseObject.signatureName\" class=\"signature\"><h4>Case Submitted and Signed by:</h4><h5>Sales Representative</h5><h6>{{ vm.caseObject.signatureName }}</h6><img ng-show=\"vm.caseObject.signatureUrl\" ng-src=\"{{ vm.caseObject.signatureUrl }}\"></div></div><div class=\"col-sm-3\"><div ng-show=\"vm.caseObject.hospitalSignatureName\" class=\"signature\"><h4>&nbsp;</h4><h5>Authorize Provider</h5><h6>{{ vm.caseObject.hospitalSignatureName }}</h6><img ng-show=\"vm.caseObject.hospitalSignatureUrl\" ng-src=\"{{ vm.caseObject.hospitalSignatureUrl }}\"></div></div></div></div>");
$templateCache.put("app/cases/create/case.create.html","<div class=\"wrapper wrapper-content animated cases-edit\"><div layout=\"row\" style=\"margin-bottom:30px; margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\"><h2 style=\"margin-top:0;\" class=\"title\">New Case</h2></div></div><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h3 class=\"subTitle\">Case Details</h3><div class=\"row\"><div class=\"col-sm-4 col-xs-12 mobPaddingNull\"><md-autocomplete class=\"big-fontSize placeholder\" ng-disabled=\"vm.loading\" md-no-cache=\"true\" md-selected-item=\"vm.caseObject.account\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectAccount(account)\" md-items=\"account in vm.accounts | filter:vm.searchText\" md-item-text=\"account.name + \' (\' + account.email + \')\'\" md-min-length=\"0\" required=\"true\" md-floating-label=\"Sales Representative\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{ account.name }} ({{ account.email }})</span></md-item-template><md-not-found>No accounts matching \"{{ vm.searchText }}\" were found.</md-not-found></md-autocomplete></div><div class=\"col-sm-4 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><label>Case Name</label> <input ng-model=\"vm.caseObject.name\" required=\"\"></md-input-container></div></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"spaceBetween spaceBetween-align\"><h3 class=\"subTitle\">Procedure</h3><div class=\"addNewButton\"><a ng-click=\"vm.createProcedure()\" class=\"primary\">Add New Procedure</a></div></div></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12 mobPaddingNull\"><md-autocomplete class=\"big-fontSize placeholder mdline-position\" md-selected-item=\"vm.caseObject.procedure\" md-search-text=\"vm.procedureSearchText\" md-selected-item-change=\"vm.selectProcedure(item)\" md-items=\"item in vm.searchProcedures(vm.procedureSearchText)\" md-item-text=\"item.name\" md-floating-label=\"Procedure\" placeholder=\"Procedure\" md-min-length=\"0\" required=\"\"><md-item-template><span md-highlight-text=\"vm.procedureSearchText\" md-highlight-flags=\"^i\">{{item.name}} {{ item.location }}</span></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div><div class=\"col-sm-8 col-xs-12 mobPaddingNull\" layout=\"row\"><div class=\"row\" style=\"width: 100%;\"><div class=\"col-sm-6 col-xs-12 mobPaddingNull\"><md-input-container style=\"width: 100%;\" class=\"datePicker\"><label>Date</label><md-datepicker class=\"big-fontSize datePicker placeholder\" ng-model=\"vm.caseObject.procedureDate\" md-placeholder=\"Select Date\" md-hide-icons=\"calendar\"></md-datepicker></md-input-container></div><div class=\"col-sm-6 col-xs-12 placeholder mobPaddingNull\"><md-input-container style=\"width: 100%;\"><label for=\"time\">Time</label> <input class=\"big-fontSize\" type=\"time\" id=\"time\" ng-model=\"vm.caseObject.procedureTime\" placeholder=\"Select Time\" required=\"\"></md-input-container></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><div class=\"spaceBetween spaceBetween-align\"><h3 class=\"subTitle\">Physician</h3><div class=\"addNewButton\"><a ng-click=\"vm.createPhysician()\" class=\"primary\">Add New Physician</a></div></div><div class=\"form-group\"><md-autocomplete class=\"big-fontSize placeholder mdline-position\" md-selected-item=\"vm.caseObject.physician\" md-search-text=\"vm.physicianSearchText\" md-selected-item-change=\"vm.selectPhysician(item)\" md-items=\"item in vm.searchPhysicians(vm.physicianSearchText)\" md-item-text=\"item.name\" md-floating-label=\"Physician\" md-min-length=\"0\" placeholder=\"Physician name\" required=\"\"><md-item-template><span md-highlight-text=\"vm.physicianSearchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div></div><div class=\"col-sm-4 col-xs-12\"><div class=\"spaceBetween spaceBetween-align\"><h3 class=\"subTitle\">Facility</h3><div class=\"addNewButton\"><a ng-click=\"vm.createFacility()\" class=\"primary\">Add New Facility</a></div></div><div class=\"form-group\"><md-autocomplete class=\"big-fontSize placeholder mdline-position\" md-selected-item=\"vm.caseObject.facility\" md-search-text=\"vm.facilitySearchText\" md-selected-item-change=\"vm.selectFacility(item)\" md-items=\"item in vm.searchFacilities(vm.facilitySearchText)\" md-item-text=\"item.name\" md-floating-label=\"Facility title\" md-min-length=\"0\" placeholder=\"Facility\" required=\"\"><md-item-template><span md-highlight-text=\"vm.facilitySearchText\" md-highlight-flags=\"^i\">{{ item.name }}</span></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Manufacturer</h3><div class=\"form-group\" layout=\"row\"><md-input-container flex=\"\"><label>Manufacturer</label><md-select class=\"big-fontSize\" ng-model=\"vm.caseObject.manufacturer\" md-selected-text=\"vm.caseObject.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Product</h3><div class=\"form-group\"><md-autocomplete class=\"big-fontSize placeholder mdline-position\" md-selected-item=\"vm.caseObject.product\" md-search-text=\"vm.productSearchText\" md-items=\"product in vm.searchProducts(vm.productSearchText)\" md-item-text=\"product.name\" md-no-cache=\"true\" md-floating-label=\"Product title\" md-min-length=\"0\" placeholder=\"Product\"><md-item-template><span md-highlight-text=\"vm.productSearchText\" md-highlight-flags=\"^i\">{{ product.name }}</span></md-item-template><md-not-found>No products matching \"{{ vm.productSearchText }}\" were found.</md-not-found></md-autocomplete></div></div></div><div class=\"row labelStyle\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Patient</h3><div class=\"\"><md-input-container class=\"md-block placeholder\"><label>Health Record ID</label><input class=\"big-fontSize\" ng-model=\"vm.caseObject.patientRecordId\"></md-input-container></div></div></div><div class=\"row flex-end\"><div class=\"col-sm-1\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div><div class=\"col-sm-2 col-xs-12\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create float-right\"><i class=\"fa fa-check\"></i> Create</button></div></div></div><div style=\"height:50px;\"></div>");
$templateCache.put("app/cases/edit/case.edit.html","<div class=\"wrapper wrapper-content animated cases-edit\"><div layout=\"row\" style=\"margin-bottom:30px; margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.caseObject.name }}</h2><div style=\"padding-bottom:8px;\" ng-class=\"vm.statusClass(vm.caseObject.status)\" class=\"csx-status\">{{ vm.caseObject.status | uppercase }}</div><p ng-if=\"vm.caseObject.poNumber && !vm.poManufacture.length\">PO #: {{ vm.caseObject.poNumber }}</p><p ng-show=\"vm.poManufacture.length\"></p><p ng-repeat=\"num in vm.poManufacture\">{{num.name}} - PO #: {{ num.poNumber }}</p><p></p></div><div><button ng-hide=\"vm.caseObject.status !== \'Closed\'\" ng-click=\"vm.addPONumber($event)\" style=\"margin-right:16px;\" csx-loading=\"\" csx-is-loading=\"vm.isCompleting\" class=\"btn btn-outline btn-default create margin-right-20\">Add PO Number</button> <button ng-hide=\"!vm.hasDut(vm.caseObject)\" ng-click=\"vm.getDutUrl()\" style=\"margin-right:16px;\" csx-loading=\"\" csx-is-loading=\"vm.isGenerating\" class=\"btn btn-outline btn-default create margin-right-20\">View Device Usage Ticket (PDF)</button> <button ng-hide=\"vm.caseObject.status !== \'Open\' || !vm.caseObject.hasUsedInventory\" ng-click=\"vm.submit()\" csx-loading=\"\" csx-is-loading=\"vm.isSubmitting\" style=\"margin-right:16px;\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-checkmark\"></i> Submit For Billing</button> <button ng-hide=\"vm.caseObject.status !== \'Open\'\" ng-click=\"vm.markUsedInventory()\" style=\"margin-right:16px;\" class=\"btn btn-outline btn-primary create\">Mark Used Inventory</button> <button csx-loading=\"\" csx-is-loading=\"vm.isReopening\" ng-show=\"vm.caseObject.status !== \'Open\'\" ng-click=\"vm.reopen()\" style=\"margin-right:16px;\" class=\"btn btn-outline btn-primary create\">Reopen</button> <button ng-show=\"vm.caseObject.status === \'Open\'\" csx-loading=\"\" csx-is-loading=\"vm.isLoading\" ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create pull-right\"><i class=\"fa fa-check\"></i> Save</button></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><uib-tabset active=\"activeJustified\"><uib-tab index=\"0\" heading=\"Details\"><p class=\"required-notice\">All fields below required.</p><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Assigned to:</label> <input ng-disabled=\"true\" ng-model=\"vm.caseObject.account.name\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Case Name</label> <input ng-disabled=\"vm.caseObject.status !== \'Open\'\" ng-model=\"vm.caseObject.name\" required=\"\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\" layout=\"row\" layout-align=\"start\" flex=\"\"><md-input-container flex=\"100\" class=\"placeholder big-fontSize\"><label>Manufacturer</label> <input ng-model=\"vm.caseObject.manufacturer.name\" disabled=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"titleIconWrap\"><h3 class=\"subTitle\">Procedure</h3><a ng-click=\"vm.createProcedure()\" class=\"primary\">Add New Procedure</a></div><md-autocomplete style=\"margin-bottom:0;\" class=\"placeholder big-fontSize mdline-position\" ng-disabled=\"vm.caseObject.status !== \'Open\'\" md-selected-item=\"vm.caseObject.procedure\" md-search-text=\"vm.procedureSearchText\" md-selected-item-change=\"vm.selectProcedure(item)\" md-items=\"item in vm.searchProcedures(vm.procedureSearchText)\" md-item-text=\"item.name\" md-floating-label=\"Procedure\" md-min-length=\"0\" placeholder=\"Procedure\" required=\"\"><md-item-template><span md-highlight-text=\"vm.procedureSearchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div><div class=\"col-md-4 col-xs-12\"><h3 style=\"min-height: 25px;\">&nbsp;</h3><md-input-container class=\"placeholder big-fontSize full-width\"><label>Date</label><md-datepicker ng-disabled=\"vm.caseObject.status !== \'Open\'\" ng-model=\"vm.caseObject.procedureDate\" md-placeholder=\"Date\" class=\"datePicker\" md-hide-icons=\"calendar\" md-open-on-focus=\"\"></md-datepicker></md-input-container></div><div class=\"col-md-2 col-xs-12\"><h3 style=\"min-height: 25px;\">&nbsp;</h3><md-input-container class=\"placeholder big-fontSize full-width\"><label for=\"time\">Time</label> <input type=\"time\" id=\"time\" ng-model=\"vm.caseObject.procedureTime\" placeholder=\"hh:mm a\" class=\"md-input\" ng-disabled=\"vm.caseObject.status !== \'Open\'\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"titleIconWrap\"><h3 class=\"subTitle\">Physician</h3><a ng-click=\"vm.createPhysician()\" class=\"primary\">Add New Physician</a></div><div class=\"form-group\"><md-autocomplete class=\"placeholder big-fontSize mdline-position\" ng-disabled=\"vm.caseObject.status !== \'Open\'\" md-selected-item=\"vm.caseObject.physician\" md-search-text=\"vm.physicianSearchText\" md-selected-item-change=\"vm.selectPhysician(item)\" md-items=\"item in vm.searchPhysicians(vm.physicianSearchText)\" md-item-text=\"vm.physicianDisplayName(item)\" md-floating-label=\"Physician\" md-min-length=\"0\" placeholder=\"Physician\" required=\"\"><md-item-template><span md-highlight-text=\"vm.physicianSearchText\" md-highlight-flags=\"^i\">{{ vm.physicianDisplayName(item) }}</span></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"titleIconWrap\"><h3 class=\"subTitle\">Facility</h3><a ng-click=\"vm.createFacility()\" class=\"primary\">Add New Facility</a></div><div class=\"form-group\"><md-autocomplete class=\"placeholder big-fontSize mdline-position\" ng-disabled=\"vm.caseObject.status !== \'Open\'\" md-selected-item=\"vm.caseObject.facility\" md-search-text=\"vm.facilitySearchText\" md-selected-item-change=\"vm.selectFacility(item)\" md-items=\"item in vm.searchFacilities(vm.facilitySearchText)\" md-item-text=\"item.name\" md-floating-label=\"Facility\" md-min-length=\"0\" placeholder=\"Facility\" required=\"\"><md-item-template><span md-highlight-text=\"vm.facilitySearchText\" md-highlight-flags=\"^i\">{{ item.name }}</span></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Patient</h3><md-input-container class=\"md-block placeholder big-fontSize\"><label>Health Record ID</label> <input ng-disabled=\"vm.caseObject.status !== \'Open\'\" ng-model=\"vm.caseObject.patientRecordId\"></md-input-container></div></div><div class=\"row margin-bottom-40\"><div class=\"col-sm-12 col-xs-12\"><div class=\"notes caseNotes\"><h3 class=\"subTitle\">Notes</h3><blockquote ng-repeat=\"note in vm.notes\"><small>{{note.modifiedDate}}</small> <small>{{note.modifiedByName}}</small><br><p>{{note.content}}</p></blockquote><p ng-if=\"!vm.notes.length\">No notes</p></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Device Usage Ticket\"><div class=\"row\"><div class=\"col-sm-5\"><h3 class=\"subTitle\">Devices</h3><p class=\"detail-field-title\">&nbsp;</p><md-input-container md-no-float=\"\" class=\"md-block placeholder big-fontSize\"><input ng-model=\"vm.deviceSearch\" placeholder=\"Filter Devices\"></md-input-container></div><div class=\"col-sm-6\"><h3 class=\"subTitle\">Device Status</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-2\"><p class=\"detail-field-title\">Used</p><p>{{ vm.counts.Used || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Implanted</p><p>{{ vm.counts.Implanted || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">In/Out</p><p>{{ vm.counts.Explanted || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Damaged</p><p>{{ vm.counts.Damaged || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Missing</p><p>{{ vm.counts.Missing || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Other</p><p>{{ vm.counts.Other || \'--\' }}</p></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><table class=\"table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Type</th><th>Name</th><th>Reference #</th><th>Lot/UDI</th><th>Tags</th><th>Status</th><th>Single Use</th><th>Quantity</th><th>Unit Price</th><th>Amount</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices | filter:vm.deviceSearch\"><td>{{ device.type }}</td><td><a ng-click=\"vm.viewDevice(device.key)\">{{ device.name }}</a></td><td>{{ device.reference }}</td><td>{{ device.udi.lot || device.udi.raw }}</td><td ng-class=\"(device.expirationStatus === \'Expired\' || device.expirationStatus === \'ExpiringSoon\' || device.tags.length > 0) ? \'\' : \'unassigned\'\"><span ng-show=\"device.expirationStatus === \'Expired\'\" class=\"csx-tag csx-error\">EXPIRED</span> <span ng-show=\"device.expirationStatus === \'ExpiringSoon\'\" class=\"csx-tag csx-warn\">EXPIRING SOON</span> <span ng-show=\"device.images.length > 0\" class=\"csx-tag\" style=\"color:white; background-color: #5B2D61;\"><i class=\"fa fa-image\"></i></span> <span ng-repeat=\"tag in device.tags track by $index\" class=\"csx-tag\">{{ tag }}</span></td><td><md-select aria-label=\"device.referenceNumber\" style=\"margin-top:-6px; margin-bottom:-2px;\" ng-model=\"device.status\" ng-change=\"vm.updateStatus(device)\" ng-disabled=\"vm.caseObject.status !== \'Open\'\" class=\"md-no-underline\"><md-option ng-value=\"status\" ng-repeat=\"status in vm.deviceStatuses\"><span ng-if=\"status === \'Explanted\'\">In/Out</span> <span ng-if=\"status !== \'Explanted\'\">{{ status }}</span></md-option></md-select></td><td><md-select aria-label=\"Device Single Use\" style=\"margin-top:-6px; margin-bottom:-2px;\" ng-model=\"device.reusable\" ng-change=\"vm.updateDevice(device)\" ng-disabled=\"vm.caseObject.status !== \'Open\'\" class=\"md-no-underline\"><md-option ng-value=\"!v\" ng-repeat=\"v in [true, false]\">{{ v ? \'Yes\' : \'No\' }}</md-option></md-select></td><td>1</td><td>{{ device.price | currency }}<md-menu ng-show=\"vm.caseObject.status === \'Open\'\" ng-if=\"device.originPrice\"><a class=\"pull-right\" ng-click=\"$mdMenu.open($event)\"><i class=\"fa fa-pencil\"></i></a><md-menu-content><md-menu-item layout=\"row\"><md-input-container><input type=\"number\" ng-model=\"device.price\"></md-input-container><a class=\"primary\" ng-click=\"vm.updateDevice(device)\">Save</a></md-menu-item></md-menu-content></md-menu></td><td>{{ device.price | currency }}</td><td>{{ device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-sm-12\" layout=\"row\" layout-align=\"center\"><md-progress-circular ng-show=\"vm.isInventoryLoading\" md-diameter=\"20\"></md-progress-circular></div></div><div class=\"row\" ng-hide=\"!vm.isInventoryLoading && vm.devices.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>No inventory is has been used in this case.</h3></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/cases/detail/case.detail.html","<div class=\"wrapper wrapper-content animated case-detail\" ng-cloak=\"\"><div layout=\"row\" layout-padding=\"20px;\" style=\"padding-left:0;\"><div style=\"padding-left:0;\"><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left\"></i></a></div><div flex=\"\"><h2 style=\"margin:0;\">{{ vm.caseObject.name }}</h2><div style=\"padding-top:8px; padding-bottom:8px;\" ng-class=\"vm.statusClass(vm.caseObject.status)\" class=\"csx-status\">{{ vm.caseObject.status | uppercase }}</div></div></div><hr><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-2\"><p class=\"detail-field-title\">Updated By</p><p>{{ vm.caseObject.modifiedByName }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Last Updated</p><p>{{ vm.caseObject.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row\"><div class=\"col-sm-2\"><p class=\"detail-field-title\">Created By</p><p>{{ vm.caseObject.createdByName }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Created</p><p>{{ vm.caseObject.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Health Record Id</p><p>{{ vm.caseObject.patientRecordId || \'Not set\'}}</p></div></div><div class=\"row\"><div class=\"col-md-12\"><hr></div></div><div class=\"row\"><div class=\"col-sm-4\"><h3><i class=\"fa fa-calendar-check-o\"></i> Procedure</h3><div class=\"row\"><div class=\"col-sm-12\"><p class=\"detail-field-title\">Name</p><p>{{ vm.caseObject.procedure.name }} {{ vm.caseObject.procedure.location }}</p></div></div><div class=\"row\"><div class=\"col-sm-6\"><p class=\"detail-field-title\">Date</p><p>{{ vm.caseObject.procedureDate | date:\'MM/dd/yyyy\' }}</p></div><div class=\"col-sm-6\"><p class=\"detail-field-title\">Time</p><p>{{ vm.caseObject.procedureTime | date:\'h:mm a\' }}</p></div></div></div><div class=\"col-sm-4\"><h3><i class=\"fa fa-building\"></i> Facility</h3><div class=\"row\"><div class=\"col-sm-12\"><p class=\"detail-field-title\">Name</p><p><a ui-sref=\"index.facilities.detail({ objectKey: vm.caseObject.facility.key })\">{{ vm.caseObject.facility.name }}</a></p></div></div></div><div class=\"col-sm-4\"><h3><i class=\"fa fa-user-md\"></i> Physician</h3><div class=\"row\"><div class=\"col-sm-12\"><p class=\"detail-field-title\">Name</p><p><a ui-sref=\"index.physicians.detail({ objectKey: vm.caseObject.physician.key })\">{{ vm.caseObject.physician.name }}</a></p></div></div></div><div class=\"col-sm-12\"><hr></div></div><div class=\"row\"><div class=\"col-sm-6\"><h3><i class=\"fa fa-truck\"></i> Tracking</h3><div class=\"row\"><div class=\"col-sm-4\"><p class=\"detail-field-title\">Carrier</p><p>{{ vm.caseObject.tracking.carrierName || \'Unspecified\'}}</p></div><div class=\"col-sm-4\" ng-show=\"vm.caseObject.tracking.number\"><p class=\"detail-field-title\">Tracking</p><p>{{ vm.caseObject.tracking.number }}</p></div></div><div class=\"row\"><div class=\"col-sm-4\" ng-show=\"vm.caseObject.tracking.status\"><p class=\"detail-field-title\">Status</p><p>{{ vm.caseObject.tracking.status }}</p></div></div></div><div class=\"col-sm-6\"><h3><i class=\"fa fa-history\"></i> History</h3><table class=\"table\"><thead><tr><th>Description</th><th>Date</th></tr></thead><tbody><tr><td>Created by {{ vm.caseObject.createdByName }}</td><td>{{ vm.caseObject.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr><tr><td>Modified by {{ vm.caseObject.modifiedByName }}</td><td>{{ vm.caseObject.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div><div class=\"col-sm-12\"><hr></div></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><h3>Devices</h3><p class=\"detail-field-title\">&nbsp;</p><md-input-container md-no-float=\"\" class=\"md-block\"><input ng-model=\"vm.deviceSearch\" placeholder=\"Filter Devices\"></md-input-container></div><div class=\"col-sm-6\"><h3><i class=\"fa fa-bar-chart\"></i> Device Status</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-2\"><p class=\"detail-field-title\">Used</p><p>{{ vm.counts[\'Used\'] || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Implanted</p><p>{{ vm.counts[\'Implanted\'] || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Explanted</p><p>{{ vm.counts[\'Explanted\'] || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Damaged</p><p>{{ vm.counts[\'Damaged\'] || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Unused</p><p>{{ vm.counts[\'Unused\'] || \'--\' }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Other</p><p>{{ vm.counts[\'Other\'] || \'--\' }}</p></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Type</th><th>Name</th><th>Reference #</th><th>Tags</th><th>Lot/UDI</th><th>Status</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices | filter:vm.deviceSearch\"><td>{{ device.type }}</td><td><a ng-click=\"vm.viewDevice(device.key)\">{{ device.name }}</a></td><td>{{ device.reference }}</td><td>{{ device.udi.lot || device.udi.raw }}</td><td ng-class=\"(device.expirationStatus === \'Expired\' || device.expirationStatus === \'ExpiringSoon\' || device.tags.length > 0) ? \'\' : \'unassigned\'\"><span ng-show=\"device.expirationStatus === \'Expired\'\" class=\"csx-tag csx-error\">EXPIRED</span> <span ng-show=\"device.expirationStatus === \'ExpiringSoon\'\" class=\"csx-tag csx-warn\">EXPIRING SOON</span> <span ng-show=\"device.images.length > 0\" class=\"csx-tag\" style=\"color:white; background-color: #5B2D61;\"><i class=\"fa fa-image\"></i></span> <span ng-repeat=\"tag in device.tags track by $index\" class=\"csx-tag\">{{ tag }}</span></td><td>{{ device.status }}</td><td>{{ device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-sm-12\" layout=\"row\" layout-align=\"center\"><md-progress-circular ng-show=\"vm.isInventoryLoading\" md-diameter=\"20\"></md-progress-circular></div></div><div class=\"row\" ng-hide=\"!vm.isInventoryLoading && vm.devices.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>No inventory is has been used in this case.</h3></div></div></div><div class=\"row\" style=\"margin-bottom:40px;\"></div>");
$templateCache.put("app/cases/inventory/case.inventory.html","<div class=\"wrapper wrapper-content animated cases-edit\"><div layout=\"row\" style=\"margin-bottom:30px; margin-top:10px;\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\">Inventory</h2></div></div><div class=\"row\"><div class=\"col-md-12\"><hr></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-5\"><h3>Search</h3><p class=\"detail-field-title\">&nbsp;</p><md-input-container md-no-float=\"\" class=\"md-block\"><input ng-model=\"vm.deviceSearch\" type=\"text\" placeholder=\"Filter Devices\"></md-input-container></div><div class=\"col-md-3\"><h3><i class=\"fa fa-tag\"></i> UDI</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-4\"><p class=\"detail-field-title\">Assigned</p><p>{{ vm.assignedLotCount || \'--\' }}</p></div><div class=\"col-sm-6\"><p class=\"detail-field-title\">Unassigned</p><p>{{ vm.unassignedLotCount || \'--\' }}</p></div></div></div></div></div><div class=\"col-md-3\"><h3><i class=\"fa fa-bar-chart\"></i> Device Status</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-4\"><p class=\"detail-field-title\">Unused</p><p>{{ (vm.devices | filter:{ deviceStatus:\'Unused\' } : true).length || \'--\' }}</p></div><div class=\"col-sm-4\"><p class=\"detail-field-title\">Used</p><p>{{ (vm.devices | filter:{ deviceStatus:\'Used\' } : true).length || \'--\' }}</p></div><div class=\"col-sm-4\"><p class=\"detail-field-title\">Other</p><p>{{ (vm.devices | filter:vm.filterOtherStatuses).length || \'--\' }}</p></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th>Device Name</th><th>Reference #</th><th>UDI</th><th>Status</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices | filter:vm.deviceSearch\"><td><a ng-click=\"vm.show.device(device.key)\">{{ device.deviceName }}</a></td><td>{{ device.referenceNumber }}</td><td>{{ device.udi.lotNumber || device.udi.raw }}<csx-washer class=\"pull-right\" ng-show=\"device.udi.washer\" washer=\"device.udi.washer\" size=\"list\"></csx-washer></td><td><md-select aria-label=\"device.referenceNumber\" style=\"margin-top:-6px; margin-bottom:-2px;\" ng-model=\"device.deviceStatus\" ng-change=\"vm.updateStatus(device)\" class=\"md-no-underline\" md-on=\"\"><md-option ng-value=\"status\" ng-repeat=\"status in vm.statuses\"><span ng-if=\"status === \'Explanted\'\">In/Out</span> <span ng-if=\"status !== \'Explanted\'\">{{ status }}</span></md-option></md-select></td><td>{{ device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-hide=\"vm.devices.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>There appears to be no inventory assigned to this case.</h3><h3>To assign inventory <a ng-click=\"vm.show.showCase(vm.caseKey)\">edit the case here</a>.</h3></div></div></div>");
$templateCache.put("app/cases/inventory/mark.inventory.tmpl.html","<md-dialog aria-label=\"Initiate Transfer\" style=\"min-width: 500px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Mark Used Inventory</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content class=\"bottom-linear-40\"><div class=\"md-dialog-content\"><div layout=\"row\"><h3><i class=\"fa fa-barcode\"></i>&nbsp; Inventory</h3></div><div layout=\"row\"><md-autocomplete flex=\"\" ng-disabled=\"vm.loading\" md-no-cache=\"true\" md-clear-button=\"true\" md-search-text=\"vm.containerSearchText\" md-selected-item=\"vm.selectedContainer\" md-items=\"item in vm.searchContainers(vm.containerSearchText)\" md-item-text=\"item.name\" md-min-length=\"1\" md-dropdown-position=\"top\" md-search-text-change=\"vm.isSearchContainerTextChanged = true\" md-floating-label=\"Container\"><md-item-template><div style=\"position: relative;\"><p style=\"margin-bottom: 0; line-height: 1;\">{{item.name | limitTo: 35}}<span ng-if=\"item.name.length > 35\">...</span></p><b ng-show=\"item.custodyName\" style=\"color:#333; line-height: 1;font-size: 0.8em;margin: 10px 0 5px;display: block\">({{ item.custodyName | limitTo: 30 }}) <span ng-if=\"item.custodyName.length > 30\">...</span></b><div ng-if=\"vm.isStringLength(item.raw) && !vm.isStringLength(item.serial) && !vm.isStringLength(item.lot)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">UDI: {{item.raw | limitTo: 25}}<span ng-if=\"item.raw.length > 25\">...</span></div><div class=\"lot\" ng-show=\"!vm.isStringLength(item.serial) && vm.isStringLength(item.lot)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">Lot: {{ item.lot | limitTo: 25}} <span ng-if=\"item.lot.length > 25\">...</span></div><div class=\"lot\" ng-show=\"vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">Serial: {{ item.serial | limitTo: 25}} <span ng-if=\"item.serial.length > 25\">...</span></div><i style=\"color:#47525d; position: absolute; font-size: 0.8em; right: 0; bottom: 0;line-height: 1;\">Ref. num.: {{ item.reference | limitTo: 25}} <span ng-if=\"item.reference.length > 25\">...</span></i></div></md-item-template><md-not-found>No containers matching \"{{ vm.containerSearchText }}\" were found.</md-not-found></md-autocomplete></div><div layout=\"row\" class=\"fixLinePreloader\"><md-autocomplete flex=\"\" ng-disabled=\"vm.loading\" md-no-cache=\"true\" md-clear-button=\"true\" md-search-text=\"vm.inventorySearchText\" md-selected-item=\"vm.selectedInventory\" md-selected-item-change=\"vm.addInventory(item)\" md-items=\"item in vm.searchInventory(vm.inventorySearchText)\" md-item-text=\"item.description\" md-min-length=\"1\" md-dropdown-position=\"top\" md-menu-class=\"transfer-autocomplete\" md-search-text-change=\"vm.isSearchContainerTextChanged = true\" md-floating-label=\"Search for inventory to use for this case.\"><md-item-template><div style=\"position: relative;\"><p style=\"margin-bottom: 0; line-height: 1;\">{{item.name | limitTo: 35}}<span ng-if=\"item.name.length > 35\">...</span></p><b ng-show=\"item.custodyName\" style=\"color:#333; line-height: 1;font-size: 0.8em;margin: 10px 0 5px;display: block\">({{ item.custodyName | limitTo: 30 }}) <span ng-if=\"item.custodyName.length > 30\">...</span></b><div ng-if=\"vm.isStringLength(item.raw) && !vm.isStringLength(item.serial) && !vm.isStringLength(item.lot)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">UDI: {{item.raw | limitTo: 25}}<span ng-if=\"item.raw.length > 25\">...</span></div><div class=\"lot\" ng-show=\"!vm.isStringLength(item.serial) && vm.isStringLength(item.lot)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">Lot: {{ item.lot | limitTo: 25}} <span ng-if=\"item.lot.length > 25\">...</span></div><div class=\"lot\" ng-show=\"vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">Serial: {{ item.serial | limitTo: 25}} <span ng-if=\"item.serial.length > 25\">...</span></div><i style=\"color:#47525d; position: absolute; font-size: 0.8em; right: 0; bottom: 0;line-height: 1;\">Ref. num.: {{ item.reference | limitTo: 25}} <span ng-if=\"item.reference.length > 25\">...</span></i></div></md-item-template><md-not-found>No results matching \"{{ vm.inventorySearchText }}\" were found.</md-not-found><div ng-switch=\"vm.selectedContainer.type\"><p ng-switch-when=\"Container\">Searching inventory in {{ vm.selectedContainer.name }}.</p><p ng-switch-default=\"\">Searching loose devices.</p></div></md-autocomplete></div><div layout=\"column\"><p class=\"text-danger\">{{ vm.error }}</p><p ng-show=\"vm.inventory.length === 0\">No inventory selected.</p><div ng-repeat=\"item in vm.inventory track by item.key\"><span ng-if=\"item.description\">{{ item.description }}</span> <span ng-if=\"!item.description && item.name\">{{item.name}}</span>&nbsp;&nbsp;<div ng-show=\"item.custodyName\" style=\"font-size: 0.8em;color:#47525d;display: inline\"><br>{{ item.custodyName }}</div><br><div ng-if=\"vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d;display: inline-block\">Serial: {{ item.serial }}</div><div ng-if=\"vm.isStringLength(item.lot) && !vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d;display: inline-block\">Lot: {{ item.lot }}</div><div ng-if=\"!vm.isStringLength(item.lot) && !vm.isStringLength(item.serial) && vm.isStringLength(item.raw)\" style=\"font-size: 0.8em;color:#47525d;display: inline-block\">UDI: {{ item.raw }}</div><div ng-show=\"item.container.name\">Container: {{ item.container.name }}</div><a class=\"text-danger\" ng-click=\"vm.removeInventory(item)\"><i class=\"fa fa-trash-o\"></i></a><hr></div></div></div></md-dialog-content><md-dialog-actions style=\"border-top: 1px solid lightgrey;\"><div layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\" flex=\"\"><md-button class=\"md-error\" ng-click=\"vm.cancel()\">Cancel</md-button><div flex=\"\"></div><div csx-loading=\"\" csx-is-loading=\"vm.updateLoading\"><md-button class=\"md-primary\" ng-click=\"vm.markAndAssign()\" ng-disabled=\"vm.udpateLoading || vm.inventory.length === 0\">Mark Devices</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/cases/invoice/case.invoice.html","<div class=\"wrapper wrapper-content animated cases-edit\"><form name=\"invoiceForm\"><div layout=\"row\" style=\"margin-bottom:30px; margin-top:10px;\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-bottom:15px; margin-top:0;\">Invoice #{{ vm.invoice.number }}</h2><h4>Balance: {{ vm.amount() | currency }}</h4></div><div><button ng-click=\"vm.save()\" csx-loading=\"\" csx-is-loading=\"vm.isLoading && !vm.emailLoading\" ng-disabled=\"invoiceForm.$invalid || vm.isLoading || vm.emailLoading\" class=\"btn btn-outline btn-default create pull-right margin-right-20\"><i class=\"fa fa-check\"></i> Save Changes</button></div><div><button ng-click=\"vm.email()\" csx-loading=\"\" csx-is-loading=\"vm.emailLoading\" ng-disabled=\"invoiceForm.$invalid || vm.isLoading || vm.emailLoading\" class=\"btn btn-outline btn-default create pull-right margin-right-20\"><i class=\"fa fa-envelope\"></i> {{ vm.invoice.sent ? \'Resend Email Invoice\' : \'Email Invoice\' }}</button></div></div><div class=\"row ibox-title\"><div class=\"col-sm-12\"><hr></div></div><div class=\"row\"><div class=\"col-sm-6\"><h3><i class=\"fa fa-pencil\"></i> Details</h3><div class=\"row\"><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex=\"100\"><label>Invoice #</label> <input ng-model=\"vm.invoice.number\" required=\"\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex=\"100\"><input time=\"false\" date=\"true\" mdc-datetime-picker=\"\" type=\"text\" id=\"issue-date\" placeholder=\"Issue Date\" ng-model=\"vm.invoice.date\" min-date=\"minDate\" max-date=\"maxDate\" class=\"md-input\" readonly=\"readonly\" required=\"\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex=\"100\"><input time=\"false\" date=\"true\" mdc-datetime-picker=\"\" type=\"text\" id=\"due-date\" placeholder=\"Due Date\" ng-model=\"vm.invoice.dueDate\" min-date=\"minDate\" max-date=\"maxDate\" class=\"md-input\" readonly=\"readonly\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex=\"100\"><label>PO #</label> <input ng-model=\"vm.invoice.poNumber\"></md-input-container></div><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex=\"100\"><label>Subject</label> <input ng-model=\"vm.invoice.comments\"></md-input-container></div></div></div><div class=\"col-sm-6\"><h3><i class=\"fa fa-user\"></i> Customer</h3><div class=\"row\"><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex=\"100\"><label>Name</label> <input ng-model=\"vm.invoice.customerName\" required=\"\"></md-input-container></div><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex=\"100\"><label>Email</label> <input ng-model=\"vm.invoice.customerContact\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex=\"100\"><label>Customer Discount</label> <input type=\"number\" ng-model=\"vm.invoice.discount\"><div class=\"hint\">Express as %</div></md-input-container></div></div></div></div></form><div class=\"row\"><div class=\"col-sm-12\"><h3><i class=\"fa fa-list\"></i> Items</h3><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th>Item</th><th>Description</th><th>Quantity</th><th>Unit Price</th><th>Amount</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{ item.referenceNumber }}</td><td>{{ item.deviceName }}<csx-washer ng-repeat=\"device in item.devices\" class=\"pull-right\" ng-show=\"device.udi.washer\" washer=\"device.udi.washer\" size=\"list\"></csx-washer></td><td>{{ item.quantity }}</td><td>{{ item.deviceCost | currency }}<md-menu><a class=\"pull-right\" ng-click=\"$mdMenu.open($event)\"><i class=\"fa fa-pencil\"></i></a><md-menu-content><md-menu-item><md-input-container><input type=\"number\" ng-model=\"item.deviceCost\"></md-input-container></md-menu-item></md-menu-content></md-menu></td><td>{{ vm.deviceCost(item) | currency }}</td></tr></tbody></table><h3 style=\"color:black;\" class=\"pull-right\">Amount Due: <strong>{{ vm.amount() | currency}}</strong></h3><div></div></div></div></div>");
$templateCache.put("app/cases/signature/signature.tmpl.html","<md-dialog aria-label=\"Signature for Billing\" style=\"width: 400px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Signature Required</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"col-sm-12\" layout=\"row\"><md-input-container flex=\"100\"><label>Rep Signature</label> <input ng-model=\"vm.signature\" required=\"\"></md-input-container></div><div class=\"col-sm-12\" layout=\"row\"><md-input-container flex=\"100\"><label>Authorized Provider Signature</label> <input ng-model=\"vm.hospitalSignature\" required=\"\"></md-input-container></div><div class=\"col-sm-12\"><span>A signature is required to submit a case. Typing your name and submitting this form constitutes a digital signature. Your signature will appear on the Device Usage Ticket.</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel()\" class=\"md-danger\">Close</md-button><span flex=\"\"></span><md-button style=\"margin-right:16px;\" ng-click=\"vm.submitForBilling()\" class=\"md-primary\">Submit for Billing</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/cases/notes/case.notes.html","<h3><i class=\"fa fa-sticky-note\"></i> Notes</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><a class=\"text-primary\" ng-show=\"vm.noteContent.length > 0 && !vm.isLoadingNotes\" ng-click=\"vm.saveNote(vm.caseObject.key, vm.noteContent)\">Save</a><md-progress-circular ng-show=\"vm.isLoadingNotes\" ng-disabled=\"!vm.isLoadingNotes\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div><md-input-container class=\"md-block\"><textarea placeholder=\"Add Note\" ng-model=\"vm.noteContent\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div><div class=\"col-sm-12\" ng-repeat=\"note in vm.caseObject.caseNotes | orderBy:\'-date\'\"><div><div class=\"pull-right\"><a ng-click=\"vm.removeNote(vm.caseObject.key, note.key)\" class=\"text-danger\"><i class=\"fa fa-trash-o\"></i></a></div><span class=\"name-text\">{{ note.displayName }}</span> <span class=\"small-text\">{{ note.date | date:\'MM/dd/yyyy\' }}</span></div><p>{{ note.content }}</p></div></div>");
$templateCache.put("app/catalog/guides/guide.edit.html","<div class=\"wrapper wrapper-content animated cases-edit mgChipFixPosition\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-40 margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.guide.name || \'New Guide\' }}</h2></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Guide Details</h3><md-input-container class=\"md-block placeholder big-fontSize\"><label>Guide Name</label> <input ng-model=\"vm.guide.name\" required=\"\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Manufacturer</h3><md-input-container flex=\"100\" ng-show=\"vm.guide.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label> <input ng-model=\"vm.guide.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.guide.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label><md-select ng-model=\"vm.guide.manufacturer\" md-selected-text=\"vm.guide.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-md-8 col-xs-12 margin-bottom-30\"><button ng-click=\"vm.addStep()\" class=\"btn create pull-right addStepButton\">Add</button><h3 class=\"subTitle\">Steps</h3></div></div><div class=\"row\"><div class=\"col-md-8 col-xs-12 guide-steps\"><div ng-hide=\"vm.guide.steps\">No Steps</div><ul dnd-list=\"vm.guide.steps\" class=\"guide\"><li ng-repeat=\"step in vm.guide.steps\" dnd-draggable=\"step\" dnd-moved=\"vm.guide.steps.splice($index, 1)\" dnd-effect-allowed=\"move\">{{ $index + 1 }} &nbsp; <a ng-click=\"vm.editStep($event, step)\">{{ step.title || \'New Step\' }}</a><div class=\"pull-right\"><a ng-click=\"vm.removeStep($event, $index)\"><i class=\"fa fa-trash-o primary\"></i></a> <i class=\"fa fa-arrows\" style=\"padding-left:20px;\"></i></div></li></ul></div></div><div class=\"row\"><div class=\"col-md-8 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block placeholder big-fontSize\"><textarea placeholder=\"Description\" ng-model=\"vm.guide.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> <span ng-hide=\"vm.guide.key\">Create</span> <span ng-show=\"vm.guide.key\">Save</span></button></div></div><div class=\"col-sm-1\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div></div></div>");
$templateCache.put("app/catalog/guides/guide.html","<div class=\"animated\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-40\"><h2 style=\"margin-top:0;\" class=\"title\">vTray / Technique Guides</h2><div flex=\"\"></div><div><button ui-sref=\"index.guides.create\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Create Guide</button></div></div><div layout=\"row\" ng-if=\"vm.filters\"><md-input-container flex=\"auto\" style=\"height:52px;\" class=\"no-horizontal-padding placeholder big-fontSize\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Name</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"guide in vm.items\"><td><a ui-sref=\"index.guides.edit({objectKey: guide.key})\">{{ guide.name }}</a></td><td>{{ guide.modifiedDate }}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"center\" flex=\"\"><md-progress-circular ng-show=\"vm.loading\" md-diameter=\"25\" class=\"md-primary\"></md-progress-circular></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div>");
$templateCache.put("app/catalog/guides/step.tmpl.html","<md-dialog aria-label=\"step.title\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ step.title || \'New Step\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"col-sm-6\" layout=\"row\"><md-input-container flex=\"100\"><label>Title</label> <input ng-model=\"step.title\" required=\"\"></md-input-container></div><div class=\"col-sm-6\" layout=\"row\"><md-input-container flex=\"100\"><label>Color</label> <input ng-model=\"step.color\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-12\"><md-input-container class=\"md-block\"><label>Content</label> <textarea maxlength=\"1500\" ng-model=\"step.content\" md-maxlength=\"1500\" md-select-on-focus=\"\" required=\"\"></textarea></md-input-container></div></div><div class=\"row fixMgChipsHeightPopup\"><div class=\"col-sm-12\" layout=\"row\"><md-input-container flex=\"100\"><h5>Devices</h5><md-chips md-separator-keys=\"keys\" ng-model=\"step.devices\"></md-chips></md-input-container></div><div class=\"col-sm-12\" layout=\"row\"><md-input-container flex=\"100\"><h5>Images</h5><md-chips md-separator-keys=\"keys\" ng-model=\"step.images\"></md-chips></md-input-container></div><div class=\"col-sm-12\" layout=\"row\"><md-input-container flex=\"100\"><h5>Videos</h5><md-chips md-separator-keys=\"keys\" ng-model=\"step.videos\"></md-chips></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"cancel()\" class=\"md-primary\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/catalog/products/product.edit.html","<div class=\"wrapper wrapper-content animated cases-edit mgChipFixPosition\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-40 margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.product.name || \'New Product\' }}</h2></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Product Details</h3><md-input-container class=\"md-block placeholder big-fontSize\"><label>Product Name</label> <input ng-model=\"vm.product.name\" required=\"\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block placeholder big-fontSize\"><label>Asset Url</label> <input ng-model=\"vm.product.assetUrl\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\" style=\"padding-top: 5px\"><h3 class=\"subTitle\">Manufacturer</h3><md-input-container flex=\"100\" ng-show=\"vm.product.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label> <input ng-model=\"vm.product.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.product.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label><md-select ng-model=\"vm.product.manufacturer\" md-selected-text=\"vm.product.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Guides</h3><md-chips ng-model=\"vm.product.guides\" class=\"placeholder big-fontSize\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"vm.selectedGuide\" md-search-text=\"vm.guideSearchText\" md-items=\"guide in vm.searchGuides(vm.guideSearchText)\" md-no-cache=\"true\" md-item-text=\"guide.name\" placeholder=\"Add Guide\"><span md-highlight-text=\"vm.guideSearchText\">{{ guide.name }}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\" style=\"padding-top: 15px\"><h3 class=\"subTitle\">Trays</h3><md-chips ng-model=\"vm.product.trays\" class=\"placeholder big-fontSize\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"vm.selectedTray\" md-search-text=\"vm.traySearchText\" md-items=\"tray in vm.searchTrays(vm.traySearchText)\" md-no-cache=\"true\" md-item-text=\"tray.name\" placeholder=\"Add Tray\"><span md-highlight-text=\"vm.traySearchText\">{{ tray.name }}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div><div class=\"col-md-4 col-xs-12 fixmd-errors-spacer\"><h3 class=\"subTitle\" style=\"margin-bottom: 0 !important;\">IFU</h3><md-input-container class=\"md-block placeholder big-fontSize\" style=\"margin-top: 10px; line-height: 1.5;\"><label></label><md-chips ng-model=\"vm.product.ifuUrls\" placeholder=\"Enter URLs\"></md-chips></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><h3 class=\"subTitle\">Description</h3><md-input-container class=\"md-block placeholder big-fontSize\"><textarea placeholder=\"Description\" ng-model=\"vm.product.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div><div class=\"row\"><div class=\"col-md-8 col-xs-12\"><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> <span ng-hide=\"vm.product.key\">Create</span> <span ng-show=\"vm.product.key\">Save</span></button></div></div><div class=\"col-sm-1\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div></div></div>");
$templateCache.put("app/catalog/products/product.html","<div class=\"animated padding-left-null-desktop\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-40\"><h2 style=\"margin-top:0;\" class=\"title\">vTray / Product Templates</h2><div flex=\"\"></div><div><button ui-sref=\"index.products.create\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Create Product</button></div></div><div layout=\"row\" ng-if=\"vm.filters\"><md-input-container flex=\"auto\" style=\"height:52px;\" class=\"no-horizontal-padding placeholder big-fontSize\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Name</th><th>Manufacturer</th><th>Trays</th><th>Guides</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"product in vm.items\"><td><a ui-sref=\"index.products.edit({objectKey: product.key})\">{{ product.name }}</a></td><td>{{ product.manufacturer.name }}</td><td>{{ product.trays.length || 0 }}</td><td>{{ product.guides.length || 0 }}</td><td>{{ product.modifiedDate }}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"center\" flex=\"\"><md-progress-circular ng-show=\"vm.loading\" md-diameter=\"25\" class=\"md-primary\"></md-progress-circular></div><div class=\"row pagination\"><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div>");
$templateCache.put("app/catalog/layers/layer.template.edit.html","<div class=\"wrapper wrapper-content animated cases-edit mgChipFixPosition\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;margin-bottom: 30px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.layer.name || \'New Layer Template\' }}</h2></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Layer Template Details</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Name</label> <input ng-model=\"vm.layer.name\" required=\"\"></md-input-container></div></div></div></div><div class=\"col-md-4 col-xs-12\"><h3 style=\"margin-bottom: 24px !important;\">&nbsp;</h3><div class=\"form-group\"><md-input-container flex=\"100\" class=\"placeholder big-fontSize full-width\"><label>Image Name</label> <input ng-model=\"vm.layer.imageName\"></md-input-container></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12 disabledFixPosition\"><h3 class=\"subTitle\">Manufacturer</h3><md-input-container flex=\"100\" ng-show=\"vm.layer.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label> <input ng-model=\"vm.layer.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.layer.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label><md-select ng-model=\"vm.layer.manufacturer\" md-selected-text=\"vm.layer.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Description</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><textarea placeholder=\"Description\" ng-model=\"vm.layer.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div></div></div></div><div class=\"row margin-bottom-30 fixPreloader-md-autocomplete\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Devices</h3><md-autocomplete flex=\"\" class=\"placeholder big-fontSize\" md-input-name=\"device-template-search-field\" md-selected-item=\"vm.selectedDevice\" md-search-text=\"vm.deviceSearchText\" md-no-cache=\"true\" md-items=\"device in vm.searchDevices(vm.deviceSearchText)\" md-item-text=\"device.name + \' (\' + device.reference + \')\'\" md-selected-item-change=\"vm.addDevice(vm.selectedDevice)\" md-require-match=\"\" md-floating-label=\"Add Device\"><md-item-template><span md-highlight-text=\"vm.deviceSearchText\">{{ device.name }} ({{device.reference }})</span></md-item-template></md-autocomplete><div style=\"max-height:300px; overflow-y: auto;\"><table class=\"table mobileFriendlyTable table-border-gray\" ng-if=\"vm.layer.devices.length\"><thead><tr><th width=\"10\"></th><th>Name</th><th>Group</th><th width=\"10\"></th><th width=\"10\"></th></tr></thead><tbody><tr ng-repeat=\"device in vm.layer.devices\"><td><a ng-click=\"vm.syncDevice(device)\"><i class=\"fa fa-refresh primary\"></i></a></td><td><i class=\"fa fa-check primary\" ng-show=\"!vm.isDeviceIncomplete(device)\">&nbsp;</i> <a ng-click=\"vm.editDevice($event, device)\">{{ device.name }} ({{ device.reference }})</a></td><td>{{ device.location.overlayKey || \'None\' }}</td><td></td><td><a ng-click=\"vm.removeDevice($index)\"><i class=\"fa fa-trash-o primary\"></i></a></td></tr></tbody></table></div></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Overlays</h3><md-chips ng-model=\"vm.layer.overlays\" md-transform-chip=\"vm.newOverlay($chip)\" placeholder=\"Add Overlay\"><md-chip-template>{{ $chip.overlayKey }}</md-chip-template></md-chips><table class=\"table mobileFriendlyTable table-border-gray\" style=\"margin-top:20px;\" ng-if=\"vm.layer.overlays.length\"><thead><tr><th>Name</th><th width=\"10\"></th><th width=\"10\"></th></tr></thead><tbody><tr ng-repeat=\"overlay in vm.layer.overlays\"><td><a ng-click=\"vm.editOverlay($event, overlay)\">{{ overlay.overlayKey }}</a></td><td></td><td><a ng-click=\"vm.removeOverlay($index)\"><i class=\"fa fa-trash-o primary\"></i></a></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> <span ng-hide=\"vm.layer.key\">Create</span> <span ng-show=\"vm.layer.key\">Save</span></button></div></div><div class=\"col-sm-1\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div></div></div>");
$templateCache.put("app/catalog/layers/layers.html","<div class=\"animated\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-40\"><h2 style=\"margin-top:0;\" class=\"title\">vTray / Layer Templates</h2><div flex=\"\"></div><div><button ui-sref=\"index.layer-templates.create\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Create Layer</button></div></div><div layout=\"row\" ng-if=\"vm.filters\"><md-input-container flex=\"auto\" style=\"height:52px;\" class=\"no-horizontal-padding\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th>Name</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"layer in vm.items\"><td><a ui-sref=\"index.layer-templates.edit({objectKey: layer.key})\">{{ layer.name }}</a></td><td>{{ layer.modifiedDate }}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"center\" flex=\"\"><md-progress-circular ng-show=\"vm.loading\" md-diameter=\"25\" class=\"md-primary\"></md-progress-circular></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div>");
$templateCache.put("app/catalog/layers/location.tmpl.html","<md-dialog aria-label=\"step.title\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ title }} ({{ editObject.deviceId || \'Panic\' }})</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"row\" ng-hide=\"objectType === \'overlay\'\"><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Overlay Key</label><md-select ng-model=\"editObject.overlayKey\"><md-option ng-value=\"undefined\"><em>None</em></md-option><md-option ng-repeat=\"overlay in overlays\" ng-value=\"overlay.overlayKey\">{{ overlay.overlayKey }}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>x</label> <input type=\"number\" ng-model=\"editObject.x\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>y</label> <input type=\"number\" ng-model=\"editObject.y\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Width</label> <input type=\"number\" ng-model=\"editObject.width\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Height</label> <input type=\"number\" ng-model=\"editObject.height\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Image Name</label> <input ng-model=\"editObject.imageMaskName\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Rotation °</label> <input type=\"number\" ng-model=\"editObject.rotation\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Parent Width</label> <input type=\"number\" ng-model=\"editObject.parentWidth\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div><div class=\"col-sm-3\" layout=\"row\"><md-input-container flex=\"100\"><label>Parent Height</label> <input type=\"number\" ng-model=\"editObject.parentHeight\" ng-disabled=\"hasOverlayKey()\"></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"cancel()\" class=\"md-primary\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/catalog/udis/udi.edit.html","<div class=\"wrapper wrapper-content animated mgChipFixPosition\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\">Inventory &nbsp; / &nbsp; UDI &nbsp; / &nbsp; {{ vm.udi.lotNumber }}</h2></div><div><button ng-click=\"vm.finish()\" csx-loading=\"\" csx-is-loading=\"vm.isSaving\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Save</button></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr></div></div><div class=\"row\"><div class=\"col-sm-2\"><p class=\"detail-field-title\">Updated By</p><p>{{ vm.udi.modifiedByName }}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Last Updated</p><p>{{ vm.udi.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-sm-2 col-sm-offset-1\"><p class=\"detail-field-title\">Created By</p><p>{{ vm.udi.createdByName || \'No name set\'}}</p></div><div class=\"col-sm-2\"><p class=\"detail-field-title\">Created</p><p>{{ vm.udi.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row\"><div class=\"col-md-12\"><hr></div></div><div class=\"row\"><div class=\"col-sm-4\"><div><h3><i class=\"fa fa-barcode\"></i> UDI</h3></div><md-input-container class=\"md-block top-padded\"><label>Raw String</label> <input ng-model=\"vm.udi.raw\"> <span class=\"text-danger\">{{ vm.verificationErrorMessage }}</span></md-input-container></div><div class=\"col-sm-7 col-sm-offset-1\"><div class=\"row\"><div class=\"col-sm-4\"><h3>&nbsp;</h3><md-input-container class=\"md-block top-padded\"><label>Device Identifier</label> <input ng-model=\"vm.udi.deviceIdentifier\" ng-disabled=\"vm.udi.raw\"></md-input-container></div><div class=\"col-sm-4\"><h3>&nbsp;</h3><md-input-container class=\"md-block top-padded\"><label>Lot Number</label> <input ng-model=\"vm.udi.lotNumber\" ng-disabled=\"vm.udi.raw\"></md-input-container></div><div class=\"col-sm-4\"><h3>&nbsp;</h3><md-input-container class=\"md-block top-padded\"><label>Expiration Date</label> <input ng-model=\"vm.udi.expirationDate\" ng-disabled=\"vm.udi.raw\"></md-input-container></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr></div></div><div class=\"row\" style=\"margin-bottom:30px;\"><div class=\"col-md-3\"><div><h3><i class=\"fa fa-picture-o\"></i> UDIcon</h3></div><div><md-input-container class=\"md-block top-padded\"><label>Color</label> <input ng-model=\"vm.udi.washer.color\"></md-input-container></div><md-input-container layout-fill=\"\"><label>Icon</label><md-select ng-model=\"vm.udi.washer.imageName\"><md-option ng-value=\"null\"><em>None</em></md-option><md-option ng-repeat=\"icon in vm.icons\" ng-value=\"icon\">{{ icon }}</md-option></md-select></md-input-container></div><div class=\"col-md-3\"><div><h3>&nbsp;</h3></div><div><md-input-container class=\"md-block top-padded\"><label>Text</label> <input ng-model=\"vm.udi.washer.name\"> <span class=\"small\">Text and Icon are mutually exclusive.</span></md-input-container></div><md-input-container layout-fill=\"\"><label>Alt Icon</label><md-select ng-model=\"vm.udi.washer.altImageName\"><md-option ng-value=\"null\"><em>None</em></md-option><md-option ng-repeat=\"icon in vm.icons\" ng-value=\"icon\">{{ icon }}</md-option></md-select></md-input-container></div><div class=\"col-md-6\"><div><h3>Preview</h3></div><csx-washer washer=\"vm.udi.washer\"></csx-washer></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr></div></div><div class=\"row\"><div class=\"col-sm-3\"><div><h3><i class=\"fa fa-tags\"></i> Alternative Methods</h3></div><div><md-input-container layout-fill=\"\" class=\"md-block top-padded\"><label>Methods</label><md-select ng-model=\"vm.udi.altMethods\" multiple=\"\"><md-option ng-value=\"method.value\" ng-repeat=\"method in vm.methods\">{{method.name}}</md-option></md-select></md-input-container></div></div><div class=\"col-sm-3\"><div><h3>&nbsp;</h3></div><md-input-container class=\"md-block top-padded\"><label>Raw Barcode Data</label> <input ng-disabled=\"vm.udi.altMethods.indexOf(\'Barcode\') === -1\"></md-input-container></div></div><div class=\"row\" style=\"height:200px;\"></div></div>");
$templateCache.put("app/catalog/udis/udis.list.html","<div ng-switch=\"vm.isLoading\"><div ng-switch-when=\"true\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div ng-switch-default=\"\" class=\"wrapper wrapper-content animated\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th class=\"col-md-4 sorting\">UDI</th><th class=\"col-md-3 sorting_asc\">Lot Number</th><th class=\"col-md-2\">Expiration</th><th class=\"col-md-3\">UDIcon</th></tr></thead><tbody><tr ng-repeat=\"udi in vm.udis\"><td ng-class=\"udi.raw ? \'\' : \'unassigned\'\">{{ udi.raw }}</td><td><a ui-sref=\"index.udis.edit({objectKey: udi.key})\">{{udi.lotNumber}}</a></td><td ng-class=\"udi.expiration ? \'\' : \'unassigned\'\">{{udi.expiration | date:\'yyyy-MM-dd\'}}</td><td ng-class=\"udi.washer ? \'\' : \'unassigned\'\"><csx-washer washer=\"udi.washer\" size=\"list\"></csx-washer></td></tr></tbody></table></div></div><div class=\"row\" ng-hide=\"vm.udis.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>It looks like no UDIs match your search. Please check your information and try again.</h3></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div></div></div></div>");
$templateCache.put("app/catalog/trays/tray.template.edit.html","<div class=\"wrapper wrapper-content animated cases-edit mgChipFixPosition\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-40 margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.tray.name || \'New Tray Template\' }}</h2></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle margin-bottom-30-important\">Tray Template Details</h3><md-input-container class=\"md-block placeholder big-fontSize full-width\"><label>Tray Template Name</label> <input ng-model=\"vm.tray.name\" required=\"\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle margin-bottom-30-important\">Manufacturer</h3><md-input-container flex=\"100\" ng-show=\"vm.tray.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label> <input ng-model=\"vm.tray.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.tray.key\" class=\"placeholder big-fontSize full-width\"><label>Manufacturer</label><md-select ng-model=\"vm.tray.manufacturer\" md-selected-text=\"vm.tray.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div><div class=\"row margin-bottom-40\"><div class=\"col-md-8 col-xs-12\"><h3 class=\"subTitle\">Layers</h3><md-chips ng-model=\"vm.tray.layers\" class=\"placeholder big-fontSize\" md-require-match=\"true\"><md-autocomplete md-selected-item=\"vm.selectedLayer\" md-search-text=\"vm.layerSearchText\" md-items=\"layer in vm.searchLayers(vm.layerSearchText)\" md-no-cache=\"true\" md-item-text=\"layer.name\" placeholder=\"Add Layer\"><span md-highlight-text=\"vm.layerSearchText\">{{ layer.name }}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div></div><div class=\"row margin-bottom-40\"><div class=\"col-md-8 col-xs-12\"><h3 class=\"subTitle\">Description</h3><md-input-container class=\"md-block placeholder big-fontSize\"><textarea placeholder=\"Description\" ng-model=\"vm.tray.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> <span ng-hide=\"vm.tray.key\">Create</span> <span ng-show=\"vm.tray.key\">Save</span></button></div><div class=\"col-sm-1 col-xs-12\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/catalog/trays/tray.templates.html","<div class=\"animated\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-bottom-30\"><h2 style=\"margin-top:0;\" class=\"title\">vTray / Tray Templates</h2><div flex=\"\"></div><div><button ui-sref=\"index.tray-templates.create\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Create Tray</button></div></div><div layout=\"row\" ng-if=\"vm.filters\"><md-input-container flex=\"auto\" style=\"height:52px;\" class=\"no-horizontal-padding\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Name</th><th>Manufacturer</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"tray in vm.items\"><td><a ui-sref=\"index.tray-templates.edit({objectKey: tray.key})\">{{ tray.name }}</a></td><td>{{ tray.manufacturer.name }}</td><td>{{ tray.modifiedDate }}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"center\" flex=\"\"><md-progress-circular ng-show=\"vm.loading\" md-diameter=\"25\" class=\"md-primary\"></md-progress-circular></div><div class=\"row pagination\"><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<nav class=\"navbar navbar-default navbar-fixed-top\" ng-class=\"main.isMobMenuActive ? \'mobileOpen\' : \'\'\"><div class=\"container-fluid container\"><img class=\"navbar-logo\" src=\"../../assets/images/Logos_ConnectSx.svg\"><div class=\"no-transition\"><ul class=\"nav navbar-nav\" layout=\"row\" id=\"nav\"><li><a ui-sref=\"index.home\" tabindex=\"-1\" class=\"titleFormBefore\" data-title=\"Dashboard\">Dashboard</a></li><li><a ui-sref=\"index.cases.list\" tabindex=\"-1\" class=\"titleFormBefore\" data-title=\"Cases\">Cases</a></li><li><a ui-sref=\"index.inventory.list\" tabindex=\"-1\" class=\"titleFormBefore\" data-title=\"Inventory\">Inventory</a></li><li><a ui-sref=\"index.accounts.list\" tabindex=\"-1\" class=\"titleFormBefore\" data-title=\"Users\">Users</a></li><li><a ui-sref=\"index.catalog.products.list\" tabindex=\"-1\" class=\"titleFormBefore\" data-title=\"vTray\">vTray</a></li><li><a ui-sref=\"index.directory.physicians.list\" tabindex=\"-1\" class=\"titleFormBefore\" data-title=\"Directory\">Directory</a></li><li flex=\"\"></li><li id=\"notification-nav-item\"><a ng-click=\"main.showMenu($event)\"><i class=\"fa fa-bell\" style=\"font-size: 24px;\"></i><div class=\"badge-count\" ng-show=\"main.notificationCount > 0\"><div>{{main.notificationCount}}</div></div></a></li><li><md-menu-bar><md-menu><a aria-label=\"Open menu\" id=\"fixStyle\" class=\"md-icon-button\" ng-click=\"main.showUserSettings($mdMenu,$event)\"><span><i class=\"fa fa-user\" style=\"font-size: 24px;\"></i></span></a><md-menu-content width=\"4\" class=\"fixPosition\"><md-menu-item><span style=\"font-size: 16px; color: #000;\">{{ main.account.name }} ({{main.account.org.name }})</span></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"ctrl.toggleNotifications()\"><span ui-sref=\"index.settings.personal\" class=\"gray-color\" style=\"display: block;width: 100%;\">Settings</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"main.logout(); ctrl.toggleNotifications()\"><span class=\"gray-color\">Logout</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></li></ul></div></div></nav><div class=\"mobileNav\"><img class=\"mobile-logo\" src=\"../../assets/images/Logos_ConnectSx.svg\"> <span class=\"navbar-burger burger\" role=\"button\" ng-class=\"main.isMobMenuActive ? \'is-active\' : \'\'\" ng-click=\"main.toggleMobileNav()\"><span></span> <span></span> <span></span></span></div><md-content id=\"page-wrapper\" class=\"container\" ng-controller=\"IndexController as index\" flex=\"\"><div ng-show=\"!index.isLoading\" ui-view=\"\" layout-fill=\"\"></div><div ng-if=\"index.isLoading\" class=\"loading\"><div class=\"sk-spinner sk-spinner-chasing-dots\"><div class=\"sk-dot1\"></div><div class=\"sk-dot2\"></div></div></div></md-content><div id=\"footer\" class=\"footer fixed_full\"><div class=\"container\" style=\"padding: 0\"><strong>ConnectSx</strong> &copy; 2019</div></div>");
$templateCache.put("app/directives/datepicker/datepicker.html","<div class=\"csx-datepicker input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"ngModel\" is-open=\"vm.open\" datepicker-options=\"vm.options\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.open = true;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div>");
$templateCache.put("app/directives/file-uploader/file-uploader.html","<div class=\"upload-field\"><label><span>{{buttonText}}</span> <input type=\"file\" class=\"uploadFileInput\" multiple=\"multiple\" accept=\"{{acceptFiles}}\" ng-model=\"ngModel\"></label><ul><li ng-repeat=\"file in ngModel track by $index\"><a href=\"{{file}}\" target=\"_blank\"><span ng-if=\"file.name\">{{ file.name }}</span> <span ng-else=\"\"><span ng-if=\"uploadOnlyImages\">image</span><span ng-if=\"!uploadOnlyImages\">item</span> {{$index + 1}}</span></a> <i class=\"fa fa-remove\" ng-click=\"removeFile($index)\"></i></li></ul></div>");
$templateCache.put("app/directives/washer/washer.html","<div class=\"csx-washer {{size ? \'csx-washer--\' + size : \'csx-washer--large\'}}\" ng-attr-style=\"background-color:#{{ washer.color}};\"><span class=\"csx-washer__code\">{{washer.name}}</span> <span class=\"csx-washer__image\" ng-show=\"washer.altImageName && (!washer.imageName || !washer.name)\"><img ng-src=\"{{washer.altImageName ? vm.imagePath + washer.altImageName + \'.png\' : \'\'}}\" alt=\"{{washer.altImageName}}\"></span> <span class=\"csx-washer__image\" ng-show=\"washer.imageName\"><img ng-src=\"{{washer.imageName ? vm.imagePath + washer.imageName + \'.png\' : \'\'}}\" alt=\"{{washer.imageName}}\"></span></div>");
$templateCache.put("app/directory/facilities/facility.html","<div class=\"animated\"><ui-view></ui-view></div>");
$templateCache.put("app/directory/physicians/physician.html","<div class=\"animated\"><ui-view></ui-view></div>");
$templateCache.put("app/inventory/add/inventory.add.html","<div class=\"wrapper wrapper-content animated\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Add Inventory</h2></div></div><div class=\"row top-padded\"><div class=\"col-sm-4 col-xs-12\"><div><div class=\"description pull-right\">{{ vm.device.udi.issuer }}</div><h3 class=\"subTitle\">UDI</h3></div><md-input-container class=\"md-block big-fontSize placeholder\"><label>Raw String (GS1, HIBC, etc.)</label> <input ng-model=\"vm.device.udi.raw\"> <span class=\"text-warning\" ng-show=\"vm.device.udi.raw && !vm.device.udi.issuer\">Not yet verified through GUDID. Click the \"Verify\" button below to complete this action.</span> <span style=\"color: red !important;\"><br>{{ vm.verificationErrorMessage }}</span></md-input-container><div><button ng-show=\"vm.device.udi.raw\" ng-click=\"vm.verifyUDI(vm.device.udi.raw)\" class=\"btn btn-outline btn-primary verify-button\"><i class=\"fa fa-check\"></i> Verify</button><md-progress-circular ng-show=\"vm.isVerifyingUDI\" ng-disabled=\"!vm.isVerifyingUDI\" class=\"md-primary pull-right\" md-diameter=\"20px\"></md-progress-circular></div></div><div class=\"col-sm-4 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block placeholder\"><label>Device Identifier</label> <input ng-model=\"vm.device.udi.di\" ng-disabled=\"vm.device.udi.raw\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block placeholder\"><label>Lot Number</label> <input ng-model=\"vm.device.udi.lot\" ng-disabled=\"vm.device.udi.raw\"></md-input-container></div></div><div class=\"row\" style=\"margin-bottom: 40px;\"><div class=\"col-sm-4 col-xs-12\"><md-input-container class=\"md-block placeholder marginNull margin-top-null\"><label>Serial Number</label> <input ng-model=\"vm.device.udi.serial\" ng-disabled=\"vm.device.udi.raw\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><div><div class=\"description pull-right placeholder\" ng-show=\"vm.device.udi.key\"><p><a ng-click=\"vm.viewUDI(vm.device.udi.key)\">View UDI</a></p></div></div><md-input-container class=\"md-block placeholder marginNull margin-top-null\"><label>Expiration Date</label> <input ng-model=\"vm.device.udi.expiration\" ng-disabled=\"vm.device.udi.raw\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><div class=\"titleIconWrap\" style=\"margin-bottom: 25px\"><h3 class=\"subTitle\">Details</h3><md-button class=\"md-fab\"><md-tooltip md-visible=\"false\" style=\"max-width: 200px;\" md-direction=\"left\">Devices are individual pieces of inventory. Containers represent groups of devices. These can be trays, sets, sterile packs or any other logical grouping that you use.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><md-input-container class=\"full-width\"><label>Inventory Type</label><md-select class=\"md-primary placeholder big-fontSize\" ng-model=\"vm.device.type\"><md-option ng-value=\"\'Device\'\">Device</md-option><md-option ng-value=\"\'Container\'\">Container</md-option></md-select><p></p></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3>&nbsp;</h3><md-autocomplete class=\"md-block placeholder big-fontSize mdline-position\" md-input-name=\"custodyField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-selected-item=\"vm.device.custody\" md-search-text=\"vm.custodySearchText\" md-items=\"item in vm.searchCustody(vm.custodySearchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-floating-label=\"Custody\"><md-item-template><span md-highlight-text=\"vm.custodySearchText\">{{ item.name }} ({{ item.email || item.type }})</span></md-item-template><div ng-messages=\"filterForm.custodyField.$error\" ng-if=\"filterForm.custodyField.$touched\"><div ng-message=\"md-require-match\">Please select custody for your search.</div></div></md-autocomplete></div><div class=\"col-sm-4 col-xs-12\"><h3>&nbsp;</h3><div class=\"flexJustify\"><md-autocomplete class=\"ng-block placeholder big-fontSize full-width\" md-input-name=\"manufacturerField\" md-input-minlength=\"2\" md-no-cache=\"true\" md-selected-item=\"vm.device.manufacturer\" md-search-text=\"vm.manufacturerSearchText\" md-items=\"item in vm.manufacturers\" md-item-text=\"item.name\" md-floating-label=\"Manufacturer\"><md-item-template><span md-highlight-text=\"vm.manufacturerSearchText\">{{ item.name }}</span></md-item-template><div ng-messages=\"filterForm.manufacturerField.$error\" ng-if=\"filterForm.manufacturerField.$touched\"><div ng-message=\"md-require-match\">Please select manufacturer for your inventory.</div></div></md-autocomplete><i class=\"fa fa-plus-circle addNewIcon\" aria-hidden=\"true\" ng-click=\"vm.addManufacture()\"></i></div></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><div class=\"flexJustify\"><md-autocomplete class=\"md-block placeholder big-fontSize margin-top-null margin-top-null margin-bottom-null preloader-linear-bottom-0 full-width\" ng-disabled=\"!vm.device.manufacturer.key\" md-input-name=\"productField\" md-input-minlength=\"2\" md-no-cache=\"true\" md-selected-item=\"vm.device.product\" md-search-text=\"vm.productSearchText\" md-items=\"item in vm.searchProducts(vm.device.manufacturer.key, vm.productSearchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-floating-label=\"Product\"><md-item-template><span md-highlight-text=\"vm.productSearchText\">{{ item.name }}</span></md-item-template><div ng-messages=\"filterForm.productField.$error\" ng-if=\"filterForm.productField.$touched\"><div ng-message=\"md-require-match\">Please select product for your inventory.</div></div></md-autocomplete><i class=\"fa fa-plus-circle addNewIcon\" aria-hidden=\"true\" ng-click=\"vm.addNewProduct()\"></i></div></div><div class=\"col-sm-4 col-xs-12\"><md-input-container class=\"md-block placeholder margin-top-null margin-bottom-null\"><div class=\"titleIconWrap full-width absoluteIcon\"><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">Reference # should be Catalog # or Model / Version #. It should uniquely identify the type of device.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><label>Reference #</label> <input ng-model=\"vm.device.reference\" class=\"padding-right-25\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><div class=\"titleIconWrap full-width absoluteIcon margin-top-null margin-bottom-null\"><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">This should be a human readable name for the device. e.g. 4.5mm Cortical Screw</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><md-input-container class=\"md-block placeholder margin-top-null\" style=\"margin-bottom: 8px\"><label>Name</label> <input ng-model=\"vm.device.name\" class=\"padding-right-25\"></md-input-container></div></div><div class=\"row\" style=\"margin-bottom: 40px\"><div class=\"col-sm-4 col-xs-12\"><md-input-container class=\"md-block top-padded placeholder margin-top-null\"><label>Quantity</label> <input ng-disabled=\"vm.device.type === \'Container\'\" ng-model=\"vm.device.quantity\" max=\"10\" min=\"1\" type=\"number\" step=\"1\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><md-autocomplete class=\"md-block placeholder big-fontSize margin-top-null mdline-position\" ng-disabled=\"vm.device.type === \'Container\' || !vm.device.manufacturer.key || !vm.device.custody.key\" md-input-name=\"containerField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-search-text-change=\"vm.isSearchContainerTextChanged = true\" md-selected-item=\"vm.device.container\" md-search-text=\"vm.containerSearchText\" md-items=\"item in vm.searchContainers(vm.device.custody.key, vm.device.manufacturer.key, vm.containerSearchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-floating-label=\"Container\"><md-item-template><div style=\"position: relative;\"><p style=\"margin-bottom: 0; line-height: 3;\">{{item.name | limitTo: 35}}<span ng-if=\"item.name.length > 35\">...</span></p><i style=\"color:#47525d; position: absolute; font-size: 0.8em; right: 0; bottom: 0;line-height: 1;\">Ref. num.: {{ item.reference | limitTo: 35}} <span ng-if=\"item.reference.length > 35\">...</span></i></div></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 placeholder\"><h3 class=\"subTitle\">Due Back</h3><br><md-input-container class=\"margin-top-null full-width datePicker\"><md-datepicker ng-model=\"vm.device.dueBackDate\" md-placeholder=\"Date\" md-hide-icons=\"calendar\" md-open-on-focus=\"\"></md-datepicker></md-input-container></div><div class=\"col-sm-4 col-xs-12 placeholder\"><h3 class=\"subTitle\">Tags</h3><md-input-container class=\"md-block big-fontSize placeholder margin-top-null\"><label></label><md-chips ng-model=\"vm.device.tags\" placeholder=\"Enter Search Tags\"></md-chips></md-input-container></div><div class=\"col-sm-4 col-xs-12 placeholder\"><div layout=\"row\" class=\"space-between\"><h3 class=\"subTitle\">Billable</h3><md-switch class=\"md-primary csx-switch\" ng-model=\"vm.device.billable\"></md-switch></div><md-input-container class=\"md-block\"><label>Price</label> <input ng-model=\"vm.device.price\" type=\"number\" ng-disabled=\"!vm.device.billable\"></md-input-container></div></div><div ng-show=\"vm.device.gudidDeviceEntity\"><div class=\"row placeholder\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">GUDID GMDN Terms</h3><div ng-repeat=\"term in vm.device.gudidDeviceEntity.gmdnTerms\"><h6>{{ term.gmdnPTName }}</h6><p>{{ term.gmdnPTDefinition }}</p></div></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Sterilization</h3><h6>Device is Sterile: {{ vm.device.gudidDeviceEntity.sterilization.deviceSterile ? \'YES\' : \'NO\' }}</h6><h6>Sterilization Prior to Use: {{ vm.device.gudidDeviceEntity.sterilization.sterilizationPriorToUse ? \'YES\' : \'NO\' }}</h6><p ng-repeat=\"method in vm.device.gudidDeviceEntity.sterilization.methodTypes\">{{ method }}</p></div></div></div><div class=\"childRightposition\"><button csx-loading=\"\" csx-is-loading=\"vm.isSaving\" ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Create</button></div></div>");
$templateCache.put("app/inventory/edit/inventory.edit.html","<form class=\"wrapper wrapper-content animated padding-left-10-desktop\" name=\"myForm\"><div layout=\"row\" style=\"margin-top:10px;margin-bottom: 40px\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.device.name }}</h2><span class=\"subSubTitle flex-row\"><span>{{ vm.device.status }}</span> <span ng-if=\"vm.device.active\" class=\"color-black\">, Active</span> <span ng-if=\"!vm.device.active\" class=\"color-black\">, Inactive</span></span></div><div><button csx-loading=\"\" csx-is-loading=\"vm.isSaving\" ng-hide=\"vm.disableEditableFields\" ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Save</button> <button csx-is-loading=\"vm.isSaving\" ng-if=\"vm.device.active && vm.device.status === \'Unused\'\" ng-click=\"vm.showConfirm()\" class=\"btn btn-outline btn-primary create hover-color-white\"><i class=\"fa fa-power-off\"></i> Deactivate</button></div></div><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Reference Number</p><p>{{ vm.device.reference }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Manufacturer</p><p>{{ vm.device.manufacturer.name }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Case</p><p><a ng-click=\"vm.viewCase(vm.device.caze.key)\">{{ vm.device.caze.name }}</a> <span class=\"unassigned\" style=\"color:lightgrey;\" ng-hide=\"vm.device.caze.key\">unassigned</span></p></div><div class=\"col-md-3 col-xs-12\" ng-show=\"vm.device.type === \'Device\'\"><p class=\"subSubTitle\">Container</p><p><a ng-click=\"vm.viewDevice(vm.device.container.key)\">{{ vm.device.container.name }}</a></p><span class=\"unassigned\" style=\"color:lightgrey;\" ng-hide=\"vm.device.container.key\">unassigned</span></div></div><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Updated By</p><p>{{ vm.device.modifiedByName }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Last Updated</p><p>{{ vm.device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Created By</p><p>{{ vm.device.createdByName || \'No name set\'}}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Created</p><p>{{ vm.device.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row margin-bottom-40\"><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Product Line</p><p><a ng-click=\"vm.viewProduct(vm.device.product.key)\">{{ vm.device.product.name }}</a></p></div><div class=\"col-md-3 col-xs-12\" ng-if=\"vm.device.caze && vm.device.caze.patientRecordId\"><p class=\"subSubTitle\">Patient ID</p><p>{{ vm.device.caze.patientRecordId }}</p></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div><div class=\"titleIconWrap\"><h3 class=\"subTitle\" style=\"margin-bottom: 24px !important;\">UDI</h3><md-button class=\"md-fab\" ng-show=\"!vm.device.udi.symbology\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">Not yet verified through GUDID. Click the \"Verify\" button below to complete this action.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><div class=\"description margin-bottom-30\" ng-if=\"vm.device.udi.symbology\">{{ vm.device.udi.symbology }}</div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\" style=\"margin-bottom: 0;margin-top: 0;\"><label>Raw String (GS1, HIBC, etc.)</label> <input ng-model=\"vm.device.udi.raw\" ng-trim=\"false\" ng-disabled=\"vm.disableEditableFields\"> <span style=\"color: red !important;\">{{ vm.verificationErrorMessage }}</span></md-input-container><div><button ng-show=\"vm.device.udi.raw\" ng-click=\"vm.verifyUDI(vm.device.udi.raw)\" ng-disabled=\"vm.disableEditableFields\" class=\"btn btn-outline btn-primary margin-bottom-30\"><i class=\"fa fa-check\"></i> Verify</button><md-progress-circular ng-show=\"vm.isVerifyingUDI\" ng-disabled=\"!vm.isVerifyingUDI\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div></div><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block top-padded placeholder big-fontSize\" style=\"margin-top:0;\"><label>Device Identifier</label> <input ng-model=\"vm.device.udi.di\" ng-disabled=\"vm.device.udi.raw || vm.disableEditableFields\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block top-padded placeholder big-fontSize\" style=\"margin-top:0;\"><label>Lot Number</label> <input ng-model=\"vm.device.udi.lot\" ng-disabled=\"vm.device.udi.raw || vm.disableEditableFields\"></md-input-container></div></div><div class=\"row\" style=\"margin-bottom: 40px\"><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block top-padded placeholder big-fontSize\" style=\"margin-top: 10px;\"><label>Serial Number</label> <input ng-model=\"vm.device.udi.serial\" ng-disabled=\"vm.device.udi.raw || vm.disableEditableFields\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><div><div class=\"description\" ng-show=\"vm.device.udi.key\"><p><a ng-click=\"vm.viewUDI(vm.device.udi.key)\">View UDI</a></p></div></div><md-input-container class=\"md-block top-padded placeholder big-fontSize\" style=\"margin-top: 10px;\"><label>Expiration Date</label> <input ng-model=\"vm.device.udi.expiration\" ng-disabled=\"vm.device.udi.raw || vm.disableEditableFields\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><br><h3 style=\"margin-bottom:22px !important;\" class=\"subTitle\">Due Back</h3><md-input-container class=\"full-width\"><md-datepicker class=\"placeholder big-fontSize full-width datePicker\" ng-model=\"vm.device.dueBackDate\" md-placeholder=\"Date\" ng-disabled=\"vm.disableEditableFields\" md-hide-icons=\"calendar\" md-open-on-focus=\"\"></md-datepicker></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Tags</h3><br><md-input-container class=\"md-block placeholder big-fontSize margin-top-null\"><label>Click enter to add a Tag</label><md-chips ng-model=\"vm.device.tags\" placeholder=\"Enter Search Tags\" readonly=\"vm.disableEditableFields\" md-removable=\"!vm.disableEditableFields\"></md-chips></md-input-container></div><div class=\"col-md-4 col-xs-12\"><div class=\"space-between\"><h3 class=\"subTitle\">Billable</h3><md-switch class=\"md-primary csx-switch placeholder big-fontSize\" ng-disabled=\"vm.disableEditableFields\" ng-model=\"vm.device.billable\"></md-switch></div><md-input-container class=\"md-block placeholder big-fontSize\"><br><label>Price</label> <input ng-model=\"vm.device.price\" type=\"number\" step=\"0.01\" min=\"0\" ng-disabled=\"!vm.device.billable || vm.disableEditableFields\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4\"><h3 class=\"subTitle\">Custody</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Name</label> <input ng-model=\"vm.device.custody.name\" ng-disabled=\"true\"></md-input-container></div><div class=\"col-sm-4\"><h3 class=\"subTitle\">Location</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><input type=\"text\" ng-places-autocomplete=\"\" details=\"vm.device.location\" ng-disabled=\"vm.disableEditableFields\" ng-model=\"vm.device.location.name\"></md-input-container></div><div class=\"col-sm-4\"><h3 class=\"subTitle\">Consignment Status</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><md-select ng-model=\"vm.device.custodyType\" ng-disabled=\"vm.disableEditableFields\"><md-option ng-value=\"custodyType.value\" ng-repeat=\"custodyType in vm.custodyTypes\">{{ custodyType.name }}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4 fixPreloader-md-autocomplete\" ng-show=\"vm.device.type === \'Device\'\"><div layout=\"row\" flex=\"\" layout-align=\"left center\"><h3 style=\"margin-bottom:22px !important;\" class=\"subTitle\">Container</h3><div flex=\"\"></div><a ng-show=\"vm.device.container.key\" class=\"text-danger\" ng-click=\"vm.releaseFromTray()\">Release</a><div layout-margin=\"\"></div><a class=\"primary\" ng-show=\"vm.device.container.key\" ng-click=\"vm.viewDevice(vm.device.container.key)\">View <i class=\"fa fa-arrow-circle-o-right\"></i></a></div><div flex=\"\"><md-autocomplete flex=\"\" ng-disabled=\"vm.disableEditableFields\" class=\"placeholder big-fontSize\" md-input-name=\"containerField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-selected-item=\"vm.device.container\" md-search-text=\"vm.searchContainerText\" md-items=\"item in vm.searchContainers(vm.searchContainerText)\" md-item-text=\"item.name\" md-require-match=\"true\" md-floating-label=\"Container\"><md-item-template><div style=\"position: relative;\"><p style=\"margin-bottom: 0; line-height: 3;\">{{item.name | limitTo: 35}}<span ng-if=\"item.name.length > 35\">...</span></p><i style=\"color:#47525d; position: absolute; font-size: 0.8em; right: 0; bottom: 0;line-height: 1;\">Ref. num.: {{ item.reference | limitTo: 35}} <span ng-if=\"item.reference.length > 35\">...</span></i></div></md-item-template><md-not-found>No results.</md-not-found></md-autocomplete></div></div><div class=\"col-sm-4\"><div><h3 class=\"subTitle\">Barcode</h3></div><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Barcode</label> <input ng-model=\"vm.device.barcode\" ng-disabled=\"vm.disableEditableFields\"></md-input-container></div><div class=\"col-sm-4\"><h3 style=\"margin-bottom:22px !important;\" class=\"subTitle\">vTray Case</h3><div flex=\"\"><md-autocomplete flex=\"\" ng-disabled=\"vm.device.container\" class=\"placeholder big-fontSize mdline-position\" md-input-name=\"virtualCaseField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-selected-item=\"vm.device.virtualCase\" md-search-text=\"vm.searchCaseText\" md-items=\"item in vm.searchCases(vm.searchCaseText)\" md-item-text=\"item.name\" md-require-match=\"true\" md-floating-label=\"Case\"><md-item-template><span>{{item.name}}</span></md-item-template></md-autocomplete></div></div></div><div ng-show=\"vm.device.gudidDeviceEntity\"><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">GUDID GMDN Terms</h3><div ng-repeat=\"term in vm.device.gudidDeviceEntity.gmdnTerms\"><h6>{{ term.gmdnPTName }}</h6><p>{{ term.gmdnPTDefinition }}</p></div></div><div class=\"col-sm-4 col-sm-offset-1\"><h3 class=\"subTitle\">Sterilization</h3><h6>Device is Sterile: {{ vm.device.gudidDeviceEntity.sterilization.deviceSterile ? \'YES\' : \'NO\' }}</h6><h6>Sterilization Prior to Use: {{ vm.device.gudidDeviceEntity.sterilization.sterilizationPriorToUse ? \'YES\' : \'NO\' }}</h6><p ng-repeat=\"method in vm.device.gudidDeviceEntity.sterilization.methodTypes\">{{ method }}</p></div></div></div><div class=\"row margin-bottom-40\"><div class=\"col-sm-4 col-xs-12\"><div layout=\"row\"><br><h3 class=\"subTitle\">Reusable</h3><md-switch class=\"md-primary csx-switch placeholder big-fontSize\" ng-disabled=\"vm.disableEditableFields\" ng-model=\"vm.device.reusable\"></md-switch></div><br><p>Inventory marked as reusable will be returned to your active inventory if it is used in a case.</p></div><div class=\"col-sm-8 col-xs-12\"><div class=\"flex-row inventoryUploadImage\"><h3 class=\"subTitle\" style=\"margin-right: 20px;\">Images</h3><div><div class=\"flexJustify wrapImageURLs\"><md-input-container class=\"md-block top-padded placeholder big-fontSize marginNull deviceImageUrlInput\"><input ng-model=\"vm.imageUrlValue\" placeholder=\"Enter image url\" ng-disabled=\"vm.device.udi.raw || vm.disableEditableFields\"></md-input-container><button ng-if=\"vm.imageUrlValue.length\" class=\"btn btn-outline btn-primary\" ng-click=\"vm.addImageUrl()\">Add</button></div><div ng-model=\"vm.device.images\" ng-hide=\"vm.device.udi.raw || vm.disableEditableFields\" upload-folder=\"inventory\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"true\" style=\"display: inline-block;\"></div><div ng-if=\"vm.device.images.length\" class=\"absolutePositionHint titleIconWrap full-width absoluteIcon margin-top-null margin-bottom-null\"><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">You can delete images attached to inventory. If you want to delete images from Product line or Catalog you can do it on their edit pages.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div></div></div><div ng-show=\"!vm.device.images.length && !vm.device.product.images.length && (!vm.catalogImages.length)\">No Images</div><div layout=\"row\" style=\"overflow-x: scroll\"><div class=\"ownImages\" ng-if=\"vm.device.images.length\"><span class=\"clueImages\">Inventory images</span><div class=\"flexRow\"><div ng-repeat=\"image in vm.device.images\" style=\"margin-right:16px;\"><a ng-href=\"{{ image }}\" target=\"_blank\"><img style=\"height:100px;width:100px; border-radius: 6px;\" ng-src=\"{{ image }}\" alt=\"Error load image\"></a></div></div></div><div class=\"productImages\" ng-if=\"vm.device.product.images.length\"><span class=\"clueImages\">Product line images</span><div class=\"flexRow\"><div ng-repeat=\"image in vm.device.product.images\" style=\"margin-right:16px;\"><a ng-href=\"{{ image }}\" target=\"_blank\"><img style=\"height:100px;width:100px; border-radius: 6px;\" ng-src=\"{{ image }}\" alt=\"Error load image\"></a></div></div></div><div class=\"imagesFromCatalog\" ng-if=\"vm.catalogImages.length\"><span class=\"clueImages\">Catalog images</span><div class=\"flexRow\"><div ng-repeat=\"image in vm.catalogImages\" style=\"margin-right:16px;\"><a ng-href=\"{{ image }}\" target=\"_blank\"><img style=\"height:100px;width:100px; border-radius: 6px;\" ng-src=\"{{ image }}\" alt=\"Error load image\"></a></div></div></div></div></div></div><div class=\"row margin-bottom-40\"><div class=\"col-sm-12 col-xs-12\"><div class=\"notes\"><h3 class=\"subTitle\">Notes</h3><blockquote ng-if=\"vm.device.note\">{{vm.device.note}}<br></blockquote><p ng-if=\"!vm.device.note\">No notes</p></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h3 class=\"subTitle\">History of actions from vTrakr</h3><table class=\"table table-striped table-bordered table-hover mobileFriendlyTable\" ng-if=\"vm.history.length\"><thead><tr><th>User</th><th>Role</th><th>Action Type</th><th>Details</th><th>Date</th></tr></thead><tbody><tr ng-repeat=\"history in vm.history\"><td><a ui-sref=\"index.accounts.detail({ objectKey: history.createdBy } )\">{{history.createdByName}}</a></td><td>{{history.createdByRole}}</td><td>{{history.typeName}}</td><td><p ng-if=\"history.statusName\">Status name: {{history.statusName}}</p><p ng-if=\"history.status === \'SHIPMENT_SHIPPED\' && history.meta\">(<span ng-if=\"history.meta.trackingNumber\">Tracking Number: {{history.meta.trackingNumber}},</span> <span ng-if=\"history.meta.carrier\">carrier: {{history.meta.carrier}}</span> )</p><p ng-if=\"history.type === \'MARK_STATUS\'\">Device status was changed from {{history.meta.oldStatus}} to {{history.meta.newStatus}} in case <a ng-if=\"history.meta.caseName && history.meta.case\" ui-sref=\"index.cases.edit({objectKey: history.meta.case})\">{{history.meta.caseName}}</a></p></td><td>{{history.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table><div ng-if=\"!vm.history.length\"><br>No actions with this device<br><br><br></div><div class=\"row pagination\" ng-if=\"vm.history.length\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setHistorySize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.historyPageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setHistorySize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.historyPageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setHistorySize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.historyPageSize == 50 ? \'selected\' : \'\'\">50</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousHistory()\" ng-disabled=\"vm.isHistoryLoading || !vm.previousHistoryPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextHistoryPage()\" ng-disabled=\"vm.isHistoryLoading || !vm.hasNextHistoryPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h3 class=\"subTitle\">Transfer</h3><table class=\"table mobileFriendlyTable\"><thead><tr><th>Status</th><th>From</th><th>To</th><th></th></tr></thead><tbody><tr ng-show=\"vm.device.transfer\"><td>{{ vm.device.transfer.status }}</td><td><a>{{ vm.device.transfer.source.name }}</a></td><td><a>{{ vm.device.transfer.target.name }}</a></td><td><div ng-show=\"vm.device.transfer.status === \'Pending\'\"><button ng-click=\"vm.acceptTransfer(vm.device.transfer)\" class=\"btn btn-xs btn-primary accept transfer-button\" csx-loading=\"\" csx-is-loading=\"vm.transferAccepting\">Accept</button> <button ng-click=\"vm.declineTransfer(vm.device.transfer)\" class=\"btn btn-xs btn-danger decline transfer-button\" csx-loading=\"\" csx-is-loading=\"vm.transferDeclining\">Decline</button></div></td></tr><tr ng-hide=\"vm.device.transfer.status === \'Pending\'\"><td colspan=\"4\"><a ng-click=\"vm.initiateTransfer()\" ng-if=\"vm.allowedTransfer || (vm.disableEditableFields && !vm.device.reusable)\" title=\"{{ vm.disableEditableFields && !vm.device.reusable ? \'You can not initiate a transfer.\' : \'\'}}\" ng-class=\"vm.disableEditableFields && !vm.device.reusable ? \'disabledLink\' : \'\'\"><span ng-if=\"vm.allowedTransferDevice\">Initiate Transfer</span></a> <b ng-if=\"!vm.allowedTransferDevice\">This device is assigned to a container. To transfer, you must first click “Release” in the top left of the “Container” field.</b></td></tr></tbody></table></div></div><div ng-show=\"vm.device.type === \'Container\'\"><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Devices</h3><p class=\"subSubTitle\">&nbsp;</p><md-input-container md-no-float=\"\" class=\"md-block\"><input ng-model=\"vm.deviceSearch\" placeholder=\"Filter Devices\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">UDI</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-4\"><p class=\"subSubTitle\">Assigned</p><p>{{ vm.assignedLotCount || \'--\' }}</p></div><div class=\"col-sm-6\"><p class=\"subSubTitle\">Unassigned</p><p>{{ vm.unassignedLotCount || \'--\' }}</p></div></div></div></div></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Device Status</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-4\"><p class=\"subSubTitle\">Used</p><p>{{ vm.usedDeviceCount || \'--\' }}</p></div><div class=\"col-sm-4\"><p class=\"subSubTitle\">Damaged</p><p>{{ vm.damagedDeviceCount || \'--\' }}</p></div><div class=\"col-sm-4\"><p class=\"subSubTitle\">Unused</p><p>{{ vm.unusedDeviceCount || \'--\' }}</p></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><table class=\"table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Name</th><th>Reference #</th><th>Tags</th><th>Lot/UDI</th><th>Status</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices | filter:vm.deviceSearch\"><td><a ng-click=\"vm.viewDevice(device.key)\">{{ device.name }}</a></td><td>{{ device.reference }}</td><td ng-class=\"(device.expirationStatus === \'Expired\' || device.expirationStatus === \'ExpiringSoon\' || device.tags.length > 0) ? \'\' : \'unassigned\'\"><span ng-show=\"device.expirationStatus === \'Expired\'\" class=\"csx-tag csx-error\">EXPIRED</span> <span ng-show=\"device.expirationStatus === \'ExpiringSoon\'\" class=\"csx-tag csx-warn\">EXPIRING SOON</span> <span ng-show=\"device.images.length > 0\" class=\"csx-tag\" style=\"color:white; background-color: #5B2D61;\"><i class=\"fa fa-image\"></i></span> <span ng-repeat=\"tag in device.tags track by $index\" class=\"csx-tag\">{{ tag }}</span></td><td>{{ device.udi.lot || device.udi.raw }}</td><td>{{ device.status }}</td><td>{{ device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr><tr ng-if=\"!vm.devices.length\"><td colspan=\"6\">This container is currently empty. You can assign individual inventory items to the container by editing the \"container\" field of the inventory you wish to add.</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-sm-12\" layout=\"row\" layout-align=\"center\"><md-progress-circular ng-show=\"vm.loadingDevices\" md-diameter=\"20\"></md-progress-circular></div></div></div></form>");
$templateCache.put("app/inventory/catalog/device.template.edit.html","<div class=\"wrapper wrapper-content animated\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.key ? vm.template.name : \'New Catalog Item\' }}</h2><p>{{ vm.template.reference }}</p></div></div><div class=\"row mobile-margin-botom margin-bottom-30\"><div class=\"col-md-4 col-xs-12\"><div><h3 class=\"subTitle\" style=\"margin-bottom: 36px !important;\">Device Template</h3></div><md-input-container class=\"md-block placeholder big-fontSize margin-bottom-null\"><label>Reference Number</label> <input ng-model=\"vm.template.reference\" ng-disabled=\"vm.template.reference.length && vm.disabledCatalogReference && vm.key\"> <span class=\"text-danger\">{{ vm.errorMessage }}</span></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize margin-bottom-null\"><label>Device Name</label> <input ng-model=\"vm.template.name\" style=\"padding: 2px 4px\" ng-disabled=\"vm.template.name.length && vm.disabledCatalogName && vm.key\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize margin-bottom-null\"><label>Manufacturer</label><md-select ng-model=\"vm.template.manufacturer\" ng-change=\"vm.template.products = []\" ng-disabled=\"vm.key\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.manufacturers\">{{ item.name }}</md-option></md-select></md-input-container></div></div><div class=\"row mobile-margin-bottom-null\" style=\"margin-bottom: 40px\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\" style=\"margin-bottom: 28px !important;\">Product Line</h3><md-autocomplete md-selected-item=\"vm.template.products\" class=\"md-block identicaUssualInput placeholder big-fontSize\" md-search-text=\"vm.productSearchText\" md-items=\"prod in vm.searchProducts(vm.productSearchText)\" md-no-cache=\"true\" md-item-text=\"prod.name\" placeholder=\"Search Product\" ng-disabled=\"vm.template.products && vm.disabledCatalogProductLine && vm.key\" md-clear-button=\"false\" md-require-match=\"\"><span md-highlight-text=\"vm.productSearchText\">{{ prod.name }}</span><md-item-template><span>{{prod.name}}</span></md-item-template><md-not-found>Not found, you can add a new product <a ui-sref=\"index.inventory.productcreate\" target=\"_blank\">here</a></md-not-found><div ng-messages=\"filterForm.productField.$error\" ng-if=\"filterForm.productField.$touched\"><div ng-message=\"md-require-match\">Please select product for your inventory.</div></div></md-autocomplete><p>if you don’t see the product line you want to add an item to, visit the <a ui-sref=\"index.inventory.productcreate\" target=\"_blank\">Product</a> page to add a new product line before continuing.</p></div><div class=\"col-md-4 col-xs-12\"><h3>&nbsp;</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Color Band</label> <input ng-model=\"vm.template.color\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><div ng-attr-style=\"height:30px; width:30px;margin: 60px 0 0; background-color:#{{ vm.template.color}};\"></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"titleIconWrap full-width absoluteIcon margin-top-null\"><h3 class=\"subTitle\">Images</h3><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">You are associating images with this device. These will be associate will all inventory with this catalog number and can include one or more images of the individual device. To add images to a specific piece of inventory (lot or UDI level), visit that inventory’s detail page.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><md-input-container class=\"md-block fixStylePosition placeholder big-fontSize\"><label></label><md-chips ng-model=\"vm.template.images\" placeholder=\"Enter URLs\"></md-chips></md-input-container><div ng-model=\"vm.template.images\" upload-folder=\"catalog\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"true\"></div></div><div class=\"col-sm-4 col-xs-12\"><div class=\"productImagesContainer\"><div ng-repeat=\"image in vm.template.images\"><a ng-href=\"{{image}}\" target=\"_blank\"><img ng-src=\"{{image}}\" alt=\"Can\'t load image\"></a></div></div></div></div><div class=\"row flex-end\"><div class=\"col-md-2 col-xs-12\"><div><md-progress-circular ng-show=\"vm.isSaving\" ng-disabled=\"!vm.isSaving\" class=\"md-primary pull-left\" style=\"margin-top:5px;margin-right:10px;\" md-diameter=\"20px\"></md-progress-circular></div><div><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create float-right\"><i class=\"fa fa-check\"></i> {{ vm.key ? \'Save\' : \'Create\' }}</button></div></div></div></div>");
$templateCache.put("app/inventory/catalog/device.templates.html","<div class=\"animated\"><div layout=\"row\" style=\"margin-top:8px; margin-bottom:8px;\" class=\"padding-left-15-desktop\"><h2 style=\"margin-top:0;\" class=\"title\">Inventory / Catalog</h2><div flex=\"\"></div><div><button ng-click=\"vm.goToCreatePage()\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Add Item</button></div></div><div layout=\"row\" class=\"padding-left-15-desktop\"><div class=\"col-sm-4\" style=\"padding-left:0;\"><h3 class=\"subTitle\">Manufacturer</h3><div class=\"form-group\" layout=\"row\"><md-input-container flex=\"\"><label>Manufacturer</label><md-select class=\"big-fontSize placeholder\" ng-model=\"vm.manufacturer\" ng-change=\"vm.search()\" md-selected-text=\"vm.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div></div><div class=\"row padding-left-15-desktop\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Product Line</th><th>Device Name</th><th>Reference #</th><th>Count</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices\"><td>{{ device.productLines }}</td><td><a ui-sref=\"index.inventory.catalog.edit({objectKey: device.key})\">{{ device.name }}</a></td><td>{{ device.reference }}</td><td>{{ device.count }}</td><td>{{ device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"center\" flex=\"\"><md-progress-circular ng-show=\"vm.loading\" md-diameter=\"25\" class=\"md-primary\"></md-progress-circular></div><div class=\"row pagination\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.hasPreviousPage()\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div>");
$templateCache.put("app/inventory/import/import.html","<div class=\"row padding-left-15-desktop\"><div class=\"col-xs-12 col-md-12\"><h1 class=\"title\">Import Inventory</h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 border-right-after\" flex=\"\" layout-padding=\"\"><div class=\"onboarding-heading\"><h2 class=\"titleF20\">1. Select File</h2><p class=\"f14\">Upload a CSV of your inventory.</p></div><form><div class=\"form-group importInputPosition\"><label class=\"sr-only\" for=\"fileUpload\">File</label> <input class=\"form-control placeholder big-fontSize\" id=\"fileUpload\" type=\"file\" accept=\".csv\" xls-import=\"\" multiple=\"false\"></div></form></div><div class=\"col-xs-12 col-md-6\" flex=\"\" layout-padding=\"\"><div class=\"onboarding-heading\"><h2 class=\"titleF20\">2. Map Fields</h2><p class=\"f14\">Select the manufacturer. Preview your imported data and update mappings below.</p></div><md-input-container style=\"margin-top:16px;width: 100%;\"><label>Manufacturer</label><md-select ng-disabled=\"vm.manufacturerDisabled\" ng-model=\"vm.manufacturer\" class=\"placeholder big-fontSize\"><md-option ng-repeat=\"option in vm.manufacturers\" ng-value=\"option\">{{ option.name }}</md-option></md-select></md-input-container></div></div><div layout=\"column\" layout-padding=\"\" layout-align=\"center\"><md-progress-linear ng-show=\"vm.progressVisible && vm.errors.length === 0\" md-mode=\"determinate\" value=\"{{vm.progressValue}}\"></md-progress-linear><p ng-show=\"vm.importMessage.length > 0\" class=\"text-success\">{{ vm.importMessage }}</p></div><div layout-padding=\"\" class=\"notice\"><b class=\"bold\">Notice:</b><p>Product, Description, and Reference Number are <b>required fields</b>. If you are importing with GS1 or HIBC UDIs that contain a Device Identifier that has been added to <a href=\"https://accessgudid.nlm.nih.gov/\" target=\"_blank\">FDA’s Access GUDID</a>, information from Access GUDID will be automatically imported into the appropriate fields in the device record. For reference, descriptions of each field available for import are outlined below. If this import contains UDIs with Lot and/or Serial numbers, data from the UDI will be used in the import <b>even if</b> you have additional Lot or Serial Number fields mapped.</p></div><div class=\"row\" ng-if=\"!vm.rows\"><div class=\"importLoading\"><div><h2 class=\"importLoading\" ng-if=\"vm.showLoading\"><div class=\"importLoading\">Import in progress<div class=\"sk-spinner sk-spinner-chasing-dots\"><div class=\"sk-dot1\"></div><div class=\"sk-dot2\"></div></div></div></h2><h4 class=\"f14\" ng-if=\"vm.showLoading\">You can continue to use the Console while your data imports. You will receive an alert when the import is complete.</h4></div></div></div><div class=\"mapFields\" ng-if=\"vm.rows\"><div class=\"row\"><div class=\"col-xs-12 col-md-12\"><h1 class=\"title\">Map your fields</h1></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Custody</h5><p flex=\"\" class=\"f14\">This is the user that currently has custody. It can be a sales user if it is out in the field, a distributor, or a manufacturer. In each case the value should be a valid email address or account ID that corresponds to an user on ConnectSx. If custody is not defined, the uploaded inventory will default to Distributor or Manufacturer custody (depending on the account type you are uploading from).</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Custody Header</label><md-select ng-model=\"vm.custodyHeader\" ng-change=\"vm.updatePreviews(vm.custodyHeader, \'custodyPreview\')\" flex=\"\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.custodyPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">UDI</h5><p class=\"f14\" flex=\"\">This is the raw GS1 or HIBCC unique device identifier string for each individual device that has been assigned in the GUDID database. This field can be left blank for items without a UDI.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>UDI Header</label><md-select ng-model=\"vm.udiHeader\" ng-change=\"vm.updatePreviews(vm.udiHeader, \'udiPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.udiPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Reference Number</h5><p class=\"f14\" flex=\"\">This is your catalog or product number that specifies the type of device (not the individual device itself). This can be any string of letters, numbers, or characters.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Reference Number Header</label><md-select ng-model=\"vm.referenceHeader\" ng-change=\"vm.updatePreviews(vm.referenceHeader, \'referencePreview\')\" flex=\"\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.referencePreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Product</h5><p class=\"f14\" flex=\"\">This is the product line or brand name.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Product Header</label><md-select ng-model=\"vm.productHeader\" ng-change=\"vm.updatePreviews(vm.productHeader, \'productPreview\')\" flex=\"\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.productPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Description</h5><p class=\"f14\" flex=\"\">This is the human readable descriptor for your devices. Some examples include \"T-Handle,\" \"80mm Cortical Screw,\" \"Slap Hammer\" and the like.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Description Header</label><md-select ng-model=\"vm.descriptionHeader\" ng-change=\"vm.updatePreviews(vm.descriptionHeader, \'descriptionPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.descriptionPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Tags</h5><p class=\"f14\" flex=\"\">These are identifies such as length, size, product type, etc. that help you quickly find relevant items in your inventory. This can be any string of letters, numbers, or characters.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Tag Headers</label><md-select ng-model=\"vm.tagHeader\" multiple=\"true\" ng-change=\"vm.updatePreviews(vm.tagHeader, \'tagPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.tagPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Quantity</h5><p class=\"f14\" flex=\"\">This is the number of items you have on hand in your assigned inventory. This must be a valid number. (\"1\" and NOT \"one\").</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Quantity Header</label><md-select ng-model=\"vm.quantityHeader\" ng-change=\"vm.updatePreviews(vm.quantityHeader, \'quantityPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.quantityPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Container</h5><p class=\"f14\" flex=\"\">This is the identifier for any top-level items containing \"child\" inventory, such as trays, sterile packs, etc. Devices assigned to these containers will reflect this number in their detail page. Items with multiple containers (e.g. implants in sterile packs that are inside trays) will reflect all appropriate IDs.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Container Header</label><md-select ng-model=\"vm.containerHeader\" ng-change=\"vm.updatePreviews(vm.containerHeader, \'containerPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.containerPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Billable</h5><p class=\"f14\" lex=\"\">This is usually a \"Yes/No\" for whether you charge for the given item or device. This must be a text string. Note: If you leave this field blank, the billable status will be determined by the price column. That is, if there is a prices associated, we will consider it billable = \"yes\".</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Billable Header</label><md-select ng-model=\"vm.billableHeader\" ng-change=\"vm.updatePreviews(vm.billableHeader, \'billablePreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.billablePreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Price</h5><p class=\"f14\" flex=\"\">This is the price of the individual item. Please note this is the list price; you can edit actual price for each case at the invoice level. Missing values will default to \"$0.\" This must be a valid number.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Price Header</label><md-select ng-model=\"vm.priceHeader\" ng-change=\"vm.updatePreviews(vm.priceHeader, \'pricePreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.pricePreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Lot Number</h5><p class=\"f14\" flex=\"\">While the lot number is present in the UDI string, we recognize some items will not have current UDIs. In the event that you do not have UDIs but you DO have Lot Number, it will be mapped to this field.</p><p>Note: If your UDI contains lot number data, that information will be used, <b>even if</b> you map this field.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Lot Header</label><md-select ng-model=\"vm.lotHeader\" ng-change=\"vm.updatePreviews(vm.lotHeader, \'lotPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.lotPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Barcode</h5><p class=\"f14\" flex=\"\">This is the barcode data. It should appear exactly as any barcode scanner will read it.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Barcode Header</label><md-select ng-model=\"vm.barcodeHeader\" ng-change=\"vm.updatePreviews(vm.barcodeHeader, \'barcodePreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.barcodePreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Serial Number</h5><p class=\"f14\" flex=\"\">While the serial number is present in the UDI string, we recognize some items will not have current UDIs. In the event that you do not have UDIs but you DO have a Serial Number, it will be mapped to this field.</p><p>Note: If your UDI contains serial number data, that information will be used, <b>even if</b> you map this field.</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Serial Header</label><md-select ng-model=\"vm.serialHeader\" ng-change=\"vm.updatePreviews(vm.serialHeader, \'serialHeaderPreview\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.serialHeaderPreview track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row margin-bottom-30\"><div class=\"col-xs-12 col-md-5\"><h5 class=\"titleF20\">Expiration date</h5><p class=\"f14\" flex=\"\">If you do not have associated data for all fields, they will leave the irrelevant field mappings blank, you can use mm/dd/yyyy or mm-dd-yyyy formats</p></div><div class=\"col-xs-12 col-md-7 border-gray\"><md-input-container class=\"full-width big-fontSize placeholder\"><label>Expiration Date Header</label><md-select ng-model=\"vm.expirationDateHeader\" ng-change=\"vm.updatePreviews(vm.expirationDateHeader, \'expirationDate\')\"><md-option>None</md-option><md-option ng-value=\"$index\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container><div class=\"onboarding-import-preview\"><b>Preview:</b><ul class=\"csx-row-preview\"><li ng-repeat=\"e in vm.expirationDate track by $index\">{{ e }}</li></ul></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-12\" style=\"padding: 0\"><button class=\"btn btn-md btn-primary float-right\" style=\"padding: 6px 30px;\" ng-click=\"vm.importInventory()\">Import</button></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-12\" style=\"padding: 0\"><div class=\"colorRed\">{{vm.importError}}</div><div class=\"colorRed\"><p ng-if=\"vm.parseDateErrorShow\">Error parse Expiration date, wrong format is used in {{vm.parseDateErrorCount}} of {{vm.rows.length}} items</p></div><ul ng-show=\"vm.errors.length > 0\" class=\"errors paddingNone\"><li class=\"no-bull text-error\" ng-repeat=\"error in vm.errors track by $index\">{{ error }}<br></li></ul></div></div>");
$templateCache.put("app/inventory/export/inventory.export.success.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><br><h3 style=\"color:white;margin-bottom: 0 !important;\">CSV file was downloaded successfully</h3><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-actions layout=\"row\"><md-button class=\"md-primary hoverButtonBg\" style=\"margin: auto;border: 2px solid #5b2d61;color: #5b2d61; background: #fff;border-radius: 5px;\" ng-click=\"vm.cancel()\"><span>Ok</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/export/inventory.export.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><br><h3 style=\"color:white;margin-bottom: 0 !important;\">Please select the data you wish to export.<br>Note that your export will be generated as a .csv file.</h3><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\" style=\"padding: 0 0 0 20px;\"><md-radio-group ng-model=\"vm.type\" style=\"margin:15px 15px 0 15px !important;\" ng-disabled=\"vm.saving\"><md-radio-button value=\"UNUSED\" aria-label=\"Label 1\">Unused Inventory Only</md-radio-button><md-radio-button aria-label=\"Green\" value=\"ALL\">All Inventory</md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions layout=\"row\"><div flex=\"\"></div><md-progress-circular ng-show=\"vm.saving\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"md-primary\" ng-click=\"vm.cancel()\">Cancel</md-button><md-button class=\"md-primary\" ng-disabled=\"vm.saving\" ng-click=\"vm.submit()\"><span ng-if=\"!vm.saving\">Submit</span> <span ng-if=\"vm.saving\">Generating...</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/list/inventory.list.html","<div ng-switch=\"vm.isLoading\" flex=\"\" class=\"padding-left-15-desktop\"><div ng-switch-when=\"true\" layout=\"row\" class=\"preloader\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div ng-switch-default=\"\" class=\"animated\"><div layout=\"row\" style=\"margin-top:8px; margin-bottom:8px;\"><h2 style=\"margin-top:0;\" class=\"title\">Inventory / Search</h2><div flex=\"\"></div><div class=\"flexWrap\"><button ui-sref=\"index.inventory.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Add Inventory</button> <button ng-if=\"vm.isShowExportButton()\" ng-click=\"vm.exportInventory()\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-file-excel-o\"></i> &nbsp;&nbsp;Export Inventory</button></div></div><div layout=\"row\"><md-input-container flex=\"auto\" style=\"height:52px;\" class=\"no-horizontal-padding\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter($chip)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip class=\"csx-add-chip\"><a ng-click=\"vm.addFilter()\"><span style=\"color:white;\"><i class=\"fa fa-plus\"></i> &nbsp; Filter</span></a></md-chip><md-chip style=\"padding-right: 12px !important;\"><span><strong>org:</strong> {{ vm.org.name }}</span></md-chip><md-chip-template><span><span ng-if=\"$chip.display === \'Explante...\'\"><strong>{{$chip.key }}:</strong> In/Out</span> <span ng-if=\"$chip.display !== \'Explante...\'\"><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" style=\"height:5px;\"><md-progress-linear style=\"margin-top:-20px;\" ng-show=\"vm.searchLoading\" ng-disabled=\"!vm.searchLoading\" class=\"md-primary\" md-mode=\"indeterminate\"></md-progress-linear></div><div layout=\"row\" ng-if=\"vm.devices.length\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\" style=\"overflow-x: hidden\"><thead><tr><th style=\"min-width:100px;\">Name</th><th>Container</th><th>Case</th><th>Reference</th><th>Tags</th><th>Lot/Serial #</th><th>Status</th><th>Custody</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices\"><td><a ng-click=\"vm.viewDevice(device.key)\">{{ device.name }}</a><span></span></td><td ng-class=\"device.container.key ? \'\' : \'unassigned\'\"><a ng-click=\"vm.viewDevice(device.container.key)\">{{ device.container.name }}</a></td><td ng-class=\"device.caze.key ? \'\' : \'unassigned\'\"><a ng-show=\"device.caze.key\" class=\"text-primary\" ng-click=\"vm.viewCase(device.caze.key)\">{{ device.caze.name || \'View Case\'}}</a></td><td>{{ device.reference }}</td><td ng-class=\"(device.expirationStatus === \'Expired\' || device.expirationStatus === \'ExpiringSoon\' || device.tags.length > 0 || vm.checkPastDate(device.dueBackDate) ) ? \'\' : \'unassigned\'\"><span ng-show=\"device.expirationStatus === \'Expired\'\" class=\"csx-tag csx-error\">EXPIRED</span> <span ng-show=\"device.dueBackStatus === \'OVERDUE\'\" class=\"csx-tag csx-error\">OVERDUE</span> <span ng-show=\"device.dueBackStatus === \'IN_24_HOURS\'\" class=\"csx-tag csx-warn\">Due in 24 hours</span> <span ng-show=\"device.dueBackStatus === \'IN_48_HOURS\'\" class=\"csx-tag csx-warn\">Due in 48 hours</span> <span ng-show=\"device.dueBackStatus === \'OVER_48_HOURS\'\" class=\"csx-tag csx-warn\">Over 48 hours</span> <span ng-show=\"device.expirationStatus === \'ExpiringSoon\'\" class=\"csx-tag csx-warn\">EXPIRING SOON</span> <span ng-show=\"device.images.length > 0\" class=\"csx-tag\" style=\"color:white; background-color: #5B2D61;\"><i class=\"fa fa-image\"></i></span> <span ng-repeat=\"tag in device.tags track by $index\" class=\"csx-tag\">{{ tag }}</span></td><td ng-class=\"(device.udi.lot || device.udi.serial) ? \'\' : \'unassigned\'\">{{ device.udi.lot || device.udi.serial }}</td><td><span ng-if=\"device.status === \'Explanted\'\">In/Out</span> <span ng-if=\"device.status !== \'Explanted\'\">{{ device.status }}</span></td><td>{{ device.custody.name }}</td><td>{{ device.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr></tbody></table></div><div class=\"row\" ng-hide=\"vm.devices.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>It looks like no inventory matches your search. Please check your information and try again.</h3></div></div><div class=\"row pagination\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div></div>");
$templateCache.put("app/inventory/products/inventory.products.create.html","<div class=\"wrapper wrapper-content animated cases-edit\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large title\" style=\"line-height: 1;\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">{{ vm.product.name || \'New Product\' }}</h2><br></div></div><h3 class=\"subTitle\">Product Details</h3><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"hide-mobile\">&nbsp;</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><label>Product Name</label> <input ng-model=\"vm.product.name\" required=\"\"></md-input-container></div></div></div></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"hide-mobile\">&nbsp;</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><label>Asset Url</label> <input ng-model=\"vm.product.assetUrl\"></md-input-container></div></div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\" style=\"margin-bottom: 21px !important;\">Manufacturer</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\" layout=\"row\" layout-align=\"start\" flex=\"\"><md-input-container flex=\"100\" ng-show=\"vm.product.key\" class=\"placeholder\"><label>Manufacturer</label> <input ng-model=\"vm.product.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.product.key\"><label>Manufacturer</label><md-select ng-model=\"vm.product.manufacturer\" md-selected-text=\"vm.product.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div></div></div><div class=\"col-md-4 col-xs-12 mobile-margin-bottom\"><h3 style=\"margin-bottom: 30px !important;\" class=\"subTitle\">vTray Guides</h3><md-chips ng-model=\"vm.product.guides\" md-require-match=\"true\" class=\"labelPosition labelPosition__md-chips chipsPositionFix placeholder\"><md-autocomplete class=\"md-block\" md-selected-item=\"vm.selectedGuide\" md-search-text=\"vm.guideSearchText\" md-items=\"guide in vm.searchGuides(vm.guideSearchText)\" md-no-cache=\"true\" md-item-text=\"guide.name\" placeholder=\"Add Guide\"><span md-highlight-text=\"vm.guideSearchText\">{{ guide.name }}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"space-between\"><h3 class=\"subTitle\" style=\"margin-bottom: 9px !important;\">Technique Guides/IFU</h3></div><md-input-container class=\"md-block fixStylePosition placeholder\"><label></label><md-chips ng-model=\"vm.product.ifuUrls\" placeholder=\"Enter URLs\"></md-chips></md-input-container><div ng-model=\"vm.product.ifuUrls\" upload-folder=\"product\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"false\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"titleIconWrap\"><h3 class=\"subTitle\">Images</h3><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">You are associating images with this product line. These will be associate will all inventory in this product family and can include images of complete sets, trays, and the like. To add images of individual instruments and devices, visit that item\'s individual catalog page.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><md-input-container class=\"md-block fixStylePosition placeholder\"><label></label><md-chips ng-model=\"vm.product.images\" placeholder=\"Enter Images URLs\"></md-chips></md-input-container><div ng-model=\"vm.product.images\" upload-folder=\"product\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"true\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"productImagesContainer\"><div ng-repeat=\"image in vm.product.images\"><a ng-href=\"{{image}}\" target=\"_blank\"><img ng-src=\"{{image}}\" alt=\"Can\'t load image\"></a></div></div></div></div><div class=\"row\"><div class=\"col-md-8 col-xs-12\"><h3 class=\"subTitle\">Description</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><textarea placeholder=\"Description\" ng-model=\"vm.product.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div></div></div></div><div class=\"row flex-end\"><div class=\"col-md-2 col-xs-12\"><div class=\"col-md-1\" style=\"padding: 10px 30px;\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> <span ng-hide=\"vm.product.key\">Create</span> <span ng-show=\"vm.product.key\">Save</span></button></div></div></div>");
$templateCache.put("app/inventory/products/inventory.products.html","<div class=\"animated padding-left-15-desktop\"><div layout=\"row\" style=\"margin-top:8px; margin-bottom:8px;\"><h2 style=\"margin-top:0;\" class=\"title\">Products</h2><div flex=\"\"></div><div flex=\"\"></div><div><button ui-sref=\"index.inventory.productcreate\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> &nbsp;&nbsp;Create Product</button></div></div><div class=\"row\"><div class=\"col-lg-12\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Product Line</th><th>Manufacturer Name</th><th>IFU</th><th>Description</th><th>Last update</th></tr></thead><tbody><tr ng-repeat=\"product in vm.allProducts\"><td><a ng-click=\"vm.editProduct(product.key)\">{{ product.name }}</a><span></span></td><td>{{ product.manufacturer.name }}</td><td style=\"max-width: 600px;\"><p ng-repeat=\"ifu in product.ifuUrls\" class=\"word-wrap\">{{ifu}}</p></td><td>{{ product.description }}</td><td>{{ product.modifiedDate | date:\'MM/dd/yyyy h:mm a\'}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/inventory/requests/request.edit.html","<div class=\"wrapper wrapper-content animated\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Inventory Request</h2><div style=\"padding-bottom:8px;\" ng-class=\"vm.statusClass(vm.request.status)\" class=\"csx-status\">{{ vm.request.status | uppercase }}</div></div><div ng-show=\"vm.request.status === \'Created\'\" style=\"margin-left:20px; margin-right:20px;\"><button csx-loading=\"\" csx-is-loading=\"vm.isCancelling\" ng-click=\"vm.cancelRequest()\" class=\"btn btn-outline btn-danger create\">Decline</button></div><div ng-show=\"vm.request.status === \'Created\'\"><button csx-loading=\"\" csx-is-loading=\"vm.isSaving\" style=\"width:100px;\" ng-click=\"vm.fulfill()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Fulfill</button></div></div><div class=\"row\" style=\"margin-bottom: 40px\"><div class=\"col-md-11\"><div class=\"row\"><div class=\"col-md-3\"><p class=\"subSubTitle\">Sender</p><p>{{ vm.request.sourceName }}</p></div><div class=\"col-md-3\"><p class=\"subSubTitle\">Recipient</p><p>{{ vm.request.targetName }}</p></div><div class=\"col-md-3\"><p class=\"subSubTitle\">Email Notifications</p><p>{{ vm.request.email }} <span class=\"unassigned\" style=\"color:lightgrey;\" ng-hide=\"vm.request.email\">none</span></p></div><div class=\"col-md-3\"><p class=\"subSubTitle\">Case</p><p><a ng-show=\"vm.request.assignedCase.key\" ui-sref=\"index.cases.edit({ objectKey: vm.request.assignedCase.key })\">{{ vm.request.assignedCase.name || \'View Case\'}}</a> <span class=\"unassigned\" style=\"color:lightgrey;\" ng-hide=\"vm.request.assignedCase\">none</span></p></div></div><div class=\"row\"><div class=\"col-md-3\"><p class=\"subSubTitle\">Updated By</p><p>{{ vm.request.modifiedByName }}</p></div><div class=\"col-md-3\"><p class=\"subSubTitle\">Last Updated</p><p>{{ vm.request.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-md-3\"><p class=\"subSubTitle\">Created By</p><p>{{ vm.request.createdByName || \'No name set\'}}</p></div><div class=\"col-md-3\"><p class=\"subSubTitle\">Created</p><p>{{ vm.request.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row\"><div class=\"col-sm-12\"><p class=\"subSubTitle\">Note</p><p>{{ vm.request.message }} <span class=\"unassigned\" style=\"color:lightgrey;\" ng-hide=\"vm.request.message\">none</span></p></div></div></div></div><div class=\"row\" style=\"margin-bottom: 40px\"><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block\"><label>Carrier</label><md-select class=\"placeholder big-fontSize\" ng-model=\"vm.request.fulfillment.tracking.carrier\" ng-disabled=\"!vm.trackingEnabled\"><md-option ng-value=\"carrier.value\" ng-repeat=\"carrier in vm.carriers\">{{ carrier.name }}</md-option></md-select></md-input-container></div><div class=\"col-md-4 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Tracking #</label> <input ng-model=\"vm.request.fulfillment.tracking.number\" ng-disabled=\"!vm.trackingEnabled\"></md-input-container></div><div class=\"col-md-4 col-xs-12\" layout=\"row\" style=\"align-items: center\"><h3 class=\"subTitle\">Tracking</h3><div layout-margin=\"\"></div><md-switch ng-show=\"vm.request.status === \'Created\'\" style=\"margin:0;\" class=\"md-primary placeholder big-fontSize\" ng-model=\"vm.trackingEnabled\">{{ vm.trackingEnabled ? \'Enabled\' : \'Disabled\' }}</md-switch><div flex=\"\"></div><div ng-show=\"vm.request.fulfillment.tracking.track.trackingStatus.objectUpdated\">Last Updated: {{ vm.request.fulfillment.tracking.track.trackingStatus.objectUpdated | date:\'MM/dd/yyyy h:mm a\' }}</div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\" ng-show=\"vm.request.status === \'Fulfilled\' && vm.request.fulfillment.tracking.number\" style=\"margin-top:-40px !important;\"><p ng-hide=\"vm.request.fulfillment.tracking.track\">No additional tracking information available. Please verify your tracking number with your carrier.</p></div><div class=\"col-md-12 col-xs-12\" ng-show=\"vm.request.status === \'Fulfilled\' && !vm.request.fulfillment.tracking.number\" style=\"margin-top:-40px !important;\"><p ng-hide=\"vm.request.fulfillment.tracking.track\">No additional tracking information provided.</p></div></div><div class=\"row\" ng-show=\"vm.request.fulfillment.tracking.track\"><div class=\"col-md-4 col-xs-12\" ng-show=\"vm.request.fulfillment.tracking.track.addressFrom\"><p class=\"detail-field-title\">From Address</p><p>{{ vm.request.fulfillment.tracking.track.addressFrom.city }}, {{ vm.request.fulfillment.tracking.track.addressFrom.state }}</p></div><div class=\"col-md-4 col-xs-12\" ng-show=\"vm.request.fulfillment.tracking.track.addressTo\"><p class=\"detail-field-title\">To Address</p><p>{{ vm.request.fulfillment.tracking.track.addressTo.city }}, {{ vm.request.fulfillment.tracking.track.addressTo.state }}</p></div><div class=\"col-md-4 col-xs-12\" ng-show=\"vm.request.fulfillment.tracking.track.trackingStatus\"><p class=\"detail-field-title\">Status</p><p><span ng-hide=\"vm.request.fulfillment.tracking.track.trackingStatus.status === \'UNKNOWN\'\">{{ vm.request.fulfillment.tracking.track.trackingStatus.status }}<br></span> {{ vm.request.fulfillment.tracking.track.trackingStatus.statusDetails }}</p></div><div class=\"col-md-4 col-xs-12\" ng-show=\"vm.request.fulfillment.tracking.track.eta\"><p class=\"detail-field-title\">ETA</p><p>{{ vm.request.fulfillment.tracking.track.eta | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Requested Inventory</h3><div ng-show=\"vm.request.products\">Products:<div ng-repeat=\"product in vm.request.products\">{{ product.name }}</div></div><div ng-show=\"vm.request.devices\"><div ng-repeat=\"device in vm.request.devices\"><p class=\"detail-field-title\">{{ device.reference }} <span style=\"font-size: 12px; color:grey;\">x{{ device.count }}</span></p><p>{{ device.name }}</p></div></div></div><div ng-show=\"vm.request.status === \'Fulfilled\' && !!vm.request.fulfillment.key\" class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Fulfilled by Transfer</h3><div>Status: {{ vm.request.fulfillment.status }}</div><div><table class=\"table no-border mobileFriendlyBitTable\"><thead><tr><th>Type</th><th>Name</th><th>Reference #</th><th>Lot #</th></tr></thead><tbody><tr ng-hide=\"vm.request.fulfillment.inventory.length > 0\"><td>No inventory.</td><td></td><td></td><td></td></tr><tr ng-repeat=\"device in vm.request.fulfillment.inventory\"><td>{{ device.type }}</td><td><a ng-click=\"vm.show.device(device)\">{{ device.name }}</a></td><td>{{ device.reference}}</td><td>{{ device.udi.lot }}</td></tr></tbody></table></div></div><div ng-show=\"vm.request.status === \'Created\'\" class=\"col-md-4 col-xs-12\"><div layout=\"row\"><h3 class=\"subTitle\">Fulfillment</h3><div style=\"margin-left: 20px;\" flex=\"\"></div><div><button csx-loading=\"\" ng-click=\"vm.addInventory()\" class=\"btn btn-outline btn-primary create\">Manage Inventory</button></div></div><p class=\"text-warning\" ng-show=\"vm.mismatch\">{{ vm.mismatchError }}</p><p ng-hide=\"vm.fulfillment && vm.fulfillment.length > 0\">No inventory selected</p><div ng-repeat=\"item in vm.fulfillment\" ng-switch=\"item.type\"><div ng-switch-when=\"Container\">{{ item.name }}</div><div ng-switch-when=\"Device\"><p class=\"detail-field-title\">{{ item.reference }} <span ng-show=\"item.udi.lot\">({{ item.udi.lot }})</span></p><p>{{ item.name }}</p></div></div></div></div></div>");
$templateCache.put("app/inventory/requests/requests.list.html","<div ng-switch=\"vm.isLoading\" class=\"padding-left-15-desktop\"><div ng-switch-when=\"true\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div ng-switch-default=\"\" class=\"animated\"><div layout=\"row\" style=\"margin-top:8px; margin-bottom:8px;\"><h2 style=\"margin-top:0;\" class=\"title\">Inventory / Requests</h2><div flex=\"\"></div><div></div></div><div layout=\"row\" ng-if=\"vm.filters\"><md-input-container flex=\"auto\" class=\"no-horizontal-padding placeholder big-fontSize\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" style=\"height:5px;\"><md-progress-linear style=\"margin-top:-20px;\" ng-show=\"vm.searchLoading\" ng-disabled=\"!vm.searchLoading\" class=\"md-primary\" md-mode=\"indeterminate\"></md-progress-linear></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Requested Inventory</th><th>From</th><th>To</th><th>Last Updated</th><th>Status</th><th style=\"width:50px;\">Actions</th></tr></thead><tbody><tr ng-repeat=\"request in vm.requests\"><td><a ng-click=\"vm.editRequest(request)\">{{ request.description }}</a><p>{{ request.message }}</p></td><td><a ng-click=\"vm.show.transferSource(request)\">{{ request.sourceName }}</a></td><td><a ng-click=\"vm.show.transferTarget(request)\">{{ request.targetName }}</a></td><td>{{ request.modifiedDate | date: \'MM/dd/yyyy\' }}</td><td>{{ request.status }}</td><td><div layout=\"row\" class=\"mobile-wrap\"><a ng-click=\"vm.showComments(request)\" style=\"margin-right:16px;\"><i class=\"fa fa-comment-o\"></i></a><div flex=\"\"></div></div></td></tr></tbody></table></div><div class=\"row\" ng-hide=\"vm.requests.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>It looks like no inventory requests match your search. Please check your information and try again.</h3></div></div><div class=\"row pagination\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div></div>");
$templateCache.put("app/inventory/transfers/transfers.list.html","<div ng-switch=\"vm.isLoading\" class=\"padding-left-15-desktop\"><div ng-switch-when=\"true\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div ng-switch-default=\"\" class=\"animated\"><div layout=\"row\" style=\"margin-top:8px; margin-bottom:8px;\"><h2 style=\"margin-top:0;\" class=\"title\">Inventory / Transfers</h2><div flex=\"\"></div><div><button ng-click=\"vm.sendInventory()\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-send\"></i> &nbsp;&nbsp;Send Inventory</button></div></div><div layout=\"row\" ng-if=\"vm.filters.length\"><md-input-container flex=\"auto\" class=\"no-horizontal-padding placeholder big-fontSize\"><md-chips readonly=\"true\" md-removable=\"true\" md-on-remove=\"vm.onRemoveFilter(filter)\" ng-model=\"vm.filters\" delete-button-label=\"Remove Filter\" delete-hint=\"Press delete to remove filter\"><md-chip-template><span><strong>{{$chip.key }}:</strong> {{$chip.display}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" style=\"height:5px;\"><md-progress-linear style=\"margin-top:-20px;\" ng-show=\"vm.searchLoading\" ng-disabled=\"!vm.searchLoading\" class=\"md-primary\" md-mode=\"indeterminate\"></md-progress-linear></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Device/Tray</th><th>From</th><th>To</th><th>Last Updated</th><th>Status</th><th style=\"width:50px;\">Actions</th></tr></thead><tbody><tr ng-repeat=\"transfer in vm.transfers\"><td><a ng-click=\"vm.show.transfer(transfer)\">{{ transfer.description }}</a></td><td><a ng-click=\"vm.show.transferSource(transfer)\">{{ transfer.source.name }}</a></td><td><a ng-click=\"vm.show.transferTarget(transfer)\">{{ transfer.target.name }}</a></td><td>{{ transfer.modifiedDate | date: \'MM/dd/yyyy\' }}</td><td>{{ transfer.status }}</td><td><div layout=\"row\" class=\"mobile-wrap\"><a ng-click=\"vm.showComments(transfer)\" style=\"margin-right:16px;\"><i class=\"fa fa-comment-o\"></i></a><div flex=\"\"></div><button ng-hide=\"transfer.status !== \'Pending\'\" ng-click=\"vm.transferAccept(transfer)\" class=\"btn btn-xs btn-primary accept transfer-button\" csx-loading=\"\" csx-is-loading=\"vm.loading[transfer.key].accepting || false\">Accept</button> <button ng-hide=\"transfer.status !== \'Pending\'\" ng-click=\"vm.transferDecline(transfer)\" class=\"btn btn-xs btn-danger decline transfer-button\" csx-loading=\"\" csx-is-loading=\"vm.loading[transfer.key].declining || false\">Decline</button></div></td></tr></tbody></table></div><div class=\"row\" ng-hide=\"vm.transfers.length > 0\"><div class=\"col-sm-12\" style=\"text-align: center;\"><h3>It looks like no transfers match your search.<br><br>Please check your information and try again.</h3></div></div><div class=\"row pagination\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize === 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize === 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize === 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div></div></div>");
$templateCache.put("app/onboarding/users/users.html","<div layout=\"row\" layout-align=\"center\"><div class=\"onboarding-heading\"><h1><i class=\"fa fa-users\"></i> Invite Users</h1><p>Users added below will receive an email invitation to claim their account.</p></div></div><div layout=\"row\" layout-align=\"center\" class=\"onboarding-horizontal-form\"><md-input-container><label>Email</label> <input required=\"\" name=\"userEmail\" ng-model=\"vm.email\"><div ng-messages=\"createForm.userEmail.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container><label>Role</label><md-select required=\"\" ng-model=\"vm.role\" style=\"min-width: 152px;\"><md-option ng-repeat=\"option in vm.roles\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container><div style=\"margin-top:24px;\"><a ng-click=\"vm.addUser(vm.email, vm.role)\"><i class=\"fa fa-plus-circle primary\"></i></a></div></div><div><div ng-repeat=\"user in vm.users\">{{ user.email }} ({{user.accountType }})</div></div><div layout=\"row\" layout-align=\"center\"><button class=\"btn btn-md btn-primary pull-right\" ng-disabled=\"vm.users.length === 0\" ng-click=\"vm.inviteUsers()\">Invite Users</button></div>");
$templateCache.put("app/onboarding/welcome/welcome.html","<div layout=\"row\" layout-align=\"center\"><div class=\"onboarding-heading\"><h1>Welcome to ConnectSx</h1></div></div><div layout=\"row\"><div class=\"col-md-6 col-md-offset-3 onboarding-box\"><h2>Get Started</h2><div class=\"row\"><div class=\"col-xs-2\"><a ui-sref=\"index.onboarding.users\"><i class=\"fa fa-users\"></i></a></div><div class=\"col-xs-10\"><h4><a ui-sref=\"index.onboarding.users\">Invite Users</a></h4><p>Invite sales or manufacturer users to your account. Sales users are reps out in the field with your inventory. Manufacturer users administer this account from the console.</p><p>If you want to assign custody to inventory as you import it into ConnectSx you will need to add sales users first.</p></div></div><div class=\"row\"><div class=\"col-xs-2\"><a ui-sref=\"index.onboarding.inventory\"><i class=\"fa fa-barcode\"></i></a></div><div class=\"col-xs-10\"><h4><a ui-sref=\"index.onboarding.inventory\">Import Inventory</a></h4><p>Import inventory by uploading a CSV file here in the console. If you have a lot of inventory to manage you should look into integrating with our Api.</p></div></div></div></div><div layout=\"row\" style=\"margin-bottom:48px;\"><div class=\"col-md-6 col-md-offset-3 onboarding-box\"><h2>Need Help?</h2><div class=\"row\"><div class=\"col-xs-2\"><a href=\"#\"><i class=\"fa fa-comment\"></i></a></div><div class=\"col-xs-10\"><h4><a href=\"#\">Messaging</a></h4><p>If you have any questions or feedback click on the chat bubble at the bottom right of your screen. This should appear on any page in the console and it\'s the quickest way for us to help.</p></div></div><div class=\"row\"><div class=\"col-xs-2\"><a href=\"#\"><i class=\"fa fa-phone\"></i></a></div><div class=\"col-xs-10\"><h4><a href=\"#\">Phone Call</a></h4><p>We are also happy to field any questions you have over the phone while you are getting up-to-speed.</p></div></div><div class=\"row\"><div class=\"col-xs-2\"><a href=\"https://www.connectsx.com/knowledge-base/\"><i class=\"fa fa-file-text\"></i></a></div><div class=\"col-xs-10\"><h4><a href=\"https://www.connectsx.com/knowledge-base/\">Read Documentation</a></h4><p>We have extensive documentation for all of our products in our knowledge base. Check it out!</p></div></div></div></div>");
$templateCache.put("app/settings/facilities/settings.facilities.html","<div class=\"wrapper wrapper-content animated\"><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><label class=\"font-normal\">Facility</label> <input type=\"text\" ng-model=\"vm.searchFacilityName\" placeholder=\"\" typeahead-loading=\"vm.loadingFacilities\" typeahead-no-results=\"vm.noFacilityResults\" typeahead-wait-ms=\"500\" typeahead-on-select=\"vm.selectFacility($item)\" uib-typeahead=\"facility as f.name for f in vm.getFacility($viewValue)\" class=\"form-control\"></div><div class=\"col-sm-1\"><button class=\"btn btn-sm btn-outline btn-primary pull-right\" ng-click=\"vm.addFavorite()\">Add</button></div></div></div><div class=\"row\"><div class=\"col-md-12\"><hr></div></div><div class=\"row\" ng-repeat=\"facility in vm.facilities\"><div class=\"col-sm-11\"><h3>{{ facility.name }}</h3><p>{{ facility.address }}, {{ facility.city }}, {{ facility.state }}</p></div><div class=\"col-sm-1\"><button class=\"btn btn-sm btn-outline btn-danger pull-right\" ng-click=\"vm.removeFavorite(facility.key)\">Remove</button></div><div class=\"col-md-12\"><hr></div></div></div>");
$templateCache.put("app/settings/accounts/accounts.html","<div class=\"wrapper wrapper-content animated\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><button ng-click=\"vm.addUser()\" class=\"btn btn-outline btn-default create pull-right\"><i class=\"fa fa-plus\"></i> Add User</button><h3>Invitations</h3><table class=\"table mobileFriendlyTable\"><thead><tr><th>Email</th><td></td><th>Role</th><th>Date</th></tr></thead><tbody><tr ng-hide=\"vm.invitations.length > 0\"><td>No Pending Invitations</td><td></td><td></td></tr><tr ng-repeat=\"invitation in vm.invitations\"><td><a>{{ invitation.email }}</a></td><td><span ng-show=\"invitation.claimed\" class=\"details\">Claimed</span> <span ng-hide=\"invitation.claimed\" class=\"details\">Invitation sent</span></td><td>{{ invitation.accountType }}</td><td>{{ invitation.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</td><td></td></tr></tbody></table></div><div class=\"col-sm-12\"><hr></div></div></div>");
$templateCache.put("app/settings/accounts/add.user.tmpl.html","<md-dialog aria-label=\"Invite User\" style=\"min-width: 500px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Invite User</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"col-sm-6\" layout=\"row\"><md-input-container flex=\"100\"><label>Email</label> <input type=\"email\" ng-model=\"email\" required=\"\"></md-input-container></div><div class=\"col-sm-6\" layout=\"row\"><md-input-container flex=\"100\"><label>Role</label><md-select aria-label=\"role\" ng-model=\"role\" required=\"\"><md-option ng-value=\"option\" ng-repeat=\"option in roles\">{{ option }}</md-option></md-select></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"submit(email, role)\" class=\"md-primary\">Add</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/settings/manufacturers/settings.manufacturers.html","<div class=\"animated\"><div layout=\"row\"><div layout=\"column\" flex=\"25\" style=\"margin-right:24px;\"><md-list ng-cloak=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"manufacturer in vm.org.manufacturers\" ng-click=\"vm.checkChanges($event, manufacturer)\"><div class=\"md-list-item-text\" layout=\"column\"><h3 style=\"margin-bottom:0 !important;\">{{ manufacturer.name }}</h3><p>{{ manufacturer.objectId }}</p></div><md-divider></md-divider></md-list-item><md-list-item class=\"md-2-line\" ng-click=\"vm.manufacturer = {}\"><div layout=\"column\"><h4 class=\"csx-closed\" style=\"margin-bottom:0 !important;\">Add Manufacturer</h4></div></md-list-item><md-divider></md-divider></md-list></div><div layout=\"column\" flex=\"\"><div class=\"row\" style=\"margin-top:20px;\"><div class=\"col-sm-4 col-xs-12\"><md-input-container class=\"md-block\"><label>ConnectSx Identifier</label> <input ng-model=\"vm.manufacturer.objectId\" disabled=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr style=\"margin-top:-20px; height:10px;\"></div></div><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h3 class=\"subTitle\">Details</h3></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\" ng-hide=\"vm.manufacturer.objectId\"><md-autocomplete class=\"placeholder big-fontSize mdline-position\" md-search-text-change=\"vm.isChange = true\" md-selected-item-change=\"vm.isChange = true\" md-selected-item=\"vm.gudidManufacturer\" md-search-text=\"vm.manufacturerSearchText\" md-items=\"item in vm.searchManufacturers(vm.manufacturerSearchText)\" md-item-text=\"item.name\" md-floating-label=\"Name\" md-min-length=\"0\" required=\"\"><md-item-template><span md-highlight-text=\"vm.manufacturerSearchText\" md-highlight-flags=\"^i\" ng-if=\"item.name\">{{ item.name }}</span></md-item-template></md-autocomplete></div><div class=\"col-sm-4 col-xs-12\" ng-show=\"vm.manufacturer.objectId\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Name</label> <input ng-model=\"vm.manufacturer.name\" required=\"\" ng-change=\"vm.isChange = true\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Email</label> <input ng-model=\"vm.manufacturer.email\" ng-change=\"vm.isChange = true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Phone</label> <input ng-model=\"vm.manufacturer.phone\" ng-change=\"vm.isChange = true\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Fax</label> <input ng-model=\"vm.manufacturer.fax\" ng-change=\"vm.isChange = true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Address</label> <input ng-model=\"vm.manufacturer.address\" ng-change=\"vm.isChange = true\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Image Url</label> <input ng-model=\"vm.manufacturer.imageUrl\" ng-change=\"vm.isChange = true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4\"><button csx-loading=\"\" csx-is-loading=\"vm.isSaving\" class=\"btn btn-sm btn-outline btn-primary\" ng-click=\"vm.save()\">Save</button></div></div></div></div></div>");
$templateCache.put("app/settings/org/settings.org.html","<div class=\"wrapper wrapper-content animated\"><div class=\"row\" style=\"margin-top:20px;\"><div class=\"col-sm-4\"><md-input-container class=\"md-block\"><label>ConnectSx Identifier</label> <input ng-model=\"vm.org.objectId\" disabled=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr style=\"margin-top:-20px; height:10px;\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><h3 class=\"subTitle\">Details</h3></div></div><div class=\"row\"><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Name</label> <input ng-model=\"vm.org.name\" required=\"\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Email</label> <input ng-model=\"vm.org.email\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Phone</label> <input ng-model=\"vm.org.phone\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Fax</label> <input ng-model=\"vm.org.fax\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Address</label> <input ng-model=\"vm.org.address\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Image Url</label> <input ng-model=\"vm.org.imageUrl\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4\"><button csx-loading=\"\" csx-is-loading=\"vm.isSaving\" class=\"btn btn-sm btn-outline btn-primary\" ng-click=\"vm.save()\">Save</button></div></div></div>");
$templateCache.put("app/settings/modalresetpassword/modal.currentpassword.html","<form autocomplete=\"off\"><md-dialog-content class=\"md-dialog-content\"><h2 class=\"md-title ng-binding\">Your current password</h2><md-input-container class=\"md-prompt-input-container ng-scope md-input-has-placeholder md-default-theme md-input-invalid\"><input autocomplete=\"false\" type=\"password\" placeholder=\"Current password\" class=\"ng-pristine md-autofocus md-input ng-empty ng-invalid ng-invalid-required ng-touched\" required=\"required\" ng-model=\"currentPassword\" aria-invalid=\"true\"><div class=\"md-errors-spacer\"></div></md-input-container></md-dialog-content><md-dialog-actions><buton class=\"md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple\" ng-click=\"cancel();\">Cancel</buton><button class=\"md-primary md-confirm-button md-button md-ink-ripple md-default-theme\" type=\"button\" ng-click=\"sendToverifyPassword(currentPassword)\" ng-disabled=\"!currentPassword\" disabled=\"disabled\"><span class=\"ng-binding ng-scope\">Ok</span></button></md-dialog-actions></form>");
$templateCache.put("app/settings/modalresetpassword/modal.newpassword.html","<form autocomplete=\"off\"><md-dialog-content class=\"md-dialog-content\"><h2 class=\"md-title ng-binding\">Your new password</h2><md-input-container class=\"md-prompt-input-container ng-scope md-input-has-placeholder md-default-theme md-input-invalid\"><input autocomplete=\"false\" type=\"password\" placeholder=\"New password\" class=\"ng-pristine md-autofocus md-input ng-empty ng-invalid ng-invalid-required ng-touched\" required=\"required\" ng-model=\"newPasswordFirst\" aria-invalid=\"true\"><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-prompt-input-container ng-scope md-input-has-placeholder md-default-theme md-input-invalid\"><input autocomplete=\"false\" type=\"password\" placeholder=\"Confirm password\" class=\"ng-pristine md-autofocus md-input ng-empty ng-invalid ng-invalid-required ng-touched\" required=\"required\" ng-model=\"newPasswordSecond\" aria-invalid=\"true\"><div class=\"md-errors-spacer\"></div></md-input-container><div class=\"md-errors-spacer\" style=\"color: red;\" ng-if=\"notMatchPassword\">Passwords do not match</div></md-dialog-content><md-dialog-actions><buton class=\"md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple\" ng-click=\"cancel();\">Cancel</buton><button class=\"md-primary md-confirm-button md-button md-ink-ripple md-default-theme\" type=\"button\" ng-click=\"saveNewPassword(newPasswordFirst, newPasswordSecond)\" ng-disabled=\"!newPasswordFirst\" disabled=\"disabled\"><span class=\"ng-binding ng-scope\">Ok</span></button></md-dialog-actions></form>");
$templateCache.put("app/settings/personal/personal.html","<div class=\"wrapper wrapper-content animated\"><div class=\"row\" style=\"margin-top:20px;\"><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Email</label> <input ng-model=\"vm.account.email\" disabled=\"\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Role</label> <input ng-model=\"vm.account.accountType\" disabled=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Name</label> <input ng-model=\"vm.account.name\" required=\"\"></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Phone</label> <input ng-model=\"vm.account.phone\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-1\"><button csx-loading=\"\" csx-is-loading=\"vm.isSaving\" class=\"btn btn-sm btn-outline btn-primary\" ng-click=\"vm.save()\">Save</button></div></div></div>");
$templateCache.put("app/cases/edit/poNumber/poNumber.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 700px;max-width: 90%\"><div ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Fill out Purchase Order Number for all manufacturers</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><div><md-dialog-content layout-margin=\"\"><div layout=\"row\" style=\"margin-top:25px;\"><div class=\"col-md-12\"><table style=\"list-style: none;padding: 0;width: 100%;\"><tr style=\"border-bottom: 1px solid #cfd0d0;\"><th><b>Add PO Number for all Manufactures at once</b><br></th><th style=\"width: 60%\"><md-input-container class=\"md-block placeholder big-fontSize marginNull mg-spacer-heightNull\"><label style=\"overflow:visible;\">Assign a purchase order to complete the case workflow.</label> <input placeholder=\"PO #\" ng-keyup=\"vm.choseAll()\" ng-model=\"vm.poNumber\"></md-input-container><br></th></tr><tr><td><br><p style=\"color: #676a6c;\">Manufactures</p><br></td><td style=\"width: 60%\"><br><p style=\"color: #676a6c;\">Purchase Order Number</p><br></td></tr><tr ng-repeat=\"manufacture in vm.manufacturers\"><td><p>{{ manufacture.name }}</p></td><td style=\"width: 60%\"><md-input-container class=\"md-block placeholder big-fontSize marginNull\"><input placeholder=\"PO #\" ng-keyup=\"vm.checkIsSelectedManufacture()\" ng-model=\"manufacture.poNumber\"></md-input-container></td></tr></table></div></div></md-dialog-content><span style=\"padding: 14px 23px; color: #676a6c;font-size: 11px;line-height: 38px;\">* Required to fill out PO for all Manufacturers</span> <button ng-click=\"vm.sendPO()\" class=\"btn btn-md btn-primary\" ng-disabled=\"!vm.isFilledPOMnufacture\" style=\"float: right;margin: 5px;\">Submit</button></div></div></md-dialog>");
$templateCache.put("app/cases/edit/popupSelectManufacture/popupSelectManufacture.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 700px;max-width: 90%\"><div ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\"><span ng-if=\"vm.manufacturers.length > 1\">You have multiple manufacturers in this case. Please select:</span> <span ng-if=\"vm.manufacturers.length < 2\">Select manufacturer:</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><div><md-dialog-content layout-margin=\"\"><div layout=\"row\" style=\"margin-top:25px;\"><md-input-container style=\"margin-left:16px; margin-right:36px; margin-top:16px;width: 100%;\"><label>Select Manufacturer</label><md-select required=\"\" ng-model=\"vm.selectedManufacturer\"><md-option ng-repeat=\"option in vm.manufacturers\" ng-value=\"option\">{{ option.name }}</md-option></md-select></md-input-container></div></md-dialog-content><button ng-click=\"vm.sendManufacture()\" class=\"btn btn-md btn-primary\" ng-disabled=\"!vm.selectedManufacturer\" style=\"float: right;margin: 5px;\">Submit</button></div></div></md-dialog>");
$templateCache.put("app/directory/facilities/add/facilities.add.html","<div class=\"wrapper wrapper-content animated padding-left-null-desktop\"><div layout=\"row\" class=\"margin-bottom-30 margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Add facilities</h2></div></div><div class=\"row wrap\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Facility Name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Facility Name*</label> <input ng-model=\"vm.facility.name\" tabindex=\"1\"></md-input-container><h3 class=\"subTitle\">State</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>State*</label> <input ng-model=\"vm.facility.providerState\" tabindex=\"4\"></md-input-container><h3 class=\"subTitle\">Primary contact name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary contact name</label> <input type=\"text\" ng-model=\"vm.facility.contact.name\" tabindex=\"7\"></md-input-container><h3 class=\"subTitle\">Billing contact name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Billing contact name</label> <input ng-model=\"vm.facility.billing.name\" tabindex=\"10\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Street Address</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Street Address*</label> <input ng-model=\"vm.facility.providerAddress\" tabindex=\"2\"></md-input-container><h3 class=\"subTitle\">Zip code</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Zip code*</label> <input ng-model=\"vm.facility.providerZip\" type=\"number\" tabindex=\"5\"></md-input-container><h3 class=\"subTitle\">Primary contact role</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary contact role</label> <input ng-model=\"vm.facility.contact.role\" tabindex=\"8\"></md-input-container><h3 class=\"subTitle\">Billing contact email</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Billing contact email</label> <input ng-model=\"vm.facility.billing.email\" tabindex=\"11\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">City</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>City*</label> <input ng-model=\"vm.facility.providerCity\" tabindex=\"3\"></md-input-container><h3 class=\"subTitle\">Primary phone</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary phone</label> <input ng-model=\"vm.facility.contact.phone\" type=\"phone\" tabindex=\"6\"></md-input-container><h3 class=\"subTitle\">Primary contact email</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary contact email</label> <input ng-model=\"vm.facility.contact.email\" tabindex=\"9\"></md-input-container><h3 class=\"subTitle\">Billing contact phone</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Billing contact phone</label> <input ng-model=\"vm.facility.billing.phone\" tabindex=\"12\"></md-input-container></div></div><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Create</button></div></div>");
$templateCache.put("app/directory/facilities/deactivated/facilities.deactivated.html","<div class=\"layout-row padding-left-null-desktop\"><h1>Deactivated Facilities</h1><div class=\"flex\"></div><div><button ui-sref=\"index.directory.facilities.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i>Add facilities</button></div></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th style=\"min-width:100px;\">Name</th><th>City</th><th>State</th><th>Zip code</th><th>Primary Contact Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"facility in vm.facilities\"><td><a ng-click=\"vm.viewFacility(facility.key)\">{{ facility.name }}</a><span></span></td><td><span>{{facility.providerCity}}</span></td><td><span>{{facility.providerState}}</span></td><td><span>{{facility.providerZip}}</span></td><td><span>{{facility.contact.name}}</span></td><td><button ng-click=\"vm.editFacility(facility.key)\" class=\"btn btn-primary btn-outline\">Edit</button> <button ng-click=\"vm.showConfirm(facility)\" class=\"btn btn-primary btn-outline\">Reactivate</button></td></tr></tbody></table></div><button ui-sref=\"index.directory.facilities.list\" class=\"btn btn-primary btn-outline\">Show active facilities</button><div class=\"row\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div></div>");
$templateCache.put("app/directory/facilities/detail/facilities.detail.html","<div class=\"wrapper wrapper-content animated padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Detail: {{vm.facility.name}}</h2><h3><b class=\"color-black\">Status:</b> <span ng-if=\"vm.facility.active\">ACTIVE</span> <span ng-if=\"!vm.facility.active\">DIACTIVATED</span></h3></div><div flex=\"\" class=\"row-buttons-position\"><div style=\"margin: 0 20px 0 0\"><button ng-click=\"vm.viewUploadPrice(vm.facility.key)\" class=\"btn btn-md btn-primary\">Upload Pricing Sheet for this Facility</button></div><a ng-click=\"vm.editFacility(vm.facility.key)\" class=\"btn btn-outline btn-primary create\">Edit</a></div></div><br><br><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Facility Name</h3><p class=\"ng-binding text\">{{vm.facility.name}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Street Address</h3><p class=\"ng-binding text\">{{vm.facility.providerAddress}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">City</h3><p class=\"ng-binding text\">{{vm.facility.providerCity}}</p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">State</h3><p class=\"ng-binding text\">{{vm.facility.providerState}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Zip code</h3><p class=\"ng-binding text\">{{vm.facility.providerZip}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Primary phone</h3><p class=\"ng-binding text\">{{vm.facility.contact.phone}}</p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Primary contact name</h3><p class=\"ng-binding text\">{{vm.facility.contact.name}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Primary contact role</h3><p class=\"ng-binding text\">{{vm.facility.contact.role}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Primary contact email</h3><p class=\"ng-binding text\"><a href=\"mailto:{{vm.facility.contact.email}}\">{{vm.facility.contact.email}}</a></p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Billing contact name</h3><p class=\"ng-binding text\">{{vm.facility.billing.name}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Billing contact email</h3><p class=\"ng-binding text\"><a href=\"mailto:vm.facility.billing.email\">{{vm.facility.billing.email}}</a></p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Billing contact phone</h3><p class=\"ng-binding text\"><a href=\"tel:vm.facility.billing.phone\">{{vm.facility.billing.phone}}</a></p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Last modified</h3><p class=\"ng-binding text\">{{ vm.facility.modifiedDate }}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Created by</h3><p class=\"ng-binding text\">{{ vm.facility.createdByName }}</p></div></div></div>");
$templateCache.put("app/directory/facilities/edit/facilities.edit.html","<div class=\"wrapper wrapper-content animated padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Edit: {{vm.facility.name}}</h2><h3><b class=\"color-black\">Status:</b> <span ng-if=\"vm.facility.active\">ACTIVE</span> <span ng-if=\"!vm.facility.active\">DIACTIVATED</span></h3></div><div flex=\"\" class=\"row-buttons-position\"><div style=\"margin: 0 20px 0 0\"><button ng-click=\"vm.viewUploadPrice(vm.facility.key)\" class=\"btn btn-md btn-primary\">Upload Pricing Sheet for this Facility</button></div><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Save</button></div></div><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Facility Name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Facility Name*</label> <input ng-model=\"vm.facility.name\" tabindex=\"1\"></md-input-container><h3 class=\"subTitle\">State</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>State*</label> <input ng-model=\"vm.facility.providerState\" tabindex=\"4\"></md-input-container><h3 class=\"subTitle\">Primary contact name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary contact name</label> <input type=\"text\" ng-model=\"vm.facility.contact.name\" tabindex=\"7\"></md-input-container><h3 class=\"subTitle\">Billing contact name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Billing contact name</label> <input ng-model=\"vm.facility.billing.name\" tabindex=\"10\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Street Address</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Street Address*</label> <input ng-model=\"vm.facility.providerAddress\" tabindex=\"2\"></md-input-container><h3 class=\"subTitle\">Zip code</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Zip code*</label> <input ng-model=\"vm.facility.providerZip\" tabindex=\"5\"></md-input-container><h3 class=\"subTitle\">Primary contact role</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary contact role</label> <input ng-model=\"vm.facility.contact.role\" tabindex=\"8\"></md-input-container><h3 class=\"subTitle\">Billing contact email</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Billing contact email</label> <input ng-model=\"vm.facility.billing.email\" tabindex=\"11\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">City</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>City*</label> <input ng-model=\"vm.facility.providerCity\" tabindex=\"3\"></md-input-container><h3 class=\"subTitle\">Primary phone</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary phone</label> <input ng-model=\"vm.facility.contact.phone\" type=\"phone\" tabindex=\"6\"></md-input-container><h3 class=\"subTitle\">Primary contact email</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary contact email</label> <input ng-model=\"vm.facility.contact.email\" tabindex=\"9\"></md-input-container><h3 class=\"subTitle\">Billing contact phone</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Billing contact phone</label> <input ng-model=\"vm.facility.billing.phone\" tabindex=\"12\"></md-input-container></div></div></div>");
$templateCache.put("app/directory/facilities/modal/facility.modal.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">New Facility</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\"><div layout=\"row\" style=\"margin-top:25px;\"><md-input-container class=\"md-block\" flex=\"\"><label>Name</label> <input ng-model=\"vm.facility.name\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\"><label>Postal Code</label> <input name=\"postalCode\" ng-model=\"vm.facility.providerZip\" placeholder=\"12345\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"></md-input-container><md-input-container class=\"md-block\"><label>State</label><md-select ng-model=\"vm.facility.providerState\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><div flex=\"\"></div><md-progress-circular ng-show=\"vm.saving\" ng-disabled=\"!vm.saving\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"md-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.saving\">Save</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/directory/facilities/list/facilities.list.html","<div ng-show=\"vm.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div class=\"layout-row margin-bottom-30\"><h1 class=\"title\">Facilities</h1><div class=\"flex\"></div><div><button ui-sref=\"index.directory.facilities.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> Add facility</button></div></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th style=\"min-width:100px;\">Name</th><th>City</th><th>State</th><th>Zip code</th><th>Primary Contact Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"facility in vm.facilities\"><td><a ng-click=\"vm.viewFacility(facility.key)\">{{ facility.name }}</a><span></span></td><td><span>{{facility.providerCity}}</span></td><td><span>{{facility.providerState}}</span></td><td><span>{{facility.providerZip}}</span></td><td><span>{{facility.contact.name}}</span></td><td><button ng-click=\"vm.editFacility(facility.key)\" class=\"btn btn-primary btn-outline\">Edit</button><button ng-click=\"vm.editPrice(facility)\" style=\"margin: 0 0 0 5px\" class=\"btn btn-primary btn-outline\">View/Edit Pricing for this facility</button></td></tr></tbody></table></div><div class=\"row pagination\"><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div>");
$templateCache.put("app/directory/procedures/add/procedures.add.html","<div class=\"wrapper wrapper-content animated mgChipFixPosition padding-left-null-desktop\"><div layout=\"row\" class=\"margin-bottom-30 margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Add procedures</h2></div></div><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Procedure name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Procedure name*</label> <input ng-model=\"vm.procedure.name\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Procedure type</h3><md-input-container class=\"md-block placeholder big-fontSize\"><md-input-container style=\"width: 100%;\"><label>Procedure type*</label><md-select ng-model=\"vm.procedure.type\" ng-change=\"vm.updatePreviews(vm.udiHeader, \'udiPreview\')\"><md-option ng-value=\"$index\" ng-repeat=\"header in vm.procedureType\">{{ header }}</md-option></md-select></md-input-container></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><br><h3 class=\"subTitle\">Assign Products</h3><md-contact-chips class=\"placeholder-small\" ng-model=\"vm.procedure.products\" md-contacts=\"vm.searchCustodyProducts($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-autocomplete-snap=\"\" ng-click=\"vm.notFound.products = false\" filter-selected=\"true\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Procedure\" input-aria-label=\"Assign Procedures\"></md-contact-chips><p ng-if=\"vm.notFound.products\" class=\"mgContactsNotFound\">No matching Products. Try your search again.</p></div></div><br><br><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Create</button></div></div>");
$templateCache.put("app/directory/facilities/modalPriceEdit/facility.modalPriceEdit.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 700px;max-width: 90%\"><div ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Edit products price</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><div ng-show=\"vm.showSelectData\"><md-dialog-content layout-margin=\"\"><div layout=\"row\" style=\"margin-top:25px;\"><md-input-container style=\"margin-left:16px; margin-right:36px; margin-top:16px;width: 100%;\"><label>Select Manufacturer</label><md-select ng-change=\"vm.searchProducts()\" ng-model=\"vm.selectedManufacturer\"><md-option ng-repeat=\"option in vm.manufacturers track by option.key\" ng-value=\"option\">{{ option.objectId }}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.selectedManufacturer\"><div class=\"col-md-8\"><md-input-container style=\"width: 100%;\"><label>Select Product by Catalog number</label><md-select ng-model=\"vm.productsSelected\" ng-change=\"vm.showSelectedProduct()\"><md-option ng-if=\"!vm.products.length\" ng-disabled=\"true\">None</md-option><md-option ng-repeat=\"option in vm.products track by $index\" ng-value=\"option\">{{ option.catalog }}</md-option></md-select></md-input-container></div><div class=\"col-md-4\"><br><button class=\"btn btn-md btn-primary\" ng-disabled=\"!vm.products.length\" ng-click=\"vm.getProducts()\">View All Products</button></div></div></md-dialog-content></div><div ng-show=\"vm.tableProducts && !vm.showSelectData\"><i class=\"fa fa-arrow-left csvParseTable__back\" ng-click=\"vm.tableProducts = false; vm.showSelectData = true;\"></i> <button ng-if=\"!vm.showSelectData\" class=\"btn btn-md btn-primary animationLoadingButton\" ng-click=\"vm.saveProducts()\" style=\"float: right;margin: 5px;\" ng-disabled=\"vm.isLoading || vm.saving\">Save &nbsp;<md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" style=\"border-color: #fff;\" md-diameter=\"15px\"></md-progress-circular></button><table class=\"footable table table-striped table-bordered table-hover csvParseTable\"><thead><tr><td><b>Catalog Number</b></td><td><b>Price</b></td></tr></thead><tbody><tr ng-repeat=\"prod in vm.productsToEdit track by $index\"><td style=\"width: 50%\"><span>{{prod.catalog}}</span></td><td style=\"width: 50%\"><span>{{prod.price}}</span><md-input-container class=\"md-block\"><input type=\"text\" numbers-only=\"\" ng-model=\"prod.price\" aria-label=\"input\"></md-input-container><button class=\"btn btn-md btn-primary editButton\" ng-click=\"vm.editCell($event)\">Edit</button></td></tr></tbody></table><button ng-if=\"!vm.showSelectData && vm.productsToEdit.length > 20\" class=\"btn btn-md btn-primary\" ng-click=\"vm.saveProducts()\" style=\"float: right;margin: 5px;\" ng-disabled=\"vm.isLoading || vm.saving\">Save</button></div><div class=\"alignCenter\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular><br><br><br></div></div></md-dialog>");
$templateCache.put("app/directory/facilities/uploadprice/facilities.uploadprice.html","<div class=\"wrapper wrapper-content animated padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Upload a csv for facility-specific pricing</h2></div><div><button ng-click=\"vm.finish()\" title=\"Save your data\" ng-disabled=\"vm.isSaveButtonDisabled\" class=\"btn btn-outline btn-primary create whiteColorDisabled\"><i class=\"fa fa-check\"></i> Save</button></div></div><div layout=\"row\" layout-padding=\"\"><div layout=\"column\" flex=\"\" layout-padding=\"\"><div class=\"onboarding-heading\"><h2 class=\"subTitle\">1. Select File</h2><p class=\"text\">Upload a CSV of your inventory.</p><p class=\"text\">Your price sheet should be in csv format and contain the following columns: 1) Catalog Number and, 2) Price. Your catalog number should match existing catalog numbers in ConnectSx. The price column should contain numbers only. Columns not mapped to Catalog and Price will be ignored.</p></div><form><div class=\"form-group\" style=\"margin: 30px 36px 0 36px;\"><label class=\"sr-only\" for=\"fileUpload\">File</label> <label class=\"sr-only\" for=\"fileUpload\">File</label> <input class=\"form-control\" id=\"fileUpload\" type=\"file\" accept=\".csv\" multiple=\"false\"></div></form></div><div layout=\"column\" flex=\"\" layout-padding=\"\"><div class=\"onboarding-heading\"><h2 class=\"subTitle\">2. Map Fields</h2><br><br><p class=\"text\">Select the manufacturer. Preview your imported data and update mappings below.</p><br><br></div><md-input-container style=\"margin-left:36px; margin-right:36px; margin-top:14px;\" class=\"placeholder big-fontSize\"><label>Manufacturer</label><md-select ng-disabled=\"vm.manufacturerDisabled\" ng-model=\"vm.manufacturer\"><md-option ng-repeat=\"option in vm.manufacturers\" ng-value=\"option\">{{ option.objectId }}</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"\" layout-padding=\"\"><div class=\"onboarding-heading\"><h2 class=\"subTitle\">3. Import</h2><br><br><p class=\"text\">Preview your imported data and update mappings below.</p><br><br></div><div layout=\"row\" layout-align=\"center\" style=\"margin-top:24px;\"><button class=\"btn btn-md btn-primary\" ng-disabled=\"!vm.manufacturer\" ng-click=\"vm.importCsvPrice(); vm.showSelectColumn = true;\">Parse</button></div></div></div><br><br><div class=\"row\" ng-if=\"vm.showSelectColumn\"><div class=\"col-md-4 col-xs-12\"><md-input-container style=\"width: 100%\" title=\"Select column in your file for parse Catalog Number data\" class=\"placeholder big-fontSize\"><label>Catalog Number Header</label><md-select ng-model=\"vm.catalogNumberHeader\" ng-change=\"vm.updatePreviews(vm.catalogNumberHeader, \'catalogNumberHeader\')\" md-selected-text=\"vm.catalogNumberHeader\" flex=\"\"><md-option>None</md-option><md-option ng-value=\"header\" ng-disabled=\"header === vm.productPriceHeader\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container></div><div class=\"col-md-4 col-xs-12\"><md-input-container style=\"width: 100%\" title=\"Select column in your file for parse Price data\" class=\"placeholder big-fontSize\"><label>Price Header</label><md-select ng-model=\"vm.productPriceHeader\" ng-change=\"vm.updatePreviews(vm.productPriceHeader, \'productPriceHeader\')\" md-selected-text=\"vm.productPriceHeader\" flex=\"\"><md-option>None</md-option><md-option ng-value=\"header\" ng-disabled=\"header === vm.catalogNumberHeader\" ng-repeat=\"header in vm.headers\">{{ header }}</md-option></md-select></md-input-container></div></div><br><br><span ng-if=\"vm.csvFile.length\">Total length: {{vm.csvFile.length}} rows</span><div class=\"row\" ng-if=\"vm.csvFile.length\"><div layout-padding=\"\" style=\"padding-left:18px;\" flex=\"\"><table class=\"footable table table-striped table-bordered table-hover csvParseTable\"><thead><tr><th><b>Catalog Number:</b> {{vm.tableTh.catalogTh}}</th><th><b>Price:</b> {{vm.tableTh.priceTh}}</th></tr></thead><tbody><tr ng-repeat=\"cvsrow in vm.csvFile | limitTo:vm.totalDisplayed track by $index\"><td style=\"width: 50%;\"><span>{{cvsrow.catalog}}</span><md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"cvsrow.catalog\" aria-label=\"input\"></md-input-container><button class=\"btn btn-md btn-primary editButton\" ng-click=\"vm.editCell($event)\" title=\"Click to edit this field\">Edit</button></td><td style=\"width: 50%;\"><span>{{cvsrow.price}}</span><md-input-container class=\"md-block\" title=\"If you need to add decimals, use the dot, not a comma.\"><input type=\"text\" numbers-only=\"\" ng-model=\"cvsrow.price\" aria-label=\"input\"></md-input-container><button class=\"btn btn-md btn-primary editButton editButton__rightColumn\" ng-click=\"vm.editCell($event)\" title=\"Click to edit this field\">Edit</button> <i class=\"fa fa-trash tableRemove\" title=\"Delete row\" ng-click=\"vm.deleteRowFromCSV($index)\"></i></td></tr></tbody></table><button class=\"btn\" ng-if=\"vm.totalDisplayed <= vm.csvFile.length\" ng-click=\"vm.loadMore()\">Show more</button></div></div></div>");
$templateCache.put("app/directory/procedures/deactivated/procedures.deactivated.html","<div class=\"layout-row padding-left-null-desktop\"><h1>Deactivated Procedures</h1><div class=\"flex\"></div><div><button ui-sref=\"index.directory.procedures.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i>Add procedure</button></div></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th style=\"min-width:100px;\">Procedure name</th><th>Procedure type</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"procedure in vm.procedures\"><td><a ng-click=\"vm.viewProcedure(procedure.key)\">{{ procedure.name }}</a><span></span></td><td><span>{{vm.procedureType[procedure.type]}}</span></td><td><button ng-click=\"vm.editProcedure(procedure.key)\" class=\"btn btn-primary btn-outline\">Edit</button> <button ng-click=\"vm.showConfirm(procedure)\" class=\"btn btn-primary btn-outline\">Activate</button></td></tr></tbody></table></div><button ui-sref=\"index.directory.procedures.list\" class=\"btn btn-primary btn-outline\">Show active procedures</button><div class=\"row\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div></div>");
$templateCache.put("app/directory/procedures/detail/procedures.detail.html","<div class=\"wrapper wrapper-content animated padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Detail: {{vm.procedure.name}}</h2><h3><b class=\"color-black\">Status:</b> <span ng-if=\"vm.procedure.active\">ACTIVE</span> <span ng-if=\"!vm.procedure.active\">DIACTIVATED</span></h3></div><div><a ng-click=\"vm.editProcedure(vm.procedure.key)\" class=\"btn btn-outline btn-primary create\">Edit</a></div><div></div></div><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Procedure name</h3><b class=\"text\">{{vm.procedure.name}}</b></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Procedure type</h3><b class=\"text\">{{ vm.procedureType[vm.procedure.type] }}</b></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Assigned products</h3><p ng-repeat=\"prod in vm.procedure.products\" class=\"text\">{{ prod.name }}</p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Last modified</h3><p class=\"ng-binding text\">{{ vm.procedure.modifiedDate }}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Created by</h3><p class=\"ng-binding text\">{{ vm.procedure.createdByName }}</p></div></div></div>");
$templateCache.put("app/directory/procedures/modal/procedure.modal.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">New Procedure</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\"><div layout=\"column\" style=\"margin-top:25px;\"><md-input-container class=\"md-block\" flex=\"\"><label>Name</label> <input ng-model=\"vm.procedure.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Location</label> <input ng-model=\"vm.procedure.location\" required=\"\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><div flex=\"\"></div><md-progress-circular ng-show=\"vm.saving\" ng-disabled=\"!vm.saving\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"md-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.saving\">Save</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/directory/procedures/edit/procedures.edit.html","<div class=\"wrapper wrapper-content animated mgChipFixPosition padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Edit: {{vm.procedure.name}}</h2><div><h3><b class=\"color-black\">Status:</b> <span ng-if=\"vm.procedure.active\">ACTIVE</span> <span ng-if=\"!vm.procedure.active\">DIACTIVATED</span></h3></div></div><div><br><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Save</button></div></div><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Procedure name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Procedure name*</label> <input ng-model=\"vm.procedure.name\"></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Procedure type</h3><md-input-container class=\"md-block placeholder big-fontSize\"><md-input-container style=\"width: 100%;\"><label>Procedure type*</label><md-select ng-model=\"vm.procedure.type\" ng-change=\"vm.updatePreviews(vm.udiHeader, \'udiPreview\')\"><md-option ng-value=\"$index\" ng-repeat=\"header in vm.procedureType\">{{ header }}</md-option></md-select></md-input-container></md-input-container></div><div class=\"col-sm-4 col-xs-12\"><br><h3 class=\"subTitle\">Assigned products</h3><md-contact-chips class=\"placeholder-small\" ng-model=\"vm.procedure.products\" md-contacts=\"vm.searchCustodyProducts($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-autocomplete-snap=\"\" filter-selected=\"true\" ng-click=\"vm.notFound.products = false\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Products\" input-aria-label=\"Assign Products\"></md-contact-chips><p ng-if=\"vm.notFound.products\" class=\"mgContactsNotFound\">No matching Products. Try your search again.</p></div></div></div>");
$templateCache.put("app/directory/procedures/list/procedures.list.html","<div ng-show=\"vm.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div class=\"layout-row margin-bottom-30\"><h1 class=\"title\">Procedures</h1><div class=\"flex\"></div><div><button ui-sref=\"index.directory.procedures.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> Add procedure</button></div></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th style=\"min-width:100px;\">Procedure name</th><th>Procedure type</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"procedure in vm.procedures\"><td><a ng-click=\"vm.viewProcedure(procedure.key)\">{{ procedure.name }}</a><span></span></td><td><span>{{vm.procedureType[procedure.type]}}</span></td><td><button ng-click=\"vm.editProcedure(procedure.key)\" class=\"btn btn-primary btn-outline\">Edit</button></td></tr></tbody></table></div><div class=\"row pagination\"><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div>");
$templateCache.put("app/directory/physicians/add/physicians.add.html","<div class=\"wrapper wrapper-content animated bottom-linear--40 padding-left-null-desktop\"><div layout=\"row\" class=\"margin-bottom-30 margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Add physicians</h2></div></div><div class=\"row wrap mgChipFixPosition\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Full Name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><div class=\"form-group\"><label>Full Name*</label> <input ng-model=\"vm.physicians.name\" tabindex=\"1\"></div></md-input-container><h3 class=\"subTitle\">City</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>City*</label> <input ng-model=\"vm.physicians.city\" tabindex=\"4\"></md-input-container><h3 class=\"subTitle\">Primary location (street address)</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary location (street address)</label> <input ng-model=\"vm.physicians.addressLine1\" tabindex=\"7\"></md-input-container><h3 class=\"subTitle\">Email</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Email</label> <input ng-model=\"vm.physicians.email\" tabindex=\"10\"></md-input-container><h3 class=\"subTitle\">Assign Facilities</h3><md-contact-chips tabindex=\"12\" class=\"placeholder-small setTabIndex12\" ng-model=\"vm.physicians.facilities\" md-contacts=\"vm.searchCustodyFacilities($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-add-on-blur=\"true\" ng-click=\"vm.notFound.facilities = false\" ng-keyup=\"vm.notFound.facilities = false\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Facility\" input-aria-label=\"Assign Facilities\"></md-contact-chips><p ng-if=\"vm.notFound.facilities\" class=\"mgContactsNotFound\">No matching Facilities. Try your search again.</p></div><div class=\"col-sm-4 col-xs-12\"><div class=\"emptyInputBlock\"></div><h3 class=\"subTitle\">State</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>State*</label> <input ng-model=\"vm.physicians.state\" tabindex=\"5\"></md-input-container><h3 class=\"subTitle\">Primary phone number</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary phone number</label> <input ng-model=\"vm.physicians.phoneNumber\" tabindex=\"8\"></md-input-container><h3 class=\"subTitle\">NPI Number</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Physicians number</label> <input ng-model=\"vm.physicians.npiNumber\" tabindex=\"11\"></md-input-container><h3 class=\"subTitle\" style=\"margin-bottom: 6px !important;\">Assign Products</h3><md-contact-chips class=\"placeholder-small setTabIndex13\" ng-model=\"vm.physicians.products\" md-contacts=\"vm.searchCustodyProducts($query)\" md-contact-name=\"name\" md-require-match=\"true\" ng-click=\"vm.notFound.products = false\" md-autocomplete-snap=\"\" filter-selected=\"true\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Products\" tabindex=\"13\" input-aria-label=\"Assign Products\"></md-contact-chips><p ng-if=\"vm.notFound.products\" class=\"mgContactsNotFound\">No matching Products. Try your search again.</p></div><div class=\"col-sm-4 col-xs-12\"><div class=\"emptyInputBlock\"></div><h3 class=\"subTitle\">Zip Code</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Zip Code*</label> <input ng-model=\"vm.physicians.zipCode\" type=\"number\" tabindex=\"6\"></md-input-container><h3 class=\"subTitle\">Secondary phone number</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Secondary phone number</label> <input ng-model=\"vm.physicians.altPhoneNumber\" tabindex=\"9\"></md-input-container><div style=\"margin-bottom: 156px\"></div><h3 class=\"subTitle\">Assign Procedures</h3><md-contact-chips class=\"placeholder-small setTabIndex14\" ng-model=\"vm.physicians.procedures\" md-contacts=\"vm.searchCustodyProcedures($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-autocomplete-snap=\"\" filter-selected=\"true\" tabindex=\"14\" ng-click=\"vm.notFound.procedures = false\" ng-keyup=\"vm.notFound.procedures = false\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Procedure\" input-aria-label=\"Assign Procedures\"></md-contact-chips><p ng-if=\"vm.notFound.procedures\" class=\"mgContactsNotFound\">No matching Procedures. Try your search again.</p></div></div><br><br><div class=\"float-right\"><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Create</button></div></div>");
$templateCache.put("app/directory/physicians/detail/physician.detail.html","<div class=\"wrapper wrapper-content animated padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large title\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Detail: {{vm.physicians.name}}</h2><h3><b style=\"color: #000;\">Status:</b> <span ng-if=\"vm.physicians.active\">ACTIVE</span> <span ng-if=\"!vm.physicians.active\">DIACTIVATED</span></h3></div><div><a ng-click=\"vm.editPhysician(vm.physicians.key)\" class=\"btn btn-outline btn-primary create\">Edit</a></div></div><br><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Full Name</h3><p class=\"ng-binding text\">{{vm.physicians.name}}</p></div><div class=\"col-sm-4 col-xs-12\"></div><div class=\"col-sm-4 col-xs-12\"></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">City</h3><p class=\"ng-binding\">{{vm.physicians.city}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">State</h3><p class=\"ng-binding text\">{{vm.physicians.state}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Zip Code</h3><p class=\"ng-binding text\">{{vm.physicians.zipCode}}</p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Primary location (street address)</h3><p class=\"ng-binding text\">{{vm.physicians.addressLine1}}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Primary phone number</h3><p class=\"ng-binding text\"><a href=\"tel:{{vm.physicians.phoneNumber}}\">{{vm.physicians.phoneNumber}}</a></p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Secondary phone number</h3><p class=\"ng-binding text\"><a href=\"tel:{{vm.physicians.altPhoneNumber}}\">{{vm.physicians.altPhoneNumber}}</a></p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Email</h3><p class=\"ng-binding text\"><a href=\"mailto:{{vm.physicians.email}}\">{{vm.physicians.email}}</a></p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">NPI Number</h3><p class=\"ng-binding text\">{{vm.physicians.npiNumber}}</p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Assigned Facilities</h3><p class=\"ng-binding text\" ng-repeat=\"facility in vm.physicians.facilities\">{{ facility.name }}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Assigned Products</h3><p class=\"ng-binding text\" ng-repeat=\"product in vm.physicians.products\">{{ product.name }}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Assigned Procedures</h3><p class=\"ng-binding text\" ng-repeat=\"procedure in vm.physicians.procedures\">{{ procedure.name }}</p></div></div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Created by</h3><p class=\"ng-binding text\">{{ vm.physicians.createdByName }}</p></div><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Last modified</h3><p class=\"ng-binding text\">{{ vm.physicians.modifiedDate }}</p></div></div><div><hr><div class=\"row wrap\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Notes</h3><blockquote ng-repeat=\"note in vm.editPhysicianNotes\"><small>{{note.modifiedDate}}</small> <small>{{note.modifiedByName}}</small><br><p>{{note.content}}</p></blockquote><p ng-if=\"!vm.editPhysicianNotes\">No notes</p></div></div></div></div>");
$templateCache.put("app/directory/physicians/deactivated/physicians.deactivated.html","<div class=\"layout-row padding-left-null-desktop\"><h1>Deactivated Physicians</h1><div class=\"flex\"></div><div><button ui-sref=\"index.directory.physicians.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i>Add physicians</button></div></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover\"><thead><tr><th style=\"min-width:100px;\">Name</th><th>City</th><th>State</th><th>Zip code</th><th>email</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"physician in vm.physicians\"><td><a ng-click=\"vm.viewPhysician(physician.key)\">{{ physician.name }}</a><span></span></td><td><span>{{physician.city}}</span></td><td><span>{{physician.state}}</span></td><td><span>{{physician.zipCode}}</span></td><td><span>{{physician.email}}</span></td><td><button ng-click=\"vm.editPhysician(physician.key)\" class=\"btn btn-primary btn-outline\">Edit</button> <button ng-click=\"vm.showConfirm(physician)\" class=\"btn btn-primary btn-outline\">Activate</button></td></tr></tbody></table></div><button ui-sref=\"index.directory.physicians.list\" class=\"btn btn-primary btn-outline\">Show active physicians</button><div class=\"row\"><div class=\"col-sm-6\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div></div>");
$templateCache.put("app/directory/physicians/list/physicians.list.html","<div ng-show=\"vm.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-top:50px;\"><md-progress-circular ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"25px\"></md-progress-circular></div><div class=\"layout-row margin-bottom-30\"><h1 class=\"title\">Physicians</h1><div class=\"flex\"></div><div><button ui-sref=\"index.directory.physicians.add\" class=\"btn btn-primary btn-outline\"><i class=\"fa fa-plus\"></i> Add physician</button></div></div><div layout=\"row\"><table class=\"footable table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th style=\"min-width:100px;\">Full Name</th><th>City</th><th>State</th><th>Zip code</th><th>email</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"physician in vm.physicians\"><td><a ng-click=\"vm.viewPhysician(physician.key)\">{{ physician.name }}</a></td><td><span>{{physician.city}}</span></td><td><span>{{physician.state}}</span></td><td><span>{{physician.zipCode}}</span></td><td><span>{{physician.email}}</span></td><td><button ng-click=\"vm.editPhysician(physician.key)\" class=\"btn btn-primary btn-outline\">Edit</button></td></tr></tbody></table></div><div class=\"row pagination\"><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-left page-count\"><a ng-click=\"vm.setPageSize(10)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 10 ? \'selected\' : \'\'\">10</a> <a ng-click=\"vm.setPageSize(20)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 20 ? \'selected\' : \'\'\">20</a> <a ng-click=\"vm.setPageSize(50)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 50 ? \'selected\' : \'\'\">50</a> <a ng-click=\"vm.setPageSize(100)\" class=\"btn btn-xs btn-white\" ng-class=\"vm.pageSize == 100 ? \'selected\' : \'\'\">100</a></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"m-t-xs btn-group pull-right\"><a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadPreviousPage()\" ng-disabled=\"vm.isLoading || !vm.previousPages.length\"><i class=\"fa fa-arrow-left\"></i></a> <a class=\"btn btn-xs btn-white\" ng-click=\"vm.loadNextPage()\" ng-disabled=\"vm.isLoading || !vm.hasNextPage()\"><i class=\"fa fa-arrow-right\"></i></a></div></div></div>");
$templateCache.put("app/directory/physicians/edit/physician.edit.html","<div class=\"wrapper wrapper-content animated bottom-linear--40 padding-left-null-desktop\"><div layout=\"row\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large title\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Edit: {{vm.physicians.name}}</h2><br><h3><b class=\"color-black\">Status:</b> <span ng-if=\"vm.physicians.active\">ACTIVE</span> <span ng-if=\"!vm.physicians.active\">DIACTIVATED</span></h3></div><div><br><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> Save</button></div></div><div class=\"row wrap mgChipFixPosition\"><div class=\"col-sm-4 col-xs-12\"><h3 class=\"subTitle\">Full Name</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><div class=\"form-group\"><label>Full Name*</label> <input tabindex=\"1\" ng-model=\"vm.physicians.name\"></div></md-input-container><h3 class=\"subTitle\">City</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>City*</label> <input tabindex=\"4\" ng-model=\"vm.physicians.city\"></md-input-container><h3 class=\"subTitle\">Primary location (street address)</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary location (street address)</label> <input tabindex=\"7\" ng-model=\"vm.physicians.addressLine1\"></md-input-container><h3 class=\"subTitle\">Email</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Email</label> <input tabindex=\"10\" ng-model=\"vm.physicians.email\"></md-input-container><h3 class=\"subTitle\">Assign Facilities</h3><md-contact-chips tabindex=\"12\" class=\"placeholder-small setTabIndex12\" ng-model=\"vm.physicians.facilities\" md-contacts=\"vm.searchCustodyFacilities($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-autocomplete-snap=\"\" filter-selected=\"true\" ng-click=\"vm.notFound.facilities = false\" ng-keyup=\"vm.notFound.facilities = false\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Facilities\" input-aria-label=\"Assign Facilities\"></md-contact-chips><p ng-if=\"vm.notFound.facilities\" class=\"mgContactsNotFound\">No matching Facilities. Try your search again.</p></div><div class=\"col-sm-4 col-xs-12\"><div class=\"emptyInputBlock\"></div><h3 class=\"subTitle\">State</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>State*</label> <input tabindex=\"5\" ng-model=\"vm.physicians.state\"></md-input-container><h3 class=\"subTitle\">Primary phone number</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Primary phone number</label> <input tabindex=\"8\" ng-model=\"vm.physicians.phoneNumber\"></md-input-container><h3 class=\"subTitle\">NPI Number</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Physician number</label> <input tabindex=\"11\" ng-model=\"vm.physicians.npiNumber\"></md-input-container><h3 class=\"subTitle\">Assign Products</h3><md-contact-chips tabindex=\"13\" class=\"placeholder-small setTabIndex13\" ng-model=\"vm.physicians.products\" md-contacts=\"vm.searchCustodyProducts($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-autocomplete-snap=\"\" filter-selected=\"true\" ng-click=\"vm.notFound.products = false\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Products\" input-aria-label=\"Assign Products\"></md-contact-chips><p ng-if=\"vm.notFound.products\" class=\"mgContactsNotFound\">No matching Products. Try your search again.</p></div><div class=\"col-sm-4 col-xs-12\"><div class=\"emptyInputBlock\"></div><h3 class=\"subTitle\">Zip Code</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Zip Code*</label> <input tabindex=\"6\" ng-model=\"vm.physicians.zipCode\"></md-input-container><h3 class=\"subTitle\">Secondary phone number</h3><md-input-container class=\"md-block top-padded placeholder big-fontSize\"><label>Secondary phone number</label> <input tabindex=\"9\" ng-model=\"vm.physicians.altPhoneNumber\"></md-input-container><div style=\"margin-bottom: 155px\"></div><h3 class=\"subTitle\">Assign Procedures</h3><md-contact-chips tabindex=\"14\" class=\"placeholder-small setTabIndex14\" ng-model=\"vm.physicians.procedures\" md-contacts=\"vm.searchCustodyProcedures($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-autocomplete-snap=\"\" filter-selected=\"true\" ng-click=\"vm.notFound.procedures = false\" ng-keyup=\"vm.notFound.procedures = false\" placeholder=\"Type name to see matches\" secondary-placeholder=\"Add another Procedures\" input-aria-label=\"Assign Procedures\"></md-contact-chips><p ng-if=\"vm.notFound.procedures\" class=\"mgContactsNotFound\">No matching Procedures. Try your search again.</p></div></div></div>");
$templateCache.put("app/directory/physicians/modal/physician.modal.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">New Physician</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\"><div layout=\"row\" style=\"margin-top:25px;\"><md-input-container class=\"md-block\" flex=\"\"><label>Name</label> <input ng-model=\"vm.physician.name\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\"><label>Postal Code</label> <input name=\"postalCode\" ng-model=\"vm.physician.zipCode\" placeholder=\"12345\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"></md-input-container><md-input-container class=\"md-block\"><label>State</label><md-select ng-model=\"vm.physician.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><div flex=\"\"></div><md-progress-circular ng-show=\"vm.saving\" ng-disabled=\"!vm.saving\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"md-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.saving\">Save</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/import/importStatusModal/import.status.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\" class=\"importCSVStatusPopup\" ng-class=\"{\'importSuccess\': vm.importKey.length}\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\" ng-if=\"vm.importKey.length\">Inventory Imported!</h2><h2 style=\"color:white;\" ng-if=\"!vm.importKey.length\">Your import completed with some errors.</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar></form></md-dialog>");
$templateCache.put("app/inventory/import/missedDevicesModal/missedDevices.status.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\" class=\"importCSVMissedDevicesPopup\" ng-class=\"{\'importSuccess\': vm.importKey.length}\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Inventories which skipped because they have incorrect quantity:</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\" style=\"padding: 0 0 0 20px;\"><md-content><table class=\"table table-striped table-bordered table-hover mobileFriendlyTable\"><thead><tr><th>Name</th><th>Line in your CSV file</th><th>Reference</th><th>UDI</th><th>Quantity</th></tr></thead><tbody><tr ng-repeat=\"item in vm.missedItems\"><td><p ng-if=\"item.name || item.name === 0\">{{ item.row[item.name] }}</p></td><td><p ng-if=\"item.str || item.str === 0\">{{ item.str + 2 }}</p></td><td><p ng-if=\"item.ref || item.ref === 0\">{{ item.row[item.ref] }}</p></td><td><p ng-if=\"item.udi || item.udi === 0\">{{ item.row[item.udi] }}</p></td><td><p ng-if=\"item.quantity || item.quantity === 0\" class=\"colorRed\">{{ item.row[item.quantity ] }}</p></td></tr></tbody></table></md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/inventory/list/filter/inventory.filter.tmpl.html","<md-dialog aria-label=\"Filter Inventory Dialog\" class=\"inventoryFilter\" style=\"min-width: 500px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Add Inventory Filters</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form ng-submit=\"$event.preventDefault()\" name=\"filterForm\"><md-input-container class=\"md-block\" flex=\"\"><label>Basic Search</label> <input ng-model=\"vm.values.basic\"><p>Basic search will match part or all of the Reference, Catalog, Version / Model, Lot or Tags. This does not search description or name fields.</p></md-input-container><md-input-container class=\"md-block\" flex=\"\"><md-autocomplete md-input-name=\"custodyField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-selected-item=\"vm.values.custody\" md-search-text=\"vm.custodySearchText\" md-items=\"item in vm.searchCustody(vm.custodySearchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-floating-label=\"Custody\"><md-item-template><span md-highlight-text=\"vm.custodySearchText\">{{ item.name }} ({{ item.email || item.type }})</span></md-item-template><div ng-messages=\"filterForm.custodyField.$error\" ng-if=\"filterForm.custodyField.$touched\"><div ng-message=\"md-require-match\">Please select custody for your search.</div></div></md-autocomplete></md-input-container><div layout=\"row\" class=\"md-block\"><md-input-container flex=\"\"><label>Status</label><md-select ng-model=\"vm.values.status\" md-placeholder=\"Status\" style=\"min-width:150px;\"><md-option ng-repeat=\"option in vm.statuses\" ng-value=\"option\"><span ng-if=\"option === \'Explanted\'\">In/Out</span> <span ng-if=\"option !== \'Explanted\'\">{{ option }}</span></md-option></md-select></md-input-container><div style=\"width:16px\"></div><md-input-container flex=\"\"><label>Expiration</label><md-select ng-model=\"vm.values.expiration\" md-placeholder=\"Type\" style=\"min-width:150px;\"><md-option>None</md-option><md-option ng-repeat=\"option in vm.expirationOptions\" ng-value=\"option\">{{ option.display }}</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"md-block\"><md-input-container flex=\"\"><label>Inventory Type</label><md-select ng-model=\"vm.values.type\" md-placeholder=\"Type\" style=\"min-width:150px;\"><md-option>None</md-option><md-option ng-repeat=\"option in [\'Device\', \'Container\']\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container><div style=\"width:16px;\"></div><md-autocomplete flex=\"\" ng-disabled=\"vm.values.type === \'Container\' || vm.values.loose\" md-input-name=\"containerField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"true\" md-input-id=\"autoCompleteSearchContainer\" md-search-text-change=\"vm.isSearchContainerTextChanged = true\" md-selected-item=\"vm.values.container\" md-search-text=\"vm.containerSearchText\" md-items=\"item in ::vm.searchContainers(vm.containerSearchText)\" md-item-text=\"item.reference\" md-require-match=\"\" md-floating-label=\"Container\"><md-item-template class=\"customMDChips\"><div style=\"position: relative;\"><p style=\"margin-bottom: 0; line-height: 3;\">{{item.name | limitTo: 25}}<span ng-if=\"item.name.length > 25\">...</span></p><i style=\"color:#47525d; position: absolute; font-size: 0.8em; right: 0; bottom: 0;line-height: 1;\">Ref. num.: {{ item.reference | limitTo: 25}} <span ng-if=\"item.reference.length > 25\">...</span></i></div></md-item-template><div ng-messages=\"filterForm.containerField.$error\" ng-if=\"filterForm.containerField.$touched\"><div ng-message=\"md-require-match\">Please select an existing container.</div><div ng-message=\"minlength\">Your search is not long enough.</div><div ng-message=\"maxlength\">Your search is too long.</div></div></md-autocomplete></div><div layout=\"row\" class=\"md-block\"><md-input-container flex=\"\"><label>Inventory Past Due</label><md-select ng-model=\"vm.values.dueBack\" md-placeholder=\"Status\" style=\"min-width:150px;\"><md-option ng-repeat=\"option in vm.dueBack\" ng-value=\"option\">{{option}}</md-option></md-select></md-input-container></div><md-checkbox ng-model=\"vm.values.nolot\" aria-label=\"No Lot #\" class=\"md-primary md-block\" flex=\"\">Only show devices without lot</md-checkbox><md-checkbox ng-disabled=\"vm.values.type === \'Container\'\" ng-model=\"vm.values.loose\" aria-label=\"Only Loose Inventory\" class=\"md-primary md-block\" flex=\"\">Only show devices without container</md-checkbox><md-checkbox ng-model=\"vm.values.billable\" aria-label=\"Billable\" class=\"md-primary md-block\" flex=\"\">Only show billable inventory</md-checkbox><md-checkbox ng-model=\"vm.values.inactive\" aria-label=\"Show Inactive\" class=\"md-primary md-block\" flex=\"\">Show all used/deactivated devices. This includes all inventory that was deactivated or closed with a case.</md-checkbox></form></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><md-button class=\"md-error\" ng-click=\"vm.cancel()\">Cancel</md-button><div flex=\"\"></div><div><md-button class=\"md-primary\" ng-click=\"vm.add()\" ng-disabled=\"angular.toJson(vm.values) === \'{}\'\">Add</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/products/addModal/addProducts.modal.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">New Product</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\" style=\"padding: 20px;\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h3 class=\"hide-mobile\">&nbsp;</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><label>Product Name</label> <input ng-model=\"vm.product.name\" required=\"\"></md-input-container></div></div></div></div><div class=\"col-md-6 col-xs-12\"><h3 class=\"hide-mobile\">&nbsp;</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><label>Asset Url</label> <input ng-model=\"vm.product.assetUrl\"></md-input-container></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><h3 class=\"subTitle\" style=\"margin-bottom: 21px !important;\">Manufacturer</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\" layout=\"row\" layout-align=\"start\" flex=\"\"><md-input-container flex=\"100\" ng-show=\"vm.product.key\" class=\"placeholder\"><label>Manufacturer</label> <input ng-model=\"vm.product.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.product.key\"><label>Manufacturer</label><md-select ng-model=\"vm.product.manufacturer\" md-selected-text=\"vm.product.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.Manufactures\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div></div></div><div class=\"col-md-6 col-xs-12 mobile-margin-bottom\"><h3 style=\"margin-bottom: 30px !important;\" class=\"subTitle\">Guides</h3><md-chips ng-model=\"vm.product.guides\" md-require-match=\"true\" class=\"labelPosition labelPosition__md-chips chipsPositionFix placeholder\"><md-autocomplete class=\"md-block\" md-selected-item=\"vm.selectedGuide\" md-search-text=\"vm.guideSearchText\" md-items=\"guide in vm.searchGuides(vm.guideSearchText)\" md-no-cache=\"true\" md-item-text=\"guide.name\" placeholder=\"Add Guide\"><span md-highlight-text=\"vm.guideSearchText\">{{ guide.name }}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"space-between\"><h3 class=\"subTitle\" style=\"margin-bottom: 9px !important;\">IFU</h3></div><md-input-container class=\"md-block fixStylePosition placeholder\"><label></label><md-chips ng-model=\"vm.product.ifuUrls\" placeholder=\"Enter URLs\"></md-chips></md-input-container><div ng-model=\"vm.product.ifuUrls\" upload-folder=\"product\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"false\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"titleIconWrap\"><h3 class=\"subTitle\">Images</h3><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">You are associating images with this product line. These will be associate will all inventory in this product family and can include images of complete sets, trays, and the like. To add images of individual instruments and devices, visit that item\'s individual catalog page.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><md-input-container class=\"md-block fixStylePosition placeholder\"><label></label><md-chips ng-model=\"vm.product.images\" placeholder=\"Enter Images URLs\"></md-chips></md-input-container><div ng-model=\"vm.product.images\" upload-folder=\"product\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><h3 class=\"subTitle\">Description</h3><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobPaddingNull\"><md-input-container class=\"md-block placeholder\"><textarea placeholder=\"Description\" ng-model=\"vm.product.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><div flex=\"\"></div><md-button class=\"btn btn-outline btn-primary create\" ng-click=\"vm.save()\" ng-disabled=\"vm.saving || !vm.product.name\"><i class=\"fa fa-check\"></i> Create</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/products/edit/products.edit.html","<div class=\"wrapper wrapper-content animated cases-edit\"><div layout=\"row\" style=\"margin-top:10px;\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Edit {{ vm.product.name }}</h2></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Edit Product</h3><md-input-container class=\"md-block placeholder mobPaddingNull big-fontSize\"><label>Product Name</label> <input ng-model=\"vm.product.name\" required=\"\"></md-input-container></div><div class=\"col-md-4 col-xs-12\"><h3 class=\"hide-mobile\">&nbsp;</h3><md-input-container class=\"md-block placeholder big-fontSize\"><label>Asset Url</label> <input ng-model=\"vm.product.assetUrl\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\" style=\"margin-bottom: 39px !important;\">Manufacturer</h3><div class=\"form-group\"><md-input-container flex=\"100\" ng-show=\"vm.product.key\" class=\"full-width\"><label>Manufacturer</label> <input ng-model=\"vm.product.manufacturer.name\" disabled=\"\"></md-input-container><md-input-container flex=\"100\" ng-hide=\"vm.product.key\"><label>Manufacturer</label><md-select ng-model=\"vm.product.manufacturer\" md-selected-text=\"vm.product.manufacturer.name\" required=\"\"><md-option ng-value=\"manufacturer\" ng-repeat=\"manufacturer in vm.manufacturers\">{{ manufacturer.name }}</md-option></md-select></md-input-container></div></div><div class=\"col-md-4 col-xs-12\"><h3 style=\"margin-bottom: 30px !important;\" class=\"subTitle\">vTray Guides</h3><md-chips ng-model=\"vm.product.guides\" md-require-match=\"true\" class=\"labelPosition labelPosition__md-chips chipsPositionFix\"><md-autocomplete class=\"md-block\" md-selected-item=\"vm.selectedGuide\" md-search-text=\"vm.guideSearchText\" md-items=\"guide in vm.searchGuides(vm.guideSearchText)\" md-no-cache=\"true\" md-item-text=\"guide.name\" placeholder=\"Add Guide\"><span md-highlight-text=\"vm.guideSearchText\">{{ guide.name }}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div></div><div class=\"row\"><div class=\"col-md-4 col-12\"><h3 class=\"subTitle\" style=\"margin-bottom: 25px !important;\">Technique Guides/IFU</h3><md-input-container class=\"md-block fixStylePosition placeholder big-fontSize\"><label></label><md-chips ng-model=\"vm.product.ifuUrls\" placeholder=\"Enter URLs\"></md-chips></md-input-container><div ng-model=\"vm.product.ifuUrls\" upload-folder=\"product\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"false\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"titleIconWrap\"><h3 class=\"subTitle\">Attach Images to this product</h3><md-button class=\"md-fab\"><md-tooltip style=\"max-width: 200px;\" md-direction=\"left\">You are associating images with this product line. These will be associate will all inventory in this product family and can include images of complete sets, trays, and the like. To add images of individual instruments and devices, visit that item\'s individual catalog page.</md-tooltip><md-icon><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></md-icon></md-button></div><md-input-container class=\"md-block fixStylePosition\"><label></label><md-chips ng-model=\"vm.product.images\" placeholder=\"Enter Images URLs\"></md-chips></md-input-container><div class=\"form-group\"><div><div ng-model=\"vm.product.images\" upload-folder=\"product\" upload-file=\"\" loading=\"vm.isLoading\" upload-only-images=\"true\"></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"productImagesContainer\"><div ng-repeat=\"image in vm.product.images\"><a ng-href=\"{{image}}\" target=\"_blank\"><img ng-src=\"{{image}}\" alt=\"Can\'t load image\"></a></div></div></div></div><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><h3 class=\"subTitle\">Description</h3><div class=\"form-group\"><md-input-container class=\"md-block\"><textarea placeholder=\"Description\" ng-model=\"vm.product.description\" md-maxlength=\"1000\" md-select-on-focus=\"\"></textarea></md-input-container></div></div></div><div class=\"row flex-end\"><div class=\"col-md-2 col-xs-12\"><div class=\"col-md-1\" style=\"padding: 10px 30px;\"><md-progress-circular ng-show=\"vm.isLoading\" ng-disabled=\"!vm.isLoading\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular></div><button ng-click=\"vm.finish()\" class=\"btn btn-outline btn-primary create\"><i class=\"fa fa-check\"></i> <span>Save</span></button><br><br></div></div><br><div class=\"row\"><div class=\"col-md-12 col-xs-12 mobileFriendlyTable\"><h3 class=\"subTitle\">Individual items</h3><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Name</th><th>Reference #</th><th>Tags</th><th>Lot/UDI</th><th>Status</th><th>Last Updated</th></tr></thead><tbody><tr ng-repeat=\"inventory in vm.inventoryList\">{{inventory}}<td><a ng-click=\"vm.viewInventory(inventory.key)\">{{ inventory.name }}</a></td><td>{{ inventory.reference }}</td><td ng-class=\"(inventory.expirationStatus === \'Expired\' || inventory.expirationStatus === \'ExpiringSoon\' || inventory.tags.length > 0) ? \'\' : \'unassigned\'\"><span ng-show=\"inventory.expirationStatus === \'Expired\'\" class=\"csx-tag csx-error\">EXPIRED</span> <span ng-show=\"device.expirationStatus === \'ExpiringSoon\'\" class=\"csx-tag csx-warn\">EXPIRING SOON</span> <span ng-show=\"device.images.length > 0\" class=\"csx-tag\" style=\"color:white; background-color: #5B2D61;\"><i class=\"fa fa-image\"></i></span> <span ng-repeat=\"tag in device.tags track by $index\" class=\"csx-tag\">{{ tag }}</span></td><td>{{ inventory.udi.lot || inventory.udi.raw }}</td><td>{{ inventory.status }}</td><td>{{ inventory.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</td></tr><tr ng-if=\"!vm.inventoryList.length\"><td colspan=\"6\">There is no individual item</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/inventory/requests/modal/add.inventory.tmpl.html","<md-dialog aria-label=\"Decline Transfer Reason\" style=\"min-width: 500px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Add Inventory</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-tabs><md-tab id=\"trayTab\"><md-tab-label>Container (Tray/Set)</md-tab-label><md-tab-body><form ng-submit=\"$event.preventDefault()\"><p style=\"margin-top:20px;\">Search for trays to fulfill the requested inventory.</p><md-autocomplete md-selected-item=\"vm.inventory\" md-search-text=\"vm.traySearchText\" md-items=\"item in vm.searchTrays(vm.traySearchText)\" md-item-text=\"item.reference\" md-min-length=\"0\" placeholder=\"What tray are you looking for?\" md-autofocus=\"\"><md-item-template><span md-highlight-text=\"vm.traySearchText\" md-highlight-flags=\"^i\">{{item.reference}}</span></md-item-template><md-not-found>No trays matching \"{{vm.traySearchText}}\" were found.</md-not-found></md-autocomplete></form></md-tab-body></md-tab><md-tab id=\"deviceTab\"><md-tab-label>Device</md-tab-label><md-tab-body><form ng-submit=\"$event.preventDefault()\"><p style=\"margin-top:20px;\">Search for devices to fulfill the requested inventory.</p><md-autocomplete md-selected-item=\"vm.inventory\" md-search-text=\"vm.deviceSearchText\" md-items=\"item in vm.searchDevices(vm.deviceSearchText)\" md-item-text=\"item.reference + \' (\' + (item.udi.lot || \'\') + \')\'\" md-min-length=\"0\" placeholder=\"What device are you looking for?\" md-autofocus=\"\"><md-item-template><p>{{ item.reference }} <span ng-show=\"item.udi.lot\">({{ item.udi.lot }})</span></p><p>{{ item.name }}</p></md-item-template><md-not-found>No devices matching \"{{vm.deviceSearchText}}\" were found.</md-not-found></md-autocomplete></form></md-tab-body></md-tab></md-tabs></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><md-button class=\"md-error\" ng-click=\"vm.cancel()\">Cancel</md-button><div flex=\"\"></div><div><md-button class=\"md-primary\" ng-click=\"vm.add(vm.inventory)\" ng-disabled=\"!vm.inventory.key\">Add</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/transfers/comments/decline.transfer.tmpl.html","<md-dialog aria-label=\"Decline Transfer Reason\" style=\"min-width: 500px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Decline Transfer</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Reason for declining transfer</label> <textarea ng-model=\"vm.reason\" md-maxlength=\"150\" md-select-on-focus=\"\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><md-button class=\"md-error\" ng-click=\"vm.cancel()\">Cancel</md-button><div flex=\"\"></div><div><md-button class=\"md-primary\" ng-click=\"vm.transfer()\" ng-disabled=\"!vm.reason\">Decline Transfer</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/inventory/transfers/detail/transfer.detail.html","<div class=\"wrapper wrapper-content animated\"><div layout=\"row\" style=\"margin-top:10px;margin-bottom: 30px\" class=\"margin-40-desktop\"><div><a csx-back=\"\" class=\"primary large\"><i class=\"fa fa-arrow-left title\"></i></a></div><div style=\"padding-left:20px;\" flex=\"\"><h2 style=\"margin-top:0;\" class=\"title\">Transfer</h2><div style=\"padding-bottom:8px;\" ng-class=\"vm.statusClass(vm.transfer.status)\" class=\"csx-status\">{{ vm.transfer.status | uppercase }}</div></div><div ng-show=\"vm.transfer.status === \'Pending\'\" style=\"margin-left:20px; margin-right:20px;\" layout=\"row\"><div><button csx-loading=\"\" csx-is-loading=\"vm.isAccepting\" ng-click=\"vm.acceptTransfer(vm.transfer)\" style=\"margin-left:8px;\" class=\"btn btn-outline btn-primary create\">Accept</button></div><div style=\"width: 16px;\"></div><div><button csx-loading=\"\" csx-is-loading=\"vm.isCancelling\" ng-click=\"vm.cancelTransfer()\" class=\"btn btn-outline btn-danger create\">Decline</button></div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Sender</p><p class=\"text\">{{ vm.transfer.source.name }}</p></div><div class=\"col-md-3 col-xs-12\"><p class=\"subSubTitle\">Recipient</p><p class=\"text\">{{ vm.transfer.target.name }}</p></div><div class=\"col-md-3 col-xs-12\"></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><p class=\"subSubTitle\">Updated By</p><p class=\"text\">{{ vm.transfer.modifiedByName }}</p></div><div class=\"col-md-4 col-xs-12\"><p class=\"subSubTitle\">Last Updated</p><p>{{ vm.transfer.modifiedDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div><div class=\"col-md-4 col-xs-12\"><p class=\"subSubTitle\">Created By</p><p class=\"text\">{{ vm.transfer.createdByName || \'No name set\'}}</p></div><div class=\"col-md-4 col-xs-12\"><p class=\"subSubTitle\">Created</p><p class=\"text\">{{ vm.transfer.createdDate | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><p class=\"subSubTitle\">Note</p><p class=\"text\">{{ vm.transfer.note }} <span class=\"unassigned\" style=\"color:lightgrey;\" ng-hide=\"vm.transfer.note\">none</span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\" layout=\"row\"><h3 class=\"subTitle\">Tracking</h3><div flex=\"\"></div><div ng-show=\"vm.transfer.tracking.track.trackingStatus.objectUpdated\">Last Updated: {{ vm.transfer.tracking.track.trackingStatus.objectUpdated | date:\'MM/dd/yyyy h:mm a\' }}</div><md-switch ng-show=\"vm.transfer.status === \'Created\'\" style=\"margin:0;\" class=\"md-primary placeholder\" ng-model=\"vm.trackingEnabled\"></md-switch></div></div><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><md-input-container class=\"md-block\"><label>Carrier</label><md-select ng-disabled=\"vm.transfer.status !== \'Pending\' || !vm.trackingEnabled\" ng-model=\"vm.transfer.tracking.carrier\" class=\"placeholder big-fontSize\"><md-option ng-value=\"carrier.value\" ng-repeat=\"carrier in vm.carriers\">{{ carrier.name }}</md-option></md-select></md-input-container></div><div class=\"col-md-3 col-xs-12\"><div class=\"row\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Tracking #</label> <input ng-disabled=\"vm.transfer.status !== \'Pending\' || !vm.trackingEnabled\" ng-model=\"vm.transfer.tracking.number\"></md-input-container><md-input-container class=\"md-block placeholder big-fontSize\"><button ng-if=\"vm.transfer.status === \'Pending\'\" ng-click=\"vm.save()\" style=\"margin-left:8px;\" class=\"btn btn-outline btn-primary create\">Save</button></md-input-container></div></div><div class=\"col-md-12 col-xs-12 text\" ng-show=\"vm.transfer.tracking.number\" style=\"margin-top:-40px !important;\"><p ng-hide=\"vm.transfer.tracking.track\">No additional tracking information available. Please verify your tracking number with your carrier.</p></div><div class=\"col-md-12 col-xs-12\" ng-show=\"!vm.transfer.tracking.number\" style=\"margin-top:-40px !important;\"><p ng-hide=\"vm.transfer.tracking.track\">No additional tracking information provided.</p></div></div><div class=\"row\" ng-show=\"vm.transfer.tracking.track\"><div class=\"col-md-3 col-xs-12\" ng-show=\"vm.transfer.tracking.track.addressFrom\"><p class=\"subSubTitle\">From Address</p><p class=\"text\">{{ vm.transfer.tracking.track.addressFrom.city }}, {{ vm.transfer.tracking.track.addressFrom.state }}</p></div><div class=\"col-md-3 col-xs-12\" ng-show=\"vm.transfer.tracking.track.addressTo\"><p class=\"subSubTitle\">To Address</p><p class=\"text\">{{ vm.transfer.tracking.track.addressTo.city }}, {{ vm.transfer.tracking.track.addressTo.state }}</p></div><div class=\"col-md-3 col-xs-12\" ng-show=\"vm.transfer.tracking.track.trackingStatus\"><p class=\"subSubTitle\">Status</p><p class=\"text\"><span ng-hide=\"vm.transfer.tracking.track.trackingStatus.status === \'UNKNOWN\'\">{{ vm.transfer.tracking.track.trackingStatus.status }}<br></span> {{ vm.transfer.tracking.track.trackingStatus.statusDetails }}</p></div><div class=\"col-md-3 col-xs-12\" ng-show=\"vm.transfer.tracking.track.eta\"><p class=\"subSubTitle\">ETA</p><p class=\"text\">{{ vm.transfer.tracking.track.eta | date:\'MM/dd/yyyy h:mm a\' }}</p></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><h3 class=\"subTitle\">Transferred Inventory</h3><div><table class=\"table no-border\"><thead><tr><th>Type</th><th>Name</th><th>Reference #</th><th>Quantity</th></tr></thead><tbody><tr ng-hide=\"vm.transfer.inventory.length > 0\"><td>No inventory.</td><td></td><td></td></tr><tr ng-repeat=\"device in vm.transfer.inventory\"><td>{{ device.type }}</td><td><a ng-click=\"vm.show.device(device)\">{{ device.name }}</a></td><td>{{ device.reference}}</td><td>{{ device.quantity}}</td></tr></tbody></table></div></div><div class=\"col-md-8 col-xs-12\"><h3 class=\"subTitle\">Inventory Transfer Notes</h3><div class=\"text\"><p ng-if=\"vm.transfer.note\">{{vm.transfer.note}}</p><p ng-if=\"!vm.transfer.note\">There are no comments for this inventory transfer record.</p></div></div></div></div>");
$templateCache.put("app/inventory/transfers/modal/transfer.tmpl.html","<md-dialog aria-label=\"Initiate Transfer\" style=\"min-width: 500px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">Transfer Inventory</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content bottom-linear-40\"><div layout=\"row\"><h3><i class=\"fa fa-barcode\"></i>&nbsp; Inventory</h3></div><div layout=\"row\"><div class=\"col-md-5 paddingNone\"><md-input-container class=\"marginNull block\"><p class=\"color-gray\">Inventory Type</p><md-radio-group ng-model=\"vm.type\" class=\"flexJustify\" ng-change=\"vm.inventorySearchText = \'\'\"><md-radio-button value=\"Device\" class=\"md-primary\">Loose Device</md-radio-button><md-radio-button value=\"Container\" class=\"md-primary\">Container</md-radio-button></md-radio-group></md-input-container></div><div class=\"col-md-7 paddingNone\"><md-autocomplete style=\"margin-left:16px;\" flex=\"\" ng-disabled=\"vm.loading\" md-clear-button=\"true\" md-no-cache=\"true\" md-search-text=\"vm.inventorySearchText\" md-selected-item-change=\"vm.contsinsInventoriesFromRequestPage = false; vm.isInventoryItem = false;vm.addInventory(item)\" md-items=\"item in vm.searchInventory(vm.inventorySearchText)\" md-item-text=\"item.description\" md-dropdown-position=\"top\" md-search-text-change=\"vm.isSearchContainerTextChanged = true\" md-min-length=\"1\" md-menu-class=\"transfer-autocomplete\" md-floating-label=\"Search for inventory to transfer\"><md-item-template><div style=\"position: relative;\" ng-attr-data-index=\"{{$index}}\" class=\"itemInnerContent\"><p style=\"margin-bottom: 0; line-height: 1;\">{{item.name | limitTo: 24}}<span ng-if=\"item.name.length > 24\">...</span></p><b ng-show=\"item.custodyName\" style=\"color:#333; line-height: 1;font-size: 0.8em;margin: 10px 0 5px;display: block\">({{ item.custodyName | limitTo: 20 }}) <span ng-if=\"item.custodyName.length > 20\">...</span></b><div ng-if=\"vm.isStringLength(item.raw) && !vm.isStringLength(item.serial) && !vm.isStringLength(item.lot)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">UDI: {{item.raw | limitTo: 15}}<span ng-if=\"item.raw.length > 15\">...</span></div><div class=\"transferExpiration\"><strong ng-if=\"item.expirationStatus=== \'Expired\'\" class=\"colorRed\">Expired</strong> <strong ng-if=\"item.expirationStatus=== \'ExpiringSoon\'\" class=\"colorOrange\">Expiring Soon</strong></div><div class=\"lot\" ng-show=\"!vm.isStringLength(item.serial) && vm.isStringLength(item.lot)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">Lot: {{ item.lot | limitTo: 20}} <span ng-if=\"item.lot.length > 20\">...</span></div><div class=\"lot\" ng-show=\"vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d; margin-top: 5px;line-height: 1;\">Serial: {{ item.serial | limitTo: 20}} <span ng-if=\"item.serial.length > 20\">...</span></div><i style=\"color:#47525d; position: absolute; font-size: 0.8em; right: 0; bottom: 0;line-height: 1;\">Ref. num.: {{ item.reference | limitTo: 20}} <span ng-if=\"item.reference.length > 20\">...</span></i></div></md-item-template><md-not-found>No inventory matching \"{{ vm.inventorySearchText }}\" were found.</md-not-found></md-autocomplete></div></div><div><p class=\"text-danger\">{{ vm.error }}</p><div class=\"flex-center\" ng-if=\"vm.findingExistInventory\"><div csx-loading=\"\" csx-is-loading=\"vm.findingExistInventory\"></div><br><br></div><p ng-show=\"vm.inventory.length === 0 && !vm.findingExistInventory\">No inventory selected for transfer</p><p ng-show=\"vm.errorFindInventory\" class=\"colorRed\">Current item not allowed for transfer</p><div ng-repeat=\"item in vm.inventory track by item.key\"><div class=\"inventoriesPosition\"><div class=\"inventoriesPosition__content\"><div class=\"detail-field-title\"><span ng-if=\"item.description\">{{ item.description }}</span> <span ng-if=\"!item.description && item.name\">{{item.name}}</span>&nbsp;&nbsp;<div ng-show=\"item.custodyName\" style=\"font-size: 0.8em;color:#47525d;display: inline\"><br>{{ item.custodyName }}</div><br><span><strong ng-if=\"item.expirationStatus === \'Expired\'\" class=\"colorRed\">Expired</strong> <strong ng-if=\"item.expirationStatus === \'ExpiringSoon\'\" class=\"colorOrange\">Expiring Soon</strong><br></span><div ng-if=\"vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d;display: inline-block\">Serial: {{ item.serial }}</div><div ng-if=\"vm.isStringLength(item.lot) && !vm.isStringLength(item.serial)\" style=\"font-size: 0.8em;color:#47525d;display: inline-block\">Lot: {{ item.lot }}</div><div ng-if=\"!vm.isStringLength(item.lot) && !vm.isStringLength(item.serial) && vm.isStringLength(item.raw)\" style=\"font-size: 0.8em;color:#47525d;display: inline-block\">UDI: {{ item.raw }}</div><a class=\"text-danger\" ng-click=\"vm.removeInventory(item)\"><i class=\"fa fa-trash-o\"></i></a></div></div><div style=\"width: 10px;\" ng-if=\"item.loading\"><div csx-loading=\"\" csx-is-loading=\"item.loading\"></div></div><div class=\"inventoryButtonsWrap\" ng-if=\"item.relatedItems.length\"><button class=\"btn btn-primary\" ng-disabled=\"item.amount === 1\" ng-click=\"vm.changeAmount(item, false)\">-</button> {{item.amount}} <button class=\"btn btn-primary\" ng-disabled=\"item.amount >= item.relatedItems.length\" ng-click=\"vm.changeAmount(item, true)\">+</button></div></div><hr></div></div><div class=\"row\"><div class=\"col-sm-12\"><hr></div></div><div layout=\"row\" layout-align=\"true\"><h3>Recipient</h3><div flex=\"\"></div><md-progress-circular ng-show=\"vm.loading\" md-diameter=\"15\"></md-progress-circular></div><md-autocomplete ng-disabled=\"vm.loading || vm.requestMode\" md-no-cache=\"true\" md-selected-item=\"vm.selectedAccount\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectItem(account)\" md-items=\"account in vm.accounts | filter:vm.searchText\" md-item-text=\"account.name\" md-min-length=\"0\" md-floating-label=\"Who would you like to transfer to?\"><md-item-template><span>{{ account.name }}<span ng-show=\"account.email.length > 0\">({{ account.email }})</span></span></md-item-template><md-not-found>No recipients matching \"{{ vm.searchText }}\" were found.</md-not-found></md-autocomplete><md-input-container class=\"md-block\" flex=\"\"><textarea placeholder=\"Comment\" ng-model=\"vm.comment\" max-rows=\"4\" md-maxlength=\"500\" md-select-on-focus=\"\" flex=\"\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions style=\"border-top: 1px solid lightgrey;\"><div layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\" flex=\"\"><md-button class=\"md-error\" ng-click=\"vm.cancel()\">Cancel</md-button><div flex=\"\"></div><div ng-switch=\"vm.requestMode\"><div ng-switch-when=\"true\"><md-button class=\"md-primary\" ng-click=\"vm.done()\">Done</md-button></div><div ng-switch-default=\"\"><div csx-loading=\"\" csx-is-loading=\"vm.transferLoading\"><md-button class=\"md-primary\" ng-click=\"vm.transfer()\" ng-disabled=\"!vm.selectedAccount || vm.inventory.length === 0\">Make Transfer</md-button></div></div></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/settings/manufacturers/modal/manufacturer.modal.tmpl.html","<md-dialog aria-label=\"Comments\" style=\"width: 600px;\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">New Manufacturer</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content layout-margin=\"\" style=\"padding: 20px;\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><md-autocomplete class=\"placeholder big-fontSize mdline-position\" md-search-text-change=\"vm.isChange = true\" md-selected-item-change=\"vm.isChange = true\" md-selected-item=\"vm.gudidManufacturer\" md-search-text=\"vm.manufacturerSearchText\" md-items=\"item in vm.searchManufacturers(vm.manufacturerSearchText)\" md-item-text=\"item.name\" md-floating-label=\"Name\" md-min-length=\"0\" required=\"\"><md-item-template><span md-highlight-text=\"vm.manufacturerSearchText\" md-highlight-flags=\"^i\" ng-if=\"item.name\">{{ item.name }}</span></md-item-template></md-autocomplete></div><div class=\"col-sm-6\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Email</label> <input ng-model=\"vm.manufacturer.email\" ng-change=\"vm.isChange = true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Phone</label> <input ng-model=\"vm.manufacturer.phone\" ng-change=\"vm.isChange = true\"></md-input-container></div><div class=\"col-sm-6\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Fax</label> <input ng-model=\"vm.manufacturer.fax\" ng-change=\"vm.isChange = true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Address</label> <input ng-model=\"vm.manufacturer.address\" ng-change=\"vm.isChange = true\"></md-input-container></div><div class=\"col-sm-6\"><md-input-container class=\"md-block placeholder big-fontSize\"><label>Image Url</label> <input ng-model=\"vm.manufacturer.imageUrl\" ng-change=\"vm.isChange = true\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" style=\"margin-bottom: 15px; margin-right:15px;\"><div flex=\"\"></div><md-progress-circular ng-show=\"vm.saving\" ng-disabled=\"!vm.saving\" class=\"md-primary\" md-diameter=\"20px\"></md-progress-circular><div><md-button class=\"btn btn-outline btn-primary create\" ng-click=\"vm.save()\" ng-disabled=\"vm.saving || vm.gudidManufacturer === \'\' || vm.manufacturerSearchText ===\'\'\"><i class=\"fa fa-check\"></i> Create</md-button></div></md-dialog-actions></form></md-dialog>");}]);